import { a as e, i as t, n, r } from "./languageStore-T5E15Nsa.js";
import { A as i, E as a, S as o, U as s, W as c, _ as l, b as u, d, g as f, l as p, m, t as h, w as g, x as _ } from "./useCollections-V5XMzAS9.js";
import { i as v, n as y, r as b, t as x } from "./useNotification-Dj6bNdsY.js";
import { Banner as S, Box as C, Button as w, FieldWrapper as T, FlexBox as E, FormField as ee, FormGrid as D, InputSelectionList as O, ModalBody as te, ModalFoot as k, ModalHead as ne, SelectionList as re, Spinner as A, Text as ie } from "@dixa/lib-shared-habla";
import { Fragment as ae, jsx as j, jsxs as M } from "react/jsx-runtime";
import * as oe from "react";
import N, { Component as se, createContext as ce, forwardRef as le, lazy as ue, memo as de, useCallback as P, useContext as fe, useDebugValue as pe, useEffect as me, useLayoutEffect as he, useMemo as ge, useReducer as _e, useRef as ve, useState as ye } from "react";
import "classnames";
import { ampli as be } from "lib-shared-tracking";
import xe from "react-dom";
import { Controller as Se, appendErrors as Ce, get as we, set as Te, useForm as Ee } from "react-hook-form";
import { atom as De, atom as Oe, createStore as ke, useAtom as Ae, useAtomValue as je, useSetAtom as Me } from "jotai";
import { atom as Ne, createStore as Pe } from "jotai/vanilla";
import { useHydrateAtoms as Fe } from "jotai/utils";
import Ie from "lodash/cloneDeep.js";
import Le from "lodash/defaultsDeep.js";
import Re from "lodash/castArray.js";
import ze from "lodash/map.js";
import "lodash/last.js";
import Be from "lodash/keyBy.js";
import Ve from "lodash/merge.js";
import He from "lodash/values.js";
import Ue from "lodash/pick.js";
import "lodash/isEqual.js";
import We from "lodash/debounce";
import Ge from "lodash/throttle";
import Ke from "lodash/omit.js";
import qe from "lodash/defaults.js";
// ../../../node_modules/@hookform/resolvers/dist/resolvers.mjs
var Je = (e, t, n) => {
	if (e && "reportValidity" in e) {
		let r = we(n, t);
		e.setCustomValidity(r && r.message || ""), e.reportValidity();
	}
}, Ye = (e, t) => {
	for (let n in t.fields) {
		let r = t.fields[n];
		r && r.ref && "reportValidity" in r.ref ? Je(r.ref, n, e) : r && r.refs && r.refs.forEach((t) => Je(t, n, e));
	}
}, Xe = (e, t) => {
	t.shouldUseNativeValidation && Ye(e, t);
	let n = {};
	for (let r in e) {
		let i = we(t.fields, r), a = Object.assign(e[r] || {}, { ref: i && i.refs ? i.refs[0] : i && i.ref });
		if (Ze(t.names || Object.keys(e), r)) {
			let e = Object.assign({}, we(n, r));
			Te(e, "root", a), Te(n, r, e);
		} else Te(n, r, a);
	}
	return n;
}, Ze = (e, t) => {
	let n = Qe(t).replace(/[.*+?^${}()|\\]/g, "\\$&");
	return e.some((e) => Qe(e).match(`^${n}\\.\\d+`));
};
function Qe(e) {
	return e.replace(/\[(\d+)]/g, ".$1").replace(/[[\]]/g, "");
}
// ../../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
function $e() {
	return $e = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, $e.apply(null, arguments);
}
function et(e, t) {
	try {
		var n = e();
	} catch (e) {
		return t(e);
	}
	return n && n.then ? n.then(void 0, t) : n;
}
function tt(e, t) {
	for (var n = Object.create(null); e.length;) {
		var r = e[0], i = r.code, a = r.message, o = r.path.join(".");
		if (!n[o]) {
			if ("unionErrors" in r) {
				var s = r.unionErrors.reduce(function(e, t) {
					return t.errors.length < e.errors.length ? t : e;
				}).errors[0];
				n[o] = {
					message: s?.message ?? a,
					type: s?.code ?? i
				};
			} else n[o] = {
				message: a,
				type: i
			};
		}
		if ("unionErrors" in r && r.unionErrors.forEach(function(t) {
			return t.errors.forEach(function(t) {
				return e.push(t);
			});
		}), t) {
			var c = n[o].types, l = c && c[r.code];
			n[o] = Ce(o, t, n, i, l ? [].concat(l, r.message) : r.message);
		}
		e.shift();
	}
	return n;
}
function nt(e, t) {
	for (var n = Object.create(null), r = function() {
		var r = e[0], i = r.code, a = r.message, o = r.path.join(".");
		if (!n[o]) {
			if (r.code === "invalid_union" && r.errors.length > 0) {
				var s = r.errors.reduce(function(e, t) {
					return t.length < e.length ? t : e;
				})[0];
				n[o] = {
					message: s?.message ?? a,
					type: s?.code ?? i
				};
			} else n[o] = {
				message: a,
				type: i
			};
		}
		if (r.code === "invalid_union" && r.errors.forEach(function(t) {
			return t.forEach(function(t) {
				return e.push($e({}, t, { path: [].concat(r.path, t.path) }));
			});
		}), t) {
			var c = n[o].types, l = c && c[r.code];
			n[o] = Ce(o, t, n, i, l ? [].concat(l, r.message) : r.message);
		}
		e.shift();
	}; e.length;) r();
	return n;
}
function rt(e, t, n) {
	if (n === void 0 && (n = {}), function(e) {
		return "_zod" in e && typeof e._zod == "object";
	}(e)) return function(r, i, a) {
		try {
			return Promise.resolve(et(function() {
				function i(e) {
					return a.shouldUseNativeValidation && Ye({}, a), {
						errors: {},
						values: n.raw ? Object.assign({}, r) : e
					};
				}
				var o = e;
				return n.mode === "sync" ? i(o.parse(r, t)) : Promise.resolve(o.parseAsync(r, t)).then(i);
			}, function(e) {
				if (function(e) {
					var t;
					return !(e == null || (t = e._zod) == null || (t = t.traits) == null || !t.has("$ZodError"));
				}(e)) return {
					values: {},
					errors: Xe(nt(e.issues, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a)
				};
				throw e;
			}));
		} catch (e) {
			return Promise.reject(e);
		}
	};
	if (function(e) {
		return "_def" in e && typeof e._def == "object";
	}(e)) return function(r, i, a) {
		try {
			return Promise.resolve(et(function() {
				return Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](r, t)).then(function(e) {
					return a.shouldUseNativeValidation && Ye({}, a), {
						errors: {},
						values: n.raw ? Object.assign({}, r) : e
					};
				});
			}, function(e) {
				if (function(e) {
					return Array.isArray(e?.issues);
				}(e)) return {
					values: {},
					errors: Xe(tt(e.errors, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a)
				};
				throw e;
			}));
		} catch (e) {
			return Promise.reject(e);
		}
	};
	throw Error("Invalid input: not a Zod schema");
}
// ../form/src/utils/index.ts
function it(e) {
	return { error: e.error?.message || void 0 };
}
ue(() => import("./dist-B4c1Yg8X.js").then((e) => ({ default: e.Editor })));
// ../form/src/components/hookForm/fieldSelectionList.tsx
function at({ control: e, name: t, label: n, required: r, description: i, itemsLoading: a, equalityFn: o, placeholders: s, listItems: c, multiple: l = !0, disabled: u }) {
	return /* @__PURE__ */ j(Se, {
		control: e,
		name: t,
		render: ({ field: e, fieldState: t }) => {
			let d = it(t);
			return /* @__PURE__ */ j(T, {
				label: n,
				required: r,
				meta: d,
				description: i,
				children: /* @__PURE__ */ j(O, {
					multiple: l,
					value: e.value,
					onChange: (t) => e.onChange(t.selectedValues),
					disabled: a || u,
					placeholder: a ? s.loading : s.empty,
					equalityFn: o,
					getItemTitleByValue: ot,
					selectionListProps: { style: {
						maxHeight: 300,
						overflow: "auto"
					} },
					children: (c || []).map((e) => /* @__PURE__ */ j(re.Item, {
						value: e,
						children: /* @__PURE__ */ j(ie.Paragraph, { children: e.name })
					}, e.id))
				})
			});
		}
	});
}
function ot(e) {
	return /* @__PURE__ */ j(ae, { children: e?.name });
}
// ../../../node_modules/zod/v4/core/util.js
function st(e) {
	let t = Object.values(e).filter((e) => typeof e == "number");
	return Object.entries(e).filter(([e, n]) => t.indexOf(+e) === -1).map(([e, t]) => t);
}
function ct(e, t = "|") {
	return e.map((e) => Nt(e)).join(t);
}
function lt(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
var ut = class {
	constructor(e) {
		this._getter = e, this._value = void 0;
	}
	get value() {
		let e = this._getter;
		return e !== void 0 && (this._value = e(), this._getter = void 0), this._value;
	}
};
function dt(e) {
	return new ut(e);
}
function ft(e) {
	return e == null;
}
function pt(e) {
	let t = +!!e.startsWith("^"), n = e.endsWith("$") ? e.length - 1 : e.length;
	return e.slice(t, n);
}
function mt(e, t) {
	let n = e / t, r = Math.round(n), i = 4 * 2 ** -52 * Math.max(Math.abs(n), 1);
	return Math.abs(n - r) < i ? 0 : n - r;
}
function ht(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}
function gt(e) {
	let t = Object.getOwnPropertyDescriptor(e, "shape");
	return t?.get ? t.get.raw : t?.value;
}
function _t(e) {
	return gt(e._zod.def) ?? e._zod.def.shape;
}
function vt(e, t, n) {
	Object.defineProperty(e, t, {
		get() {
			let e = n();
			return ht(this, t, e), e;
		},
		enumerable: !0,
		configurable: !0
	});
}
function yt(e, t, n) {
	t in e ? ht(e, t, n) : e[t] = n;
}
function bt(e, t, n, r) {
	let i = _t(t);
	for (let a of n) {
		let n = Object.getOwnPropertyDescriptor(i, a);
		n.enumerable && (n.get ? vt(e, a, () => {
			let e = t._zod.def.shape[a];
			return r ? r(e, a) : e;
		}) : yt(e, a, r ? r(n.value, a) : n.value));
	}
}
function xt(e, t) {
	for (let n of Reflect.ownKeys(t)) {
		let r = Object.getOwnPropertyDescriptor(t, n);
		r.enumerable && (r.get ? vt(e, n, () => t[n]) : yt(e, n, r.value));
	}
}
function St(...e) {
	let t = {};
	for (let n of e) {
		let e = Object.getOwnPropertyDescriptors(n);
		Object.assign(t, e);
	}
	return Object.defineProperties({}, t);
}
function Ct(e) {
	return JSON.stringify(e);
}
function wt(e) {
	return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
var Tt = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
function Et(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var Dt = /* @__PURE__*/ dt(() => {
	if (Cn.jitless || typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
	try {
		return Function(""), !0;
	} catch {
		return !1;
	}
});
function Ot(e) {
	if (Et(e) === !1) return !1;
	let t = e.constructor;
	if (t === void 0 || typeof t != "function") return !0;
	let n = t.prototype;
	return Et(n) !== !1 && Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") !== !1;
}
function kt(e) {
	return Ot(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
var At = /* @__PURE__*/ new Set([
	"string",
	"number",
	"symbol"
]);
function jt(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Mt(e, t, n) {
	let r = new e._zod.constr(t ?? e._zod.def);
	return (!t || n?.parent) && (r._zod.parent = e), r;
}
function F(e) {
	let t = e;
	if (!t) return {};
	if (typeof t == "string") return { error: () => t };
	if (t?.message !== void 0) {
		if (t?.error !== void 0) throw Error("Cannot specify both `message` and `error` params");
		t.error = t.message;
	}
	return delete t.message, typeof t.error == "string" ? {
		...t,
		error: () => t.error
	} : t;
}
function Nt(e) {
	return typeof e == "bigint" ? e.toString() + "n" : typeof e == "string" ? `"${e}"` : `${e}`;
}
function Pt(e) {
	return Object.keys(e).filter((t) => e[t]._zod.optin !== void 0 && e[t]._zod.optout === "optional");
}
var Ft = {
	safeint: [-(2 ** 53 - 1), 2 ** 53 - 1],
	int32: [-2147483648, 2147483647],
	uint32: [0, 4294967295],
	float32: [-34028234663852886e22, 34028234663852886e22],
	float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
}, It = {
	int64: [/* @__PURE__*/ BigInt("-9223372036854775808"), /* @__PURE__*/ BigInt("9223372036854775807")],
	uint64: [/* @__PURE__*/ BigInt(0), /* @__PURE__*/ BigInt("18446744073709551615")]
};
function Lt(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".pick() cannot be used on object schemas containing refinements");
	let i = {};
	return bt(i, e, Rt(e, t)), Mt(e, St(n, {
		shape: i,
		checks: []
	}));
}
function Rt(e, t) {
	let n = _t(e), r = [];
	for (let e of Reflect.ownKeys(t)) {
		if (!Object.getOwnPropertyDescriptor(n, e)?.enumerable) throw Error(`Unrecognized key: "${String(e)}"`);
		t[e] && r.push(e);
	}
	return r;
}
function zt(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".omit() cannot be used on object schemas containing refinements");
	let i = new Set(Rt(e, t)), a = {};
	return bt(a, e, Reflect.ownKeys(_t(e)).filter((e) => !i.has(e))), Mt(e, St(n, {
		shape: a,
		checks: []
	}));
}
function Bt(e, t) {
	if (!Ot(t)) throw Error("Invalid input to extend: expected a plain object");
	let n = e._zod.def.checks;
	if (n && n.length > 0) {
		let n = _t(e);
		for (let e of Reflect.ownKeys(t)) if (Object.getOwnPropertyDescriptor(n, e) !== void 0) throw Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
	}
	return Mt(e, St(e._zod.def, { shape: Vt(e, t) }));
}
function Vt(e, t) {
	let n = {};
	return bt(n, e, Reflect.ownKeys(_t(e))), xt(n, t), n;
}
function Ht(e, t) {
	if (!Ot(t)) throw Error("Invalid input to safeExtend: expected a plain object");
	return Mt(e, St(e._zod.def, { shape: Vt(e, t) }));
}
function Ut(e, t) {
	if (!t?._zod?.def) throw Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
	if (e._zod.def.checks?.length) throw Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
	let n = {};
	return bt(n, e, Reflect.ownKeys(_t(e))), bt(n, t, Reflect.ownKeys(_t(t))), Mt(e, St(e._zod.def, {
		shape: n,
		get catchall() {
			return t._zod.def.catchall;
		},
		checks: t._zod.def.checks ?? []
	}));
}
function Wt(e, t, n, r = "partial") {
	let i = t._zod.def.checks;
	if (i && i.length > 0) throw Error(`.${r}() cannot be used on object schemas containing refinements`);
	let a = n ? new Set(Rt(t, n)) : void 0, o = {};
	return bt(o, t, Reflect.ownKeys(_t(t)), e && ((t, n) => a && !a.has(n) ? t : new e({
		type: "optional",
		innerType: t
	}))), Mt(t, St(t._zod.def, {
		shape: o,
		checks: []
	}));
}
function Gt(e, t, n) {
	let r = n ? new Set(Rt(t, n)) : void 0, i = {};
	return bt(i, t, Reflect.ownKeys(_t(t)), (t, n) => r && !r.has(n) ? t : new e({
		type: "nonoptional",
		innerType: t
	})), Mt(t, St(t._zod.def, { shape: i }));
}
function Kt(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue !== !0) return !0;
	return !1;
}
function qt(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue === !1) return !0;
	return !1;
}
function Jt(e, t) {
	return t.map((t) => {
		var n;
		return (n = t).path ?? (n.path = []), t.path.unshift(e), t;
	});
}
function Yt(e) {
	return typeof e == "string" ? e : e?.message;
}
function Xt(e) {
	let t = [];
	for (let n of e ?? []) {
		let e = n._zod.def;
		if (!/_(length|size)$|_equals$/.test(e.check)) break;
		let r = e.maximum ?? e.length ?? e.size;
		r >= 0 && t.push([r, n]);
	}
	return t;
}
function Zt(e, t, n) {
	var r;
	for (let i = t; i < e.length; i++) (r = e[i]).schema ?? (r.schema = n);
}
function Qt(e, t, n) {
	var r;
	let i = e.inst?._zod?.traits;
	i?.has("$ZodType") && (i.has("$ZodCheck") ? (r = e).schema ?? (r.schema = e.inst) : e.schema = e.inst);
	let a = e.schema === e.inst ? void 0 : e.schema?._zod.def?.error, o = e.message ? e.message : Yt(e.inst?._zod.def?.error?.(e)) ?? Yt(a?.(e)) ?? Yt(t?.error?.(e)) ?? Yt(n.customError?.(e)) ?? Yt(n.localeError?.(e)) ?? "Invalid input", s = {};
	for (let t of Object.keys(e)) t !== "inst" && t !== "schema" && t !== "continue" && t !== "input" && t !== "__proto__" && (s[t] = e[t]);
	return s.path ??= [], s.message = o, t?.reportInput && (s.input = e.input), s;
}
var $t = /[\uD800-\uDBFF]/;
function en(e) {
	let t = e.length;
	if (!$t.test(e)) return t;
	let n = t;
	for (let r = 0; r < t - 1; r++) (e.charCodeAt(r) & 64512) == 55296 && (e.charCodeAt(r + 1) & 64512) == 56320 && (n--, r++);
	return n;
}
function tn(e) {
	return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function nn(e) {
	let t = typeof e;
	switch (t) {
		case "number": return Number.isNaN(e) ? "nan" : "number";
		case "object": {
			if (e === null) return "null";
			if (Array.isArray(e)) return "array";
			let t = e;
			if (t && Object.getPrototypeOf(t) !== Object.prototype && "constructor" in t && t.constructor) return t.constructor.name;
		}
	}
	return t;
}
function rn(...e) {
	let [t, n, r] = e;
	return typeof t == "string" ? {
		message: t,
		code: "custom",
		input: n,
		inst: r
	} : { ...t };
}
function an(e, t) {
	for (let n in t) {
		let r = Object.getOwnPropertyDescriptor(t, n);
		r.get ? Object.defineProperty(e, n, {
			...r,
			enumerable: !1
		}) : ln(e, n, r.value);
	}
}
function on(e, t, n, r = !0) {
	return Object.defineProperty(e, t, {
		configurable: !0,
		writable: !0,
		enumerable: r,
		value: n
	}), n;
}
function sn(e, t, n) {
	return on(e, t, n, !1);
}
/* @__NO_SIDE_EFFECTS__ */
function cn(e, t) {
	for (let n in e) {
		let r = e[n];
		Object.defineProperty(t, n, {
			configurable: !0,
			enumerable: !0,
			get() {
				return on(this, n, r(this));
			},
			set(e) {
				on(this, n, e);
			}
		});
	}
	return t;
}
function ln(e, t, n) {
	Object.defineProperty(e, t, {
		configurable: !0,
		get() {
			return this == null ? n : on(this, t, n.bind(this));
		},
		set(e) {
			on(this, t, e);
		}
	});
}
function un(e, t) {
	let n = Object.getPrototypeOf(e);
	return t in n ? void 0 : n;
}
var dn, fn = !1, pn = {
	configurable: !0,
	get() {
		fn = !0;
	}
};
function I(e, t, n) {
	let r = Object.getPrototypeOf(e._zod);
	t in r && dn !== e._zod ? dn = void 0 : (dn = e._zod, Object.defineProperty(r, t, {
		configurable: !0,
		get() {
			Object.defineProperty(this, t, pn);
			let e = fn;
			fn = !1;
			try {
				let r = n(this);
				return fn ? delete this[t] : Object.defineProperty(this, t, {
					configurable: !0,
					writable: !0,
					value: r
				}), fn ||= e, r;
			} catch (n) {
				throw delete this[t], fn ||= e, n;
			}
		},
		set(e) {
			Object.defineProperty(this, t, {
				configurable: !0,
				writable: !0,
				value: e
			});
		}
	}));
}
function mn(e, t, n, r) {
	let i = un(e, t);
	i && Object.defineProperty(i, t, {
		configurable: !0,
		get() {
			let e = {
				configurable: !0,
				writable: !0,
				enumerable: r,
				value: void 0
			};
			return Object.defineProperty(this, t, e), e.value = n(this), Object.defineProperty(this, t, e), e.value;
		},
		set(e) {
			Object.defineProperty(this, t, {
				configurable: !0,
				writable: !0,
				enumerable: r,
				value: e
			});
		}
	});
}
var hn = "~constantCatch";
function gn(e) {
	let t = () => e;
	return t[hn] = !0, t;
}
// ../../../node_modules/zod/v4/core/core.js
var _n, vn = {
	value: void 0,
	enumerable: !1
}, yn = "captureStackTrace" in Error ? Error : null;
function bn(e) {
	let t = yn;
	if (t) {
		let n = t.stackTraceLimit;
		if (typeof n == "number") {
			try {
				t.stackTraceLimit = 0;
			} catch {
				return yn = null, new e();
			}
			try {
				return new e();
			} finally {
				t.stackTraceLimit = n;
			}
		}
	}
	return new e();
}
/* @__NO_SIDE_EFFECTS__ */
function L(e, t, n, r) {
	let i = {};
	function a(e) {
		this.def = e, this.constr = d, this.traits = /* @__PURE__ */ new Set();
	}
	a.prototype = i;
	let o = n, s = o && /* @__PURE__ */ new WeakSet();
	function c(n, r) {
		if (!n._zod) {
			vn.value = new a(r);
			try {
				Object.defineProperty(n, "_zod", vn);
			} finally {
				vn.value = void 0;
			}
		} else if (n._zod.traits.has(e)) return;
		if (n._zod.traits.add(e), t(n, r), s) {
			let e = Object.getPrototypeOf(n), t = n._zod.constr.prototype, r = e;
			for (; r && r !== t;) r = Object.getPrototypeOf(r);
			let i = r ?? e;
			s.has(i) || (s.add(i), an(i, o));
		}
		let i = d.prototype;
		for (let e in i) Object.prototype.hasOwnProperty.call(i, e) && (e in n || (n[e] = i[e].bind(n)));
	}
	let l = r?.Parent ?? Object;
	class u extends l {}
	Object.defineProperty(u, "name", { value: e });
	function d(e) {
		let t = r?.Parent ? bn(u) : this;
		c(t, e);
		let n = t._zod.deferred;
		if (n) {
			for (let e of n) e();
			t._zod.deferred = void 0;
		}
		let i = globalThis.__zod_globalConfig?.postProcessor;
		return i && i(t), t;
	}
	return Object.defineProperty(d, "init", { value: c }), Object.defineProperty(d, Symbol.hasInstance, { value: (t) => r?.Parent && t instanceof r.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(d, "name", { value: e }), d;
}
var xn = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
}, Sn = class extends Error {
	constructor(e) {
		super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
	}
};
(_n = globalThis).__zod_globalConfig ?? (_n.__zod_globalConfig = {});
var Cn = globalThis.__zod_globalConfig;
function wn(e) {
	return e && Object.assign(Cn, e), Cn;
}
// ../../../node_modules/zod/v4/core/errors.js
function Tn() {
	let e = this._zod;
	return e.message ??= JSON.stringify(e.def, lt, 2), e.message;
}
function En(e) {
	this._zod.message = e;
}
var Dn = {
	get: Tn,
	set: En,
	enumerable: !0,
	configurable: !0
}, On = {
	value: void 0,
	enumerable: !1
}, kn = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]), An = /* @__PURE__ */ L("$ZodError", (e, t) => {
	e.name = "$ZodError", On.value = t, Object.defineProperty(e, "issues", On), On.value = void 0, Object.defineProperty(e, "message", Dn);
	let n = Object.getPrototypeOf(e);
	kn.has(n) || (kn.add(n), Object.defineProperty(n, "toString", {
		configurable: !0,
		enumerable: !1,
		get() {
			let e = () => this.message;
			return Object.defineProperty(this, "toString", {
				value: e,
				configurable: !0,
				writable: !0
			}), e;
		},
		set(e) {
			Object.defineProperty(this, "toString", {
				value: e,
				configurable: !0,
				writable: !0
			});
		}
	}));
});
function jn(e, t, n) {
	return Object.prototype.hasOwnProperty.call(e, t) || (t === "__proto__" ? Object.defineProperty(e, t, {
		value: n(),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : e[t] = n()), e[t];
}
function Mn(e, t = (e) => e.message) {
	let n = {}, r = [];
	for (let i of e.issues) i.path.length > 0 ? jn(n, i.path[0], () => []).push(t(i)) : r.push(t(i));
	return {
		formErrors: r,
		fieldErrors: n
	};
}
function Nn(e, t = (e) => e.message) {
	let n = { _errors: [] }, r = (e, i = []) => {
		for (let a of e.issues) if (a.code === "invalid_union" && a.errors.length) a.errors.map((e) => r({ issues: e }, [...i, ...a.path]));
		else if (a.code === "invalid_key") r({ issues: a.issues }, [...i, ...a.path]);
		else if (a.code === "invalid_element") r({ issues: a.issues }, [...i, ...a.path]);
		else {
			let e = [...i, ...a.path];
			if (e.length === 0) n._errors.push(t(a));
			else {
				let r = n, i = 0;
				for (; i < e.length;) {
					let n = e[i], o = i === e.length - 1;
					if (n === "_errors") {
						o && r._errors.push(t(a)), i++;
						continue;
					}
					Object.prototype.hasOwnProperty.call(r, n) || Object.defineProperty(r, n, {
						value: { _errors: [] },
						enumerable: !0,
						writable: !0,
						configurable: !0
					});
					let s = r[n];
					o && s._errors.push(t(a)), r = s, i++;
				}
			}
		}
	};
	return r(e), n;
}
// ../../../node_modules/zod/v4/core/parse.js
function Pn(e, t) {
	return {
		callee: t?.callee ?? e,
		Err: t?.Err
	};
}
var Fn = (e) => {
	let t = (n, r, i, a) => {
		let o = i ? {
			...i,
			async: !1
		} : { async: !1 }, s = n._zod.run({
			value: r,
			issues: []
		}, o);
		if (s instanceof Promise) throw new xn();
		if (s.issues.length) {
			let n = new ((a?.Err) ?? e)(s.issues.map((e) => Qt(e, o, wn())));
			throw Tt(n, a?.callee ?? t), n;
		}
		return s.value;
	};
	return t;
}, In = (e) => {
	let t = async (n, r, i, a) => {
		let o = i ? {
			...i,
			async: !0
		} : { async: !0 }, s = n._zod.run({
			value: r,
			issues: []
		}, o);
		if (s instanceof Promise && (s = await s), s.issues.length) {
			let n = new ((a?.Err) ?? e)(s.issues.map((e) => Qt(e, o, wn())));
			throw Tt(n, a?.callee ?? t), n;
		}
		return s.value;
	};
	return t;
}, Ln = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		async: !1
	} : { async: !1 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	if (a instanceof Promise) throw new xn();
	return a.issues.length ? Rn(e, a.issues, i) : {
		success: !0,
		data: a.value
	};
};
function Rn(e, t, n) {
	let r;
	return {
		success: !1,
		get error() {
			return r || (r = new e(t.map((e) => Qt(e, n, wn()))), t = void 0, n = void 0), r;
		},
		set error(e) {
			r = e, t = void 0, n = void 0;
		}
	};
}
var zn = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		async: !0
	} : { async: !0 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	return a instanceof Promise && (a = await a), a.issues.length ? Rn(e, a.issues, i) : {
		success: !0,
		data: a.value
	};
}, Bn = /* @__PURE__ */ Symbol.for("zod.compile.invalid"), Vn = /* @__PURE__ */ Symbol.for("zod.compile.fallback"), Hn = ((e, t, n) => {
	let r = e._zod.bag.validator;
	if (r !== void 0) {
		if (r(t) !== Bn) return !0;
		if (r.definite === !0 && n === void 0) return !1;
	}
	return Un(e, t, n);
});
function Un(e, t, n) {
	let r = n ? {
		...n,
		async: !1,
		abortEarly: !0
	} : {
		async: !1,
		abortEarly: !0
	}, i = e._zod.bag.fallbackRun, a;
	if (i ? (r[Vn] = !0, a = i({
		value: t,
		issues: []
	}, r)) : a = e._zod.run({
		value: t,
		issues: []
	}, r), a instanceof Promise) throw new xn();
	return a.issues.length === 0;
}
var Wn = async (e, t, n) => {
	let r = n ? {
		...n,
		async: !0,
		abortEarly: !0
	} : {
		async: !0,
		abortEarly: !0
	}, i = e._zod.run({
		value: t,
		issues: []
	}, r);
	return i instanceof Promise && (i = await i), i.issues.length === 0;
}, Gn = (e) => {
	let t = Fn(e), n = (e, r, i, a) => {
		let o = i ? {
			...i,
			direction: "backward"
		} : { direction: "backward" };
		return t(e, r, o, Pn(n, a));
	};
	return n;
}, Kn = (e) => {
	let t = Fn(e), n = (e, r, i, a) => t(e, r, i, Pn(n, a));
	return n;
}, qn = (e) => {
	let t = In(e), n = async (e, r, i, a) => {
		let o = i ? {
			...i,
			direction: "backward"
		} : { direction: "backward" };
		return await t(e, r, o, Pn(n, a));
	};
	return n;
}, Jn = (e) => {
	let t = In(e), n = async (e, r, i, a) => await t(e, r, i, Pn(n, a));
	return n;
}, Yn = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return Ln(e)(t, n, i);
}, Xn = (e) => (t, n, r) => Ln(e)(t, n, r), Zn = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return zn(e)(t, n, i);
}, Qn = (e) => async (t, n, r) => zn(e)(t, n, r), $n = /^[cC][0-9a-z]{6,}$/, er = /^[0-9a-z]+$/, tr = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/, nr = /^[0-9a-vA-V]{20}$/, rr = /^[A-Za-z0-9]{27}$/, ir = /^[a-zA-Z0-9_-]{21}$/;
function ar(e) {
	return RegExp(`^[a-zA-Z0-9_-]{${e}}$`);
}
var or = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, sr = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, cr = (e) => e ? RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, lr = /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, ur = "^(?=[\\s\\S]*[\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u20E3])[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$";
function dr() {
	return new RegExp(ur, "u");
}
var fr = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, pr = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, mr = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, hr = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, gr = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, _r = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2,3})?$/, vr = /^https?$/, yr = /^\+[1-9]\d{6,14}$/, br = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
function xr(e) {
	return RegExp(`^${e}$`);
}
var Sr = /*@__PURE__*/ xr(br);
function Cr(e) {
	let t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
	return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : e.seconds ? `${t}:[0-5]\\d(?:\\.\\d+)?` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function wr(e) {
	return RegExp(`^${Cr(e)}$`);
}
function Tr(e) {
	let t = ["Z"];
	e.offset && t.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
	let n = `${Cr({
		precision: e.precision,
		seconds: !0
	})}(?:${t.join("|")})`, r = e.local ? `${n}|${Cr({ precision: e.precision })}` : n;
	return RegExp(`^${br}T(?:${r})$`);
}
var Er = /^[\s\S]{0,}$/, Dr = /^-?\d+(?:\.\d+)?$/, Or = /^[^A-Z]*$/, kr = /^[^a-z]*$/, Ar = /*@__PURE__*/ L("$ZodCheck", (e, t) => {
	var n;
	e._zod ??= {}, e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), jr = (e) => {
	let t = e.value;
	return !ft(t) && t.length !== void 0;
}, Mr = {
	number: "number",
	bigint: "bigint",
	object: "date"
}, Nr = /*@__PURE__*/ L("$ZodCheckLessThan", (e, t) => {
	Ar.init(e, t);
	let n = Mr[typeof t.value];
	e._zod.check = (r) => {
		(t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
			origin: Mr[typeof r.value] ?? n,
			code: "too_big",
			maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), Pr = /*@__PURE__*/ L("$ZodCheckGreaterThan", (e, t) => {
	Ar.init(e, t);
	let n = Mr[typeof t.value];
	e._zod.check = (r) => {
		(t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
			origin: Mr[typeof r.value] ?? n,
			code: "too_small",
			minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), Fr = /*@__PURE__*/ L("$ZodCheckMultipleOf", (e, t) => {
	Ar.init(e, t), e._zod.check = (n) => {
		if (typeof n.value != typeof t.value) throw Error("Cannot mix number and bigint in multiple_of check.");
		(typeof n.value == "bigint" ? t.value !== BigInt(0) && n.value % t.value === BigInt(0) : mt(n.value, t.value) === 0) || n.issues.push({
			origin: typeof n.value,
			code: "not_multiple_of",
			divisor: t.value,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Ir = /*@__PURE__*/ L("$ZodCheckNumberFormat", (e, t) => {
	Ar.init(e, t), t.format = t.format || "float64";
	let n = t.format?.includes("int"), r = n ? "int" : "number", [i, a] = Ft[t.format];
	e._zod.check = (o) => {
		let s = o.value;
		if (n) {
			if (!Number.isInteger(s)) {
				o.issues.push({
					expected: r,
					format: t.format,
					code: "invalid_type",
					continue: !1,
					input: s,
					inst: e
				});
				return;
			}
			if (!Number.isSafeInteger(s)) {
				s > 0 ? o.issues.push({
					input: s,
					code: "too_big",
					maximum: 2 ** 53 - 1,
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				}) : o.issues.push({
					input: s,
					code: "too_small",
					minimum: -(2 ** 53 - 1),
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				});
				return;
			}
		}
		s < i && o.issues.push({
			origin: "number",
			input: s,
			code: "too_small",
			minimum: i,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		}), s > a && o.issues.push({
			origin: "number",
			input: s,
			code: "too_big",
			maximum: a,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		});
	};
}), Lr = /*@__PURE__*/ L("$ZodCheckMaxLength", (e, t) => {
	var n;
	Ar.init(e, t), (n = e._zod.def).when ?? (n.when = jr), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if ((typeof r == "string" && i > t.maximum ? en(r) : i) <= t.maximum) return;
		let a = tn(r);
		n.issues.push({
			origin: a,
			code: "too_big",
			maximum: t.maximum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), Rr = /*@__PURE__*/ L("$ZodCheckMinLength", (e, t) => {
	var n;
	Ar.init(e, t), (n = e._zod.def).when ?? (n.when = jr), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if ((typeof r == "string" && i >= t.minimum && i < t.minimum * 2 ? en(r) : i) >= t.minimum) return;
		let a = tn(r);
		n.issues.push({
			origin: a,
			code: "too_small",
			minimum: t.minimum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), zr = /*@__PURE__*/ L("$ZodCheckLengthEquals", (e, t) => {
	var n;
	Ar.init(e, t), (n = e._zod.def).when ?? (n.when = jr), e._zod.check = (n) => {
		let r = n.value, i = r.length, a = typeof r == "string" && i >= t.length && i <= t.length * 2 ? en(r) : i;
		if (a === t.length) return;
		let o = tn(r), s = a > t.length;
		n.issues.push({
			origin: o,
			...s ? {
				code: "too_big",
				maximum: t.length
			} : {
				code: "too_small",
				minimum: t.length
			},
			inclusive: !0,
			exact: !0,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Br = /*@__PURE__*/ L("$ZodCheckStringFormat", (e, t) => {
	var n, r;
	Ar.init(e, t), t.pattern ? (n = e._zod).check ?? (n.check = (n) => {
		t.pattern.lastIndex = 0, t.pattern.test(n.value) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: t.format,
			input: n.value,
			...t.pattern ? { pattern: t.pattern.toString() } : {},
			inst: e,
			continue: !t.abort
		});
	}) : (r = e._zod).check ?? (r.check = () => {});
}), Vr = /*@__PURE__*/ L("$ZodCheckRegex", (e, t) => {
	Br.init(e, t), e._zod.check = (n) => {
		t.pattern.lastIndex = 0, t.pattern.test(n.value) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "regex",
			input: n.value,
			pattern: t.pattern.toString(),
			inst: e,
			continue: !t.abort
		});
	};
}), Hr = /*@__PURE__*/ L("$ZodCheckLowerCase", (e, t) => {
	t.pattern ??= Or, Br.init(e, t);
}), Ur = /*@__PURE__*/ L("$ZodCheckUpperCase", (e, t) => {
	t.pattern ??= kr, Br.init(e, t);
}), Wr = /*@__PURE__*/ L("$ZodCheckIncludes", (e, t) => {
	Ar.init(e, t);
	let n = jt(t.includes);
	t.pattern = new RegExp(typeof t.position == "number" ? `^.{${t.position},}${n}` : n), e._zod.check = (n) => {
		n.value.includes(t.includes, t.position) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "includes",
			includes: t.includes,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Gr = /*@__PURE__*/ L("$ZodCheckStartsWith", (e, t) => {
	Ar.init(e, t);
	let n = RegExp(`^${jt(t.prefix)}.*`);
	t.pattern ??= n, e._zod.check = (n) => {
		n.value.startsWith(t.prefix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "starts_with",
			prefix: t.prefix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Kr = /*@__PURE__*/ L("$ZodCheckEndsWith", (e, t) => {
	Ar.init(e, t);
	let n = RegExp(`.*${jt(t.suffix)}$`);
	t.pattern ??= n, e._zod.check = (n) => {
		n.value.endsWith(t.suffix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "ends_with",
			suffix: t.suffix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), qr = /*@__PURE__*/ L("$ZodCheckOverwrite", (e, t) => {
	Ar.init(e, t), e._zod.check = (e) => {
		e.value = t.tx(e.value);
	};
}), Jr = class {
	constructor(e = [], t = {}) {
		this.content = [], this.indent = 0, this.args = e, this.closed = t;
	}
	indented(e) {
		this.indent += 1;
		try {
			e(this);
		} finally {
			--this.indent;
		}
	}
	write(e) {
		if (typeof e == "function") {
			e(this, { execution: "sync" }), e(this, { execution: "async" });
			return;
		}
		let t = e.split("\n").filter((e) => e), n = Math.min(...t.map((e) => e.length - e.trimStart().length)), r = t.map((e) => e.slice(n)).map((e) => " ".repeat(this.indent * 2) + e);
		for (let e of r) this.content.push(e);
	}
	compile() {
		let e = Function, t = this?.content ?? [""];
		return new e(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {\n${t.join("\n")}\n};`)(...Object.values(this.closed));
	}
}, Yr = {
	major: 4,
	minor: 6,
	patch: 7
}, Xr = /*@__PURE__*/ L("$ZodType", (e, t) => {
	var n;
	e ??= {}, e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Yr;
	let r = e._zod.def.checks, i = e._zod.traits.has("$ZodCheck") ? [e, ...r ?? []] : r?.length ? [...r] : [];
	for (let t of i) for (let n of t._zod.onattach) n(e);
	if (i.length === 0) (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
		e._zod.run = e._zod.parse;
	});
	else {
		let t = (t, n, r) => {
			if (t.memo) return t;
			let i = Kt(t), a;
			for (let o of n) {
				if (o._zod.def.when) {
					if (qt(t) || !o._zod.def.when(t)) continue;
				} else if (i) continue;
				let n = t.issues.length, s = o._zod.check(t);
				if (s instanceof Promise && r?.async === !1) throw new xn();
				if (a || s instanceof Promise) a = (a ?? Promise.resolve()).then(async () => {
					await s, t.issues.length !== n && (Zt(t.issues, n, e), i ||= Kt(t, n));
				});
				else {
					if (t.issues.length === n) continue;
					Zt(t.issues, n, e), i ||= Kt(t, n);
				}
			}
			return a ? a.then(() => t) : t;
		}, n = (n, r, a) => {
			if (Kt(n)) return n.aborted = !0, n;
			let o = t(r, i, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new xn();
				return o.then((t) => e._zod.parse(t, a));
			}
			return e._zod.parse(o, a);
		};
		e._zod.run = (r, a) => {
			if (a.skipChecks) return e._zod.parse(r, a);
			if (a.direction === "backward") {
				let t = e._zod.parse({
					value: r.value,
					issues: []
				}, {
					...a,
					skipChecks: !0
				});
				return t instanceof Promise ? t.then((e) => n(e, r, a)) : n(t, r, a);
			}
			let o = e._zod.parse(r, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new xn();
				return o.then((e) => t(e, i, a));
			}
			return t(o, i, a);
		};
	}
}, {
	get "~standard"() {
		return sn(this, "~standard", $r(this));
	},
	set "~standard"(e) {
		on(this, "~standard", e);
	}
}), Zr = (e, t) => e.issues.length ? { issues: e.issues.map((e) => Qt(e, t, wn())) } : { value: e.value };
async function Qr(e, t) {
	let n = { async: !0 };
	return Zr(await e._zod.run({
		value: t,
		issues: []
	}, n), n);
}
function $r(e) {
	return {
		validate: (t) => {
			let n = { async: !1 };
			try {
				let r = e._zod.run({
					value: t,
					issues: []
				}, n);
				if (!(r instanceof Promise)) return Zr(r, n);
			} catch {}
			return Qr(e, t);
		},
		vendor: "zod",
		version: 1
	};
}
var ei = /*@__PURE__*/ L("$ZodString", (e, t) => {
	Xr.init(e, t), e._zod.pattern = t.pattern ?? Er, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = String(n.value);
		} catch {}
		return typeof n.value == "string" || n.issues.push({
			expected: "string",
			code: "invalid_type",
			input: n.value,
			inst: e
		}), n;
	};
}), ti = /*@__PURE__*/ L("$ZodStringFormat", (e, t) => {
	Br.init(e, t), ei.init(e, t);
}), ni = /*@__PURE__*/ L("$ZodGUID", (e, t) => {
	t.pattern ??= sr, ti.init(e, t);
}), ri = /*@__PURE__*/ L("$ZodUUID", (e, t) => {
	if (t.version) {
		let e = {
			v1: 1,
			v2: 2,
			v3: 3,
			v4: 4,
			v5: 5,
			v6: 6,
			v7: 7,
			v8: 8
		}[t.version];
		if (e === void 0) throw Error(`Invalid UUID version: "${t.version}"`);
		t.pattern ??= cr(e);
	} else t.pattern ??= cr();
	ti.init(e, t);
}), ii = /*@__PURE__*/ L("$ZodEmail", (e, t) => {
	t.pattern ??= lr, ti.init(e, t);
});
function ai(e) {
	try {
		return typeof URL < "u" && typeof URL.canParse == "function" ? URL.canParse(e) : (new URL(e), !0);
	} catch {
		return !1;
	}
}
function oi(e, t) {
	return !("normalize" in t) && !("hostname" in t) && !("protocol" in t) ? ai(e) || 2 : si(e, t);
}
function si(e, t) {
	if (!t.normalize && t.protocol?.source === vr.source && !/^https?:\/\//i.test(e)) return 1;
	try {
		if (typeof URL < "u") {
			let t = URL;
			if (typeof t.parse == "function") return t.parse(e) ?? 2;
		}
		return new URL(e);
	} catch {
		return 2;
	}
}
var ci = /[\t\n\r]/g;
function li(e) {
	return e.replace(ci, "");
}
function ui(e, t) {
	return t.lastIndex = 0, t.test(e.hostname);
}
function di(e, t) {
	return t.lastIndex = 0, t.test(e.protocol.endsWith(":") ? e.protocol.slice(0, -1) : e.protocol);
}
var fi = /*@__PURE__*/ L("$ZodURL", (e, t) => {
	ti.init(e, t), e._zod.check = (n) => {
		try {
			let r = n.value.trim(), i = oi(r, t);
			if (i === 1) {
				n.issues.push({
					code: "invalid_format",
					format: "url",
					note: "Invalid URL format",
					input: n.value,
					inst: e,
					continue: !t.abort
				});
				return;
			}
			if (i === 2) {
				n.issues.push({
					code: "invalid_format",
					format: "url",
					input: n.value,
					inst: e,
					continue: !t.abort
				});
				return;
			}
			if (i === !0) {
				n.value = li(r);
				return;
			}
			t.hostname && !ui(i, t.hostname) && n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid hostname",
				pattern: t.hostname.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			}), t.protocol && !di(i, t.protocol) && n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid protocol",
				pattern: t.protocol.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			}), n.value = t.normalize ? i.href : li(r);
			return;
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "url",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), pi = /*@__PURE__*/ L("$ZodEmoji", (e, t) => {
	t.pattern ??= dr(), ti.init(e, t);
}), mi = /*@__PURE__*/ L("$ZodNanoID", (e, t) => {
	if (t.length !== void 0 && (!Number.isInteger(t.length) || t.length < 1)) throw Error(`Invalid nanoid length: ${t.length}`);
	t.pattern ??= t.length === void 0 ? ir : ar(t.length), ti.init(e, t);
}), hi = /*@__PURE__*/ L("$ZodCUID", (e, t) => {
	t.pattern ??= $n, ti.init(e, t);
}), gi = /*@__PURE__*/ L("$ZodCUID2", (e, t) => {
	t.pattern ??= er, ti.init(e, t);
}), _i = /*@__PURE__*/ L("$ZodULID", (e, t) => {
	t.pattern ??= tr, ti.init(e, t);
}), vi = /*@__PURE__*/ L("$ZodXID", (e, t) => {
	t.pattern ??= nr, ti.init(e, t);
}), yi = /*@__PURE__*/ L("$ZodKSUID", (e, t) => {
	t.pattern ??= rr, ti.init(e, t);
}), bi = /*@__PURE__*/ L("$ZodISODateTime", (e, t) => {
	t.pattern ??= Tr(t), ti.init(e, t);
}), xi = /*@__PURE__*/ L("$ZodISODate", (e, t) => {
	t.pattern ??= Sr, ti.init(e, t);
}), Si = /*@__PURE__*/ L("$ZodISOTime", (e, t) => {
	t.pattern ??= wr(t), ti.init(e, t);
}), Ci = /*@__PURE__*/ L("$ZodISODuration", (e, t) => {
	t.pattern ??= or, ti.init(e, t);
}), wi = /*@__PURE__*/ L("$ZodIPv4", (e, t) => {
	t.pattern ??= fr, ti.init(e, t);
}), Ti = /^[0-9a-fA-F:.]+$/;
function Ei(e) {
	return Ti.test(e) ? ai(`http://[${e}]`) : !1;
}
var Di = /*@__PURE__*/ L("$ZodIPv6", (e, t) => {
	t.pattern ??= pr, ti.init(e, t), e._zod.check = (n) => {
		Ei(n.value) || n.issues.push({
			code: "invalid_format",
			format: "ipv6",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Oi = /*@__PURE__*/ L("$ZodCIDRv4", (e, t) => {
	t.pattern ??= mr, ti.init(e, t);
});
function ki(e) {
	let t = e.split("/");
	if (t.length !== 2) return !1;
	let [n, r] = t;
	if (!r) return !1;
	let i = Number(r);
	return `${i}` !== r || i < 0 || i > 128 ? !1 : Ei(n);
}
var Ai = /*@__PURE__*/ L("$ZodCIDRv6", (e, t) => {
	t.pattern ??= hr, ti.init(e, t), e._zod.check = (n) => {
		ki(n.value) || n.issues.push({
			code: "invalid_format",
			format: "cidrv6",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
});
function ji(e) {
	if (e === "") return !0;
	if (/\s/.test(e) || e.length % 4 != 0) return !1;
	try {
		return atob(e), !0;
	} catch {
		return !1;
	}
}
var Mi = /^[0-9a-zA-Z+/]*={0,2}$/, Ni = /*@__PURE__*/ L("$ZodBase64", (e, t) => {
	t.pattern ??= Mi, ti.init(e, t), e._zod.check = (n) => {
		ji(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Pi = /^[A-Za-z0-9_-]*$/;
function Fi(e) {
	if (!Pi.test(e)) return !1;
	let t = e.replace(/[-_]/g, (e) => e === "-" ? "+" : "/");
	return ji(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
var Ii = /*@__PURE__*/ L("$ZodBase64URL", (e, t) => {
	t.pattern ??= Pi, ti.init(e, t), e._zod.check = (n) => {
		Fi(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64url",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Li = /*@__PURE__*/ L("$ZodE164", (e, t) => {
	t.pattern ??= yr, ti.init(e, t);
});
function Ri(e, t = null) {
	try {
		let n = e.split(".");
		if (n.length !== 3) return !1;
		let [r] = n;
		if (!r) return !1;
		let i = JSON.parse(atob(r));
		return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
	} catch {
		return !1;
	}
}
var zi = /*@__PURE__*/ L("$ZodJWT", (e, t) => {
	ti.init(e, t), e._zod.check = (n) => {
		Ri(n.value, t.alg) || n.issues.push({
			code: "invalid_format",
			format: "jwt",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Bi = /*@__PURE__*/ L("$ZodNumber", (e, t) => {
	Xr.init(e, t), e._zod.pattern = Dr, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = Number(n.value);
		} catch {}
		let i = n.value;
		if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i)) return n;
		let a = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : String(i) : void 0;
		return n.issues.push({
			expected: "number",
			code: "invalid_type",
			input: i,
			inst: e,
			...a ? { received: a } : {}
		}), n;
	};
}), Vi = /*@__PURE__*/ L("$ZodNumberFormat", (e, t) => {
	Ir.init(e, t), Bi.init(e, t);
}), Hi = /*@__PURE__*/ L("$ZodUnknown", (e, t) => {
	Xr.init(e, t), e._zod.parse = (e) => e;
}), Ui = /*@__PURE__*/ L("$ZodNever", (e, t) => {
	Xr.init(e, t), e._zod.parse = (t, n) => (t.issues.push({
		expected: "never",
		code: "invalid_type",
		input: t.value,
		inst: e
	}), t);
});
function Wi(e, t) {
	let n = Xt(e._zod.def.checks);
	if (!n.length) return;
	let r = Math.min(...n.map((e) => e[0])), i = e._zod.parse;
	e._zod.parse = (n, a) => {
		let o = t(n.value);
		if (o > r && !a?.skipChecks && a?.direction !== "backward") {
			for (let [t, r] of Xt(e._zod.def.checks)) if (o > t && r._zod.def.when(n)) {
				let t = n.issues.length;
				return r._zod.check(n), n.issues[t].continue = !1, Zt(n.issues, t, e), n;
			}
		}
		return i(n, a);
	};
}
var Gi = (e) => Array.isArray(e) ? e.length : -1;
function Ki(e, t, n) {
	e.issues.length && t.issues.push(...Jt(n, e.issues)), t.value[n] = e.value;
}
var qi = /*@__PURE__*/ L("$ZodArray", (e, t) => {
	Xr.init(e, t);
	let n = Cn.memoizer;
	n?.attach(e), e._zod.parse = (r, i) => {
		let a = r.value;
		if (!Array.isArray(a)) return r.issues.push({
			expected: "array",
			code: "invalid_type",
			input: a,
			inst: e
		}), r;
		r.value = n ? n.alloc(e, r, Array(a.length), i) : Array(a.length);
		let o = [], s = i?.abortEarly;
		for (let e = 0; e < a.length; e++) {
			let n = a[e], c = t.element._zod.run({
				value: n,
				issues: []
			}, i);
			if (c instanceof Promise) o.push(c.then((t) => Ki(t, r, e)));
			else if (Ki(c, r, e), s && c.issues.length !== 0 && Kt(c)) break;
		}
		return o.length ? Promise.all(o).then(() => r) : r;
	}, Wi(e, Gi);
});
function Ji(e, t, n, r, i, a) {
	let o = n in r, s = a === "optional";
	if (o || !s || i !== "optional") {
		if (e.issues.length) {
			if (i !== void 0 && s && !o) return;
			t.issues.push(...Jt(n, e.issues));
		}
		!o && i === void 0 ? e.issues.length || t.issues.push({
			code: "invalid_type",
			expected: "nonoptional",
			input: void 0,
			path: [n]
		}) : e.value === void 0 ? (o || i === "defaulted" && !s) && (t.value[n] = void 0) : t.value[n] = e.value;
	}
}
var Yi = [];
function Xi(e) {
	let t = Object.keys(e.shape), n = Object.getOwnPropertySymbols(e.shape), r = n.length ? n : Yi, i = r.length ? [...t, ...r] : t;
	for (let t of i) if (!e.shape?.[t]?._zod?.traits?.has("$ZodType")) throw Error(`Invalid element at key "${String(t)}": expected a Zod schema`);
	let a = Pt(e.shape);
	return {
		...e,
		allKeys: i,
		symbolKeys: r,
		keySet: new Set(t),
		numKeys: t.length,
		optionalKeys: new Set(a)
	};
}
function Zi(e, t, n, r, i, a, o) {
	let s = [], c = i.keySet, l = i.catchall._zod, u = l.def.type, d = l.optin, f = l.optout, p = 0;
	for (let i in t) {
		if (o && n.issues.length !== p) {
			if (Kt(n, p)) break;
			p = n.issues.length;
		}
		if (c.has(i)) continue;
		if (i === "__proto__") {
			u === "never" && s.push(i);
			continue;
		}
		if (u === "never") {
			s.push(i);
			continue;
		}
		let a = l.run({
			value: t[i],
			issues: []
		}, r);
		a instanceof Promise ? e.push(a.then((e) => Ji(e, n, i, t, d, f))) : Ji(a, n, i, t, d, f);
	}
	return s.length && n.issues.push({
		code: "unrecognized_keys",
		keys: s,
		input: t,
		inst: a,
		continue: !0
	}), e.length ? Promise.all(e).then(() => n) : n;
}
var Qi = /*@__PURE__*/ L("$ZodObject", (e, t) => {
	Xr.init(e, t);
	let n = Object.getOwnPropertyDescriptor(t, "shape"), r = n?.get ? n.get.raw : t.shape ?? {};
	if (r) {
		let e = () => {
			let n = { ...r };
			return Object.defineProperty(t, "shape", { value: n }), e.raw = n, n;
		};
		e.raw = r, Object.defineProperty(t, "shape", { get: e });
	}
	let i = dt(() => Xi(t));
	I(e, "propValues", (e) => {
		let t = e.def.shape, n = {};
		for (let e in t) {
			let r = t[e]._zod;
			if (r.values) {
				Object.prototype.hasOwnProperty.call(n, e) || ht(n, e, /* @__PURE__ */ new Set());
				for (let t of r.values) n[e].add(t);
				r.optin !== void 0 && n[e].add(void 0);
			}
		}
		return n;
	});
	let a = Et, o = t.catchall, s, c = Cn.memoizer;
	c?.attach(e), e._zod.parse = (t, n) => {
		s ??= i.value;
		let r = t.value;
		if (!a(r)) return t.issues.push({
			expected: "object",
			code: "invalid_type",
			input: r,
			inst: e
		}), t;
		t.value = c ? c.alloc(e, t, {}, n) : {};
		let l = [], u = s.shape, d = n?.abortEarly, f = t.issues.length;
		for (let e of s.allKeys) {
			if (d && t.issues.length !== f) {
				if (Kt(t, f)) break;
				f = t.issues.length;
			}
			if (e === "__proto__") continue;
			let i = u[e], a = i._zod.optin, o = i._zod.optout, s = i._zod.run({
				value: r[e],
				issues: []
			}, n);
			s instanceof Promise ? l.push(s.then((n) => Ji(n, t, e, r, a, o))) : Ji(s, t, e, r, a, o);
		}
		return o ? Zi(l, r, t, n, i.value, e, d === !0) : l.length ? Promise.all(l).then(() => t) : t;
	};
}), $i = /*@__PURE__*/ L("$ZodObjectJIT", (e, t) => {
	Qi.init(e, t);
	let n = e._zod.parse, r = dt(() => Xi(t)), i = Cn.memoizer, a = (t) => {
		let n = r.value, a = n.symbolKeys, o = new Jr(["payload", "ctx"], {
			shape: t,
			inst: e,
			memo: i,
			syms: a
		}), s = (e) => `shape[${e}]._zod.run({ value: input[${e}], issues: [] }, ctx)`, c = (e, t) => `
          let ${e}_ab = false;
          for (let i = 0; i < ${e}.issues.length; i++) {
            const iss = ${e}.issues[i];
            iss.path = iss.path ? [${t}, ...iss.path] : [${t}];
            payload.issues.push(iss);
            if (iss.continue !== true) ${e}_ab = true;
          }
          if (${e}_ab && ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }`;
		o.write("const input = payload.value;");
		let l = Object.create(null), u = 0;
		for (let e of n.allKeys) l[e] = `key_${u++}`;
		o.write(i ? "const newResult = memo.alloc(inst, payload, {}, ctx);" : "const newResult = {};");
		for (let e of n.allKeys) {
			if (e === "__proto__") continue;
			let n = l[e], r = typeof e == "symbol" ? `syms[${a.indexOf(e)}]` : Ct(e), i = `${r} in input`, u = t[e], d = u?._zod?.optin, f = d !== void 0, p = u?._zod?.optout === "optional";
			if (o.write(`const ${n} = ${s(r)};`), f && p) {
				let e = d === "optional" ? `${n}_present` : `${n}.value !== undefined || ${n}_present`;
				o.write(`
        const ${n}_present = ${i};
        if (!${n}.issues.length || ${n}_present) {
          if (${n}.issues.length) {${c(n, r)}
          }

          if (${e}) {
            newResult[${r}] = ${n}.value;
          }
        }

      `);
			} else f ? (o.write(`
        if (${n}.issues.length) {${c(n, r)}
        }
      `), d === "defaulted" ? o.write(`newResult[${r}] = ${n}.value;`) : o.write(`
        if (${n}.value !== undefined || ${i}) {
          newResult[${r}] = ${n}.value;
        }
      `)) : o.write(`
        const ${n}_present = ${i};
        if (${n}.issues.length) {${c(n, r)}
        }
        if (!${n}_present && !${n}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${r}]
          });
          if (ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }
        }

        if (${n}_present) {
          newResult[${r}] = ${n}.value;
        }

      `);
		}
		return o.write("payload.value = newResult;"), o.write("return payload;"), o.compile();
	}, o, s = Et, c = !Cn.jitless, l = c && Dt.value, u = t.catchall, d;
	e._zod.parse = (i, f) => {
		d ??= r.value;
		let p = i.value;
		return s(p) ? c && l && f?.async === !1 && f.jitless !== !0 ? (o ||= a(t.shape), i = o(i, f), u ? Zi([], p, i, f, d, e, f?.abortEarly === !0) : i) : n(i, f) : (i.issues.push({
			expected: "object",
			code: "invalid_type",
			input: p,
			inst: e
		}), i);
	};
});
function ea(e, t, n, r) {
	for (let n of e) if (n.issues.length === 0) return t.value = n.value, t;
	let i = e.filter((e) => !Kt(e));
	return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
		code: "invalid_union",
		input: t.value,
		inst: n,
		errors: e.map((e) => e.issues.map((e) => Qt(e, r, wn())))
	}), t);
}
var ta = /*@__PURE__*/ L("$ZodUnion", (e, t) => {
	Xr.init(e, t), I(e, "optin", (e) => e.def.options.some((e) => e._zod.optin === "defaulted") ? "defaulted" : e.def.options.some((e) => e._zod.optin !== void 0) ? "optional" : void 0), I(e, "optout", (e) => e.def.options.some((e) => e._zod.optout === "optional") ? "optional" : void 0), I(e, "values", (e) => {
		if (e.def.options.every((e) => e._zod.values)) return new Set(e.def.options.flatMap((e) => Array.from(e._zod.values)));
	}), I(e, "pattern", (e) => {
		if (e.def.options.every((e) => e._zod.pattern)) {
			let t = e.def.options.map((e) => e._zod.pattern);
			return RegExp(`^(${t.map((e) => pt(e.source)).join("|")})$`);
		}
	});
	let n = t.options.length === 1 ? t.options[0]._zod.run : null;
	e._zod.parse = (r, i) => {
		if (n) return n(r, i);
		let a = !1, o = [];
		for (let e of t.options) {
			let t = e._zod.run({
				value: r.value,
				issues: []
			}, i);
			if (t instanceof Promise) o.push(t), a = !0;
			else {
				if (t.issues.length === 0) return t;
				o.push(t);
			}
		}
		return a ? Promise.all(o).then((t) => ea(t, r, e, i)) : ea(o, r, e, i);
	};
}), na = /*@__PURE__*/ L("$ZodIntersection", (e, t) => {
	Xr.init(e, t), e._zod.parse = (e, n) => {
		let r = e.value, i = t.left._zod.run({
			value: r,
			issues: []
		}, n), a = t.right._zod.run({
			value: r,
			issues: []
		}, n);
		return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([t, n]) => ia(e, t, n)) : ia(e, i, a);
	};
});
function ra(e, t) {
	if (e === t || e instanceof Date && t instanceof Date && +e == +t) return {
		valid: !0,
		data: e
	};
	if (Ot(e) && Ot(t)) {
		let n = Object.keys(t), r = Object.keys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		Object.prototype.hasOwnProperty.call(i, "__proto__") && delete i.__proto__;
		for (let n of r) {
			if (n === "__proto__") continue;
			let r = ra(e[n], t[n]);
			if (!r.valid) return {
				valid: !1,
				mergeErrorPath: [n, ...r.mergeErrorPath]
			};
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (Array.isArray(e) && Array.isArray(t)) {
		if (e.length !== t.length) return {
			valid: !1,
			mergeErrorPath: []
		};
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = ra(i, a);
			if (!o.valid) return {
				valid: !1,
				mergeErrorPath: [r, ...o.mergeErrorPath]
			};
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return {
		valid: !1,
		mergeErrorPath: []
	};
}
function ia(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i, a = /* @__PURE__ */ new Map(), o = (e, t) => {
		let n;
		if (e.code === "unrecognized_keys" && !e.path?.length) i ??= e, n = e.keys;
		else if (e.code === "invalid_key" && e.origin === "record" && e.path?.length === 1) {
			let t = String(e.path[0]);
			a.has(t) || a.set(t, e), n = [t];
		} else return !1;
		for (let e of n) r.has(e) || r.set(e, {}), r.get(e)[t] = !0;
		return !0;
	};
	for (let n of t.issues) o(n, "l") || e.issues.push(n);
	for (let t of n.issues) o(t, "r") || e.issues.push(t);
	let s = [...r].filter(([, e]) => e.l && e.r).map(([e]) => e);
	if (s.length) {
		let t = i ? s.filter((e) => i.keys.includes(e)) : [];
		t.length && e.issues.push({
			...i,
			keys: t
		});
		for (let n of s) !t.includes(n) && a.has(n) && e.issues.push(a.get(n));
	}
	let c = ra(t.value, n.value);
	if (!c.valid) {
		if (Kt(e)) return e;
		throw Error(`Unmergable intersection. Error path: ${JSON.stringify(c.mergeErrorPath)}`);
	}
	return e.value = c.data, e;
}
var aa = /*@__PURE__*/ L("$ZodEnum", (e, t) => {
	Xr.init(e, t);
	let n = st(t.entries), r = new Set(n);
	e._zod.values = r, I(e, "pattern", (e) => {
		let t = st(e.def.entries).filter((e) => At.has(typeof e));
		return RegExp(t.length ? `^(${t.map((e) => jt(e.toString())).join("|")})$` : "^[^\\s\\S]$");
	}), e._zod.parse = (t, i) => {
		let a = t.value;
		return r.has(a) || t.issues.push({
			code: "invalid_value",
			values: n,
			input: a,
			inst: e
		}), t;
	};
}), oa = /*@__PURE__*/ L("$ZodTransform", (e, t) => {
	Xr.init(e, t), e._zod.optin = "optional", Cn.memoizer?.guard(e), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new Sn(e.constructor.name);
		let i = t.transform(n.value, n);
		if (r.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((e) => (n.value = e, n));
		if (i instanceof Promise) throw new xn();
		return n.value = i, n;
	};
});
function sa(e, t) {
	return e.value = t.issues.length ? void 0 : t.value, e;
}
var ca = /*@__PURE__*/ L("$ZodOptional", (e, t) => {
	Xr.init(e, t), I(e, "optin", (e) => e.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), e._zod.optout = "optional", I(e, "values", (e) => {
		let t = e.def.innerType._zod.values;
		return t ? /* @__PURE__ */ new Set([...t, void 0]) : void 0;
	}), I(e, "pattern", (e) => {
		let t = e.def.innerType._zod.pattern;
		return t ? RegExp(`^(${pt(t.source)})?$`) : void 0;
	}), e._zod.parse = (e, n) => {
		if (e.value === void 0) {
			if (t.innerType._zod.optin !== "defaulted") return e;
			let r = t.innerType._zod.run({
				value: e.value,
				issues: []
			}, n);
			return r instanceof Promise ? r.then((t) => sa(e, t)) : sa(e, r);
		}
		return t.innerType._zod.run(e, n);
	};
}), la = /*@__PURE__*/ L("$ZodExactOptional", (e, t) => {
	ca.init(e, t), I(e, "values", (e) => e.def.innerType._zod.values), I(e, "pattern", (e) => e.def.innerType._zod.pattern), e._zod.parse = (e, n) => t.innerType._zod.run(e, n);
}), ua = /*@__PURE__*/ L("$ZodNullable", (e, t) => {
	Xr.init(e, t), I(e, "optin", (e) => e.def.innerType._zod.optin), I(e, "optout", (e) => e.def.innerType._zod.optout), I(e, "pattern", (e) => {
		let t = e.def.innerType._zod.pattern;
		return t ? RegExp(`^(${pt(t.source)}|null)$`) : void 0;
	}), I(e, "values", (e) => e.def.innerType._zod.values ? /* @__PURE__ */ new Set([...e.def.innerType._zod.values, null]) : void 0), e._zod.parse = (e, n) => e.value === null ? e : t.innerType._zod.run(e, n);
}), da = /*@__PURE__*/ L("$ZodDefault", (e, t) => {
	Xr.init(e, t), e._zod.optin = "defaulted", I(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		if (e.value === void 0) return e.value = t.defaultValue, e;
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => fa(e, t)) : fa(r, t);
	};
});
function fa(e, t) {
	return e.value === void 0 && (e.value = t.defaultValue), e;
}
var pa = /*@__PURE__*/ L("$ZodPrefault", (e, t) => {
	Xr.init(e, t), e._zod.optin = "defaulted", I(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => (n.direction === "backward" || e.value === void 0 && (e.value = t.defaultValue), t.innerType._zod.run(e, n));
}), ma = /*@__PURE__*/ L("$ZodNonOptional", (e, t) => {
	Xr.init(e, t), I(e, "values", (e) => {
		let t = e.def.innerType._zod.values;
		return t ? new Set([...t].filter((e) => e !== void 0)) : void 0;
	}), e._zod.parse = (n, r) => {
		let i = t.innerType._zod.run(n, r);
		return i instanceof Promise ? i.then((t) => ha(t, e)) : ha(i, e);
	};
});
function ha(e, t) {
	return !e.issues.length && e.value === void 0 && e.issues.push({
		code: "invalid_type",
		expected: "nonoptional",
		input: e.value,
		inst: t
	}), e;
}
function ga(e, t, n, r) {
	return t.issues.length ? (e.value = n.catchValue({
		...t,
		value: e.value,
		error: { issues: t.issues.map((e) => Qt(e, r, wn())) },
		input: e.value
	}), e) : (e.value = t.value, t.memo && (e.memo = !0), e);
}
var _a = /*@__PURE__*/ L("$ZodCatch", (e, t) => {
	Xr.init(e, t), I(e, "optin", (e) => e.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), I(e, "optout", (e) => e.def.innerType._zod.optout), I(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run({
			value: e.value,
			issues: []
		}, n);
		return r instanceof Promise ? r.then((r) => ga(e, r, t, n)) : ga(e, r, t, n);
	};
}), va = /*@__PURE__*/ L("$ZodPipe", (e, t) => {
	Xr.init(e, t), I(e, "values", (e) => e.def.in._zod.values), I(e, "optin", (e) => e.def.in._zod.optin), I(e, "optout", (e) => e.def.out._zod.optout), I(e, "propValues", (e) => e.def.in._zod.propValues), e._zod.parse = (e, n) => {
		if (n.direction === "backward") {
			let r = t.out._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => ya(e, t.in, n)) : ya(r, t.in, n);
		}
		let r = t.in._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => ya(e, t.out, n)) : ya(r, t.out, n);
	};
});
function ya(e, t, n) {
	return e.issues.some((e) => e.code !== "unrecognized_keys") ? (e.aborted = !0, e) : t._zod.run({
		value: e.value,
		issues: e.issues
	}, n);
}
var ba = /*@__PURE__*/ L("$ZodReadonly", (e, t) => {
	Xr.init(e, t), I(e, "propValues", (e) => e.def.innerType._zod.propValues), I(e, "values", (e) => e.def.innerType._zod.values), I(e, "optin", (e) => e.def.innerType?._zod?.optin), I(e, "optout", (e) => e.def.innerType?._zod?.optout), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then(xa) : xa(r);
	};
});
function xa(e) {
	return e.memo || (e.value = Object.freeze(e.value)), e;
}
var Sa = /*@__PURE__*/ L("$ZodCustom", (e, t) => {
	Ar.init(e, t), Xr.init(e, t), e._zod.parse = (e, t) => e, e._zod.check = (n) => {
		let r = n.value, i = t.fn(r);
		if (i instanceof Promise) return i.then((t) => Ca(t, n, r, e));
		Ca(i, n, r, e);
	};
});
function Ca(e, t, n, r) {
	if (!e) {
		let e = {
			code: "custom",
			input: n,
			inst: r,
			path: [...r._zod.def.path ?? []],
			continue: !r._zod.def.abort
		};
		r._zod.def.params && (e.params = r._zod.def.params), t.issues.push(rn(e));
	}
}
// ../../../node_modules/zod/v4/core/memoizer.js
var wa = class extends Error {
	constructor() {
		super("Cannot parse a reference cycle that closes through a transform"), this.name = "ZodCyclicError";
	}
}, Ta = "~memo", Ea = [];
function Da(e) {
	return typeof e == "object" && !!e;
}
function Oa(e) {
	return e.map((e) => e.path ? {
		...e,
		path: e.path.slice()
	} : { ...e });
}
var ka = /*@__PURE__*/ new WeakMap(), Aa = 0, ja = 1, Ma = 2;
function Na(e, t, n) {
	let r = ka.get(e);
	if (r !== void 0) return r ? Ma : Aa;
	if (t.has(e)) return Ma;
	t.add(e);
	let i = Aa, a = (e) => {
		if (i !== Ma && e?._zod) {
			let r = Na(e, t, n);
			r > i && (i = r);
		}
	}, o = (e, r) => {
		let i = Aa;
		for (let a of Reflect.ownKeys(e)) {
			let o = Object.getOwnPropertyDescriptor(e, a);
			if (r && !o.enumerable) continue;
			let s = o.get ? ja : o.value?._zod ? Na(o.value, t, n) : Aa;
			s > i && (i = s);
		}
		return i;
	}, s = (e) => {
		e > i && (i = e);
	}, c = e._zod.def;
	switch (c.type) {
		case "object": {
			let e = gt(c);
			s(e ? o(e, !0) : ja), a(c.catchall);
			break;
		}
		case "array":
			a(c.element);
			break;
		case "tuple":
			for (let e of c.items) a(e);
			a(c.rest);
			break;
		case "record":
		case "map":
			a(c.keyType), a(c.valueType);
			break;
		case "set":
			a(c.valueType);
			break;
		case "union":
			for (let e of c.options) a(e);
			break;
		case "intersection":
			a(c.left), a(c.right);
			break;
		case "optional":
		case "nullable":
		case "default":
		case "prefault":
		case "catch":
		case "readonly":
		case "nonoptional":
		case "promise":
		case "success":
			a(c.innerType);
			break;
		case "pipe":
			a(c.in), a(c.out);
			break;
		case "function":
			a(c.input), a(c.output);
			break;
		case "lazy": {
			let r = c._cachedInner ?? (n ? e._zod.innerType : void 0);
			s(r ? Na(r, t, !1) : ja);
			break;
		}
		case "template_literal":
		case "string":
		case "number":
		case "int":
		case "boolean":
		case "bigint":
		case "symbol":
		case "undefined":
		case "null":
		case "void":
		case "never":
		case "any":
		case "unknown":
		case "date":
		case "nan":
		case "enum":
		case "literal":
		case "file":
		case "transform":
		case "custom": break;
		default: for (let e in c) {
			let t = Object.getOwnPropertyDescriptor(c, e);
			if (!t || t.get) continue;
			let n = t.value;
			if (n && typeof n == "object") {
				if (n._zod) a(n);
				else if (Array.isArray(n)) for (let e of n) a(e);
			}
		}
	}
	return t.delete(e), Pa(e, i);
}
function Pa(e, t) {
	return t !== ja && ka.set(e, t === Ma), t;
}
function Fa(e, t) {
	let n = e.buckets.get(t);
	return n || (n = /* @__PURE__ */ new WeakMap(), e.buckets.set(t, n)), n;
}
var Ia, La = [], Ra = {
	alloc(e, t, n) {
		let r = Ia;
		if (!r) return n;
		Ia = void 0;
		let i = {
			value: n,
			issues: null
		};
		return r.set(t.value, i), La.push(i), n;
	},
	guard(e) {
		var t;
		(t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
			let t = e._zod.parse, n = (e, n) => {
				if (n.direction !== "backward" && Ba(n, e.value)) throw new wa();
				return t(e, n);
			};
			e._zod.parse = n, e._zod.run === t && (e._zod.run = n);
		});
	},
	attach(e) {
		var t;
		let n, r = !1, i, a;
		(t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
			let t = e._zod.parse, o = (s, c) => {
				if (n === void 0) {
					let i = Na(e, /* @__PURE__ */ new Set(), !1);
					if (i === Aa) return e._zod.parse = t, e._zod.run === o && (e._zod.run = t), t(s, c);
					i === Ma || r ? n = !0 : r = !0;
				}
				let l = s.value;
				if (!Da(l)) return t(s, c);
				let u = c[Ta];
				u || (u = {
					buckets: /* @__PURE__ */ new WeakMap(),
					backEdges: void 0
				}, c[Ta] = u);
				let d;
				i === c ? d = a : (d = Fa(u, e), i = c, a = d);
				let f = d.get(l);
				if (f) return s.value = f.value, f.issues ? f.issues.length && s.issues.push(...Oa(f.issues)) : (s.memo = !0, u.backEdges ?? (u.backEdges = /* @__PURE__ */ new WeakSet()), u.backEdges.add(f.value)), s;
				Ia = d;
				let p = La.length, m = t(s, c);
				Ia = void 0;
				let h = La.length > p ? La.pop() : void 0;
				return m instanceof Promise ? m.then((e) => (h && (h.issues = e.issues.length ? Oa(e.issues) : Ea), e)) : (h && (h.issues = m.issues.length ? Oa(m.issues) : Ea), m);
			};
			e._zod.parse = o, e._zod.run === t && (e._zod.run = o);
		});
	}
};
function za() {
	return Ra;
}
function Ba(e, t) {
	let n = e[Ta]?.backEdges;
	return n !== void 0 && Da(t) && n.has(t);
}
// ../../../node_modules/zod/v4/locales/en.js
var Va = () => {
	let e = {
		string: {
			unit: "characters",
			verb: "to have"
		},
		file: {
			unit: "bytes",
			verb: "to have"
		},
		array: {
			unit: "items",
			verb: "to have"
		},
		set: {
			unit: "items",
			verb: "to have"
		},
		map: {
			unit: "entries",
			verb: "to have"
		}
	};
	function t(t) {
		return e[t] ?? null;
	}
	let n = {
		regex: "input",
		email: "email address",
		url: "URL",
		emoji: "emoji",
		uuid: "UUID",
		uuidv4: "UUIDv4",
		uuidv6: "UUIDv6",
		nanoid: "nanoid",
		guid: "GUID",
		cuid: "cuid",
		cuid2: "cuid2",
		ulid: "ULID",
		xid: "XID",
		ksuid: "KSUID",
		datetime: "ISO datetime",
		date: "ISO date",
		time: "ISO time",
		duration: "ISO duration",
		ipv4: "IPv4 address",
		ipv6: "IPv6 address",
		mac: "MAC address",
		cidrv4: "IPv4 range",
		cidrv6: "IPv6 range",
		base64: "base64-encoded string",
		base64url: "base64url-encoded string",
		json_string: "JSON string",
		e164: "E.164 number",
		currency_code: "currency code",
		credit_card: "credit card number",
		iban: "IBAN",
		jwt: "JWT",
		template_literal: "input"
	}, r = { nan: "NaN" };
	function i(e, t) {
		return e === "number" && typeof t == "number" && !Number.isFinite(t) ? String(t) : r[e] ?? e;
	}
	return (e) => {
		switch (e.code) {
			case "invalid_type": return `Invalid input: expected ${i(e.expected)}, received ${i(nn(e.input), e.input)}`;
			case "invalid_value": return e.values.length === 1 ? `Invalid input: expected ${Nt(e.values[0])}` : `Invalid option: expected one of ${ct(e.values, "|")}`;
			case "too_big": {
				let n = e.exact ? "exactly " : e.inclusive ? "<=" : "<", r = t(e.origin);
				return r ? `Too big: expected ${e.origin ?? "value"} to have ${n}${e.maximum.toString()} ${r.unit ?? "elements"}` : `Too big: expected ${e.origin ?? "value"} to be ${n}${e.maximum.toString()}`;
			}
			case "too_small": {
				let n = e.exact ? "exactly " : e.inclusive ? ">=" : ">", r = t(e.origin);
				return r ? `Too small: expected ${e.origin} to have ${n}${e.minimum.toString()} ${r.unit}` : `Too small: expected ${e.origin} to be ${n}${e.minimum.toString()}`;
			}
			case "invalid_format": {
				let t = e;
				return t.format === "starts_with" ? `Invalid string: must start with "${t.prefix}"` : t.format === "ends_with" ? `Invalid string: must end with "${t.suffix}"` : t.format === "includes" ? `Invalid string: must include "${t.includes}"` : t.format === "regex" ? `Invalid string: must match pattern ${t.pattern}` : `Invalid ${n[t.format] ?? e.format}`;
			}
			case "not_multiple_of": return `Invalid number: must be a multiple of ${e.divisor}`;
			case "unrecognized_keys": return `Unrecognized key${e.keys.length > 1 ? "s" : ""}: ${ct(e.keys, ", ")}`;
			case "invalid_key": return `Invalid key in ${e.origin}`;
			case "invalid_union": return e.options && Array.isArray(e.options) && e.options.length > 0 ? `Invalid discriminator value. Expected ${e.options.map((e) => `'${e}'`).join(" | ")}` : e.inclusive === !1 ? "Invalid input: more than one option matched" : "Invalid input";
			case "invalid_element": return `Invalid value in ${e.origin}`;
			default: return "Invalid input";
		}
	};
};
function Ha() {
	return { localeError: Va() };
}
// ../../../node_modules/zod/v4/core/registries.js
var Ua, Wa = class {
	constructor() {
		this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
	}
	add(e, ...t) {
		let n = t[0];
		return this._map.set(e, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, e), this;
	}
	clear() {
		return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
	}
	remove(e) {
		let t = this._map.get(e);
		return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
	}
	get(e) {
		let t = e._zod.parent;
		if (t) {
			let n = { ...this.get(t) ?? {} };
			delete n.id;
			let r = {
				...n,
				...this._map.get(e)
			};
			return Object.keys(r).length ? r : void 0;
		}
		return this._map.get(e);
	}
	has(e) {
		return this._map.has(e);
	}
};
function Ga() {
	return new Wa();
}
(Ua = globalThis).__zod_globalRegistry ?? (Ua.__zod_globalRegistry = Ga());
var Ka = globalThis.__zod_globalRegistry;
// ../../../node_modules/zod/v4/core/api.js
function qa(e) {
	return e.checks &&= [...e.checks], e;
}
// @__NO_SIDE_EFFECTS__
function Ja(e, t) {
	return new e(qa({
		type: "string",
		...F(t)
	}));
}
// @__NO_SIDE_EFFECTS__
function Ya(e, t) {
	return new e({
		type: "string",
		format: "email",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Xa(e, t) {
	return new e({
		type: "string",
		format: "guid",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Za(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Qa(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v4",
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function $a(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v6",
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function eo(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v7",
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function to(e, t) {
	return new e({
		type: "string",
		format: "url",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function no(e, t) {
	return new e({
		type: "string",
		format: "emoji",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ro(e, t) {
	return new e({
		type: "string",
		format: "nanoid",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function io(e, t) {
	return new e({
		type: "string",
		format: "cuid",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ao(e, t) {
	return new e({
		type: "string",
		format: "cuid2",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function oo(e, t) {
	return new e({
		type: "string",
		format: "ulid",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function so(e, t) {
	return new e({
		type: "string",
		format: "xid",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function co(e, t) {
	return new e({
		type: "string",
		format: "ksuid",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function lo(e, t) {
	return new e({
		type: "string",
		format: "ipv4",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function uo(e, t) {
	return new e({
		type: "string",
		format: "ipv6",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function fo(e, t) {
	return new e({
		type: "string",
		format: "cidrv4",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function po(e, t) {
	return new e({
		type: "string",
		format: "cidrv6",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function mo(e, t) {
	return new e({
		type: "string",
		format: "base64",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ho(e, t) {
	return new e({
		type: "string",
		format: "base64url",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function go(e, t) {
	return new e({
		type: "string",
		format: "e164",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function _o(e, t) {
	return new e({
		type: "string",
		format: "jwt",
		check: "string_format",
		abort: !1,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function vo(e, t) {
	return new e({
		type: "string",
		format: "datetime",
		check: "string_format",
		offset: !1,
		local: !1,
		precision: null,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function yo(e, t) {
	return new e({
		type: "string",
		format: "date",
		check: "string_format",
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function bo(e, t) {
	return new e({
		type: "string",
		format: "time",
		check: "string_format",
		precision: null,
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function xo(e, t) {
	return new e({
		type: "string",
		format: "duration",
		check: "string_format",
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function So(e, t) {
	return new e(qa({
		type: "number",
		checks: [],
		...F(t)
	}));
}
// @__NO_SIDE_EFFECTS__
function Co(e, t) {
	return new e({
		type: "number",
		check: "number_format",
		abort: !1,
		format: "safeint",
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function wo(e) {
	return new e({ type: "unknown" });
}
// @__NO_SIDE_EFFECTS__
function To(e, t) {
	return new e({
		type: "never",
		...F(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Eo(e, t) {
	return new Nr({
		check: "less_than",
		...F(t),
		value: e,
		inclusive: !1
	});
}
// @__NO_SIDE_EFFECTS__
function Do(e, t) {
	return new Nr({
		check: "less_than",
		...F(t),
		value: e,
		inclusive: !0
	});
}
// @__NO_SIDE_EFFECTS__
function Oo(e, t) {
	return new Pr({
		check: "greater_than",
		...F(t),
		value: e,
		inclusive: !1
	});
}
// @__NO_SIDE_EFFECTS__
function ko(e, t) {
	return new Pr({
		check: "greater_than",
		...F(t),
		value: e,
		inclusive: !0
	});
}
// @__NO_SIDE_EFFECTS__
function Ao(e, t) {
	return new Fr({
		check: "multiple_of",
		...F(t),
		value: e
	});
}
// @__NO_SIDE_EFFECTS__
function jo(e, t) {
	return new Lr({
		check: "max_length",
		...F(t),
		maximum: e
	});
}
// @__NO_SIDE_EFFECTS__
function Mo(e, t) {
	return new Rr({
		check: "min_length",
		...F(t),
		minimum: e
	});
}
// @__NO_SIDE_EFFECTS__
function No(e, t) {
	return new zr({
		check: "length_equals",
		...F(t),
		length: e
	});
}
// @__NO_SIDE_EFFECTS__
function Po(e, t) {
	return new Vr({
		check: "string_format",
		format: "regex",
		...F(t),
		pattern: e
	});
}
// @__NO_SIDE_EFFECTS__
function Fo(e) {
	return new Hr({
		check: "string_format",
		format: "lowercase",
		...F(e)
	});
}
// @__NO_SIDE_EFFECTS__
function Io(e) {
	return new Ur({
		check: "string_format",
		format: "uppercase",
		...F(e)
	});
}
// @__NO_SIDE_EFFECTS__
function Lo(e, t) {
	return new Wr({
		check: "string_format",
		format: "includes",
		...F(t),
		includes: e
	});
}
// @__NO_SIDE_EFFECTS__
function Ro(e, t) {
	return new Gr({
		check: "string_format",
		format: "starts_with",
		...F(t),
		prefix: e
	});
}
// @__NO_SIDE_EFFECTS__
function zo(e, t) {
	return new Kr({
		check: "string_format",
		format: "ends_with",
		...F(t),
		suffix: e
	});
}
// @__NO_SIDE_EFFECTS__
function Bo(e) {
	return new qr({
		check: "overwrite",
		tx: e
	});
}
// @__NO_SIDE_EFFECTS__
function Vo(e) {
	return /* @__PURE__ */ Bo((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function Ho() {
	return /* @__PURE__ */ Bo((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function Uo() {
	return /* @__PURE__ */ Bo((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Wo() {
	return /* @__PURE__ */ Bo((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Go() {
	return /* @__PURE__ */ Bo((e) => wt(e));
}
// @__NO_SIDE_EFFECTS__
function Ko(e, t, n) {
	return new e({
		type: "array",
		element: t,
		...F(n)
	});
}
// @__NO_SIDE_EFFECTS__
function qo(e, t, n) {
	return new e({
		type: "custom",
		check: "custom",
		fn: t,
		...F(n)
	});
}
// @__NO_SIDE_EFFECTS__
function Jo(e, t) {
	let n = /* @__PURE__ */ Yo((t) => (t.addIssue = (e) => {
		if (typeof e == "string") t.issues.push(rn(e, t.value, n._zod.def));
		else {
			let r = e;
			r.fatal && (r.continue = !1), r.code ??= "custom", "input" in r || (r.input = t.value), r.inst ??= n, r.continue ??= !n._zod.def.abort, t.issues.push(rn(r));
		}
	}, e(t.value, t)), t);
	return n;
}
// @__NO_SIDE_EFFECTS__
function Yo(e, t) {
	let n = new Ar({
		check: "custom",
		...F(t)
	});
	return n._zod.check = e, n;
}
// ../../../node_modules/zod/v4/core/to-json-schema.js
function Xo(e, ...t) {
	for (let n of t) for (let t of Reflect.ownKeys(n)) Object.prototype.propertyIsEnumerable.call(n, t) && ht(e, t, n[t]);
	return e;
}
function Zo(e) {
	let t = e?.target ?? "draft-2020-12";
	return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
		processors: e.processors ?? {},
		metadataRegistry: e?.metadata ?? Ka,
		target: t,
		unrepresentable: e?.unrepresentable ?? "throw",
		override: e?.override ?? (() => {}),
		io: e?.io ?? "output",
		counter: 0,
		seen: /* @__PURE__ */ new Map(),
		sharedDefsExtractedFor: void 0,
		sharedEmitDoneFor: void 0,
		cycles: e?.cycles ?? "ref",
		reused: e?.reused ?? "inline",
		intersections: [],
		deferred: [],
		external: e?.external ?? void 0
	};
}
function Qo(e, t, n, r, i) {
	let a = typeof t.unrepresentable == "function" ? t.unrepresentable({
		zodSchema: e,
		path: r.path,
		message: i
	}) : t.unrepresentable;
	if (a === "any") return !1;
	if (a === void 0 || a === "throw") throw Error(i);
	return Object.assign(n, a), !0;
}
function $o(e, t, n = {
	path: [],
	schemaPath: []
}) {
	var r;
	let i = e._zod.def, a = t.seen.get(e);
	if (a) return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
	let o = {
		schema: {},
		count: 1,
		cycle: void 0,
		path: n.path
	};
	t.seen.set(e, o), t.sharedDefsExtractedFor = void 0, t.sharedEmitDoneFor = void 0;
	let s = e._zod.toJSONSchema?.();
	if (s) o.schema = s;
	else {
		let r = {
			...n,
			schemaPath: [...n.schemaPath, e],
			path: n.path
		};
		if (e._zod.processJSONSchema) e._zod.processJSONSchema(t, o.schema, r);
		else {
			let n = o.schema, a = t.processors[i.type];
			if (!a) throw Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
			a(e, t, n, r);
		}
		let a = e._zod.parent;
		a && (o.ref ||= a, $o(a, t, r), t.seen.get(a).isParent = !0);
	}
	let c = t.metadataRegistry.get(e);
	return c && Xo(o.schema, c), t.io === "input" && ls(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && "_prefault" in o.schema && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function es(e) {
	return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function ts(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	if (e.external && e.sharedDefsExtractedFor === e.external) return;
	let r = /* @__PURE__ */ new Map();
	for (let t of e.seen.entries()) {
		let n = e.metadataRegistry.get(t[0])?.id;
		if (n) {
			let e = r.get(n);
			if (e && e !== t[0]) throw Error(`Duplicate schema id "${n}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
			r.set(n, t[0]);
		}
	}
	let i = (t) => {
		let r = e.target === "draft-2020-12" ? "$defs" : "definitions";
		if (e.external) {
			let n = e.external.registry.get(t[0])?.id, i = e.external.uri ?? ((e) => e);
			if (n) return { ref: i(n) };
			let a = t[1].defId ?? t[1].schema.id ?? `schema${e.counter++}`;
			return t[1].defId = a, {
				defId: a,
				ref: `${i("__shared")}#/${r}/${es(a)}`
			};
		}
		let i = `#/${r}/`;
		if (t[1] === n && !t[1].schema.id) return { ref: "#" };
		let a = t[1].schema.id ?? `__schema${e.counter++}`;
		return {
			defId: a,
			ref: i + es(a)
		};
	}, a = (e) => {
		if (e[1].schema.$ref) return;
		let t = e[1], { ref: n, defId: r } = i(e);
		t.def = { ...t.schema }, r && (t.defId = r);
		let a = t.schema;
		for (let e in a) delete a[e];
		a.$ref = n;
	};
	if (e.cycles === "throw") for (let t of e.seen.entries()) {
		let e = t[1];
		if (e.cycle) throw Error(`Cycle detected: #/${e.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
	}
	for (let n of e.seen.entries()) {
		let r = n[1];
		if (t === n[0]) a(n);
		else {
			if (e.external) {
				let r = e.external.registry.get(n[0])?.id;
				if (t !== n[0] && r) {
					a(n);
					continue;
				}
			}
			(e.metadataRegistry.get(n[0])?.id || r.cycle || r.count > 1 && e.reused === "ref") && a(n);
		}
	}
	e.external && (e.sharedDefsExtractedFor = e.external);
}
function ns(e) {
	let t = e.anyOf;
	if (!Array.isArray(t) || t.length === 0 || e.type !== void 0) return;
	let n = [];
	for (let e of t) {
		if (!e || typeof e != "object") return;
		ns(e);
		let t = Object.keys(e);
		if (t.length !== 1 || t[0] !== "type") return;
		let r = e.type;
		for (let e of Array.isArray(r) ? r : [r]) {
			if (typeof e != "string") return;
			n.includes(e) || n.push(e);
		}
	}
	delete e.anyOf, e.type = n.length === 1 ? n[0] : n;
}
var rs = /* @__PURE__ */ new Set([
	"type",
	"properties",
	"required",
	"additionalProperties"
]), is = ["oneOf", "anyOf"];
function as(e) {
	let t = e.additionalProperties;
	return t === void 0 || t === !1 || typeof t != "object" || !t ? null : Object.keys(t).length ? t : null;
}
function os(e) {
	let t = [];
	for (let n of e) {
		if (typeof n != "object" || n.type !== "object") return null;
		for (let e in n) if (!rs.has(e)) return null;
		t.push(n);
	}
	let n = {}, r = /* @__PURE__ */ new Set();
	for (let e of t) {
		for (let r in e.properties) {
			if (Object.prototype.hasOwnProperty.call(n, r)) continue;
			let e = [];
			for (let n of t) {
				let t = n.properties?.[r] ?? as(n);
				t != null && (e.some((e) => JSON.stringify(e) === JSON.stringify(t)) || e.push(t));
			}
			ht(n, r, e.length === 1 ? e[0] : os(e) ?? { allOf: e });
		}
		for (let t of e.required ?? []) r.add(t);
	}
	let i = {
		type: "object",
		properties: n
	};
	if (r.size && (i.required = [...r]), t.every((e) => e.additionalProperties === !1)) i.additionalProperties = !1;
	else {
		let e = [];
		for (let n of t) {
			let t = as(n);
			t && !e.some((e) => JSON.stringify(e) === JSON.stringify(t)) && e.push(t);
		}
		e.length === 1 ? i.additionalProperties = e[0] : e.length > 1 && (i.additionalProperties = { allOf: e });
	}
	return i;
}
function ss(e) {
	let t = e.allOf;
	if (!Array.isArray(t) || t.length < 2) return;
	for (let t of rs) if (t in e) return;
	let n = t.filter((e) => is.some((t) => Array.isArray(e[t]))), r = null;
	if (!n.length) r = os(t);
	else {
		let e = n[0], i = is.find((t) => Array.isArray(e[t]));
		if (Object.keys(e).length !== 1) return;
		let a = t.filter((t) => t !== e), o = e[i].map((e) => os([...a, e]));
		if (o.some((e) => !e)) return;
		r = { [i]: o };
	}
	r && (delete e.allOf, Xo(e, r));
}
function cs(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = (t) => {
		let n = e.seen.get(t);
		if (n.ref === null) return;
		let i = n.def ?? n.schema, a = { ...i }, o = n.ref;
		if (n.ref = null, o) {
			r(o);
			let n = e.seen.get(o), s = n.schema;
			if (s.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (i.allOf = i.allOf ?? [], i.allOf.push(s)) : Xo(i, s), Xo(i, a), t._zod.parent === o) for (let e in i) e !== "$ref" && e !== "allOf" && (e in a || delete i[e]);
			if (s.$ref && n.def) for (let e in i) e !== "$ref" && e !== "allOf" && e in n.def && JSON.stringify(i[e]) === JSON.stringify(n.def[e]) && delete i[e];
		}
		let s = t._zod.parent;
		if (s && s !== o) {
			r(s);
			let t = e.seen.get(s);
			if (t?.schema.$ref && (i.$ref = t.schema.$ref, t.def)) for (let e in i) e !== "$ref" && e !== "allOf" && e in t.def && JSON.stringify(i[e]) === JSON.stringify(t.def[e]) && delete i[e];
		}
		e.override({
			zodSchema: t,
			jsonSchema: i,
			path: n.path ?? []
		});
	};
	if (!e.external || e.sharedEmitDoneFor !== e.external) {
		for (let t of [...e.seen.entries()].reverse()) r(t[0]);
		if (e.target !== "openapi-3.0") for (let t of e.seen.entries()) ns(t[1].def ?? t[1].schema);
		for (let t of e.deferred) t();
		if (e.intersections.length) {
			let t = /* @__PURE__ */ new Map();
			for (let n of e.seen.values()) for (let e of [n.schema, n.def]) {
				let n = e?.allOf;
				if (!Array.isArray(n)) continue;
				let r = t.get(n);
				r ? r.push(e) : t.set(n, [e]);
			}
			for (let n of e.intersections) for (let e of t.get(n) ?? []) ss(e);
		}
	}
	let i = {};
	if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
		let n = e.external.registry.get(t)?.id;
		if (!n) throw Error("Schema is missing an `id` property");
		i.$id = e.external.uri(n);
	}
	Xo(i, n.defId ? n.schema : n.def ?? n.schema);
	let a = e.metadataRegistry.get(t)?.id;
	a !== void 0 && i.id === a && delete i.id;
	let o = e.external?.defs ?? {};
	if (!e.external || e.sharedEmitDoneFor !== e.external) for (let t of e.seen.entries()) {
		let e = t[1];
		e.def && e.defId && (e.def.id === e.defId && delete e.def.id, ht(o, e.defId, e.def));
	}
	e.external && (e.sharedEmitDoneFor = e.external), e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
	try {
		let n = JSON.parse(JSON.stringify(i));
		return Object.defineProperty(n, "~standard", {
			value: {
				...t["~standard"],
				jsonSchema: {
					input: ds(t, "input", e.processors),
					output: ds(t, "output", e.processors)
				}
			},
			enumerable: !1,
			writable: !1
		}), n;
	} catch {
		throw Error("Error converting schema to JSON.");
	}
}
function ls(e, t) {
	let n = t ?? { seen: /* @__PURE__ */ new Set() };
	if (n.seen.has(e)) return !1;
	n.seen.add(e);
	let r = e._zod.def;
	if (r.type === "transform") return !0;
	if (r.type === "array") return ls(r.element, n);
	if (r.type === "set") return ls(r.valueType, n);
	if (r.type === "lazy") return ls(r.getter(), n);
	if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault" || r.type === "catch") return ls(r.innerType, n);
	if (r.type === "intersection") return ls(r.left, n) || ls(r.right, n);
	if (r.type === "record" || r.type === "map") return ls(r.keyType, n) || ls(r.valueType, n);
	if (r.type === "pipe") return e._zod.traits.has("$ZodCodec") ? !0 : ls(r.in, n) || ls(r.out, n);
	if (r.type === "object") {
		for (let e in r.shape) if (ls(r.shape[e], n)) return !0;
		return !1;
	}
	if (r.type === "union") {
		for (let e of r.options) if (ls(e, n)) return !0;
		return !1;
	}
	if (r.type === "tuple") {
		for (let e of r.items) if (ls(e, n)) return !0;
		return !!(r.rest && ls(r.rest, n));
	}
	return !1;
}
var us = (e, t = {}) => (n) => {
	let r = Zo({
		...n,
		processors: t
	});
	return $o(e, r), ts(r, e), cs(r, e);
}, ds = (e, t, n = {}) => (r) => {
	let { libraryOptions: i, target: a } = r ?? {}, o = Zo({
		...i ?? {},
		target: a,
		io: t,
		processors: n
	});
	return $o(e, o), ts(o, e), cs(o, e);
}, fs = (e, t, n) => {
	(e[t] === void 0 || n > e[t]) && (e[t] = n);
}, ps = (e, t, n) => {
	(e[t] === void 0 || n < e[t]) && (e[t] = n);
}, ms = (e, t) => {
	fs(e, "minimum", t), ps(e, "maximum", t);
}, hs = (e, t) => {
	e.multipleOf ??= [], e.multipleOf.includes(t) || e.multipleOf.push(t);
}, gs = (e, t) => {
	e.patterns ??= /* @__PURE__ */ new Set(), e.patterns.add(t);
}, _s = (e, t) => {
	e.mime = e.mime ? e.mime.filter((e) => t.includes(e)) : [...t];
}, vs = (e, t) => {
	e.format = t, t.includes("int") && (e.isInt = !0);
}, ys = (e, t) => fs(e, "minimum", t.minimum), bs = (e, t) => ps(e, "maximum", t.maximum), xs = (e) => (t, n) => {
	vs(t, n.format);
	let [r, i] = e[n.format];
	fs(t, "minimum", r), ps(t, "maximum", i);
}, Ss = {
	greater_than: (e, t) => fs(e, t.inclusive ? "minimum" : "exclusiveMinimum", t.value),
	less_than: (e, t) => ps(e, t.inclusive ? "maximum" : "exclusiveMaximum", t.value),
	multiple_of: (e, t) => hs(e, t.value),
	number_format: xs(Ft),
	bigint_format: xs(It),
	min_length: ys,
	max_length: bs,
	length_equals: (e, t) => ms(e, t.length),
	min_size: ys,
	max_size: bs,
	size_equals: (e, t) => ms(e, t.size),
	string_format: (e, t) => {
		vs(e, t.format), t.pattern && gs(e, t.pattern), (t.format === "base64" || t.format === "base64url") && (e.contentEncoding = t.format), (t.local || t.precision === -1) && (e.laxFormat = !0);
	},
	mime_type: (e, t) => _s(e, t.mime)
};
function Cs(e) {
	let t = {}, n = e._zod.def, r = e._zod.traits.has("$ZodCheck") ? [e, ...n.checks ?? []] : n.checks ?? [];
	for (let e of r) Ss[e._zod.def.check]?.(t, e._zod.def);
	let i = e._zod.bag;
	i.minimum !== void 0 && fs(t, "minimum", i.minimum), i.exclusiveMinimum !== void 0 && fs(t, "exclusiveMinimum", i.exclusiveMinimum), i.maximum !== void 0 && ps(t, "maximum", i.maximum), i.exclusiveMaximum !== void 0 && ps(t, "exclusiveMaximum", i.exclusiveMaximum), i.multipleOf !== void 0 && hs(t, i.multipleOf), i.format !== void 0 && (t.format ??= i.format, i.format.includes("int") && (t.isInt = !0)), i.mime && _s(t, i.mime);
	for (let e of i.patterns ?? []) gs(t, e);
	return t;
}
var ws = {
	guid: "uuid",
	url: "uri",
	datetime: "date-time",
	json_string: "json-string",
	regex: ""
}, Ts = /* @__PURE__ */ new Map([[Mi, gr], [Pi, _r]]), Es = (e) => Ts.get(e) ?? e, Ds = (e, t, n, r) => {
	let i = n;
	i.type = "string";
	let { minimum: a, maximum: o, format: s, patterns: c, contentEncoding: l, laxFormat: u } = Cs(e);
	if (typeof a == "number" && (i.minLength = a), typeof o == "number" && (i.maxLength = o), s && (i.format = ws[s] ?? s, i.format === "" && delete i.format, (s === "time" || u) && delete i.format), l && (i.contentEncoding = l), c && c.size > 0) {
		let e = [...c].map(Es);
		e.length === 1 ? i.pattern = e[0].source : e.length > 1 && (i.allOf = [...e.map((e) => ({
			...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
			pattern: e.source
		}))]);
	}
}, Os = (e, t, n, r) => {
	let i = n, { minimum: a, maximum: o, multipleOf: s, exclusiveMaximum: c, exclusiveMinimum: l, isInt: u } = Cs(e);
	i.type = u ? "integer" : "number";
	let d = typeof l == "number" && l >= (a ?? -Infinity), f = typeof c == "number" && c <= (o ?? Infinity), p = t.target === "draft-04" || t.target === "openapi-3.0";
	if (d ? p ? (i.minimum = l, i.exclusiveMinimum = !0) : i.exclusiveMinimum = l : typeof a == "number" && (i.minimum = a), f ? p ? (i.maximum = c, i.exclusiveMaximum = !0) : i.exclusiveMaximum = c : typeof o == "number" && (i.maximum = o), s) {
		let n = /* @__PURE__ */ new Set();
		for (let a of s) Number.isFinite(a) && a !== 0 ? n.add(Math.abs(a)) : Qo(e, t, i, r, `A multipleOf divisor of ${a} cannot be represented in JSON Schema`);
		let [a, ...o] = n;
		a !== void 0 && (i.multipleOf = a), o.length && (i.allOf = [...i.allOf ?? [], ...o.map((e) => ({ multipleOf: e }))]);
	}
}, ks = (e, t, n, r) => {
	n.not = {};
}, As = (e, t, n, r) => {
	let i = e._zod.def, a = st(i.entries);
	a.length === 0 ? n.not = {} : (a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), n.enum = a);
}, js = (e, t, n, r) => {
	Qo(e, t, n, r, "Custom types cannot be represented in JSON Schema");
}, Ms = (e, t, n, r) => {
	Qo(e, t, n, r, "Transforms cannot be represented in JSON Schema");
}, Ns = (e, t, n, r) => {
	let i = n, a = e._zod.def, { minimum: o, maximum: s } = Cs(e);
	typeof o == "number" && (i.minItems = o), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = $o(a.element, t, {
		...r,
		path: [...r.path, "items"]
	});
};
function Ps(e) {
	let t = e._zod.def;
	return t.type === "pipe" && t.in._zod.traits.has("$ZodTransform") ? Ps(t.out) : t.type === "catch" ? Ps(t.innerType) : e._zod.optin;
}
var Fs = (e, t, n, r) => {
	let i = n, a = e._zod.def, o = a.shape;
	if (Object.getOwnPropertySymbols(o).length && Qo(e, t, i, r, "Symbol keys cannot be represented in JSON Schema")) return;
	i.type = "object", i.properties = {};
	for (let e in o) ht(i.properties, e, $o(o[e], t, {
		...r,
		path: [
			...r.path,
			"properties",
			e
		]
	}));
	let s = [];
	for (let e of Object.keys(o)) {
		let n = a.shape[e];
		(t.io === "input" ? Ps(n) === void 0 : n._zod.optout === void 0) && s.push(e);
	}
	s.length > 0 && (i.required = s), a.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : a.catchall ? a.catchall && (i.additionalProperties = $o(a.catchall, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	})) : t.io === "output" && (i.additionalProperties = !1);
}, Is = (e, t, n, r) => {
	let i = e._zod.def, a = i.inclusive === !1, o = i.options.map((e, n) => $o(e, t, {
		...r,
		path: [
			...r.path,
			a ? "oneOf" : "anyOf",
			n
		]
	}));
	a ? n.oneOf = o : n.anyOf = o;
}, Ls = (e, t, n, r) => {
	let i = e._zod.def, a = $o(i.left, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			0
		]
	}), o = $o(i.right, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			1
		]
	}), s = (e) => "allOf" in e && Object.keys(e).length === 1, c = [...s(a) ? a.allOf : [a], ...s(o) ? o.allOf : [o]];
	n.allOf = c, t.intersections.push(c);
}, Rs = (e, t, n, r) => {
	let i = e._zod.def, a = $o(i.innerType, t, r), o = t.seen.get(e);
	t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
}, zs = (e, t, n, r) => {
	let i = e._zod.def;
	$o(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Bs = Symbol();
function Vs(e, t, n, r, i) {
	let a = !1, o = JSON.stringify(e, (e, t) => typeof t == "bigint" ? (a = !0, null) : t);
	return a ? (Qo(t, n, r, i, "BigInt defaults cannot be represented in JSON Schema"), Bs) : JSON.parse(o);
}
var Hs = (e, t, n, r) => {
	let i = e._zod.def;
	$o(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
	let o = Vs(i.defaultValue, e, t, n, r);
	o !== Bs && (n.default = o);
}, Us = (e, t, n, r) => {
	let i = e._zod.def;
	$o(i.innerType, t, r);
	let a = t.seen.get(e);
	if (a.ref = i.innerType, t.io !== "input") return;
	let o = Vs(i.defaultValue, e, t, n, r);
	o !== Bs && (n._prefault = o);
}, Ws = (e, t, n, r) => {
	let i = e._zod.def;
	$o(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
	let o;
	try {
		o = i.catchValue(void 0);
	} catch {
		Qo(e, t, n, r, "Dynamic catch values are not supported in JSON Schema");
		return;
	}
	n.default = o;
}, Gs = (e, t, n, r) => {
	let i = e._zod.def, a = i.in._zod.traits.has("$ZodTransform"), o = t.io === "input" ? a ? i.out : i.in : i.out;
	$o(o, t, r);
	let s = t.seen.get(e);
	s.ref = o;
}, Ks = (e, t, n, r) => {
	let i = e._zod.def;
	$o(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.readOnly = !0;
}, qs = (e, t, n, r) => {
	let i = e._zod.def;
	$o(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Js = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]);
function Ys(e, t, n) {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		get() {
			let e = n(this);
			return Object.defineProperty(this, t, {
				value: e,
				configurable: !0,
				writable: !0
			}), e;
		},
		set(e) {
			Object.defineProperty(this, t, {
				value: e,
				configurable: !0,
				writable: !0
			});
		}
	});
}
var Xs = /*@__PURE__*/ L("ZodError", (e, t) => {
	An.init(e, t), e.name = "ZodError";
	let n = Object.getPrototypeOf(e);
	Js.has(n) || (Js.add(n), Ys(n, "format", (e) => (t) => Nn(e, t)), Ys(n, "flatten", (e) => (t) => Mn(e, t)), Ys(n, "addIssue", (e) => (t) => {
		e.issues.push(t), e.message = JSON.stringify(e.issues, lt, 2);
	}), Ys(n, "addIssues", (e) => (t) => {
		e.issues.push(...t), e.message = JSON.stringify(e.issues, lt, 2);
	}), Object.defineProperty(n, "isEmpty", {
		configurable: !0,
		enumerable: !1,
		get() {
			return this.issues.length === 0;
		}
	}));
}, void 0, { Parent: Error }), Zs = /* @__PURE__ */ Fn(Xs), Qs = /* @__PURE__ */ In(Xs), $s = /* @__PURE__ */ Ln(Xs), ec = /* @__PURE__ */ zn(Xs), tc = /* @__PURE__ */ Gn(Xs), nc = /* @__PURE__ */ Kn(Xs), rc = /* @__PURE__ */ qn(Xs), ic = /* @__PURE__ */ Jn(Xs), ac = /* @__PURE__ */ Yn(Xs), oc = /* @__PURE__ */ Xn(Xs), sc = /* @__PURE__ */ Zn(Xs), cc = /* @__PURE__ */ Qn(Xs);
// ../../../node_modules/zod/v4/classic/schemas.js
function lc() {
	Cn.localeError || wn(Ha());
}
function uc() {
	Cn.memoizer || wn({ memoizer: za() });
}
var dc = /*@__PURE__*/ L("ZodType", (e, t) => (lc(), Xr.init(e, t), e.def = t, e.type = t.type, e), {
	check(...e) {
		let t = this.def;
		return this.clone(St(t, { checks: [...t.checks ?? [], ...e.map((e) => typeof e == "function" ? { _zod: {
			check: e,
			def: { check: "custom" },
			onattach: []
		} } : e)] }), { parent: !0 });
	},
	with(...e) {
		return this.check(...e);
	},
	clone(e, t) {
		return Mt(this, e, t);
	},
	brand() {
		return this;
	},
	register(e, t) {
		return e.add(this, t), this;
	},
	refine(e, t) {
		return this.check(Tl(e, t));
	},
	superRefine(e, t) {
		return this.check(El(e, t));
	},
	overwrite(e) {
		return this.check(/* @__PURE__ */ Bo(e));
	},
	optional() {
		return sl(this);
	},
	exactOptional() {
		return ll(this);
	},
	nullable() {
		return dl(this);
	},
	nullish() {
		return sl(dl(this));
	},
	nonoptional(e) {
		return _l(this, e);
	},
	array() {
		return Yc(this);
	},
	or(e) {
		return $c([this, e]);
	},
	and(e) {
		return tl(this, e);
	},
	transform(e) {
		return xl(this, al(e));
	},
	default(e) {
		return pl(this, e);
	},
	prefault(e) {
		return hl(this, e);
	},
	catch(e) {
		return yl(this, e);
	},
	pipe(e) {
		return xl(this, e);
	},
	readonly() {
		return Cl(this);
	},
	describe(e) {
		let t = this.clone();
		return Ka.add(t, { description: e }), t;
	},
	meta(...e) {
		if (e.length === 0) return Ka.get(this);
		let t = this.clone();
		return Ka.add(t, e[0]), t;
	},
	isOptional() {
		return this.safeParse(void 0).success;
	},
	isNullable() {
		return this.safeParse(null).success;
	},
	apply(e, ...t) {
		return t.length === 0 ? e(this) : e(this, ...t);
	},
	get "~standard"() {
		return sn(this, "~standard", {
			...$r(this),
			jsonSchema: {
				input: ds(this, "input"),
				output: ds(this, "output")
			}
		});
	},
	set "~standard"(e) {
		on(this, "~standard", e);
	},
	parse: function e(t, n) {
		return Zs(this, t, n, { callee: e });
	},
	parseAsync: async function e(t, n) {
		return await Qs(this, t, n, { callee: e });
	},
	safeParse(e, t) {
		return $s(this, e, t);
	},
	async safeParseAsync(e, t) {
		return ec(this, e, t);
	},
	get spa() {
		return this?.safeParseAsync;
	},
	set spa(e) {
		on(this, "spa", e);
	},
	validate(e, t) {
		return Hn(this, e, t);
	},
	validateAsync(e, t) {
		return Wn(this, e, t);
	},
	encode: function e(t, n) {
		return tc(this, t, n, { callee: e });
	},
	decode: function e(t, n) {
		return nc(this, t, n, { callee: e });
	},
	encodeAsync: async function e(t, n) {
		return await rc(this, t, n, { callee: e });
	},
	decodeAsync: async function e(t, n) {
		return await ic(this, t, n, { callee: e });
	},
	safeEncode(e, t) {
		return ac(this, e, t);
	},
	safeDecode(e, t) {
		return oc(this, e, t);
	},
	async safeEncodeAsync(e, t) {
		return sc(this, e, t);
	},
	async safeDecodeAsync(e, t) {
		return cc(this, e, t);
	},
	toJSONSchema(e) {
		return us(this, {})(e);
	},
	get description() {
		return Ka.get(this)?.description;
	},
	get _def() {
		return this._zod.def;
	}
}), fc = /*@__PURE__*/ L("_ZodString", (e, t) => {
	ei.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ds(e, t, n, r);
}, /*@__PURE__*/ cn({
	format: (e) => Cs(e).format ?? null,
	minLength: (e) => Cs(e).minimum ?? null,
	maxLength: (e) => Cs(e).maximum ?? null
}, {
	regex(...e) {
		return this.check(/* @__PURE__ */ Po(...e));
	},
	includes(...e) {
		return this.check(/* @__PURE__ */ Lo(...e));
	},
	startsWith(...e) {
		return this.check(/* @__PURE__ */ Ro(...e));
	},
	endsWith(...e) {
		return this.check(/* @__PURE__ */ zo(...e));
	},
	min(...e) {
		return this.check(/* @__PURE__ */ Mo(...e));
	},
	max(...e) {
		return this.check(/* @__PURE__ */ jo(...e));
	},
	length(...e) {
		return this.check(/* @__PURE__ */ No(...e));
	},
	nonempty(...e) {
		return this.check(/* @__PURE__ */ Mo(1, ...e));
	},
	lowercase(e) {
		return this.check(/* @__PURE__ */ Fo(e));
	},
	uppercase(e) {
		return this.check(/* @__PURE__ */ Io(e));
	},
	trim() {
		return this.check(/* @__PURE__ */ Ho());
	},
	normalize(...e) {
		return this.check(/* @__PURE__ */ Vo(...e));
	},
	toLowerCase() {
		return this.check(/* @__PURE__ */ Uo());
	},
	toUpperCase() {
		return this.check(/* @__PURE__ */ Wo());
	},
	slugify() {
		return this.check(/* @__PURE__ */ Go());
	}
})), pc = /*@__PURE__*/ L("ZodString", (e, t) => {
	ei.init(e, t), fc.init(e, t);
}, {
	email(e) {
		return this.check(/* @__PURE__ */ Ya(bc, e));
	},
	url(e) {
		return this.check(/* @__PURE__ */ to(wc, e));
	},
	jwt(e) {
		return this.check(/* @__PURE__ */ _o(zc, e));
	},
	emoji(e) {
		return this.check(/* @__PURE__ */ no(Tc, e));
	},
	guid(e) {
		return this.check(/* @__PURE__ */ Xa(xc, e));
	},
	uuid(e) {
		return this.check(/* @__PURE__ */ Za(Cc, e));
	},
	uuidv4(e) {
		return this.check(/* @__PURE__ */ Qa(Cc, e));
	},
	uuidv6(e) {
		return this.check(/* @__PURE__ */ $a(Cc, e));
	},
	uuidv7(e) {
		return this.check(/* @__PURE__ */ eo(Cc, e));
	},
	nanoid(e) {
		return this.check(/* @__PURE__ */ ro(Ec, e));
	},
	cuid(e) {
		return this.check(/* @__PURE__ */ io(Dc, e));
	},
	cuid2(e) {
		return this.check(/* @__PURE__ */ ao(Oc, e));
	},
	ulid(e) {
		return this.check(/* @__PURE__ */ oo(kc, e));
	},
	base64(e) {
		return this.check(/* @__PURE__ */ mo(Ic, e));
	},
	base64url(e) {
		return this.check(/* @__PURE__ */ ho(Lc, e));
	},
	xid(e) {
		return this.check(/* @__PURE__ */ so(Ac, e));
	},
	ksuid(e) {
		return this.check(/* @__PURE__ */ co(jc, e));
	},
	ipv4(e) {
		return this.check(/* @__PURE__ */ lo(Mc, e));
	},
	ipv6(e) {
		return this.check(/* @__PURE__ */ uo(Nc, e));
	},
	cidrv4(e) {
		return this.check(/* @__PURE__ */ fo(Pc, e));
	},
	cidrv6(e) {
		return this.check(/* @__PURE__ */ po(Fc, e));
	},
	e164(e) {
		return this.check(/* @__PURE__ */ go(Rc, e));
	},
	datetime(e) {
		return this.check(/* @__PURE__ */ vo(gc, e));
	},
	date(e) {
		return this.check(/* @__PURE__ */ yo(_c, e));
	},
	time(e) {
		return this.check(/* @__PURE__ */ bo(vc, e));
	},
	duration(e) {
		return this.check(/* @__PURE__ */ xo(yc, e));
	}
});
function mc(e) {
	return /* @__PURE__ */ Ja(pc, e);
}
var hc = /*@__PURE__*/ L("ZodStringFormat", (e, t) => {
	ti.init(e, t), fc.init(e, t);
}), gc = /*@__PURE__*/ L("ZodISODateTime", (e, t) => {
	bi.init(e, t), hc.init(e, t);
}), _c = /*@__PURE__*/ L("ZodISODate", (e, t) => {
	xi.init(e, t), hc.init(e, t);
}), vc = /*@__PURE__*/ L("ZodISOTime", (e, t) => {
	Si.init(e, t), hc.init(e, t);
}), yc = /*@__PURE__*/ L("ZodISODuration", (e, t) => {
	Ci.init(e, t), hc.init(e, t);
}), bc = /*@__PURE__*/ L("ZodEmail", (e, t) => {
	ii.init(e, t), hc.init(e, t);
}), xc = /*@__PURE__*/ L("ZodGUID", (e, t) => {
	ni.init(e, t), hc.init(e, t);
});
function Sc(e) {
	return /* @__PURE__ */ Xa(xc, e);
}
var Cc = /*@__PURE__*/ L("ZodUUID", (e, t) => {
	ri.init(e, t), hc.init(e, t);
}), wc = /*@__PURE__*/ L("ZodURL", (e, t) => {
	fi.init(e, t), hc.init(e, t);
}), Tc = /*@__PURE__*/ L("ZodEmoji", (e, t) => {
	pi.init(e, t), hc.init(e, t);
}), Ec = /*@__PURE__*/ L("ZodNanoID", (e, t) => {
	mi.init(e, t), hc.init(e, t);
}), Dc = /*@__PURE__*/ L("ZodCUID", (e, t) => {
	hi.init(e, t), hc.init(e, t);
}), Oc = /*@__PURE__*/ L("ZodCUID2", (e, t) => {
	gi.init(e, t), hc.init(e, t);
}), kc = /*@__PURE__*/ L("ZodULID", (e, t) => {
	_i.init(e, t), hc.init(e, t);
}), Ac = /*@__PURE__*/ L("ZodXID", (e, t) => {
	vi.init(e, t), hc.init(e, t);
}), jc = /*@__PURE__*/ L("ZodKSUID", (e, t) => {
	yi.init(e, t), hc.init(e, t);
}), Mc = /*@__PURE__*/ L("ZodIPv4", (e, t) => {
	wi.init(e, t), hc.init(e, t);
}), Nc = /*@__PURE__*/ L("ZodIPv6", (e, t) => {
	Di.init(e, t), hc.init(e, t);
}), Pc = /*@__PURE__*/ L("ZodCIDRv4", (e, t) => {
	Oi.init(e, t), hc.init(e, t);
}), Fc = /*@__PURE__*/ L("ZodCIDRv6", (e, t) => {
	Ai.init(e, t), hc.init(e, t);
}), Ic = /*@__PURE__*/ L("ZodBase64", (e, t) => {
	Ni.init(e, t), hc.init(e, t);
}), Lc = /*@__PURE__*/ L("ZodBase64URL", (e, t) => {
	Ii.init(e, t), hc.init(e, t);
}), Rc = /*@__PURE__*/ L("ZodE164", (e, t) => {
	Li.init(e, t), hc.init(e, t);
}), zc = /*@__PURE__*/ L("ZodJWT", (e, t) => {
	zi.init(e, t), hc.init(e, t);
}), Bc = /*@__PURE__*/ L("ZodNumber", (e, t) => {
	Bi.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Os(e, t, n, r), e.isFinite = !0;
}, /*@__PURE__*/ cn({
	minValue: (e) => {
		let { minimum: t, exclusiveMinimum: n } = Cs(e);
		return Math.max(t ?? -Infinity, n ?? -Infinity);
	},
	maxValue: (e) => {
		let { maximum: t, exclusiveMaximum: n } = Cs(e);
		return Math.min(t ?? Infinity, n ?? Infinity);
	},
	isInt: (e) => {
		let { isInt: t, multipleOf: n } = Cs(e);
		return !!t || !!n?.some(Number.isSafeInteger);
	},
	format: (e) => Cs(e).format ?? null
}, {
	gt(e, t) {
		return this.check(/* @__PURE__ */ Oo(e, t));
	},
	gte(e, t) {
		return this.check(/* @__PURE__ */ ko(e, t));
	},
	min(e, t) {
		return this.check(/* @__PURE__ */ ko(e, t));
	},
	lt(e, t) {
		return this.check(/* @__PURE__ */ Eo(e, t));
	},
	lte(e, t) {
		return this.check(/* @__PURE__ */ Do(e, t));
	},
	max(e, t) {
		return this.check(/* @__PURE__ */ Do(e, t));
	},
	int(e) {
		return this.check(Uc(e));
	},
	safe(e) {
		return this.check(Uc(e));
	},
	positive(e) {
		return this.check(/* @__PURE__ */ Oo(0, e));
	},
	nonnegative(e) {
		return this.check(/* @__PURE__ */ ko(0, e));
	},
	negative(e) {
		return this.check(/* @__PURE__ */ Eo(0, e));
	},
	nonpositive(e) {
		return this.check(/* @__PURE__ */ Do(0, e));
	},
	multipleOf(e, t) {
		return this.check(/* @__PURE__ */ Ao(e, t));
	},
	step(e, t) {
		return this.check(/* @__PURE__ */ Ao(e, t));
	},
	finite() {
		return this;
	}
}));
function Vc(e) {
	return /* @__PURE__ */ So(Bc, e);
}
var Hc = /*@__PURE__*/ L("ZodNumberFormat", (e, t) => {
	Vi.init(e, t), Bc.init(e, t);
});
function Uc(e) {
	return /* @__PURE__ */ Co(Hc, e);
}
var Wc = /*@__PURE__*/ L("ZodUnknown", (e, t) => {
	Hi.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (e, t, n) => void 0;
});
function Gc() {
	return /* @__PURE__ */ wo(Wc);
}
var Kc = /*@__PURE__*/ L("ZodNever", (e, t) => {
	Ui.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => ks(e, t, n, r);
});
function qc(e) {
	return /* @__PURE__ */ To(Kc, e);
}
var Jc = /*@__PURE__*/ L("ZodArray", (e, t) => {
	uc(), qi.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ns(e, t, n, r), e.element = t.element;
}, {
	min(e, t) {
		return this.check(/* @__PURE__ */ Mo(e, t));
	},
	nonempty(e) {
		return this.check(/* @__PURE__ */ Mo(1, e));
	},
	max(e, t) {
		return this.check(/* @__PURE__ */ jo(e, t));
	},
	length(e, t) {
		return this.check(/* @__PURE__ */ No(e, t));
	},
	unwrap() {
		return this.element;
	}
});
function Yc(e, t) {
	return /* @__PURE__ */ Ko(Jc, e, t);
}
var Xc = /*@__PURE__*/ L("ZodObject", (e, t) => {
	uc(), $i.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Fs(e, t, n, r), mn(e, "shape", (e) => e._zod.def.shape, !1);
}, {
	keyof() {
		return rl(Object.keys(this._zod.def.shape));
	},
	catchall(e) {
		return this.clone(St(this._zod.def, { catchall: e }));
	},
	passthrough() {
		return this.clone(St(this._zod.def, { catchall: Gc() }));
	},
	loose() {
		return this.clone(St(this._zod.def, { catchall: Gc() }));
	},
	strict() {
		return this.clone(St(this._zod.def, { catchall: qc() }));
	},
	strip() {
		return this.clone(St(this._zod.def, { catchall: void 0 }));
	},
	extend(e) {
		return Bt(this, e);
	},
	safeExtend(e) {
		return Ht(this, e);
	},
	merge(e) {
		return Ut(this, e);
	},
	pick(e) {
		return Lt(this, e);
	},
	omit(e) {
		return zt(this, e);
	},
	partial(...e) {
		return Wt(ol, this, e[0]);
	},
	exactPartial(...e) {
		return Wt(cl, this, e[0], "exactPartial");
	},
	required(...e) {
		return Gt(gl, this, e[0]);
	}
});
function Zc(e, t) {
	return new Xc({
		type: "object",
		shape: e ?? {},
		...F(t)
	});
}
var Qc = /*@__PURE__*/ L("ZodUnion", (e, t) => {
	ta.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Is(e, t, n, r), e.options = t.options;
});
function $c(e, t) {
	return new Qc({
		type: "union",
		options: e,
		...F(t)
	});
}
var el = /*@__PURE__*/ L("ZodIntersection", (e, t) => {
	na.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ls(e, t, n, r);
});
function tl(e, t) {
	return new el({
		type: "intersection",
		left: e,
		right: t
	});
}
var nl = /*@__PURE__*/ L("ZodEnum", (e, t) => {
	aa.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => As(e, t, n, r), e.enum = t.entries, e.options = [...e._zod.values];
	let n = new Set(Object.keys(t.entries));
	e.extract = (e, r) => {
		let i = {};
		for (let r of e) if (n.has(r)) i[r] = t.entries[r];
		else throw Error(`Key ${r} not found in enum`);
		return new nl({
			...t,
			checks: [],
			...F(r),
			entries: i
		});
	}, e.exclude = (e, r) => {
		let i = { ...t.entries };
		for (let t of e) if (n.has(t)) delete i[t];
		else throw Error(`Key ${t} not found in enum`);
		return new nl({
			...t,
			checks: [],
			...F(r),
			entries: i
		});
	};
});
function rl(e, t) {
	return new nl({
		type: "enum",
		entries: Array.isArray(e) ? Object.fromEntries(e.map((e) => [e, e])) : e,
		...F(t)
	});
}
var il = /*@__PURE__*/ L("ZodTransform", (e, t) => {
	uc(), oa.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ms(e, t, n, r), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new Sn(e.constructor.name);
		n.addIssue = (r) => {
			if (typeof r == "string") n.issues.push(rn(r, n.value, t));
			else {
				let t = r;
				t.fatal && (t.continue = !1), t.code ??= "custom", "input" in t || (t.input = n.value), t.inst ??= e, n.issues.push(rn(t));
			}
		};
		let i = t.transform(n.value, n);
		return i instanceof Promise ? i.then((e) => (n.value = e, n)) : (n.value = i, n);
	};
});
function al(e) {
	return new il({
		type: "transform",
		transform: e
	});
}
var ol = /*@__PURE__*/ L("ZodOptional", (e, t) => {
	ca.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => qs(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function sl(e) {
	return new ol({
		type: "optional",
		innerType: e
	});
}
var cl = /*@__PURE__*/ L("ZodExactOptional", (e, t) => {
	la.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => qs(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function ll(e) {
	return new cl({
		type: "optional",
		innerType: e
	});
}
var ul = /*@__PURE__*/ L("ZodNullable", (e, t) => {
	ua.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Rs(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function dl(e) {
	return new ul({
		type: "nullable",
		innerType: e
	});
}
var fl = /*@__PURE__*/ L("ZodDefault", (e, t) => {
	da.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Hs(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function pl(e, t) {
	return new fl({
		type: "default",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : kt(t);
		}
	});
}
var ml = /*@__PURE__*/ L("ZodPrefault", (e, t) => {
	pa.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Us(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function hl(e, t) {
	return new ml({
		type: "prefault",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : kt(t);
		}
	});
}
var gl = /*@__PURE__*/ L("ZodNonOptional", (e, t) => {
	ma.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => zs(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function _l(e, t) {
	return new gl({
		type: "nonoptional",
		innerType: e,
		...F(t)
	});
}
var vl = /*@__PURE__*/ L("ZodCatch", (e, t) => {
	_a.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ws(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function yl(e, t) {
	return new vl({
		type: "catch",
		innerType: e,
		catchValue: typeof t == "function" ? t : gn(t)
	});
}
var bl = /*@__PURE__*/ L("ZodPipe", (e, t) => {
	va.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Gs(e, t, n, r), e.in = t.in, e.out = t.out;
});
function xl(e, t) {
	return new bl({
		type: "pipe",
		in: e,
		out: t
	});
}
var Sl = /*@__PURE__*/ L("ZodReadonly", (e, t) => {
	ba.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ks(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Cl(e) {
	return new Sl({
		type: "readonly",
		innerType: e
	});
}
var wl = /*@__PURE__*/ L("ZodCustom", (e, t) => {
	Sa.init(e, t), dc.init(e, t), e._zod.processJSONSchema = (t, n, r) => js(e, t, n, r);
});
function Tl(e, t = {}) {
	return /* @__PURE__ */ qo(wl, e, t);
}
function El(e, t) {
	return /* @__PURE__ */ Jo(e, t);
}
// src/components/Modals/articleDraftModalSchema.ts
var Dl = Zc({
	id: Sc(),
	name: mc()
}), Ol = Zc({
	id: rl(i),
	name: mc()
}), kl = Zc({
	conversationId: Vc(),
	collection: Yc(Dl),
	language: Yc(Ol).min(1)
}), Al = (e = !0) => e ? kl.extend({ collection: Yc(Dl).min(1) }) : kl;
// src/components/Modals/components/draftArticleActions.tsx
function jl({ onDiscard: e, onSave: t, isGenerating: n, isSaving: r, discardVariant: i = "danger" }) {
	return /* @__PURE__ */ M(E, {
		justifyContent: "flex-end",
		gap: "200",
		children: [/* @__PURE__ */ j(w, {
			variant: i,
			onClick: e,
			disabled: r || n,
			children: "Discard Draft"
		}), /* @__PURE__ */ j(w, {
			variant: "primary",
			onClick: t,
			disabled: n,
			isLoading: r,
			loadingIndicator: /* @__PURE__ */ j(ie.Paragraph, {
				color: "white",
				variant: "3",
				children: "Creating..."
			}),
			children: "Save Draft"
		})]
	});
}
// src/components/Modals/components/draftArticleFooter.tsx
function Ml({ className: e, ...t }) {
	return /* @__PURE__ */ j(k, {
		className: e,
		children: /* @__PURE__ */ j(jl, { ...t })
	});
}
// ../../../node_modules/@udecode/plate-core/node_modules/jotai-x/dist/index.mjs
var Nl = Object.defineProperty, Pl = Object.defineProperties, Fl = Object.getOwnPropertyDescriptors, Il = Object.getOwnPropertySymbols, Ll = Object.prototype.hasOwnProperty, Rl = Object.prototype.propertyIsEnumerable, zl = (e, t, n) => t in e ? Nl(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Bl = (e, t) => {
	for (var n in t ||= {}) Ll.call(t, n) && zl(e, n, t[n]);
	if (Il) for (var n of Il(t)) Rl.call(t, n) && zl(e, n, t[n]);
	return e;
}, Vl = (e, t) => Pl(e, Fl(t)), Hl = (e, t) => {
	var n = {};
	for (var r in e) Ll.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && Il) for (var r of Il(e)) t.indexOf(r) < 0 && Rl.call(e, r) && (n[r] = e[r]);
	return n;
}, Ul = (e) => typeof e == "function" ? { __fn: e } : e, Wl = (e) => e && typeof e == "object" && "__fn" in e ? e.__fn : e, Gl = (e) => {
	let t = De(Ul(e));
	return De((e) => Wl(e(t)), (e, n, r) => n(t, Ul(r)));
}, Kl = (e, t, n = {}) => {
	let r = [];
	for (let n of Object.keys(e)) {
		let i = t[n];
		i !== void 0 && r.push([e[n], i]);
	}
	Fe(r, n);
}, ql = (e, t, { store: n } = {}) => {
	for (let r of Object.keys(e)) {
		let i = t[r], a = e[r], o = Me(a, { store: n });
		N.useEffect(() => {
			i != null && o(i);
		}, [o, i]);
	}
}, Jl = (e, t) => `${e}:${t}`, Yl = "provider", Xl = N.createContext(/* @__PURE__ */ new Map()), Zl = (e, t = Yl, n = !0) => {
	let r = N.useContext(Xl), i = r.get(Jl(e, t)) ?? r.get(Jl(e, Yl));
	return !i && n && console.warn(`Tried to access jotai store '${e}' outside of a matching provider.`), i;
}, Ql = (e) => {
	var t = e, { initialValues: n, children: r, store: i, atoms: a } = t, o = Hl(t, [
		"initialValues",
		"children",
		"store",
		"atoms"
	]);
	return Kl(a, Bl(Bl({}, n), o), { store: i }), ql(a, o, { store: i }), /* @__PURE__ */ N.createElement(N.Fragment, null, r);
}, $l = (e, t, n = {}) => {
	let r = n.effect;
	return (n) => {
		var i = n, { store: a, scope: o, children: s, resetKey: c } = i, l = Hl(i, [
			"store",
			"scope",
			"children",
			"resetKey"
		]);
		let [u, d] = N.useState(Pe());
		N.useEffect(() => {
			c && d(Pe());
		}, [c]);
		let f = N.useContext(Xl), p = N.useMemo(() => {
			let t = new Map(f);
			return o && t.set(Jl(e, o), u), t.set(Jl(e, Yl), u), t;
		}, [
			f,
			o,
			u
		]);
		return /* @__PURE__ */ N.createElement(Xl.Provider, { value: p }, /* @__PURE__ */ N.createElement(Ql, Bl({
			store: u,
			atoms: t
		}, l), !!r && /* @__PURE__ */ N.createElement(r, null), s));
	};
}, eu = (e = "") => e.length > 0 ? e[0].toUpperCase() + e.slice(1) : "", tu = (e = "") => `${eu(e)}Provider`, nu = (e = "") => e.length > 0 ? `${e}Store` : "store", ru = (e = "") => `use${eu(e)}Store`, iu = (e) => !!e && typeof e == "object" && "read" in e && typeof e.read == "function", au = (e, t) => Object.fromEntries(Object.entries(e).map(([e, n]) => [e, (e = {}) => n(Bl(Bl({}, t), e))])), ou = (e = {}) => typeof e == "string" ? { scope: e } : e, su = (e, { name: t, delay: n, effect: r, extend: i }) => {
	let a = tu(t), o = ru(t), s = nu(t), c = {}, l = {}, u = {};
	for (let [t, n] of Object.entries(e)) {
		let e = iu(n) ? n : Gl(n);
		c[t] = e;
		let r = "write" in e;
		u[t] = r, r && (l[t] = e);
	}
	let d = Bl({}, c);
	if (i) {
		let e = i(c);
		for (let [t, n] of Object.entries(e)) d[t] = n, u[t] = "write" in n;
	}
	let f = {}, p = {}, m = {}, h = (e = {}) => {
		let { scope: n, store: r, warnIfNoStore: i = !0 } = ou(e), a = Zl(t, n, !r && i);
		return r ?? a;
	}, g = (e, t) => {
		let r = ou(t), i = h(Bl({ warnIfNoStore: !1 }, r));
		return je(e, {
			store: i,
			delay: r.delay ?? n
		});
	}, _ = (e, t) => {
		let n = h(t);
		return Me(e, { store: n });
	}, v = (e, t) => {
		let r = h(t), { delay: i = n } = ou(t);
		return Ae(e, {
			store: r,
			delay: i
		});
	};
	for (let e of Object.keys(d)) {
		let t = d[e], n = u[e];
		f[e] = (e = {}) => g(t, e), n && (p[e] = (e = {}) => _(t, e), m[e] = (e = {}) => v(t, e));
	}
	let y = $l(t, l, { effect: r }), b = {
		atom: d,
		name: t
	}, x = (e = {}) => ({
		get: Vl(Bl({}, au(f, ou(e))), { atom: (t, n) => g(t, Bl(Bl({}, ou(e)), ou(n))) }),
		set: Vl(Bl({}, au(p, ou(e))), { atom: (t, n) => _(t, Bl(Bl({}, ou(e)), ou(n))) }),
		use: Vl(Bl({}, au(m, ou(e))), { atom: (t, n) => v(t, Bl(Bl({}, ou(e)), ou(n))) }),
		store: (t) => h(Bl(Bl({}, ou(e)), ou(t)))
	});
	return {
		[a]: y,
		[o]: x,
		[s]: b,
		name: t
	};
}, cu = Symbol.for("immer-nothing"), lu = Symbol.for("immer-draftable"), R = Symbol.for("immer-state"), uu = process.env.NODE_ENV === "production" ? [] : [
	function(e) {
		return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
	},
	function(e) {
		return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
	},
	"This object has been frozen and should not be mutated",
	function(e) {
		return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
	},
	"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
	"Immer forbids circular references",
	"The first or second argument to `produce` must be a function",
	"The third argument to `produce` must be a function or undefined",
	"First argument to `createDraft` must be a plain object, an array, or an immerable object",
	"First argument to `finishDraft` must be a draft returned by `createDraft`",
	function(e) {
		return `'current' expects a draft, got: ${e}`;
	},
	"Object.defineProperty() cannot be used on an Immer draft",
	"Object.setPrototypeOf() cannot be used on an Immer draft",
	"Immer only supports deleting array indices",
	"Immer only supports setting array indices and the 'length' property",
	function(e) {
		return `'original' expects a draft, got: ${e}`;
	}
];
function du(e, ...t) {
	if (process.env.NODE_ENV !== "production") {
		let n = uu[e], r = typeof n == "function" ? n.apply(null, t) : n;
		throw Error(`[Immer] ${r}`);
	}
	throw Error(`[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`);
}
var fu = Object.getPrototypeOf;
function pu(e) {
	return !!e && !!e[R];
}
function mu(e) {
	return e ? _u(e) || Array.isArray(e) || !!e[lu] || !!e.constructor?.[lu] || Cu(e) || wu(e) : !1;
}
var hu = Object.prototype.constructor.toString(), gu = /* @__PURE__ */ new WeakMap();
function _u(e) {
	if (!e || typeof e != "object") return !1;
	let t = Object.getPrototypeOf(e);
	if (t === null || t === Object.prototype) return !0;
	let n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
	if (n === Object) return !0;
	if (typeof n != "function") return !1;
	let r = gu.get(n);
	return r === void 0 && (r = Function.toString.call(n), gu.set(n, r)), r === hu;
}
function vu(e, t, n = !0) {
	yu(e) === 0 ? (n ? Reflect.ownKeys(e) : Object.keys(e)).forEach((n) => {
		t(n, e[n], e);
	}) : e.forEach((n, r) => t(r, n, e));
}
function yu(e) {
	let t = e[R];
	return t ? t.type_ : Array.isArray(e) ? 1 : Cu(e) ? 2 : wu(e) ? 3 : 0;
}
function bu(e, t) {
	return yu(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function xu(e, t, n) {
	let r = yu(e);
	r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function Su(e, t) {
	return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
}
function Cu(e) {
	return e instanceof Map;
}
function wu(e) {
	return e instanceof Set;
}
function Tu(e) {
	return e.copy_ || e.base_;
}
function Eu(e, t) {
	if (Cu(e)) return new Map(e);
	if (wu(e)) return new Set(e);
	if (Array.isArray(e)) return Array.prototype.slice.call(e);
	let n = _u(e);
	if (t === !0 || t === "class_only" && !n) {
		let t = Object.getOwnPropertyDescriptors(e);
		delete t[R];
		let n = Reflect.ownKeys(t);
		for (let r = 0; r < n.length; r++) {
			let i = n[r], a = t[i];
			a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (t[i] = {
				configurable: !0,
				writable: !0,
				enumerable: a.enumerable,
				value: e[i]
			});
		}
		return Object.create(fu(e), t);
	}
	{
		let t = fu(e);
		if (t !== null && n) return { ...e };
		let r = Object.create(t);
		return Object.assign(r, e);
	}
}
function Du(e, t = !1) {
	return Au(e) || pu(e) || !mu(e) || (yu(e) > 1 && Object.defineProperties(e, {
		set: ku,
		add: ku,
		clear: ku,
		delete: ku
	}), Object.freeze(e), t && Object.values(e).forEach((e) => Du(e, !0))), e;
}
function Ou() {
	du(2);
}
var ku = { value: Ou };
function Au(e) {
	return typeof e != "object" || !e || Object.isFrozen(e);
}
var ju = {};
function Mu(e) {
	let t = ju[e];
	return t || du(0, e), t;
}
function Nu(e, t) {
	ju[e] || (ju[e] = t);
}
var Pu;
function Fu() {
	return Pu;
}
function Iu(e, t) {
	return {
		drafts_: [],
		parent_: e,
		immer_: t,
		canAutoFreeze_: !0,
		unfinalizedDrafts_: 0
	};
}
function Lu(e, t) {
	t && (Mu("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Ru(e) {
	zu(e), e.drafts_.forEach(Vu), e.drafts_ = null;
}
function zu(e) {
	e === Pu && (Pu = e.parent_);
}
function Bu(e) {
	return Pu = Iu(Pu, e);
}
function Vu(e) {
	let t = e[R];
	t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Hu(e, t) {
	t.unfinalizedDrafts_ = t.drafts_.length;
	let n = t.drafts_[0];
	return e !== void 0 && e !== n ? (n[R].modified_ && (Ru(t), du(4)), mu(e) && (e = Uu(t, e), t.parent_ || Gu(t, e)), t.patches_ && Mu("Patches").generateReplacementPatches_(n[R].base_, e, t.patches_, t.inversePatches_)) : e = Uu(t, n, []), Ru(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e === cu ? void 0 : e;
}
function Uu(e, t, n) {
	if (Au(t)) return t;
	let r = e.immer_.shouldUseStrictIteration(), i = t[R];
	if (!i) return vu(t, (r, a) => Wu(e, i, t, r, a, n), r), t;
	if (i.scope_ !== e) return t;
	if (!i.modified_) return Gu(e, i.base_, !0), i.base_;
	if (!i.finalized_) {
		i.finalized_ = !0, i.scope_.unfinalizedDrafts_--;
		let t = i.copy_, a = t, o = !1;
		i.type_ === 3 && (a = new Set(t), t.clear(), o = !0), vu(a, (r, a) => Wu(e, i, t, r, a, n, o), r), Gu(e, t, !1), n && e.patches_ && Mu("Patches").generatePatches_(i, n, e.patches_, e.inversePatches_);
	}
	return i.copy_;
}
function Wu(e, t, n, r, i, a, o) {
	if (i == null || typeof i != "object" && !o) return;
	let s = Au(i);
	if (!s || o) {
		if (process.env.NODE_ENV !== "production" && i === n && du(5), pu(i)) {
			let o = Uu(e, i, a && t && t.type_ !== 3 && !bu(t.assigned_, r) ? a.concat(r) : void 0);
			if (xu(n, r, o), pu(o)) e.canAutoFreeze_ = !1;
			else return;
		} else o && n.add(i);
		if (mu(i) && !s) {
			if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1 || t && t.base_ && t.base_[r] === i && s) return;
			Uu(e, i), (!t || !t.scope_.parent_) && typeof r != "symbol" && (Cu(n) ? n.has(r) : Object.prototype.propertyIsEnumerable.call(n, r)) && Gu(e, i);
		}
	}
}
function Gu(e, t, n = !1) {
	!e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Du(t, n);
}
function Ku(e, t) {
	let n = Array.isArray(e), r = {
		type_: +!!n,
		scope_: t ? t.scope_ : Fu(),
		modified_: !1,
		finalized_: !1,
		assigned_: {},
		parent_: t,
		base_: e,
		draft_: null,
		copy_: null,
		revoke_: null,
		isManual_: !1
	}, i = r, a = qu;
	n && (i = [r], a = Ju);
	let { revoke: o, proxy: s } = Proxy.revocable(i, a);
	return r.draft_ = s, r.revoke_ = o, s;
}
var qu = {
	get(e, t) {
		if (t === R) return e;
		let n = Tu(e);
		if (!bu(n, t)) return Xu(e, n, t);
		let r = n[t];
		return e.finalized_ || !mu(r) ? r : r === Yu(e.base_, t) ? ($u(e), e.copy_[t] = td(r, e)) : r;
	},
	has(e, t) {
		return t in Tu(e);
	},
	ownKeys(e) {
		return Reflect.ownKeys(Tu(e));
	},
	set(e, t, n) {
		let r = Zu(Tu(e), t);
		if (r?.set) return r.set.call(e.draft_, n), !0;
		if (!e.modified_) {
			let r = Yu(Tu(e), t), i = r?.[R];
			if (i && i.base_ === n) return e.copy_[t] = n, e.assigned_[t] = !1, !0;
			if (Su(n, r) && (n !== void 0 || bu(e.base_, t))) return !0;
			$u(e), Qu(e);
		}
		return e.copy_[t] === n && (n !== void 0 || t in e.copy_) || Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
	},
	deleteProperty(e, t) {
		return Yu(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, $u(e), Qu(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
	},
	getOwnPropertyDescriptor(e, t) {
		let n = Tu(e), r = Reflect.getOwnPropertyDescriptor(n, t);
		return r && {
			writable: !0,
			configurable: e.type_ !== 1 || t !== "length",
			enumerable: r.enumerable,
			value: n[t]
		};
	},
	defineProperty() {
		du(11);
	},
	getPrototypeOf(e) {
		return fu(e.base_);
	},
	setPrototypeOf() {
		du(12);
	}
}, Ju = {};
vu(qu, (e, t) => {
	Ju[e] = function() {
		return arguments[0] = arguments[0][0], t.apply(this, arguments);
	};
}), Ju.deleteProperty = function(e, t) {
	return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && du(13), Ju.set.call(this, e, t, void 0);
}, Ju.set = function(e, t, n) {
	return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && du(14), qu.set.call(this, e[0], t, n, e[0]);
};
function Yu(e, t) {
	let n = e[R];
	return (n ? Tu(n) : e)[t];
}
function Xu(e, t, n) {
	let r = Zu(t, n);
	return r ? "value" in r ? r.value : r.get?.call(e.draft_) : void 0;
}
function Zu(e, t) {
	if (!(t in e)) return;
	let n = fu(e);
	for (; n;) {
		let e = Object.getOwnPropertyDescriptor(n, t);
		if (e) return e;
		n = fu(n);
	}
}
function Qu(e) {
	e.modified_ || (e.modified_ = !0, e.parent_ && Qu(e.parent_));
}
function $u(e) {
	e.copy_ ||= Eu(e.base_, e.scope_.immer_.useStrictShallowCopy_);
}
var ed = class {
	constructor(e) {
		this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (e, t, n) => {
			if (typeof e == "function" && typeof t != "function") {
				let n = t;
				t = e;
				let r = this;
				return function(e = n, ...i) {
					return r.produce(e, (e) => t.call(this, e, ...i));
				};
			}
			typeof t != "function" && du(6), n !== void 0 && typeof n != "function" && du(7);
			let r;
			if (mu(e)) {
				let i = Bu(this), a = td(e, void 0), o = !0;
				try {
					r = t(a), o = !1;
				} finally {
					o ? Ru(i) : zu(i);
				}
				return Lu(i, n), Hu(r, i);
			}
			if (!e || typeof e != "object") {
				if (r = t(e), r === void 0 && (r = e), r === cu && (r = void 0), this.autoFreeze_ && Du(r, !0), n) {
					let t = [], i = [];
					Mu("Patches").generateReplacementPatches_(e, r, t, i), n(t, i);
				}
				return r;
			}
			du(1, e);
		}, this.produceWithPatches = (e, t) => {
			if (typeof e == "function") return (t, ...n) => this.produceWithPatches(t, (t) => e(t, ...n));
			let n, r;
			return [
				this.produce(e, t, (e, t) => {
					n = e, r = t;
				}),
				n,
				r
			];
		}, typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof e?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy), typeof e?.useStrictIteration == "boolean" && this.setUseStrictIteration(e.useStrictIteration);
	}
	createDraft(e) {
		mu(e) || du(8), pu(e) && (e = nd(e));
		let t = Bu(this), n = td(e, void 0);
		return n[R].isManual_ = !0, zu(t), n;
	}
	finishDraft(e, t) {
		let n = e && e[R];
		n && n.isManual_ || du(9);
		let { scope_: r } = n;
		return Lu(r, t), Hu(void 0, r);
	}
	setAutoFreeze(e) {
		this.autoFreeze_ = e;
	}
	setUseStrictShallowCopy(e) {
		this.useStrictShallowCopy_ = e;
	}
	setUseStrictIteration(e) {
		this.useStrictIteration_ = e;
	}
	shouldUseStrictIteration() {
		return this.useStrictIteration_;
	}
	applyPatches(e, t) {
		let n;
		for (n = t.length - 1; n >= 0; n--) {
			let r = t[n];
			if (r.path.length === 0 && r.op === "replace") {
				e = r.value;
				break;
			}
		}
		n > -1 && (t = t.slice(n + 1));
		let r = Mu("Patches").applyPatches_;
		return pu(e) ? r(e, t) : this.produce(e, (e) => r(e, t));
	}
};
function td(e, t) {
	let n = Cu(e) ? Mu("MapSet").proxyMap_(e, t) : wu(e) ? Mu("MapSet").proxySet_(e, t) : Ku(e, t);
	return (t ? t.scope_ : Fu()).drafts_.push(n), n;
}
function nd(e) {
	return pu(e) || du(10, e), rd(e);
}
function rd(e) {
	if (!mu(e) || Au(e)) return e;
	let t = e[R], n, r = !0;
	if (t) {
		if (!t.modified_) return t.base_;
		t.finalized_ = !0, n = Eu(e, t.scope_.immer_.useStrictShallowCopy_), r = t.scope_.immer_.shouldUseStrictIteration();
	} else n = Eu(e, !0);
	return vu(n, (e, t) => {
		xu(n, e, rd(t));
	}, r), t && (t.finalized_ = !1), n;
}
function id() {
	class e extends Map {
		constructor(e, t) {
			super(), this[R] = {
				type_: 2,
				parent_: t,
				scope_: t ? t.scope_ : Fu(),
				modified_: !1,
				finalized_: !1,
				copy_: void 0,
				assigned_: void 0,
				base_: e,
				draft_: this,
				isManual_: !1,
				revoked_: !1
			};
		}
		get size() {
			return Tu(this[R]).size;
		}
		has(e) {
			return Tu(this[R]).has(e);
		}
		set(e, t) {
			let r = this[R];
			return o(r), Tu(r).has(e) && Tu(r).get(e) === t || (n(r), Qu(r), r.assigned_.set(e, !0), r.copy_.set(e, t), r.assigned_.set(e, !0)), this;
		}
		delete(e) {
			if (!this.has(e)) return !1;
			let t = this[R];
			return o(t), n(t), Qu(t), t.base_.has(e) ? t.assigned_.set(e, !1) : t.assigned_.delete(e), t.copy_.delete(e), !0;
		}
		clear() {
			let e = this[R];
			o(e), Tu(e).size && (n(e), Qu(e), e.assigned_ = /* @__PURE__ */ new Map(), vu(e.base_, (t) => {
				e.assigned_.set(t, !1);
			}), e.copy_.clear());
		}
		forEach(e, t) {
			let n = this[R];
			Tu(n).forEach((n, r, i) => {
				e.call(t, this.get(r), r, this);
			});
		}
		get(e) {
			let t = this[R];
			o(t);
			let r = Tu(t).get(e);
			if (t.finalized_ || !mu(r) || r !== t.base_.get(e)) return r;
			let i = td(r, t);
			return n(t), t.copy_.set(e, i), i;
		}
		keys() {
			return Tu(this[R]).keys();
		}
		values() {
			let e = this.keys();
			return {
				[Symbol.iterator]: () => this.values(),
				next: () => {
					let t = e.next();
					return t.done ? t : {
						done: !1,
						value: this.get(t.value)
					};
				}
			};
		}
		entries() {
			let e = this.keys();
			return {
				[Symbol.iterator]: () => this.entries(),
				next: () => {
					let t = e.next();
					if (t.done) return t;
					let n = this.get(t.value);
					return {
						done: !1,
						value: [t.value, n]
					};
				}
			};
		}
		[Symbol.iterator]() {
			return this.entries();
		}
	}
	function t(t, n) {
		return new e(t, n);
	}
	function n(e) {
		e.copy_ ||= (e.assigned_ = /* @__PURE__ */ new Map(), new Map(e.base_));
	}
	class r extends Set {
		constructor(e, t) {
			super(), this[R] = {
				type_: 3,
				parent_: t,
				scope_: t ? t.scope_ : Fu(),
				modified_: !1,
				finalized_: !1,
				copy_: void 0,
				base_: e,
				draft_: this,
				drafts_: /* @__PURE__ */ new Map(),
				revoked_: !1,
				isManual_: !1
			};
		}
		get size() {
			return Tu(this[R]).size;
		}
		has(e) {
			let t = this[R];
			return o(t), t.copy_ ? !!(t.copy_.has(e) || t.drafts_.has(e) && t.copy_.has(t.drafts_.get(e))) : t.base_.has(e);
		}
		add(e) {
			let t = this[R];
			return o(t), this.has(e) || (a(t), Qu(t), t.copy_.add(e)), this;
		}
		delete(e) {
			if (!this.has(e)) return !1;
			let t = this[R];
			return o(t), a(t), Qu(t), t.copy_.delete(e) || (t.drafts_.has(e) ? t.copy_.delete(t.drafts_.get(e)) : 
			/* istanbul ignore next */
			!1);
		}
		clear() {
			let e = this[R];
			o(e), Tu(e).size && (a(e), Qu(e), e.copy_.clear());
		}
		values() {
			let e = this[R];
			return o(e), a(e), e.copy_.values();
		}
		entries() {
			let e = this[R];
			return o(e), a(e), e.copy_.entries();
		}
		keys() {
			return this.values();
		}
		[Symbol.iterator]() {
			return this.values();
		}
		forEach(e, t) {
			let n = this.values(), r = n.next();
			for (; !r.done;) e.call(t, r.value, r.value, this), r = n.next();
		}
	}
	function i(e, t) {
		return new r(e, t);
	}
	function a(e) {
		e.copy_ || (e.copy_ = /* @__PURE__ */ new Set(), e.base_.forEach((t) => {
			if (mu(t)) {
				let n = td(t, e);
				e.drafts_.set(t, n), e.copy_.add(n);
			} else e.copy_.add(t);
		}));
	}
	function o(e) {
		e.revoked_ && du(3, JSON.stringify(Tu(e)));
	}
	Nu("MapSet", {
		proxyMap_: t,
		proxySet_: i
	});
}
var ad = new ed(), od = ad.produce, sd = /* @__PURE__ */ ad.setAutoFreeze.bind(ad), cd = (e, t) => {
	let n = ve();
	me(() => {
		n.current = o(e, t);
	}), pe(e);
}, ld = (e) => () => {
	let [, t] = _e((e) => e + 1, 0), n = /* @__PURE__ */ new WeakMap(), r = ve(), i = ve(), a = ve();
	me(() => {
		r.current = n, i.current !== a.current && _(i.current, a.current, n, /* @__PURE__ */ new WeakMap()) && (i.current = a.current, t());
	});
	let o = e(P((e) => (a.current = e, i.current && i.current !== e && r.current && !_(i.current, e, r.current, /* @__PURE__ */ new WeakMap()) ? i.current : (i.current = e, e)), []));
	typeof process == "object" && process.env.NODE_ENV !== "production" && cd(o, n);
	let s = ge(() => /* @__PURE__ */ new WeakMap(), []);
	return u(o, n, s);
}, ud = /* @__PURE__ */ new Map(), dd = (e) => {
	let t = ud.get(e);
	return t ? Object.fromEntries(Object.entries(t.stores).map(([e, t]) => [e, t.getState()])) : {};
}, fd = (e, t, n) => {
	if (e === void 0) return {
		type: "untracked",
		connection: t.connect(n)
	};
	let r = ud.get(n.name);
	if (r) return {
		type: "tracked",
		store: e,
		...r
	};
	let i = {
		connection: t.connect(n),
		stores: {}
	};
	return ud.set(n.name, i), {
		type: "tracked",
		store: e,
		...i
	};
}, pd = (e, t = {}) => (n, r, i) => {
	let { enabled: a, anonymousActionType: o, store: s, ...c } = t, l;
	try {
		l = (a ?? !1) && window.__REDUX_DEVTOOLS_EXTENSION__;
	} catch {}
	if (!l) return e(n, r, i);
	let { connection: u, ...d } = fd(s, l, c), f = !0;
	i.setState = (e, t, a) => {
		let l = n(e, t);
		if (!f) return l;
		let d = a === void 0 ? { type: o || "anonymous" } : typeof a == "string" ? { type: a } : a;
		return s === void 0 ? (u?.send(d, r()), l) : (u?.send({
			...d,
			type: `${s}/${d.type}`
		}, {
			...dd(c.name),
			[s]: i.getState()
		}), l);
	};
	let p = (...e) => {
		let t = f;
		f = !1, n(...e), f = t;
	}, m = e(i.setState, r, i);
	if (d.type === "untracked" ? u?.init(m) : (d.stores[d.store] = i, u?.init(Object.fromEntries(Object.entries(d.stores).map(([e, t]) => [e, e === d.store ? m : t.getState()])))), i.dispatchFromDevtools && typeof i.dispatch == "function") {
		let e = i.dispatch;
		i.dispatch = (...t) => {
			e(...t);
		};
	}
	return u.subscribe((e) => {
		switch (e.type) {
			case "ACTION":
				if (typeof e.payload != "string") {
					console.error("[zustand devtools middleware] Unsupported action format");
					return;
				}
				return md(e.payload, (e) => {
					if (e.type === "__setState") {
						if (s === void 0) {
							p(e.state);
							return;
						}
						Object.keys(e.state).length !== 1 && console.error("\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { \"type\": \"__setState\", \"state\": { \"abc123Store\": { \"foo\": \"bar\" } } }\n                    ");
						let t = e.state[s];
						if (t == null) return;
						JSON.stringify(i.getState()) !== JSON.stringify(t) && p(t);
					} else i.dispatchFromDevtools && typeof i.dispatch == "function" && i.dispatch(e);
				});
			case "DISPATCH":
				switch (e.payload.type) {
					case "RESET": return p(m), s === void 0 ? u?.init(i.getState()) : u?.init(dd(c.name));
					case "COMMIT":
						if (s === void 0) {
							u?.init(i.getState());
							return;
						}
						return u?.init(dd(c.name));
					case "ROLLBACK": return md(e.state, (e) => {
						s === void 0 ? (p(e), u?.init(i.getState())) : (p(e[s]), u?.init(dd(c.name)));
					});
					case "JUMP_TO_STATE":
					case "JUMP_TO_ACTION": return md(e.state, (e) => {
						s === void 0 ? p(e) : JSON.stringify(i.getState()) !== JSON.stringify(e[s]) && p(e[s]);
					});
					case "IMPORT_STATE": {
						let { nextLiftedState: t } = e.payload, n = t.computedStates.slice(-1)[0]?.state;
						if (!n) return;
						p(s === void 0 ? n : n[s]), u?.send(null, t);
						return;
					}
					case "PAUSE_RECORDING": return f = !f;
				}
				return;
		}
	}), m;
}, md = (e, t) => {
	let n;
	try {
		n = JSON.parse(e);
	} catch (e) {
		console.error("[zustand devtools middleware] Could not parse the received json", e);
	}
	n !== void 0 && t(n);
};
function hd(e, t) {
	let n;
	try {
		n = e();
	} catch {
		return;
	}
	return {
		getItem: (e) => {
			let r = (e) => e === null ? null : JSON.parse(e, t?.reviver), i = n.getItem(e) ?? null;
			return i instanceof Promise ? i.then(r) : r(i);
		},
		setItem: (e, r) => n.setItem(e, JSON.stringify(r, t?.replacer)),
		removeItem: (e) => n.removeItem(e)
	};
}
var gd = (e) => (t) => {
	try {
		let n = e(t);
		return n instanceof Promise ? n : {
			then(e) {
				return gd(e)(n);
			},
			catch(e) {
				return this;
			}
		};
	} catch (e) {
		return {
			then(e) {
				return this;
			},
			catch(t) {
				return gd(t)(e);
			}
		};
	}
}, _d = (e, t) => (n, r, i) => {
	let a = {
		getStorage: () => localStorage,
		serialize: JSON.stringify,
		deserialize: JSON.parse,
		partialize: (e) => e,
		version: 0,
		merge: (e, t) => ({
			...t,
			...e
		}),
		...t
	}, o = !1, s = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), l;
	try {
		l = a.getStorage();
	} catch {}
	if (!l) return e((...e) => {
		console.warn(`[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`), n(...e);
	}, r, i);
	let u = gd(a.serialize), d = () => {
		let e = a.partialize({ ...r() }), t, n = u({
			state: e,
			version: a.version
		}).then((e) => l.setItem(a.name, e)).catch((e) => {
			t = e;
		});
		if (t) throw t;
		return n;
	}, f = i.setState;
	i.setState = (e, t) => {
		f(e, t), d();
	};
	let p = e((...e) => {
		n(...e), d();
	}, r, i), m, h = () => {
		if (!l) return;
		o = !1, s.forEach((e) => e(r()));
		let e = a.onRehydrateStorage?.call(a, r()) || void 0;
		return gd(l.getItem.bind(l))(a.name).then((e) => {
			if (e) return a.deserialize(e);
		}).then((e) => {
			if (e) {
				if (typeof e.version == "number" && e.version !== a.version) {
					if (a.migrate) return a.migrate(e.state, e.version);
					console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
				} else return e.state;
			}
		}).then((e) => (m = a.merge(e, r() ?? p), n(m, !0), d())).then(() => {
			e?.(m, void 0), o = !0, c.forEach((e) => e(m));
		}).catch((t) => {
			e?.(void 0, t);
		});
	};
	return i.persist = {
		setOptions: (e) => {
			a = {
				...a,
				...e
			}, e.getStorage && (l = e.getStorage());
		},
		clearStorage: () => {
			l?.removeItem(a.name);
		},
		getOptions: () => a,
		rehydrate: () => h(),
		hasHydrated: () => o,
		onHydrate: (e) => (s.add(e), () => {
			s.delete(e);
		}),
		onFinishHydration: (e) => (c.add(e), () => {
			c.delete(e);
		})
	}, h(), m || p;
}, vd = (e, t) => (n, r, i) => {
	let a = {
		storage: hd(() => localStorage),
		partialize: (e) => e,
		version: 0,
		merge: (e, t) => ({
			...t,
			...e
		}),
		...t
	}, o = !1, s = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), l = a.storage;
	if (!l) return e((...e) => {
		console.warn(`[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`), n(...e);
	}, r, i);
	let u = () => {
		let e = a.partialize({ ...r() });
		return l.setItem(a.name, {
			state: e,
			version: a.version
		});
	}, d = i.setState;
	i.setState = (e, t) => {
		d(e, t), u();
	};
	let f = e((...e) => {
		n(...e), u();
	}, r, i);
	i.getInitialState = () => f;
	let p, m = () => {
		if (!l) return;
		o = !1, s.forEach((e) => e(r() ?? f));
		let e = a.onRehydrateStorage?.call(a, r() ?? f) || void 0;
		return gd(l.getItem.bind(l))(a.name).then((e) => {
			if (e) {
				if (typeof e.version == "number" && e.version !== a.version) {
					if (a.migrate) return [!0, a.migrate(e.state, e.version)];
					console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
				} else return [!1, e.state];
			}
			return [!1, void 0];
		}).then((e) => {
			let [t, i] = e;
			if (p = a.merge(i, r() ?? f), n(p, !0), t) return u();
		}).then(() => {
			e?.(p, void 0), p = r(), o = !0, c.forEach((e) => e(p));
		}).catch((t) => {
			e?.(void 0, t);
		});
	};
	return i.persist = {
		setOptions: (e) => {
			a = {
				...a,
				...e
			}, e.storage && (l = e.storage);
		},
		clearStorage: () => {
			l?.removeItem(a.name);
		},
		getOptions: () => a,
		rehydrate: () => m(),
		hasHydrated: () => o,
		onHydrate: (e) => (s.add(e), () => {
			s.delete(e);
		}),
		onFinishHydration: (e) => (c.add(e), () => {
			c.delete(e);
		})
	}, a.skipHydration || m(), p || f;
}, yd = (e, t) => "getStorage" in t || "serialize" in t || "deserialize" in t ? _d(e, t) : vd(e, t), bd = /* @__PURE__ */ s(((e) => {
	var t = l();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, l = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, u(c) && l({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return u(c) && l({ inst: c }), e(function() {
				u(c) && l({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function u(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function d(e, t) {
		return t();
	}
	var f = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? d : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? f : t.useSyncExternalStore;
})), xd = /* @__PURE__ */ s(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		function n(e, t) {
			f || a.startTransition === void 0 || (f = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
			var n = t();
			if (!p) {
				var i = t();
				o(n, i) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), p = !0);
			}
			i = s({ inst: {
				value: n,
				getSnapshot: t
			} });
			var l = i[0].inst, m = i[1];
			return u(function() {
				l.value = n, l.getSnapshot = t, r(l) && m({ inst: l });
			}, [
				e,
				n,
				t
			]), c(function() {
				return r(l) && m({ inst: l }), e(function() {
					r(l) && m({ inst: l });
				});
			}, [e]), d(n), n;
		}
		function r(e) {
			var t = e.getSnapshot;
			e = e.value;
			try {
				var n = t();
				return !o(e, n);
			} catch {
				return !0;
			}
		}
		function i(e, t) {
			return t();
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var a = l(), o = typeof Object.is == "function" ? Object.is : t, s = a.useState, c = a.useEffect, u = a.useLayoutEffect, d = a.useDebugValue, f = !1, p = !1, m = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? i : n;
		e.useSyncExternalStore = a.useSyncExternalStore === void 0 ? m : a.useSyncExternalStore, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), Sd = /* @__PURE__ */ s(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? bd() : xd();
})), Cd = /* @__PURE__ */ s(((e) => {
	var t = l(), n = Sd();
	function r(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var i = typeof Object.is == "function" ? Object.is : r, a = n.useSyncExternalStore, o = t.useRef, s = t.useEffect, c = t.useMemo, u = t.useDebugValue;
	e.useSyncExternalStoreWithSelector = function(e, t, n, r, l) {
		var d = o(null);
		if (d.current === null) {
			var f = {
				hasValue: !1,
				value: null
			};
			d.current = f;
		} else f = d.current;
		d = c(function() {
			function e(e) {
				if (!a) {
					if (a = !0, o = e, e = r(e), l !== void 0 && f.hasValue) {
						var t = f.value;
						if (l(t, e)) return s = t;
					}
					return s = e;
				}
				if (t = s, i(o, e)) return t;
				var n = r(e);
				return l !== void 0 && l(t, n) ? (o = e, t) : (o = e, s = n);
			}
			var a = !1, o, s, c = n === void 0 ? null : n;
			return [function() {
				return e(t());
			}, c === null ? void 0 : function() {
				return e(c());
			}];
		}, [
			t,
			n,
			r,
			l
		]);
		var p = a(e, d[0], d[1]);
		return s(function() {
			f.hasValue = !0, f.value = p;
		}, [p]), u(p), p;
	};
})), wd = /* @__PURE__ */ s(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var n = l(), r = Sd(), i = typeof Object.is == "function" ? Object.is : t, a = r.useSyncExternalStore, o = n.useRef, s = n.useEffect, c = n.useMemo, u = n.useDebugValue;
		e.useSyncExternalStoreWithSelector = function(e, t, n, r, l) {
			var d = o(null);
			if (d.current === null) {
				var f = {
					hasValue: !1,
					value: null
				};
				d.current = f;
			} else f = d.current;
			d = c(function() {
				function e(e) {
					if (!a) {
						if (a = !0, o = e, e = r(e), l !== void 0 && f.hasValue) {
							var t = f.value;
							if (l(t, e)) return s = t;
						}
						return s = e;
					}
					if (t = s, i(o, e)) return t;
					var n = r(e);
					return l !== void 0 && l(t, n) ? (o = e, t) : (o = e, s = n);
				}
				var a = !1, o, s, c = n === void 0 ? null : n;
				return [function() {
					return e(t());
				}, c === null ? void 0 : function() {
					return e(c());
				}];
			}, [
				t,
				n,
				r,
				l
			]);
			var p = a(e, d[0], d[1]);
			return s(function() {
				f.hasValue = !0, f.value = p;
			}, [p]), u(p), p;
		}, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), Td = /* @__PURE__ */ s(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? Cd() : wd();
})), Ed = (e) => {
	let t, n = /* @__PURE__ */ new Set(), r = (e, r) => {
		let i = typeof e == "function" ? e(t) : e;
		if (!Object.is(i, t)) {
			let e = t;
			t = r ?? (typeof i != "object" || !i) ? i : Object.assign({}, t, i), n.forEach((n) => n(t, e));
		}
	}, i = () => t, a = {
		setState: r,
		getState: i,
		getInitialState: () => o,
		subscribe: (e) => (n.add(e), () => n.delete(e)),
		destroy: () => {
			n.clear();
		}
	}, o = t = e(r, i, a);
	return a;
}, Dd = (e) => e ? Ed(e) : Ed, Od = /* @__PURE__ */ c(Td(), 1), { useDebugValue: kd } = N, { useSyncExternalStoreWithSelector: Ad } = Od.default, jd = (e) => e;
function Md(e, t = jd, n) {
	let r = Ad(e.subscribe, e.getState, e.getServerState || e.getInitialState, t, n);
	return kd(r), r;
}
(/* @__PURE__ */ s(((e, t) => {
	var n = "__lodash_hash_undefined__", r = 9007199254740991, i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", c = "[object Error]", l = "[object Function]", u = "[object Map]", d = "[object Number]", f = "[object Object]", p = "[object Promise]", m = "[object RegExp]", h = "[object Set]", g = "[object String]", _ = "[object Symbol]", v = "[object WeakMap]", y = "[object ArrayBuffer]", b = "[object DataView]", x = "[object Float32Array]", S = "[object Float64Array]", C = "[object Int8Array]", w = "[object Int16Array]", T = "[object Int32Array]", E = "[object Uint8Array]", ee = "[object Uint8ClampedArray]", D = "[object Uint16Array]", O = "[object Uint32Array]", te = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, k = /^\w*$/, ne = /^\./, re = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, A = /[\\^$.*+?()[\]{}|]/g, ie = /\\(\\)?/g, ae = /^\[object .+?Constructor\]$/, j = /^(?:0|[1-9]\d*)$/, M = {};
	M[x] = M[S] = M[C] = M[w] = M[T] = M[E] = M[ee] = M[D] = M[O] = !0, M[i] = M[a] = M[y] = M[o] = M[b] = M[s] = M[c] = M[l] = M[u] = M[d] = M[f] = M[m] = M[h] = M[g] = M[v] = !1;
	var oe = typeof global == "object" && global && global.Object === Object && global, N = typeof self == "object" && self && self.Object === Object && self, se = oe || N || Function("return this")(), ce = typeof e == "object" && e && !e.nodeType && e, le = ce && typeof t == "object" && t && !t.nodeType && t, ue = le && le.exports === ce && oe.process, de = function() {
		try {
			return ue && ue.binding("util");
		} catch {}
	}(), P = de && de.isTypedArray;
	function fe(e, t) {
		for (var n = -1, r = e ? e.length : 0; ++n < r;) if (t(e[n], n, e)) return !0;
		return !1;
	}
	function pe(e) {
		return function(t) {
			return t?.[e];
		};
	}
	function me(e, t) {
		for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
		return r;
	}
	function he(e) {
		return function(t) {
			return e(t);
		};
	}
	function ge(e, t) {
		return e?.[t];
	}
	function _e(e) {
		var t = !1;
		if (e != null && typeof e.toString != "function") try {
			t = !!(e + "");
		} catch {}
		return t;
	}
	function ve(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e, r) {
			n[++t] = [r, e];
		}), n;
	}
	function ye(e, t) {
		return function(n) {
			return e(t(n));
		};
	}
	function be(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	var xe = Array.prototype, Se = Function.prototype, Ce = Object.prototype, we = se["__core-js_shared__"], Te = function() {
		var e = /[^.]+$/.exec(we && we.keys && we.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), Ee = Se.toString, De = Ce.hasOwnProperty, Oe = Ce.toString, ke = RegExp("^" + Ee.call(De).replace(A, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ae = se.Symbol, je = se.Uint8Array, Me = Ce.propertyIsEnumerable, Ne = xe.splice, Pe = ye(Object.keys, Object), Fe = Kt(se, "DataView"), Ie = Kt(se, "Map"), Le = Kt(se, "Promise"), Re = Kt(se, "Set"), ze = Kt(se, "WeakMap"), Be = Kt(Object, "create"), Ve = an(Fe), He = an(Ie), Ue = an(Le), We = an(Re), Ge = an(ze), Ke = Ae ? Ae.prototype : void 0, qe = Ke ? Ke.valueOf : void 0, Je = Ke ? Ke.toString : void 0;
	function Ye(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function Xe() {
		this.__data__ = Be ? Be(null) : {};
	}
	function Ze(e) {
		return this.has(e) && delete this.__data__[e];
	}
	function Qe(e) {
		var t = this.__data__;
		if (Be) {
			var r = t[e];
			return r === n ? void 0 : r;
		}
		return De.call(t, e) ? t[e] : void 0;
	}
	function $e(e) {
		var t = this.__data__;
		return Be ? t[e] !== void 0 : De.call(t, e);
	}
	function et(e, t) {
		var r = this.__data__;
		return r[e] = Be && t === void 0 ? n : t, this;
	}
	Ye.prototype.clear = Xe, Ye.prototype.delete = Ze, Ye.prototype.get = Qe, Ye.prototype.has = $e, Ye.prototype.set = et;
	function tt(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function nt() {
		this.__data__ = [];
	}
	function rt(e) {
		var t = this.__data__, n = Ct(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Ne.call(t, n, 1), !0);
	}
	function it(e) {
		var t = this.__data__, n = Ct(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function at(e) {
		return Ct(this.__data__, e) > -1;
	}
	function ot(e, t) {
		var n = this.__data__, r = Ct(n, e);
		return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
	}
	tt.prototype.clear = nt, tt.prototype.delete = rt, tt.prototype.get = it, tt.prototype.has = at, tt.prototype.set = ot;
	function st(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function ct() {
		this.__data__ = {
			hash: new Ye(),
			map: new (Ie || tt)(),
			string: new Ye()
		};
	}
	function lt(e) {
		return Wt(this, e).delete(e);
	}
	function ut(e) {
		return Wt(this, e).get(e);
	}
	function dt(e) {
		return Wt(this, e).has(e);
	}
	function ft(e, t) {
		return Wt(this, e).set(e, t), this;
	}
	st.prototype.clear = ct, st.prototype.delete = lt, st.prototype.get = ut, st.prototype.has = dt, st.prototype.set = ft;
	function pt(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.__data__ = new st(); ++t < n;) this.add(e[t]);
	}
	function mt(e) {
		return this.__data__.set(e, n), this;
	}
	function ht(e) {
		return this.__data__.has(e);
	}
	pt.prototype.add = pt.prototype.push = mt, pt.prototype.has = ht;
	function gt(e) {
		this.__data__ = new tt(e);
	}
	function _t() {
		this.__data__ = new tt();
	}
	function vt(e) {
		return this.__data__.delete(e);
	}
	function yt(e) {
		return this.__data__.get(e);
	}
	function bt(e) {
		return this.__data__.has(e);
	}
	function xt(e, t) {
		var n = this.__data__;
		if (n instanceof tt) {
			var r = n.__data__;
			if (!Ie || r.length < 199) return r.push([e, t]), this;
			n = this.__data__ = new st(r);
		}
		return n.set(e, t), this;
	}
	gt.prototype.clear = _t, gt.prototype.delete = vt, gt.prototype.get = yt, gt.prototype.has = bt, gt.prototype.set = xt;
	function St(e, t) {
		var n = ln(e) || cn(e) ? me(e.length, String) : [], r = n.length, i = !!r;
		for (var a in e) (t || De.call(e, a)) && (!i || a != "length" && !Yt(a, r)) && n.push(a);
		return n;
	}
	function Ct(e, t) {
		for (var n = e.length; n--;) if (sn(e[n][0], t)) return n;
		return -1;
	}
	var wt = Bt();
	function Tt(e, t) {
		return e && wt(e, t, bn);
	}
	function Et(e, t) {
		t = Xt(t, e) ? [t] : zt(t);
		for (var n = 0, r = t.length; e != null && n < r;) e = e[rn(t[n++])];
		return n && n == r ? e : void 0;
	}
	function Dt(e) {
		return Oe.call(e);
	}
	function Ot(e, t) {
		return e != null && t in Object(e);
	}
	function kt(e, t, n, r, i) {
		return e === t ? !0 : e == null || t == null || !I(e) && !mn(t) ? e !== e && t !== t : At(e, t, kt, n, r, i);
	}
	function At(e, t, n, r, o, s) {
		var c = ln(e), l = ln(t), u = a, d = a;
		c || (u = qt(e), u = u == i ? f : u), l || (d = qt(t), d = d == i ? f : d);
		var p = u == f && !_e(e), m = d == f && !_e(t), h = u == d;
		if (h && !p) return s ||= new gt(), c || gn(e) ? Vt(e, t, n, r, o, s) : Ht(e, t, u, n, r, o, s);
		if (!(o & 2)) {
			var g = p && De.call(e, "__wrapped__"), _ = m && De.call(t, "__wrapped__");
			if (g || _) {
				var v = g ? e.value() : e, y = _ ? t.value() : t;
				return s ||= new gt(), n(v, y, r, o, s);
			}
		}
		return h ? (s ||= new gt(), Ut(e, t, n, r, o, s)) : !1;
	}
	function jt(e, t, n, r) {
		var i = n.length, a = i, o = !r;
		if (e == null) return !a;
		for (e = Object(e); i--;) {
			var s = n[i];
			if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
		}
		for (; ++i < a;) {
			s = n[i];
			var c = s[0], l = e[c], u = s[1];
			if (o && s[2]) {
				if (l === void 0 && !(c in e)) return !1;
			} else {
				var d = new gt();
				if (r) var f = r(l, u, c, e, t, d);
				if (!(f === void 0 ? kt(u, l, r, 3, d) : f)) return !1;
			}
		}
		return !0;
	}
	function Mt(e) {
		return !I(e) || Qt(e) ? !1 : (fn(e) || _e(e) ? ke : ae).test(an(e));
	}
	function F(e) {
		return mn(e) && pn(e.length) && !!M[Oe.call(e)];
	}
	function Nt(e) {
		return typeof e == "function" ? e : e == null ? xn : typeof e == "object" ? ln(e) ? It(e[0], e[1]) : Ft(e) : Sn(e);
	}
	function Pt(e) {
		if (!$t(e)) return Pe(e);
		var t = [];
		for (var n in Object(e)) De.call(e, n) && n != "constructor" && t.push(n);
		return t;
	}
	function Ft(e) {
		var t = Gt(e);
		return t.length == 1 && t[0][2] ? tn(t[0][0], t[0][1]) : function(n) {
			return n === e || jt(n, e, t);
		};
	}
	function It(e, t) {
		return Xt(e) && en(t) ? tn(rn(e), t) : function(n) {
			var r = vn(n, e);
			return r === void 0 && r === t ? yn(n, e) : kt(t, r, void 0, 3);
		};
	}
	function Lt(e) {
		return function(t) {
			return Et(t, e);
		};
	}
	function Rt(e) {
		if (typeof e == "string") return e;
		if (hn(e)) return Je ? Je.call(e) : "";
		var t = e + "";
		return t == "0" && 1 / e == -Infinity ? "-0" : t;
	}
	function zt(e) {
		return ln(e) ? e : nn(e);
	}
	function Bt(e) {
		return function(t, n, r) {
			for (var i = -1, a = Object(t), o = r(t), s = o.length; s--;) {
				var c = o[e ? s : ++i];
				if (n(a[c], c, a) === !1) break;
			}
			return t;
		};
	}
	function Vt(e, t, n, r, i, a) {
		var o = i & 2, s = e.length, c = t.length;
		if (s != c && !(o && c > s)) return !1;
		var l = a.get(e);
		if (l && a.get(t)) return l == t;
		var u = -1, d = !0, f = i & 1 ? new pt() : void 0;
		for (a.set(e, t), a.set(t, e); ++u < s;) {
			var p = e[u], m = t[u];
			if (r) var h = o ? r(m, p, u, t, e, a) : r(p, m, u, e, t, a);
			if (h !== void 0) {
				if (h) continue;
				d = !1;
				break;
			}
			if (f) {
				if (!fe(t, function(e, t) {
					if (!f.has(t) && (p === e || n(p, e, r, i, a))) return f.add(t);
				})) {
					d = !1;
					break;
				}
			} else if (!(p === m || n(p, m, r, i, a))) {
				d = !1;
				break;
			}
		}
		return a.delete(e), a.delete(t), d;
	}
	function Ht(e, t, n, r, i, a, l) {
		switch (n) {
			case b:
				if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
				e = e.buffer, t = t.buffer;
			case y: return !(e.byteLength != t.byteLength || !r(new je(e), new je(t)));
			case o:
			case s:
			case d: return sn(+e, +t);
			case c: return e.name == t.name && e.message == t.message;
			case m:
			case g: return e == t + "";
			case u: var f = ve;
			case h:
				var p = a & 2;
				if (f ||= be, e.size != t.size && !p) return !1;
				var v = l.get(e);
				if (v) return v == t;
				a |= 1, l.set(e, t);
				var x = Vt(f(e), f(t), r, i, a, l);
				return l.delete(e), x;
			case _: if (qe) return qe.call(e) == qe.call(t);
		}
		return !1;
	}
	function Ut(e, t, n, r, i, a) {
		var o = i & 2, s = bn(e), c = s.length;
		if (c != bn(t).length && !o) return !1;
		for (var l = c; l--;) {
			var u = s[l];
			if (!(o ? u in t : De.call(t, u))) return !1;
		}
		var d = a.get(e);
		if (d && a.get(t)) return d == t;
		var f = !0;
		a.set(e, t), a.set(t, e);
		for (var p = o; ++l < c;) {
			u = s[l];
			var m = e[u], h = t[u];
			if (r) var g = o ? r(h, m, u, t, e, a) : r(m, h, u, e, t, a);
			if (!(g === void 0 ? m === h || n(m, h, r, i, a) : g)) {
				f = !1;
				break;
			}
			p ||= u == "constructor";
		}
		if (f && !p) {
			var _ = e.constructor, v = t.constructor;
			_ != v && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof v == "function" && v instanceof v) && (f = !1);
		}
		return a.delete(e), a.delete(t), f;
	}
	function Wt(e, t) {
		var n = e.__data__;
		return Zt(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function Gt(e) {
		for (var t = bn(e), n = t.length; n--;) {
			var r = t[n], i = e[r];
			t[n] = [
				r,
				i,
				en(i)
			];
		}
		return t;
	}
	function Kt(e, t) {
		var n = ge(e, t);
		return Mt(n) ? n : void 0;
	}
	var qt = Dt;
	(Fe && qt(new Fe(/* @__PURE__ */ new ArrayBuffer(1))) != b || Ie && qt(new Ie()) != u || Le && qt(Le.resolve()) != p || Re && qt(new Re()) != h || ze && qt(new ze()) != v) && (qt = function(e) {
		var t = Oe.call(e), n = t == f ? e.constructor : void 0, r = n ? an(n) : void 0;
		if (r) switch (r) {
			case Ve: return b;
			case He: return u;
			case Ue: return p;
			case We: return h;
			case Ge: return v;
		}
		return t;
	});
	function Jt(e, t, n) {
		t = Xt(t, e) ? [t] : zt(t);
		for (var r, i = -1, a = t.length; ++i < a;) {
			var o = rn(t[i]);
			if (!(r = e != null && n(e, o))) break;
			e = e[o];
		}
		if (r) return r;
		var a = e ? e.length : 0;
		return !!a && pn(a) && Yt(o, a) && (ln(e) || cn(e));
	}
	function Yt(e, t) {
		return t ??= r, !!t && (typeof e == "number" || j.test(e)) && e > -1 && e % 1 == 0 && e < t;
	}
	function Xt(e, t) {
		if (ln(e)) return !1;
		var n = typeof e;
		return n == "number" || n == "symbol" || n == "boolean" || e == null || hn(e) ? !0 : k.test(e) || !te.test(e) || t != null && e in Object(t);
	}
	function Zt(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function Qt(e) {
		return !!Te && Te in e;
	}
	function $t(e) {
		var t = e && e.constructor;
		return e === (typeof t == "function" && t.prototype || Ce);
	}
	function en(e) {
		return e === e && !I(e);
	}
	function tn(e, t) {
		return function(n) {
			return n != null && n[e] === t && (t !== void 0 || e in Object(n));
		};
	}
	var nn = on(function(e) {
		e = _n(e);
		var t = [];
		return ne.test(e) && t.push(""), e.replace(re, function(e, n, r, i) {
			t.push(r ? i.replace(ie, "$1") : n || e);
		}), t;
	});
	function rn(e) {
		if (typeof e == "string" || hn(e)) return e;
		var t = e + "";
		return t == "0" && 1 / e == -Infinity ? "-0" : t;
	}
	function an(e) {
		if (e != null) {
			try {
				return Ee.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function on(e, t) {
		if (typeof e != "function" || t && typeof t != "function") throw TypeError("Expected a function");
		var n = function() {
			var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
			if (a.has(i)) return a.get(i);
			var o = e.apply(this, r);
			return n.cache = a.set(i, o), o;
		};
		return n.cache = new (on.Cache || st)(), n;
	}
	on.Cache = st;
	function sn(e, t) {
		return e === t || e !== e && t !== t;
	}
	function cn(e) {
		return dn(e) && De.call(e, "callee") && (!Me.call(e, "callee") || Oe.call(e) == i);
	}
	var ln = Array.isArray;
	function un(e) {
		return e != null && pn(e.length) && !fn(e);
	}
	function dn(e) {
		return mn(e) && un(e);
	}
	function fn(e) {
		var t = I(e) ? Oe.call(e) : "";
		return t == l || t == "[object GeneratorFunction]";
	}
	function pn(e) {
		return typeof e == "number" && e > -1 && e % 1 == 0 && e <= r;
	}
	function I(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function mn(e) {
		return !!e && typeof e == "object";
	}
	function hn(e) {
		return typeof e == "symbol" || mn(e) && Oe.call(e) == _;
	}
	var gn = P ? he(P) : F;
	function _n(e) {
		return e == null ? "" : Rt(e);
	}
	function vn(e, t, n) {
		var r = e == null ? void 0 : Et(e, t);
		return r === void 0 ? n : r;
	}
	function yn(e, t) {
		return e != null && Jt(e, t, Ot);
	}
	function bn(e) {
		return un(e) ? St(e) : Pt(e);
	}
	function L(e, t) {
		var n = {};
		return t = Nt(t, 3), Tt(e, function(e, r, i) {
			n[r] = t(e, r, i);
		}), n;
	}
	function xn(e) {
		return e;
	}
	function Sn(e) {
		return Xt(e) ? pe(rn(e)) : Lt(e);
	}
	t.exports = L;
})))();
var Nd = Object.defineProperty, Pd = Object.defineProperties, Fd = Object.getOwnPropertyDescriptors, Id = Object.getOwnPropertySymbols, Ld = Object.prototype.hasOwnProperty, Rd = Object.prototype.propertyIsEnumerable, zd = (e, t, n) => t in e ? Nd(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Bd = (e, t) => {
	for (var n in t ||= {}) Ld.call(t, n) && zd(e, n, t[n]);
	if (Id) for (var n of Id(t)) Rd.call(t, n) && zd(e, n, t[n]);
	return e;
}, Vd = (e, t) => Pd(e, Fd(t)), Hd = (e) => (t, n, r) => {
	let i = (e, n) => t(od(e), !0, n);
	return r.setState = i, e(i, n, r);
}, Ud = (e, t) => {
	let n = {};
	return Object.keys(e.getState()).forEach((r) => {
		n[r] = (n) => {
			if (e.getState()[r] === n) return;
			let i = r.replace(/^\S/, (e) => e.toUpperCase());
			e.setState((e) => {
				e[r] = n;
			}, `@@${t}/set${i}`);
		};
	}), n;
}, Wd = (e) => {
	let t = {};
	return Object.keys(e.getState()).forEach((n) => {
		t[n] = () => e.getState()[n];
	}), t;
}, Gd = (e, t) => {
	let n = {};
	return Object.keys(t.getState()).forEach((t) => {
		n[t] = (n) => e((e) => e[t], n);
	}), n;
}, Kd = (e, t) => {
	let n = {};
	return Object.keys(t.getState()).forEach((t) => {
		n[t] = () => e()[t];
	}), n;
};
function qd(e, ...t) {
	return t.reduce((e, t) => t(e), e);
}
var Jd = (e, t) => {
	let n = e(t.set, t.get, t);
	return Vd(Bd({}, t), { set: Bd(Bd({}, t.set), n) });
}, Yd = (e, t) => {
	let n = Bd({}, t.use), r = Bd({}, t.useTracked), i = Bd({}, t.get);
	return Object.keys(e(t.store.getState(), t.get, t)).forEach((a) => {
		n[a] = (...n) => t.useStore((r) => {
			let i = e(r, t.get, t)[a];
			return i(...n);
		}), r[a] = (...n) => {
			let r = e(t.useTrackedStore(), t.get, t)[a];
			return r(...n);
		}, i[a] = (...n) => {
			let r = e(t.store.getState(), t.get, t)[a];
			return r(...n);
		};
	}), Vd(Bd({}, t), {
		get: i,
		use: n,
		useTracked: r
	});
}, Xd = (e) => Vd(Bd({}, e), {
	extendSelectors: (t) => Xd(Yd(t, e)),
	extendActions: (t) => Xd(Jd(t, e))
}), Zd = (e) => (t, n = {}) => {
	let { middlewares: r = [], devtools: i, persist: a, immer: o } = n;
	sd(o?.enabledAutoFreeze ?? !1), o?.enableMapSet && id();
	let s = [Hd, ...r];
	if (a?.enabled) {
		let t = Vd(Bd({}, a), { name: a.name ?? e });
		s.push((e) => yd(e, t));
	}
	i?.enabled && s.push((t) => pd(t, Vd(Bd({}, i), { name: e }))), s.push(Dd);
	let c = ((e) => qd(e, ...s))(() => t), l = (e, t) => Md(c, e, t), u = Ud(c, e), d = (t, n) => {
		c.setState((e) => {
			Object.assign(e, t);
		}, n || `@@${e}/mergeState`);
	}, f = (t, n) => {
		c.setState(t, n || `@@${e}/setState`);
	}, p = Gd(l, c), m = Wd(c), h = ld(l), g = Kd(h, c), _ = {
		get: Bd({ state: c.getState }, m),
		name: e,
		set: Bd({
			state: f,
			mergeState: d
		}, u),
		store: c,
		use: p,
		useTracked: g,
		useStore: l,
		useTrackedStore: h,
		extendSelectors: () => _,
		extendActions: () => _
	};
	return Xd(_);
};
// ../../../node_modules/react-hotkeys-hook/dist/react-hotkeys-hook.esm.js
function Qd() {
	return Qd = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Qd.apply(null, arguments);
}
var $d = [
	"shift",
	"alt",
	"meta",
	"mod",
	"ctrl"
], ef = {
	esc: "escape",
	return: "enter",
	".": "period",
	",": "comma",
	"-": "slash",
	" ": "space",
	"`": "backquote",
	"#": "backslash",
	"+": "bracketright",
	ShiftLeft: "shift",
	ShiftRight: "shift",
	AltLeft: "alt",
	AltRight: "alt",
	MetaLeft: "meta",
	MetaRight: "meta",
	OSLeft: "meta",
	OSRight: "meta",
	ControlLeft: "ctrl",
	ControlRight: "ctrl"
};
function tf(e) {
	return (e && ef[e] || e || "").trim().toLowerCase().replace(/key|digit|numpad|arrow/, "");
}
function nf(e) {
	return $d.includes(e);
}
function rf(e, t) {
	return t === void 0 && (t = ","), e.split(t);
}
function af(e, t, n) {
	t === void 0 && (t = "+");
	var r = e.toLocaleLowerCase().split(t).map(function(e) {
		return tf(e);
	}), i = {
		alt: r.includes("alt"),
		ctrl: r.includes("ctrl") || r.includes("control"),
		shift: r.includes("shift"),
		meta: r.includes("meta"),
		mod: r.includes("mod")
	}, a = r.filter(function(e) {
		return !$d.includes(e);
	});
	return Qd({}, i, {
		keys: a,
		description: n,
		hotkey: e
	});
}
(function() {
	typeof document < "u" && (document.addEventListener("keydown", function(e) {
		e.key !== void 0 && lf([tf(e.key), tf(e.code)]);
	}), document.addEventListener("keyup", function(e) {
		e.key !== void 0 && uf([tf(e.key), tf(e.code)]);
	})), typeof window < "u" && window.addEventListener("blur", function() {
		of.clear();
	});
})();
var of = /*#__PURE__*/ new Set();
function sf(e) {
	return Array.isArray(e);
}
function cf(e, t) {
	return t === void 0 && (t = ","), (sf(e) ? e : e.split(t)).every(function(e) {
		return of.has(e.trim().toLowerCase());
	});
}
function lf(e) {
	var t = Array.isArray(e) ? e : [e];
	of.has("meta") && of.forEach(function(e) {
		return !nf(e) && of.delete(e.toLowerCase());
	}), t.forEach(function(e) {
		return of.add(e.toLowerCase());
	});
}
function uf(e) {
	e === "meta" ? of.clear() : (Array.isArray(e) ? e : [e]).forEach(function(e) {
		return of.delete(e.toLowerCase());
	});
}
function df(e, t, n) {
	(typeof n == "function" && n(e, t) || n === !0) && e.preventDefault();
}
function ff(e, t, n) {
	return typeof n == "function" ? n(e, t) : n === !0 || n === void 0;
}
function pf(e) {
	return mf(e, [
		"input",
		"textarea",
		"select"
	]);
}
function mf(e, t) {
	t === void 0 && (t = !1);
	var n = e.target, r = e.composed, i = null;
	return i = hf(n) && r ? e.composedPath()[0] && e.composedPath()[0].tagName : n && n.tagName, sf(t) ? !!(i && t && t.some(function(e) {
		return e.toLowerCase() === i?.toLowerCase();
	})) : !!(i && t && t);
}
function hf(e) {
	return !!e.tagName && !e.tagName.startsWith("-") && e.tagName.includes("-");
}
function gf(e, t) {
	return e.length === 0 && t ? (console.warn("A hotkey has the \"scopes\" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>"), !0) : !t || e.some(function(e) {
		return t.includes(e);
	}) || e.includes("*");
}
var _f = function(e, t, n) {
	n === void 0 && (n = !1);
	var r = t.alt, i = t.meta, a = t.mod, o = t.shift, s = t.ctrl, c = t.keys, l = e.key, u = e.code, d = e.ctrlKey, f = e.metaKey, p = e.shiftKey, m = e.altKey, h = tf(u), g = l.toLowerCase();
	if (!(c != null && c.includes(h)) && !(c != null && c.includes(g)) && ![
		"ctrl",
		"control",
		"unknown",
		"meta",
		"alt",
		"shift",
		"os"
	].includes(h)) return !1;
	if (!n) {
		if (r === !m && g !== "alt" || o === !p && g !== "shift") return !1;
		if (a) {
			if (!f && !d) return !1;
		} else if (i === !f && g !== "meta" && g !== "os" || s === !d && g !== "ctrl" && g !== "control") return !1;
	}
	return c && c.length === 1 && (c.includes(g) || c.includes(h)) ? !0 : c ? cf(c) : !c;
}, vf = /*#__PURE__*/ ce(void 0), yf = function() {
	return fe(vf);
};
function bf(e, t) {
	return e && t && typeof e == "object" && typeof t == "object" ? Object.keys(e).length === Object.keys(t).length && Object.keys(e).reduce(function(n, r) {
		return n && bf(e[r], t[r]);
	}, !0) : e === t;
}
var xf = /*#__PURE__*/ ce({
	hotkeys: [],
	enabledScopes: [],
	toggleScope: function() {},
	enableScope: function() {},
	disableScope: function() {}
}), Sf = function() {
	return fe(xf);
};
function Cf(e) {
	var t = ve(void 0);
	return bf(t.current, e) || (t.current = e), t.current;
}
var wf = function(e) {
	e.stopPropagation(), e.preventDefault(), e.stopImmediatePropagation();
}, Tf = typeof window < "u" ? he : me;
function Ef(e, t, n, r) {
	var i = ye(null), a = i[0], o = i[1], s = ve(!1), c = n instanceof Array ? r instanceof Array ? void 0 : r : n, l = sf(e) ? e.join(c?.splitKey) : e, u = n instanceof Array ? n : r instanceof Array ? r : void 0, d = P(t, u ?? []), f = ve(d);
	f.current = u ? d : t;
	var p = Cf(c), m = Sf().enabledScopes, h = yf();
	return Tf(function() {
		if (p?.enabled !== !1 && gf(m, p?.scopes)) {
			var e = function(e, t) {
				var n;
				if (t === void 0 && (t = !1), !pf(e) || mf(e, p?.enableOnFormTags)) {
					if (a !== null) {
						var r = a.getRootNode();
						if ((r instanceof Document || r instanceof ShadowRoot) && r.activeElement !== a && !a.contains(r.activeElement)) {
							wf(e);
							return;
						}
					}
					((n = e.target) == null || !n.isContentEditable || p != null && p.enableOnContentEditable) && rf(l, p?.splitKey).forEach(function(n) {
						var r, i = af(n, p?.combinationKey);
						if (_f(e, i, p?.ignoreModifiers) || (r = i.keys) != null && r.includes("*")) {
							if (p != null && p.ignoreEventWhen != null && p.ignoreEventWhen(e) || t && s.current) return;
							if (df(e, i, p?.preventDefault), !ff(e, i, p?.enabled)) {
								wf(e);
								return;
							}
							f.current(e, i), t || (s.current = !0);
						}
					});
				}
			}, t = function(t) {
				t.key !== void 0 && (lf(tf(t.code)), (p?.keydown === void 0 && p?.keyup !== !0 || p != null && p.keydown) && e(t));
			}, n = function(t) {
				t.key !== void 0 && (uf(tf(t.code)), s.current = !1, p != null && p.keyup && e(t, !0));
			}, r = a || c?.document || document;
			return r.addEventListener("keyup", n, c?.eventListenerOptions), r.addEventListener("keydown", t, c?.eventListenerOptions), h && rf(l, p?.splitKey).forEach(function(e) {
				return h.addHotkey(af(e, p?.combinationKey, p?.description));
			}), function() {
				r.removeEventListener("keyup", n, c?.eventListenerOptions), r.removeEventListener("keydown", t, c?.eventListenerOptions), h && rf(l, p?.splitKey).forEach(function(e) {
					return h.removeHotkey(af(e, p?.combinationKey, p?.description));
				});
			};
		}
	}, [
		a,
		l,
		p,
		m
	]), o;
}
// ../../../node_modules/is-plain-object/dist/is-plain-object.mjs
function Df(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Of(e) {
	var t, n;
	return Df(e) !== !1 && (t = e.constructor, t === void 0 || (n = t.prototype, Df(n) !== !1 && n.hasOwnProperty("isPrototypeOf") !== !1));
}
// ../../../node_modules/immer/dist/immer.esm.mjs
function kf(e) {
	var t = [...arguments].slice(1);
	if (process.env.NODE_ENV !== "production") {
		var n = vp[e], r = n ? typeof n == "function" ? n.apply(null, t) : n : "unknown error nr: " + e;
		throw Error("[Immer] " + r);
	}
	throw Error("[Immer] minified error nr: " + e + (t.length ? " " + t.map((function(e) {
		return "'" + e + "'";
	})).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Af(e) {
	return !!e && !!e[_p];
}
function jf(e) {
	return !!e && (function(e) {
		if (!e || typeof e != "object") return !1;
		var t = Object.getPrototypeOf(e);
		if (t === null) return !0;
		var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
		return n === Object || typeof n == "function" && Function.toString.call(n) === yp;
	}(e) || Array.isArray(e) || !!e[gp] || !!e.constructor?.[gp] || Rf(e) || zf(e));
}
function Mf(e, t, n) {
	n === void 0 && (n = !1), Nf(e) === 0 ? (n ? Object.keys : bp)(e).forEach((function(r) {
		n && typeof r == "symbol" || t(r, e[r], e);
	})) : e.forEach((function(n, r) {
		return t(r, n, e);
	}));
}
function Nf(e) {
	var t = e[_p];
	return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : Rf(e) ? 2 : zf(e) ? 3 : 0;
}
function Pf(e, t) {
	return Nf(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Ff(e, t) {
	return Nf(e) === 2 ? e.get(t) : e[t];
}
function If(e, t, n) {
	var r = Nf(e);
	r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function Lf(e, t) {
	return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function Rf(e) {
	return fp && e instanceof Map;
}
function zf(e) {
	return pp && e instanceof Set;
}
function Bf(e) {
	return e.o || e.t;
}
function Vf(e) {
	if (Array.isArray(e)) return Array.prototype.slice.call(e);
	var t = xp(e);
	delete t[_p];
	for (var n = bp(t), r = 0; r < n.length; r++) {
		var i = n[r], a = t[i];
		!1 === a.writable && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (t[i] = {
			configurable: !0,
			writable: !0,
			enumerable: a.enumerable,
			value: e[i]
		});
	}
	return Object.create(Object.getPrototypeOf(e), t);
}
function Hf(e, t) {
	return t === void 0 && (t = !1), Wf(e) || Af(e) || !jf(e) || (Nf(e) > 1 && (e.set = e.add = e.clear = e.delete = Uf), Object.freeze(e), t && Mf(e, (function(e, t) {
		return Hf(t, !0);
	}), !0)), e;
}
function Uf() {
	kf(2);
}
function Wf(e) {
	return typeof e != "object" || !e || Object.isFrozen(e);
}
function Gf(e) {
	var t = Sp[e];
	return t || kf(18, e), t;
}
function Kf() {
	return process.env.NODE_ENV === "production" || up || kf(0), up;
}
function qf(e, t) {
	t && (Gf("Patches"), e.u = [], e.s = [], e.v = t);
}
function Jf(e) {
	Yf(e), e.p.forEach(Zf), e.p = null;
}
function Yf(e) {
	e === up && (up = e.l);
}
function Xf(e) {
	return up = {
		p: [],
		l: up,
		h: e,
		m: !0,
		_: 0
	};
}
function Zf(e) {
	var t = e[_p];
	t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function Qf(e, t) {
	t._ = t.p.length;
	var n = t.p[0], r = e !== void 0 && e !== n;
	return t.h.O || Gf("ES5").S(t, e, r), r ? (n[_p].P && (Jf(t), kf(4)), jf(e) && (e = $f(t, e), t.l || tp(t, e)), t.u && Gf("Patches").M(n[_p].t, e, t.u, t.s)) : e = $f(t, n, []), Jf(t), t.u && t.v(t.u, t.s), e === hp ? void 0 : e;
}
function $f(e, t, n) {
	if (Wf(t)) return t;
	var r = t[_p];
	if (!r) return Mf(t, (function(i, a) {
		return ep(e, r, t, i, a, n);
	}), !0), t;
	if (r.A !== e) return t;
	if (!r.P) return tp(e, r.t, !0), r.t;
	if (!r.I) {
		r.I = !0, r.A._--;
		var i = r.i === 4 || r.i === 5 ? r.o = Vf(r.k) : r.o, a = i, o = !1;
		r.i === 3 && (a = new Set(i), i.clear(), o = !0), Mf(a, (function(t, a) {
			return ep(e, r, i, t, a, n, o);
		})), tp(e, i, !1), n && e.u && Gf("Patches").N(r, n, e.u, e.s);
	}
	return r.o;
}
function ep(e, t, n, r, i, a, o) {
	if (process.env.NODE_ENV !== "production" && i === n && kf(5), Af(i)) {
		var s = $f(e, i, a && t && t.i !== 3 && !Pf(t.R, r) ? a.concat(r) : void 0);
		if (If(n, r, s), !Af(s)) return;
		e.m = !1;
	} else o && n.add(i);
	if (jf(i) && !Wf(i)) {
		if (!e.h.D && e._ < 1) return;
		$f(e, i), t && t.A.l || tp(e, i);
	}
}
function tp(e, t, n) {
	n === void 0 && (n = !1), !e.l && e.h.D && e.m && Hf(t, n);
}
function np(e, t) {
	var n = e[_p];
	return (n ? Bf(n) : e)[t];
}
function rp(e, t) {
	if (t in e) for (var n = Object.getPrototypeOf(e); n;) {
		var r = Object.getOwnPropertyDescriptor(n, t);
		if (r) return r;
		n = Object.getPrototypeOf(n);
	}
}
function ip(e) {
	e.P || (e.P = !0, e.l && ip(e.l));
}
function ap(e) {
	e.o ||= Vf(e.t);
}
function op(e, t, n) {
	var r = Rf(t) ? Gf("MapSet").F(t, n) : zf(t) ? Gf("MapSet").T(t, n) : e.O ? function(e, t) {
		var n = Array.isArray(e), r = {
			i: +!!n,
			A: t ? t.A : Kf(),
			P: !1,
			I: !1,
			R: {},
			l: t,
			t: e,
			k: null,
			o: null,
			j: null,
			C: !1
		}, i = r, a = Cp;
		n && (i = [r], a = wp);
		var o = Proxy.revocable(i, a), s = o.revoke, c = o.proxy;
		return r.k = c, r.j = s, c;
	}(t, n) : Gf("ES5").J(t, n);
	return (n ? n.A : Kf()).p.push(r), r;
}
function sp(e) {
	return Af(e) || kf(22, e), function e(t) {
		if (!jf(t)) return t;
		var n, r = t[_p], i = Nf(t);
		if (r) {
			if (!r.P && (r.i < 4 || !Gf("ES5").K(r))) return r.t;
			r.I = !0, n = cp(t, i), r.I = !1;
		} else n = cp(t, i);
		return Mf(n, (function(t, i) {
			r && Ff(r.t, t) === i || If(n, t, e(i));
		})), i === 3 ? new Set(n) : n;
	}(e);
}
function cp(e, t) {
	switch (t) {
		case 2: return new Map(e);
		case 3: return Array.from(e);
	}
	return Vf(e);
}
var lp, up, dp = typeof Symbol < "u" && typeof Symbol("x") == "symbol", fp = typeof Map < "u", pp = typeof Set < "u", mp = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", hp = dp ? Symbol.for("immer-nothing") : ((lp = {})["immer-nothing"] = !0, lp), gp = dp ? Symbol.for("immer-draftable") : "__$immer_draftable", _p = dp ? Symbol.for("immer-state") : "__$immer_state", vp = {
	0: "Illegal state",
	1: "Immer drafts cannot have computed properties",
	2: "This object has been frozen and should not be mutated",
	3: function(e) {
		return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
	},
	4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
	5: "Immer forbids circular references",
	6: "The first or second argument to `produce` must be a function",
	7: "The third argument to `produce` must be a function or undefined",
	8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
	9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
	10: "The given draft is already finalized",
	11: "Object.defineProperty() cannot be used on an Immer draft",
	12: "Object.setPrototypeOf() cannot be used on an Immer draft",
	13: "Immer only supports deleting array indices",
	14: "Immer only supports setting array indices and the 'length' property",
	15: function(e) {
		return "Cannot apply patch, path doesn't resolve: " + e;
	},
	16: "Sets cannot have \"replace\" patches.",
	17: function(e) {
		return "Unsupported patch operation: " + e;
	},
	18: function(e) {
		return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
	},
	20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
	21: function(e) {
		return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
	},
	22: function(e) {
		return "'current' expects a draft, got: " + e;
	},
	23: function(e) {
		return "'original' expects a draft, got: " + e;
	},
	24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, yp = "" + Object.prototype.constructor, bp = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols === void 0 ? Object.getOwnPropertyNames : function(e) {
	return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
}, xp = Object.getOwnPropertyDescriptors || function(e) {
	var t = {};
	return bp(e).forEach((function(n) {
		t[n] = Object.getOwnPropertyDescriptor(e, n);
	})), t;
}, Sp = {}, Cp = {
	get: function(e, t) {
		if (t === _p) return e;
		var n = Bf(e);
		if (!Pf(n, t)) return function(e, t, n) {
			var r = rp(t, n);
			return r ? "value" in r ? r.value : r.get?.call(e.k) : void 0;
		}(e, n, t);
		var r = n[t];
		return e.I || !jf(r) ? r : r === np(e.t, t) ? (ap(e), e.o[t] = op(e.A.h, r, e)) : r;
	},
	has: function(e, t) {
		return t in Bf(e);
	},
	ownKeys: function(e) {
		return Reflect.ownKeys(Bf(e));
	},
	set: function(e, t, n) {
		var r = rp(Bf(e), t);
		if (r?.set) return r.set.call(e.k, n), !0;
		if (!e.P) {
			var i = np(Bf(e), t), a = i?.[_p];
			if (a && a.t === n) return e.o[t] = n, e.R[t] = !1, !0;
			if (Lf(n, i) && (n !== void 0 || Pf(e.t, t))) return !0;
			ap(e), ip(e);
		}
		return e.o[t] === n && (n !== void 0 || t in e.o) || Number.isNaN(n) && Number.isNaN(e.o[t]) || (e.o[t] = n, e.R[t] = !0), !0;
	},
	deleteProperty: function(e, t) {
		return np(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, ap(e), ip(e)) : delete e.R[t], e.o && delete e.o[t], !0;
	},
	getOwnPropertyDescriptor: function(e, t) {
		var n = Bf(e), r = Reflect.getOwnPropertyDescriptor(n, t);
		return r && {
			writable: !0,
			configurable: e.i !== 1 || t !== "length",
			enumerable: r.enumerable,
			value: n[t]
		};
	},
	defineProperty: function() {
		kf(11);
	},
	getPrototypeOf: function(e) {
		return Object.getPrototypeOf(e.t);
	},
	setPrototypeOf: function() {
		kf(12);
	}
}, wp = {};
Mf(Cp, (function(e, t) {
	wp[e] = function() {
		return arguments[0] = arguments[0][0], t.apply(this, arguments);
	};
})), wp.deleteProperty = function(e, t) {
	return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && kf(13), wp.set.call(this, e, t, void 0);
}, wp.set = function(e, t, n) {
	return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && kf(14), Cp.set.call(this, e[0], t, n, e[0]);
};
var Tp = new (function() {
	function e(e) {
		var t = this;
		this.O = mp, this.D = !0, this.produce = function(e, n, r) {
			if (typeof e == "function" && typeof n != "function") {
				var i = n;
				n = e;
				var a = t;
				return function(e) {
					var t = this;
					e === void 0 && (e = i);
					var r = [...arguments].slice(1);
					return a.produce(e, (function(e) {
						var i;
						return (i = n).call.apply(i, [t, e].concat(r));
					}));
				};
			}
			var o;
			if (typeof n != "function" && kf(6), r !== void 0 && typeof r != "function" && kf(7), jf(e)) {
				var s = Xf(t), c = op(t, e, void 0), l = !0;
				try {
					o = n(c), l = !1;
				} finally {
					l ? Jf(s) : Yf(s);
				}
				return typeof Promise < "u" && o instanceof Promise ? o.then((function(e) {
					return qf(s, r), Qf(e, s);
				}), (function(e) {
					throw Jf(s), e;
				})) : (qf(s, r), Qf(o, s));
			}
			if (!e || typeof e != "object") {
				if ((o = n(e)) === void 0 && (o = e), o === hp && (o = void 0), t.D && Hf(o, !0), r) {
					var u = [], d = [];
					Gf("Patches").M(e, o, u, d), r(u, d);
				}
				return o;
			}
			kf(21, e);
		}, this.produceWithPatches = function(e, n) {
			if (typeof e == "function") return function(n) {
				var r = [...arguments].slice(1);
				return t.produceWithPatches(n, (function(t) {
					return e.apply(void 0, [t].concat(r));
				}));
			};
			var r, i, a = t.produce(e, n, (function(e, t) {
				r = e, i = t;
			}));
			return typeof Promise < "u" && a instanceof Promise ? a.then((function(e) {
				return [
					e,
					r,
					i
				];
			})) : [
				a,
				r,
				i
			];
		}, typeof e?.useProxies == "boolean" && this.setUseProxies(e.useProxies), typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze);
	}
	var t = e.prototype;
	return t.createDraft = function(e) {
		jf(e) || kf(8), Af(e) && (e = sp(e));
		var t = Xf(this), n = op(this, e, void 0);
		return n[_p].C = !0, Yf(t), n;
	}, t.finishDraft = function(e, t) {
		var n = e && e[_p];
		process.env.NODE_ENV !== "production" && (n && n.C || kf(9), n.I && kf(10));
		var r = n.A;
		return qf(r, t), Qf(void 0, r);
	}, t.setAutoFreeze = function(e) {
		this.D = e;
	}, t.setUseProxies = function(e) {
		e && !mp && kf(20), this.O = e;
	}, t.applyPatches = function(e, t) {
		for (var n = t.length - 1; n >= 0; n--) {
			var r = t[n];
			if (r.path.length === 0 && r.op === "replace") {
				e = r.value;
				break;
			}
		}
		n > -1 && (t = t.slice(n + 1));
		var i = Gf("Patches").$;
		return Af(e) ? i(e, t) : this.produce(e, (function(e) {
			return i(e, t);
		}));
	}, e;
}())(), Ep = Tp.produce;
Tp.produceWithPatches.bind(Tp), Tp.setAutoFreeze.bind(Tp), Tp.setUseProxies.bind(Tp), Tp.applyPatches.bind(Tp);
var Dp = Tp.createDraft.bind(Tp), Op = Tp.finishDraft.bind(Tp), kp = { transform(e, t) {
	var { current: n, affinity: r } = e;
	if (n != null) {
		var i = z.transform(n, t, { affinity: r });
		e.current = i, i ?? e.unref();
	}
} }, Ap = { transform(e, t) {
	var { current: n, affinity: r } = e;
	if (n != null) {
		var i = W.transform(n, t, { affinity: r });
		e.current = i, i ?? e.unref();
	}
} }, jp = { transform(e, t) {
	var { current: n, affinity: r } = e;
	if (n != null) {
		var i = B.transform(n, t, { affinity: r });
		e.current = i, i ?? e.unref();
	}
} }, Mp = /* @__PURE__ */ new WeakMap(), Np = /* @__PURE__ */ new WeakMap(), Pp = /* @__PURE__ */ new WeakMap(), Fp = /* @__PURE__ */ new WeakMap(), Ip = /* @__PURE__ */ new WeakMap(), Lp = /* @__PURE__ */ new WeakMap(), Rp = /* @__PURE__ */ new WeakMap(), z = {
	ancestors(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { reverse: n = !1 } = t, r = z.levels(e, t);
		return r = n ? r.slice(1) : r.slice(0, -1), r;
	},
	common(e, t) {
		for (var n = [], r = 0; r < e.length && r < t.length; r++) {
			var i = e[r];
			if (i !== t[r]) break;
			n.push(i);
		}
		return n;
	},
	compare(e, t) {
		for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
			if (e[r] < t[r]) return -1;
			if (e[r] > t[r]) return 1;
		}
		return 0;
	},
	endsAfter(e, t) {
		var n = e.length - 1, r = e.slice(0, n), i = t.slice(0, n), a = e[n], o = t[n];
		return z.equals(r, i) && a > o;
	},
	endsAt(e, t) {
		var n = e.length, r = e.slice(0, n), i = t.slice(0, n);
		return z.equals(r, i);
	},
	endsBefore(e, t) {
		var n = e.length - 1, r = e.slice(0, n), i = t.slice(0, n), a = e[n], o = t[n];
		return z.equals(r, i) && a < o;
	},
	equals(e, t) {
		return e.length === t.length && e.every((e, n) => e === t[n]);
	},
	hasPrevious(e) {
		return e[e.length - 1] > 0;
	},
	isAfter(e, t) {
		return z.compare(e, t) === 1;
	},
	isAncestor(e, t) {
		return e.length < t.length && z.compare(e, t) === 0;
	},
	isBefore(e, t) {
		return z.compare(e, t) === -1;
	},
	isChild(e, t) {
		return e.length === t.length + 1 && z.compare(e, t) === 0;
	},
	isCommon(e, t) {
		return e.length <= t.length && z.compare(e, t) === 0;
	},
	isDescendant(e, t) {
		return e.length > t.length && z.compare(e, t) === 0;
	},
	isParent(e, t) {
		return e.length + 1 === t.length && z.compare(e, t) === 0;
	},
	isPath(e) {
		return Array.isArray(e) && (e.length === 0 || typeof e[0] == "number");
	},
	isSibling(e, t) {
		if (e.length !== t.length) return !1;
		var n = e.slice(0, -1), r = t.slice(0, -1);
		return e[e.length - 1] !== t[t.length - 1] && z.equals(n, r);
	},
	levels(e) {
		for (var { reverse: t = !1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = 0; r <= e.length; r++) n.push(e.slice(0, r));
		return t && n.reverse(), n;
	},
	next(e) {
		if (e.length === 0) throw Error(`Cannot get the next path of a root path [${e}], because it has no next index.`);
		var t = e[e.length - 1];
		return e.slice(0, -1).concat(t + 1);
	},
	operationCanTransformPath(e) {
		switch (e.type) {
			case "insert_node":
			case "remove_node":
			case "merge_node":
			case "split_node":
			case "move_node": return !0;
			default: return !1;
		}
	},
	parent(e) {
		if (e.length === 0) throw Error(`Cannot get the parent path of the root path [${e}].`);
		return e.slice(0, -1);
	},
	previous(e) {
		if (e.length === 0) throw Error(`Cannot get the previous path of a root path [${e}], because it has no previous index.`);
		var t = e[e.length - 1];
		if (t <= 0) throw Error(`Cannot get the previous path of a first child path [${e}] because it would result in a negative index.`);
		return e.slice(0, -1).concat(t - 1);
	},
	relative(e, t) {
		if (!z.isAncestor(t, e) && !z.equals(e, t)) throw Error(`Cannot get the relative path of [${e}] inside ancestor [${t}], because it is not above or equal to the path.`);
		return e.slice(t.length);
	},
	transform(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		if (!e) return null;
		var r = [...e], { affinity: i = "forward" } = n;
		if (e.length === 0) return r;
		switch (t.type) {
			case "insert_node":
				var { path: a } = t;
				(z.equals(a, r) || z.endsBefore(a, r) || z.isAncestor(a, r)) && (r[a.length - 1] += 1);
				break;
			case "remove_node":
				var { path: o } = t;
				if (z.equals(o, r) || z.isAncestor(o, r)) return null;
				z.endsBefore(o, r) && --r[o.length - 1];
				break;
			case "merge_node":
				var { path: s, position: c } = t;
				z.equals(s, r) || z.endsBefore(s, r) ? --r[s.length - 1] : z.isAncestor(s, r) && (--r[s.length - 1], r[s.length] += c);
				break;
			case "split_node":
				var { path: l, position: u } = t;
				if (z.equals(l, r)) {
					if (i === "forward") r[r.length - 1] += 1;
					else if (i !== "backward") return null;
				} else z.endsBefore(l, r) ? r[l.length - 1] += 1 : z.isAncestor(l, r) && e[l.length] >= u && (r[l.length - 1] += 1, r[l.length] -= u);
				break;
			case "move_node":
				var { path: d, newPath: f } = t;
				if (z.equals(d, f)) return r;
				if (z.isAncestor(d, r) || z.equals(d, r)) {
					var p = f.slice();
					return z.endsBefore(d, f) && d.length < f.length && --p[d.length - 1], p.concat(r.slice(d.length));
				}
				z.isSibling(d, f) && (z.isAncestor(f, r) || z.equals(f, r)) ? z.endsBefore(d, r) ? --r[d.length - 1] : r[d.length - 1] += 1 : z.endsBefore(f, r) || z.equals(f, r) || z.isAncestor(f, r) ? (z.endsBefore(d, r) && --r[d.length - 1], r[f.length - 1] += 1) : z.endsBefore(d, r) && (z.equals(f, r) && (r[f.length - 1] += 1), --r[d.length - 1]);
		}
		return r;
	}
};
function zp(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Bp(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Vp(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Bp(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bp(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var Hp = (e, t, n) => {
	switch (n.type) {
		case "insert_node":
			var { path: r, node: i } = n, a = H.parent(e, r), o = r[r.length - 1];
			if (o > a.children.length) throw Error(`Cannot apply an "insert_node" operation at path [${r}] because the destination is past the end of the node.`);
			if (a.children.splice(o, 0, i), t) for (var [s, c] of B.points(t)) t[c] = W.transform(s, n);
			break;
		case "insert_text":
			var { path: l, offset: u, text: d } = n;
			if (d.length === 0) break;
			var f = H.leaf(e, l), p = f.text.slice(0, u), m = f.text.slice(u);
			if (f.text = p + d + m, t) for (var [h, g] of B.points(t)) t[g] = W.transform(h, n);
			break;
		case "merge_node":
			var { path: _ } = n, v = H.get(e, _), y = z.previous(_), b = H.get(e, y), x = H.parent(e, _), S = _[_.length - 1];
			if (G.isText(v) && G.isText(b)) b.text += v.text;
			else if (!G.isText(v) && !G.isText(b)) b.children.push(...v.children);
			else throw Error(`Cannot apply a "merge_node" operation at path [${_}] to nodes of different interfaces: ${dm.stringify(v)} ${dm.stringify(b)}`);
			if (x.children.splice(S, 1), t) for (var [C, w] of B.points(t)) t[w] = W.transform(C, n);
			break;
		case "move_node":
			var { path: T, newPath: E } = n;
			if (z.isAncestor(T, E)) throw Error(`Cannot move a path [${T}] to new path [${E}] because the destination is inside itself.`);
			var ee = H.get(e, T), D = H.parent(e, T), O = T[T.length - 1];
			D.children.splice(O, 1);
			var te = z.transform(T, n), k = H.get(e, z.parent(te)), ne = te[te.length - 1];
			if (k.children.splice(ne, 0, ee), t) for (var [re, A] of B.points(t)) t[A] = W.transform(re, n);
			break;
		case "remove_node":
			var { path: ie } = n, ae = ie[ie.length - 1];
			if (H.parent(e, ie).children.splice(ae, 1), t) for (var [j, M] of B.points(t)) {
				var oe = W.transform(j, n);
				if (t != null && oe != null) t[M] = oe;
				else {
					var N = void 0, se = void 0;
					for (var [ce, le] of H.texts(e)) if (z.compare(le, ie) === -1) N = [ce, le];
					else {
						se = [ce, le];
						break;
					}
					var ue = !1;
					N && se && (ue = z.equals(se[1], ie) ? !z.hasPrevious(se[1]) : z.common(N[1], ie).length < z.common(se[1], ie).length), N && !ue ? (j.path = N[1], j.offset = N[0].text.length) : se ? (j.path = se[1], j.offset = 0) : t = null;
				}
			}
			break;
		case "remove_text":
			var { path: de, offset: P, text: fe } = n;
			if (fe.length === 0) break;
			var pe = H.leaf(e, de);
			if (pe.text = pe.text.slice(0, P) + pe.text.slice(P + fe.length), t) for (var [me, he] of B.points(t)) t[he] = W.transform(me, n);
			break;
		case "set_node":
			var { path: ge, properties: _e, newProperties: ve } = n;
			if (ge.length === 0) throw Error("Cannot set properties on the root node!");
			var ye = H.get(e, ge);
			for (var be in ve) {
				if (be === "children" || be === "text") throw Error(`Cannot set the "${be}" property of nodes!`);
				var xe = ve[be];
				xe == null ? delete ye[be] : ye[be] = xe;
			}
			for (var Se in _e) ve.hasOwnProperty(Se) || delete ye[Se];
			break;
		case "set_selection":
			var { newProperties: Ce } = n;
			if (Ce == null) t = Ce;
			else {
				if (t == null) {
					if (!B.isRange(Ce)) throw Error(`Cannot apply an incomplete "set_selection" operation properties ${dm.stringify(Ce)} when there is no current selection.`);
					t = Vp({}, Ce);
				}
				for (var we in Ce) {
					var Te = Ce[we];
					if (Te == null) {
						if (we === "anchor" || we === "focus") throw Error(`Cannot remove the "${we}" selection property`);
						delete t[we];
					} else t[we] = Te;
				}
			}
			break;
		case "split_node":
			var { path: Ee, position: De, properties: Oe } = n;
			if (Ee.length === 0) throw Error(`Cannot apply a "split_node" operation at path [${Ee}] because the root node cannot be split.`);
			var ke = H.get(e, Ee), Ae = H.parent(e, Ee), je = Ee[Ee.length - 1], Me;
			if (G.isText(ke)) {
				var Ne = ke.text.slice(0, De), Pe = ke.text.slice(De);
				ke.text = Ne, Me = Vp(Vp({}, Oe), {}, { text: Pe });
			} else {
				var Fe = ke.children.slice(0, De), Ie = ke.children.slice(De);
				ke.children = Fe, Me = Vp(Vp({}, Oe), {}, { children: Ie });
			}
			if (Ae.children.splice(je + 1, 0, Me), t) for (var [Le, Re] of B.points(t)) t[Re] = W.transform(Le, n);
	}
	return t;
}, Up = { transform(e, t) {
	e.children = Dp(e.children);
	var n = e.selection && Dp(e.selection);
	try {
		n = Hp(e, n, t);
	} finally {
		e.children = Op(e.children), e.selection = n ? Af(n) ? Op(n) : n : null;
	}
} }, Wp = {
	insertNodes(e, t, n) {
		e.insertNodes(t, n);
	},
	liftNodes(e, t) {
		e.liftNodes(t);
	},
	mergeNodes(e, t) {
		e.mergeNodes(t);
	},
	moveNodes(e, t) {
		e.moveNodes(t);
	},
	removeNodes(e, t) {
		e.removeNodes(t);
	},
	setNodes(e, t, n) {
		e.setNodes(t, n);
	},
	splitNodes(e, t) {
		e.splitNodes(t);
	},
	unsetNodes(e, t, n) {
		e.unsetNodes(t, n);
	},
	unwrapNodes(e, t) {
		e.unwrapNodes(t);
	},
	wrapNodes(e, t, n) {
		e.wrapNodes(t, n);
	}
}, Gp = {
	collapse(e, t) {
		e.collapse(t);
	},
	deselect(e) {
		e.deselect();
	},
	move(e, t) {
		e.move(t);
	},
	select(e, t) {
		e.select(t);
	},
	setPoint(e, t, n) {
		e.setPoint(t, n);
	},
	setSelection(e, t) {
		e.setSelection(t);
	}
}, Kp = (e, t) => {
	for (var n in e) {
		var r = e[n], i = t[n];
		if (Of(r) && Of(i)) {
			if (!Kp(r, i)) return !1;
		} else if (Array.isArray(r) && Array.isArray(i)) {
			if (r.length !== i.length) return !1;
			for (var a = 0; a < r.length; a++) if (r[a] !== i[a]) return !1;
		} else if (r !== i) return !1;
	}
	for (var o in t) if (e[o] === void 0 && t[o] !== void 0) return !1;
	return !0;
};
function qp(e, t) {
	if (e == null) return {};
	for (var n = {}, r = Object.keys(e), i, a = 0; a < r.length; a++) i = r[a], t.indexOf(i) >= 0 || (n[i] = e[i]);
	return n;
}
function Jp(e, t) {
	if (e == null) return {};
	var n = qp(e, t), r, i;
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (i = 0; i < a.length; i++) r = a[i], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
	}
	return n;
}
var Yp = ["anchor", "focus"];
function Xp(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Zp(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Xp(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xp(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var B = {
	edges(e) {
		var { reverse: t = !1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { anchor: n, focus: r } = e;
		return B.isBackward(e) === t ? [n, r] : [r, n];
	},
	end(e) {
		var [, t] = B.edges(e);
		return t;
	},
	equals(e, t) {
		return W.equals(e.anchor, t.anchor) && W.equals(e.focus, t.focus);
	},
	includes(e, t) {
		if (B.isRange(t)) {
			if (B.includes(e, t.anchor) || B.includes(e, t.focus)) return !0;
			var [n, r] = B.edges(e), [i, a] = B.edges(t);
			return W.isBefore(n, i) && W.isAfter(r, a);
		}
		var [o, s] = B.edges(e), c = !1, l = !1;
		return W.isPoint(t) ? (c = W.compare(t, o) >= 0, l = W.compare(t, s) <= 0) : (c = z.compare(t, o.path) >= 0, l = z.compare(t, s.path) <= 0), c && l;
	},
	intersection(e, t) {
		var n = Jp(e, Yp), [r, i] = B.edges(e), [a, o] = B.edges(t), s = W.isBefore(r, a) ? a : r, c = W.isBefore(i, o) ? i : o;
		return W.isBefore(c, s) ? null : Zp({
			anchor: s,
			focus: c
		}, n);
	},
	isBackward(e) {
		var { anchor: t, focus: n } = e;
		return W.isAfter(t, n);
	},
	isCollapsed(e) {
		var { anchor: t, focus: n } = e;
		return W.equals(t, n);
	},
	isExpanded(e) {
		return !B.isCollapsed(e);
	},
	isForward(e) {
		return !B.isBackward(e);
	},
	isRange(e) {
		return Of(e) && W.isPoint(e.anchor) && W.isPoint(e.focus);
	},
	*points(e) {
		yield [e.anchor, "anchor"], yield [e.focus, "focus"];
	},
	start(e) {
		var [t] = B.edges(e);
		return t;
	},
	transform(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		return Ep(e, (e) => {
			if (e === null) return null;
			var { affinity: r = "inward" } = n, i, a;
			if (r === "inward") {
				var o = B.isCollapsed(e);
				B.isForward(e) ? (i = "forward", a = o ? i : "backward") : (i = "backward", a = o ? i : "forward");
			} else r === "outward" ? B.isForward(e) ? (i = "backward", a = "forward") : (i = "forward", a = "backward") : (i = r, a = r);
			var s = W.transform(e.anchor, t, { affinity: i }), c = W.transform(e.focus, t, { affinity: a });
			if (!s || !c) return null;
			e.anchor = s, e.focus = c;
		});
	}
}, Qp = (e) => Of(e) && H.isNodeList(e.children) && !U.isEditor(e), V = {
	isAncestor(e) {
		return Of(e) && H.isNodeList(e.children);
	},
	isElement: Qp,
	isElementList(e) {
		return Array.isArray(e) && e.every((e) => V.isElement(e));
	},
	isElementProps(e) {
		return e.children !== void 0;
	},
	isElementType: function(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
		return Qp(e) && e[n] === t;
	},
	matches(e, t) {
		for (var n in t) if (n !== "children" && e[n] !== t[n]) return !1;
		return !0;
	}
}, $p = ["children"], em = ["text"], tm = /* @__PURE__ */ new WeakMap(), H = {
	ancestor(e, t) {
		var n = H.get(e, t);
		if (G.isText(n)) throw Error(`Cannot get the ancestor node at path [${t}] because it refers to a text node instead: ${dm.stringify(n)}`);
		return n;
	},
	*ancestors(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		for (var r of z.ancestors(t, n)) yield [H.ancestor(e, r), r];
	},
	child(e, t) {
		if (G.isText(e)) throw Error(`Cannot get the child of a text node: ${dm.stringify(e)}`);
		var n = e.children[t];
		if (n == null) throw Error(`Cannot get child at index \`${t}\` in node: ${dm.stringify(e)}`);
		return n;
	},
	*children(e, t) {
		for (var { reverse: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = H.ancestor(e, t), { children: i } = r, a = n ? i.length - 1 : 0; n ? a >= 0 : a < i.length;) yield [H.child(r, a), t.concat(a)], a = n ? a - 1 : a + 1;
	},
	common(e, t, n) {
		var r = z.common(t, n);
		return [H.get(e, r), r];
	},
	descendant(e, t) {
		var n = H.get(e, t);
		if (U.isEditor(n)) throw Error(`Cannot get the descendant node at path [${t}] because it refers to the root editor node instead: ${dm.stringify(n)}`);
		return n;
	},
	*descendants(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		for (var [n, r] of H.nodes(e, t)) r.length !== 0 && (yield [n, r]);
	},
	*elements(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		for (var [n, r] of H.nodes(e, t)) V.isElement(n) && (yield [n, r]);
	},
	extractProps(e) {
		if (V.isAncestor(e)) {
			var t = Jp(e, $p);
			return t;
		}
		var t = Jp(e, em);
		return t;
	},
	first(e, t) {
		for (var n = t.slice(), r = H.get(e, n); r && !(G.isText(r) || r.children.length === 0);) r = r.children[0], n.push(0);
		return [r, n];
	},
	fragment(e, t) {
		if (G.isText(e)) throw Error(`Cannot get a fragment starting from a root text node: ${dm.stringify(e)}`);
		return Ep({ children: e.children }, (e) => {
			var [n, r] = B.edges(t);
			for (var [, i] of H.nodes(e, {
				reverse: !0,
				pass: (e) => {
					var [, n] = e;
					return !B.includes(t, n);
				}
			})) {
				if (!B.includes(t, i)) {
					var a = H.parent(e, i), o = i[i.length - 1];
					a.children.splice(o, 1);
				}
				if (z.equals(i, r.path)) {
					var s = H.leaf(e, i);
					s.text = s.text.slice(0, r.offset);
				}
				if (z.equals(i, n.path)) {
					var c = H.leaf(e, i);
					c.text = c.text.slice(n.offset);
				}
			}
			U.isEditor(e) && (e.selection = null);
		}).children;
	},
	get(e, t) {
		for (var n = e, r = 0; r < t.length; r++) {
			var i = t[r];
			if (G.isText(n) || !n.children[i]) throw Error(`Cannot find a descendant at path [${t}] in node: ${dm.stringify(e)}`);
			n = n.children[i];
		}
		return n;
	},
	has(e, t) {
		for (var n = e, r = 0; r < t.length; r++) {
			var i = t[r];
			if (G.isText(n) || !n.children[i]) return !1;
			n = n.children[i];
		}
		return !0;
	},
	isNode(e) {
		return G.isText(e) || V.isElement(e) || U.isEditor(e);
	},
	isNodeList(e) {
		if (!Array.isArray(e)) return !1;
		var t = tm.get(e);
		if (t !== void 0) return t;
		var n = e.every((e) => H.isNode(e));
		return tm.set(e, n), n;
	},
	last(e, t) {
		for (var n = t.slice(), r = H.get(e, n); r && !(G.isText(r) || r.children.length === 0);) {
			var i = r.children.length - 1;
			r = r.children[i], n.push(i);
		}
		return [r, n];
	},
	leaf(e, t) {
		var n = H.get(e, t);
		if (!G.isText(n)) throw Error(`Cannot get the leaf node at path [${t}] because it refers to a non-leaf node: ${dm.stringify(n)}`);
		return n;
	},
	*levels(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		for (var r of z.levels(t, n)) yield [H.get(e, r), r];
	},
	matches(e, t) {
		return V.isElement(e) && V.isElementProps(t) && V.matches(e, t) || G.isText(e) && G.isTextProps(t) && G.matches(e, t);
	},
	*nodes(e) {
		for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { pass: n, reverse: r = !1 } = t, { from: i = [], to: a } = t, o = /* @__PURE__ */ new Set(), s = [], c = e; !(a && (r ? z.isBefore(s, a) : z.isAfter(s, a)));) if (o.has(c) || (yield [c, s]), !o.has(c) && !G.isText(c) && c.children.length !== 0 && (n == null || n([c, s]) === !1)) {
			o.add(c);
			var l = r ? c.children.length - 1 : 0;
			z.isAncestor(s, i) && (l = i[s.length]), s = s.concat(l), c = H.get(e, s);
		} else {
			if (s.length === 0) break;
			if (!r) {
				var u = z.next(s);
				if (H.has(e, u)) {
					s = u, c = H.get(e, s);
					continue;
				}
			}
			r && s[s.length - 1] !== 0 ? (s = z.previous(s), c = H.get(e, s)) : (s = z.parent(s), c = H.get(e, s), o.add(c));
		}
	},
	parent(e, t) {
		var n = z.parent(t), r = H.get(e, n);
		if (G.isText(r)) throw Error(`Cannot get the parent of path [${t}] because it does not exist in the root.`);
		return r;
	},
	string(e) {
		return G.isText(e) ? e.text : e.children.map(H.string).join("");
	},
	*texts(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		for (var [n, r] of H.nodes(e, t)) G.isText(n) && (yield [n, r]);
	}
};
function nm(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function rm(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? nm(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nm(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var im = {
	isNodeOperation(e) {
		return im.isOperation(e) && e.type.endsWith("_node");
	},
	isOperation(e) {
		if (!Of(e)) return !1;
		switch (e.type) {
			case "insert_node": return z.isPath(e.path) && H.isNode(e.node);
			case "insert_text": return typeof e.offset == "number" && typeof e.text == "string" && z.isPath(e.path);
			case "merge_node": return typeof e.position == "number" && z.isPath(e.path) && Of(e.properties);
			case "move_node": return z.isPath(e.path) && z.isPath(e.newPath);
			case "remove_node": return z.isPath(e.path) && H.isNode(e.node);
			case "remove_text": return typeof e.offset == "number" && typeof e.text == "string" && z.isPath(e.path);
			case "set_node": return z.isPath(e.path) && Of(e.properties) && Of(e.newProperties);
			case "set_selection": return e.properties === null && B.isRange(e.newProperties) || e.newProperties === null && B.isRange(e.properties) || Of(e.properties) && Of(e.newProperties);
			case "split_node": return z.isPath(e.path) && typeof e.position == "number" && Of(e.properties);
			default: return !1;
		}
	},
	isOperationList(e) {
		return Array.isArray(e) && e.every((e) => im.isOperation(e));
	},
	isSelectionOperation(e) {
		return im.isOperation(e) && e.type.endsWith("_selection");
	},
	isTextOperation(e) {
		return im.isOperation(e) && e.type.endsWith("_text");
	},
	inverse(e) {
		switch (e.type) {
			case "insert_node": return rm(rm({}, e), {}, { type: "remove_node" });
			case "insert_text": return rm(rm({}, e), {}, { type: "remove_text" });
			case "merge_node": return rm(rm({}, e), {}, {
				type: "split_node",
				path: z.previous(e.path)
			});
			case "move_node":
				var { newPath: t, path: n } = e;
				if (z.equals(t, n)) return e;
				if (z.isSibling(n, t)) return rm(rm({}, e), {}, {
					path: t,
					newPath: n
				});
				var r = z.transform(n, e), i = z.transform(z.next(n), e);
				return rm(rm({}, e), {}, {
					path: r,
					newPath: i
				});
			case "remove_node": return rm(rm({}, e), {}, { type: "insert_node" });
			case "remove_text": return rm(rm({}, e), {}, { type: "insert_text" });
			case "set_node":
				var { properties: a, newProperties: o } = e;
				return rm(rm({}, e), {}, {
					properties: o,
					newProperties: a
				});
			case "set_selection":
				var { properties: s, newProperties: c } = e;
				return s == null ? rm(rm({}, e), {}, {
					properties: c,
					newProperties: null
				}) : c == null ? rm(rm({}, e), {}, {
					properties: null,
					newProperties: s
				}) : rm(rm({}, e), {}, {
					properties: c,
					newProperties: s
				});
			case "split_node": return rm(rm({}, e), {}, {
				type: "merge_node",
				path: z.next(e.path)
			});
		}
	}
}, am = /* @__PURE__ */ new WeakMap(), om = (e) => {
	var t = am.get(e);
	if (t !== void 0) return t;
	if (!Of(e)) return !1;
	var n = typeof e.addMark == "function" && typeof e.apply == "function" && typeof e.deleteFragment == "function" && typeof e.insertBreak == "function" && typeof e.insertSoftBreak == "function" && typeof e.insertFragment == "function" && typeof e.insertNode == "function" && typeof e.insertText == "function" && typeof e.isElementReadOnly == "function" && typeof e.isInline == "function" && typeof e.isSelectable == "function" && typeof e.isVoid == "function" && typeof e.normalizeNode == "function" && typeof e.onChange == "function" && typeof e.removeMark == "function" && typeof e.getDirtyPaths == "function" && (e.marks === null || Of(e.marks)) && (e.selection === null || B.isRange(e.selection)) && H.isNodeList(e.children) && im.isOperationList(e.operations);
	return am.set(e, n), n;
}, U = {
	above(e, t) {
		return e.above(t);
	},
	addMark(e, t, n) {
		e.addMark(t, n);
	},
	after(e, t, n) {
		return e.after(t, n);
	},
	before(e, t, n) {
		return e.before(t, n);
	},
	deleteBackward(e) {
		var { unit: t = "character" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		e.deleteBackward(t);
	},
	deleteForward(e) {
		var { unit: t = "character" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		e.deleteForward(t);
	},
	deleteFragment(e, t) {
		e.deleteFragment(t);
	},
	edges(e, t) {
		return e.edges(t);
	},
	elementReadOnly(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		return e.elementReadOnly(t);
	},
	end(e, t) {
		return e.end(t);
	},
	first(e, t) {
		return e.first(t);
	},
	fragment(e, t) {
		return e.fragment(t);
	},
	hasBlocks(e, t) {
		return e.hasBlocks(t);
	},
	hasInlines(e, t) {
		return e.hasInlines(t);
	},
	hasPath(e, t) {
		return e.hasPath(t);
	},
	hasTexts(e, t) {
		return e.hasTexts(t);
	},
	insertBreak(e) {
		e.insertBreak();
	},
	insertFragment(e, t, n) {
		e.insertFragment(t, n);
	},
	insertNode(e, t) {
		e.insertNode(t);
	},
	insertSoftBreak(e) {
		e.insertSoftBreak();
	},
	insertText(e, t) {
		e.insertText(t);
	},
	isBlock(e, t) {
		return e.isBlock(t);
	},
	isEdge(e, t, n) {
		return e.isEdge(t, n);
	},
	isEditor(e) {
		return om(e);
	},
	isElementReadOnly(e, t) {
		return e.isElementReadOnly(t);
	},
	isEmpty(e, t) {
		return e.isEmpty(t);
	},
	isEnd(e, t, n) {
		return e.isEnd(t, n);
	},
	isInline(e, t) {
		return e.isInline(t);
	},
	isNormalizing(e) {
		return e.isNormalizing();
	},
	isSelectable(e, t) {
		return e.isSelectable(t);
	},
	isStart(e, t, n) {
		return e.isStart(t, n);
	},
	isVoid(e, t) {
		return e.isVoid(t);
	},
	last(e, t) {
		return e.last(t);
	},
	leaf(e, t, n) {
		return e.leaf(t, n);
	},
	levels(e, t) {
		return e.levels(t);
	},
	marks(e) {
		return e.getMarks();
	},
	next(e, t) {
		return e.next(t);
	},
	node(e, t, n) {
		return e.node(t, n);
	},
	nodes(e, t) {
		return e.nodes(t);
	},
	normalize(e, t) {
		e.normalize(t);
	},
	parent(e, t, n) {
		return e.parent(t, n);
	},
	path(e, t, n) {
		return e.path(t, n);
	},
	pathRef(e, t, n) {
		return e.pathRef(t, n);
	},
	pathRefs(e) {
		return e.pathRefs();
	},
	point(e, t, n) {
		return e.point(t, n);
	},
	pointRef(e, t, n) {
		return e.pointRef(t, n);
	},
	pointRefs(e) {
		return e.pointRefs();
	},
	positions(e, t) {
		return e.positions(t);
	},
	previous(e, t) {
		return e.previous(t);
	},
	range(e, t, n) {
		return e.range(t, n);
	},
	rangeRef(e, t, n) {
		return e.rangeRef(t, n);
	},
	rangeRefs(e) {
		return e.rangeRefs();
	},
	removeMark(e, t) {
		e.removeMark(t);
	},
	setNormalizing(e, t) {
		e.setNormalizing(t);
	},
	start(e, t) {
		return e.start(t);
	},
	string(e, t, n) {
		return e.string(t, n);
	},
	unhangRange(e, t, n) {
		return e.unhangRange(t, n);
	},
	void(e, t) {
		return e.void(t);
	},
	withoutNormalizing(e, t) {
		e.withoutNormalizing(t);
	}
}, sm = { isSpan(e) {
	return Array.isArray(e) && e.length === 2 && e.every(z.isPath);
} };
function cm(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function lm(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? cm(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cm(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var W = {
	compare(e, t) {
		var n = z.compare(e.path, t.path);
		return n === 0 ? e.offset < t.offset ? -1 : +(e.offset > t.offset) : n;
	},
	isAfter(e, t) {
		return W.compare(e, t) === 1;
	},
	isBefore(e, t) {
		return W.compare(e, t) === -1;
	},
	equals(e, t) {
		return e.offset === t.offset && z.equals(e.path, t.path);
	},
	isPoint(e) {
		return Of(e) && typeof e.offset == "number" && z.isPath(e.path);
	},
	transform(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		return Ep(e, (e) => {
			if (e === null) return null;
			var { affinity: r = "forward" } = n, { path: i, offset: a } = e;
			switch (t.type) {
				case "insert_node":
				case "move_node":
					e.path = z.transform(i, t, n);
					break;
				case "insert_text":
					z.equals(t.path, i) && (t.offset < a || t.offset === a && r === "forward") && (e.offset += t.text.length);
					break;
				case "merge_node":
					z.equals(t.path, i) && (e.offset += t.position), e.path = z.transform(i, t, n);
					break;
				case "remove_text":
					z.equals(t.path, i) && t.offset <= a && (e.offset -= Math.min(a - t.offset, t.text.length));
					break;
				case "remove_node":
					if (z.equals(t.path, i) || z.isAncestor(t.path, i)) return null;
					e.path = z.transform(i, t, n);
					break;
				case "split_node": if (z.equals(t.path, i)) {
					if (t.position === a && r == null) return null;
					(t.position < a || t.position === a && r === "forward") && (e.offset -= t.position, e.path = z.transform(i, t, lm(lm({}, n), {}, { affinity: "forward" })));
				} else e.path = z.transform(i, t, n);
			}
		});
	}
}, um = void 0, dm = {
	setScrubber(e) {
		um = e;
	},
	stringify(e) {
		return JSON.stringify(e, um);
	}
}, fm = ["text"], pm = ["anchor", "focus"];
function mm(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function hm(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? mm(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mm(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var G = {
	equals(e, t) {
		var { loose: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		function r(e) {
			return Jp(e, fm);
		}
		return Kp(n ? r(e) : e, n ? r(t) : t);
	},
	isText(e) {
		return Of(e) && typeof e.text == "string";
	},
	isTextList(e) {
		return Array.isArray(e) && e.every((e) => G.isText(e));
	},
	isTextProps(e) {
		return e.text !== void 0;
	},
	matches(e, t) {
		for (var n in t) if (n !== "text" && (!e.hasOwnProperty(n) || e[n] !== t[n])) return !1;
		return !0;
	},
	decorations(e, t) {
		var n = [hm({}, e)];
		for (var r of t) {
			var i = Jp(r, pm), [a, o] = B.edges(r), s = [], c = 0, l = a.offset, u = o.offset;
			for (var d of n) {
				var { length: f } = d.text, p = c;
				if (c += f, l <= p && c <= u) Object.assign(d, i), s.push(d);
				else if (l !== u && (l === c || u === p) || l > c || u < p || u === p && p !== 0) s.push(d);
				else {
					var m = d, h = void 0, g = void 0;
					if (u < c) {
						var _ = u - p;
						g = hm(hm({}, m), {}, { text: m.text.slice(_) }), m = hm(hm({}, m), {}, { text: m.text.slice(0, _) });
					}
					if (l > p) {
						var v = l - p;
						h = hm(hm({}, m), {}, { text: m.text.slice(0, v) }), m = hm(hm({}, m), {}, { text: m.text.slice(v) });
					}
					Object.assign(m, i), h && s.push(h), s.push(m), g && s.push(g);
				}
			}
			n = s;
		}
		return n;
	}
}, gm = (e) => e.selection ? e.selection : e.children.length > 0 ? U.end(e, []) : [0], _m = (e, t) => {
	var [n] = U.node(e, t);
	return (e) => e === n;
}, vm = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = !t, r = t ? Tm(e) : e, i = K.None, a = K.None, o = 0, s = null, c = null;
	for (var l of r) {
		var u = l.codePointAt(0);
		if (!u) break;
		var d = Lm(l, u);
		if ([i, a] = n ? [a, d] : [d, i], Rm(i, K.ZWJ) && Rm(a, K.ExtPict) && (s = Hm(n ? e.substring(0, o) : e.substring(0, e.length - o)), !s) || Rm(i, K.RI) && Rm(a, K.RI) && (c = c === null ? n ? !0 : Wm(e.substring(0, e.length - o)) : !c, !c) || i !== K.None && a !== K.None && Bm(i, a)) break;
		o += l.length;
	}
	return o || 1;
}, ym = /\s/, bm = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, xm = /['\u2018\u2019]/, Sm = function(e) {
	for (var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = 0, r = !1; e.length > 0;) {
		var i = vm(e, t), [a, o] = Cm(e, i, t);
		if (wm(a, o, t)) r = !0, n += i;
		else if (!r) n += i;
		else break;
		e = o;
	}
	return n;
}, Cm = (e, t, n) => {
	if (n) {
		var r = e.length - t;
		return [e.slice(r, e.length), e.slice(0, r)];
	}
	return [e.slice(0, t), e.slice(t)];
}, wm = function e(t, n) {
	var r = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
	if (ym.test(t)) return !1;
	if (xm.test(t)) {
		var [i, a] = Cm(n, vm(n, r), r);
		if (e(i, a, r)) return !0;
	}
	return !bm.test(t);
}, Tm = function* (e) {
	for (var t = e.length - 1, n = 0; n < e.length; n++) {
		var r = e.charAt(t - n);
		if (Dm(r.charCodeAt(0))) {
			var i = e.charAt(t - n - 1);
			if (Em(i.charCodeAt(0))) {
				yield i + r, n++;
				continue;
			}
		}
		yield r;
	}
}, Em = (e) => e >= 55296 && e <= 56319, Dm = (e) => e >= 56320 && e <= 57343, K;
(function(e) {
	e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
})(K ||= {});
var Om = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, km = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, Am = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, jm = /^[\u1100-\u115F\uA960-\uA97C]$/, Mm = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, Nm = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, Pm = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, Fm = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, Im = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, Lm = (e, t) => {
	var n = K.Any;
	return e.search(Om) !== -1 && (n |= K.Extend), t === 8205 && (n |= K.ZWJ), t >= 127462 && t <= 127487 && (n |= K.RI), e.search(km) !== -1 && (n |= K.Prepend), e.search(Am) !== -1 && (n |= K.SpacingMark), e.search(jm) !== -1 && (n |= K.L), e.search(Mm) !== -1 && (n |= K.V), e.search(Nm) !== -1 && (n |= K.T), e.search(Pm) !== -1 && (n |= K.LV), e.search(Fm) !== -1 && (n |= K.LVT), e.search(Im) !== -1 && (n |= K.ExtPict), n;
};
function Rm(e, t) {
	return (e & t) !== 0;
}
var zm = [
	[K.L, K.L | K.V | K.LV | K.LVT],
	[K.LV | K.V, K.V | K.T],
	[K.LVT | K.T, K.T],
	[K.Any, K.Extend | K.ZWJ],
	[K.Any, K.SpacingMark],
	[K.Prepend, K.Any],
	[K.ZWJ, K.ExtPict],
	[K.RI, K.RI]
];
function Bm(e, t) {
	return zm.findIndex((n) => Rm(e, n[0]) && Rm(t, n[1])) === -1;
}
var Vm = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, Hm = (e) => e.search(Vm) !== -1, Um = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, Wm = (e) => {
	var t = e.match(Um);
	return t !== null && t[0].length / 2 % 2 == 1;
}, Gm = {
	delete(e, t) {
		e.delete(t);
	},
	insertFragment(e, t, n) {
		e.insertFragment(t, n);
	},
	insertText(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		U.withoutNormalizing(e, () => {
			var { voids: r = !1 } = n, { at: i = gm(e) } = n;
			if (z.isPath(i) && (i = U.range(e, i)), B.isRange(i)) {
				if (B.isCollapsed(i)) i = i.anchor;
				else {
					var a = B.end(i);
					if (!r && U.void(e, { at: a })) return;
					var o = B.start(i), s = U.pointRef(e, o), c = U.pointRef(e, a);
					q.delete(e, {
						at: i,
						voids: r
					});
					var l = s.unref(), u = c.unref();
					i = l || u, q.setSelection(e, {
						anchor: i,
						focus: i
					});
				}
			}
			if (!(!r && U.void(e, { at: i }) || U.elementReadOnly(e, { at: i }))) {
				var { path: d, offset: f } = i;
				t.length > 0 && e.apply({
					type: "insert_text",
					path: d,
					offset: f,
					text: t
				});
			}
		});
	}
};
function Km(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function qm(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Km(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Km(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var q = qm(qm(qm(qm({}, Up), Wp), Gp), Gm), Jm = (e, t) => {
	for (var n of U.pathRefs(e)) kp.transform(n, t);
	for (var r of U.pointRefs(e)) Ap.transform(r, t);
	for (var i of U.rangeRefs(e)) jp.transform(i, t);
	var a = Mp.get(e) || [], o = Np.get(e) || /* @__PURE__ */ new Set(), s, c, l = (e) => {
		if (e) {
			var t = e.join(",");
			c.has(t) || (c.add(t), s.push(e));
		}
	};
	if (z.operationCanTransformPath(t)) {
		s = [], c = /* @__PURE__ */ new Set();
		for (var u of a) l(z.transform(u, t));
	} else s = a, c = o;
	for (var d of e.getDirtyPaths(t)) l(d);
	Mp.set(e, s), Np.set(e, c), q.transform(e, t), e.operations.push(t), U.normalize(e, { operation: t }), t.type === "set_selection" && (e.marks = null), Pp.get(e) || (Pp.set(e, !0), Promise.resolve().then(() => {
		Pp.set(e, !1), e.onChange({ operation: t }), e.operations = [];
	}));
}, Ym = (e, t) => {
	switch (t.type) {
		case "insert_text":
		case "remove_text":
		case "set_node":
			var { path: n } = t;
			return z.levels(n);
		case "insert_node":
			var { node: r, path: i } = t, a = z.levels(i), o = G.isText(r) ? [] : Array.from(H.nodes(r), (e) => {
				var [, t] = e;
				return i.concat(t);
			});
			return [...a, ...o];
		case "merge_node":
			var { path: s } = t, c = z.ancestors(s), l = z.previous(s);
			return [...c, l];
		case "move_node":
			var { path: u, newPath: d } = t;
			if (z.equals(u, d)) return [];
			var f = [], p = [];
			for (var m of z.ancestors(u)) {
				var h = z.transform(m, t);
				f.push(h);
			}
			for (var g of z.ancestors(d)) {
				var _ = z.transform(g, t);
				p.push(_);
			}
			var v = p[p.length - 1], y = d[d.length - 1], b = v.concat(y);
			return [
				...f,
				...p,
				b
			];
		case "remove_node":
			var { path: x } = t;
			return [...z.ancestors(x)];
		case "split_node":
			var { path: S } = t, C = z.levels(S), w = z.next(S);
			return [...C, w];
		default: return [];
	}
}, Xm = (e) => {
	var { selection: t } = e;
	return t ? H.fragment(e, t) : [];
}, Zm = (e, t) => {
	var [n, r] = t;
	if (!G.isText(n)) {
		if (V.isElement(n) && n.children.length === 0) q.insertNodes(e, { text: "" }, {
			at: r.concat(0),
			voids: !0
		});
		else for (var i = !U.isEditor(n) && V.isElement(n) && (e.isInline(n) || n.children.length === 0 || G.isText(n.children[0]) || e.isInline(n.children[0])), a = 0, o = 0; o < n.children.length; o++, a++) {
			var s = H.get(e, r);
			if (!G.isText(s)) {
				var c = s.children[a], l = s.children[a - 1], u = o === n.children.length - 1;
				(G.isText(c) || V.isElement(c) && e.isInline(c)) === i ? V.isElement(c) ? e.isInline(c) && (l == null || !G.isText(l) ? (q.insertNodes(e, { text: "" }, {
					at: r.concat(a),
					voids: !0
				}), a++) : u && (q.insertNodes(e, { text: "" }, {
					at: r.concat(a + 1),
					voids: !0
				}), a++)) : l != null && G.isText(l) && (G.equals(c, l, { loose: !0 }) ? (q.mergeNodes(e, {
					at: r.concat(a),
					voids: !0
				}), a--) : l.text === "" ? (q.removeNodes(e, {
					at: r.concat(a - 1),
					voids: !0
				}), a--) : c.text === "" && (q.removeNodes(e, {
					at: r.concat(a),
					voids: !0
				}), a--)) : (q.removeNodes(e, {
					at: r.concat(a),
					voids: !0
				}), a--);
			}
		}
	}
}, Qm = (e, t) => {
	var { iteration: n, initialDirtyPathsLength: r } = t, i = r * 42;
	if (n > i) throw Error(`Could not completely normalize the editor after ${i} iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.`);
	return !0;
}, $m = function(e) {
	var { voids: t = !1, mode: n = "lowest", at: r = e.selection, match: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	if (r) {
		var a = U.path(e, r), o = n === "lowest";
		for (var [s, c] of U.levels(e, {
			at: a,
			voids: t,
			match: i,
			reverse: o
		})) if (!G.isText(s)) {
			if (B.isRange(r)) {
				if (z.isAncestor(c, r.anchor.path) && z.isAncestor(c, r.focus.path)) return [s, c];
			} else if (!z.equals(a, c)) return [s, c];
		}
	}
};
function eh(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function th(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? eh(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : eh(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var nh = (e, t, n) => {
	var { selection: r } = e;
	if (r) {
		var i = (t, n) => {
			if (!G.isText(t)) return !1;
			var [r, i] = U.parent(e, n);
			return !e.isVoid(r) || e.markableVoid(r);
		}, a = B.isExpanded(r), o = !1;
		if (!a) {
			var [s, c] = U.node(e, r);
			if (s && i(s, c)) {
				var [l] = U.parent(e, c);
				o = l && e.markableVoid(l);
			}
		}
		a || o ? q.setNodes(e, { [t]: n }, {
			match: i,
			split: !0,
			voids: !0
		}) : (e.marks = th(th({}, U.marks(e) || {}), {}, { [t]: n }), Pp.get(e) || e.onChange());
	}
};
function rh(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ih(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? rh(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rh(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var ah = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		anchor: U.point(e, t, { edge: "end" }),
		focus: U.end(e, [])
	}, { distance: i = 1 } = n, a = 0, o;
	for (var s of U.positions(e, ih(ih({}, n), {}, { at: r }))) {
		if (a > i) break;
		a !== 0 && (o = s), a++;
	}
	return o;
};
function oh(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function sh(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? oh(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oh(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var ch = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		anchor: U.start(e, []),
		focus: U.point(e, t, { edge: "start" })
	}, { distance: i = 1 } = n, a = 0, o;
	for (var s of U.positions(e, sh(sh({}, n), {}, {
		at: r,
		reverse: !0
	}))) {
		if (a > i) break;
		a !== 0 && (o = s), a++;
	}
	return o;
}, lh = (e, t) => {
	var { selection: n } = e;
	n && B.isCollapsed(n) && q.delete(e, {
		unit: t,
		reverse: !0
	});
}, uh = (e, t) => {
	var { selection: n } = e;
	n && B.isCollapsed(n) && q.delete(e, { unit: t });
}, dh = function(e) {
	var { direction: t = "forward" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { selection: n } = e;
	n && B.isExpanded(n) && q.delete(e, { reverse: t === "backward" });
}, fh = (e, t) => [U.start(e, t), U.end(e, t)];
function ph(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function mh(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ph(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ph(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var hh = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	return U.above(e, mh(mh({}, t), {}, { match: (t) => V.isElement(t) && U.isElementReadOnly(e, t) }));
}, gh = (e, t) => U.point(e, t, { edge: "end" }), _h = (e, t) => {
	var n = U.path(e, t, { edge: "start" });
	return U.node(e, n);
}, vh = (e, t) => {
	var n = U.range(e, t);
	return H.fragment(e, n);
};
function yh(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function bh(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? yh(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yh(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var xh = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	return U.above(e, bh(bh({}, t), {}, { match: (t) => V.isElement(t) && U.isVoid(e, t) }));
}, Sh = (e, t) => t.children.some((t) => V.isElement(t) && U.isBlock(e, t)), Ch = (e, t) => t.children.some((t) => G.isText(t) || U.isInline(e, t)), wh = (e, t) => H.has(e, t), Th = (e, t) => t.children.every((e) => G.isText(e)), Eh = (e) => {
	q.splitNodes(e, { always: !0 });
}, Dh = (e, t, n) => {
	q.insertNodes(e, t, n);
}, Oh = (e) => {
	q.splitNodes(e, { always: !0 });
};
function kh(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Ah(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? kh(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kh(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var jh = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, { selection: r, marks: i } = e;
	if (r) {
		if (i) {
			var a = Ah({ text: t }, i);
			q.insertNodes(e, a, {
				at: n.at,
				voids: n.voids
			});
		} else q.insertText(e, t, n);
		e.marks = null;
	}
}, Mh = (e, t) => !e.isInline(t), Nh = (e, t, n) => U.isStart(e, t, n) || U.isEnd(e, t, n), Ph = (e, t) => {
	var { children: n } = t, [r] = n;
	return n.length === 0 || n.length === 1 && G.isText(r) && r.text === "" && !e.isVoid(t);
}, Fh = (e, t, n) => {
	var r = U.end(e, n);
	return W.equals(t, r);
}, Ih = (e) => {
	var t = Fp.get(e);
	return t === void 0 || t;
}, Lh = (e, t, n) => {
	if (t.offset !== 0) return !1;
	var r = U.start(e, n);
	return W.equals(t, r);
}, Rh = (e, t) => {
	var n = U.path(e, t, { edge: "end" });
	return U.node(e, n);
}, zh = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = U.path(e, t, n);
	return [H.leaf(e, r), r];
};
function* Bh(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { at: n = e.selection, reverse: r = !1, voids: i = !1 } = t, { match: a } = t;
	if (a ??= () => !0, n) {
		var o = [], s = U.path(e, n);
		for (var [c, l] of H.levels(e, s)) if (a(c, l) && (o.push([c, l]), !i && V.isElement(c) && U.isVoid(e, c))) break;
		r && o.reverse(), yield* o;
	}
}
var Vh = ["text"], Hh = ["text"], Uh = function(e) {
	var { marks: t, selection: n } = e;
	if (!n) return null;
	if (t) return t;
	if (B.isExpanded(n)) {
		var [r] = U.nodes(e, { match: G.isText });
		if (r) {
			var [i] = r;
			return Jp(i, Vh);
		}
		return {};
	}
	var { anchor: a } = n, { path: o } = a, [s] = U.leaf(e, o);
	if (a.offset === 0) {
		var c = U.previous(e, {
			at: o,
			match: G.isText
		});
		if (!U.above(e, { match: (t) => V.isElement(t) && U.isVoid(e, t) && e.markableVoid(t) })) {
			var l = U.above(e, { match: (t) => V.isElement(t) && U.isBlock(e, t) });
			if (c && l) {
				var [u, d] = c, [, f] = l;
				z.isAncestor(f, d) && (s = u);
			}
		}
	}
	return Jp(s, Hh);
}, Wh = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { mode: n = "lowest", voids: r = !1 } = t, { match: i, at: a = e.selection } = t;
	if (a) {
		var o = U.after(e, a, { voids: r });
		if (o) {
			var [, s] = U.last(e, []), c = [o.path, s];
			if (z.isPath(a) && a.length === 0) throw Error("Cannot get the next node from the root node!");
			if (i == null) {
				if (z.isPath(a)) {
					var [l] = U.parent(e, a);
					i = (e) => l.children.includes(e);
				} else i = () => !0;
			}
			var [u] = U.nodes(e, {
				at: c,
				match: i,
				mode: n,
				voids: r
			});
			return u;
		}
	}
}, Gh = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = U.path(e, t, n);
	return [H.get(e, r), r];
};
function* Kh(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { at: n = e.selection, mode: r = "all", universal: i = !1, reverse: a = !1, voids: o = !1, ignoreNonSelectable: s = !1 } = t, { match: c } = t;
	if (c ||= () => !0, n) {
		var l, u;
		if (sm.isSpan(n)) l = n[0], u = n[1];
		else {
			var d = U.path(e, n, { edge: "start" }), f = U.path(e, n, { edge: "end" });
			l = a ? f : d, u = a ? d : f;
		}
		var p = H.nodes(e, {
			reverse: a,
			from: l,
			to: u,
			pass: (t) => {
				var [n] = t;
				return V.isElement(n) ? !!(!o && (U.isVoid(e, n) || U.isElementReadOnly(e, n)) || s && !U.isSelectable(e, n)) : !1;
			}
		}), m = [], h;
		for (var [g, _] of p) if (!(s && V.isElement(g) && !U.isSelectable(e, g))) {
			var v = h && z.compare(_, h[1]) === 0;
			if (!(r === "highest" && v)) {
				if (!c(g, _)) {
					if (i && !v && G.isText(g)) return;
				} else if (r === "lowest" && v) h = [g, _];
				else {
					var y = r === "lowest" ? h : [g, _];
					y && (i ? m.push(y) : yield y), h = [g, _];
				}
			}
		}
		r === "lowest" && h && (i ? m.push(h) : yield h), i && (yield* m);
	}
}
var qh = function(e) {
	var { force: t = !1, operation: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (e) => Mp.get(e) || [], i = (e) => Np.get(e) || /* @__PURE__ */ new Set(), a = (e) => {
		var t = r(e).pop(), n = t.join(",");
		return i(e).delete(n), t;
	};
	if (U.isNormalizing(e)) {
		if (t) {
			var o = Array.from(H.nodes(e), (e) => {
				var [, t] = e;
				return t;
			}), s = new Set(o.map((e) => e.join(",")));
			Mp.set(e, o), Np.set(e, s);
		}
		r(e).length !== 0 && U.withoutNormalizing(e, () => {
			for (var t of r(e)) if (H.has(e, t)) {
				var i = U.node(e, t), [o, s] = i;
				V.isElement(o) && o.children.length === 0 && e.normalizeNode(i, { operation: n });
			}
			for (var c = r(e), l = c.length, u = 0; c.length !== 0;) {
				if (!e.shouldNormalize({
					dirtyPaths: c,
					iteration: u,
					initialDirtyPathsLength: l,
					operation: n
				})) return;
				var d = a(e);
				if (H.has(e, d)) {
					var f = U.node(e, d);
					e.normalizeNode(f, { operation: n });
				}
				u++, c = r(e);
			}
		});
	}
}, Jh = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = U.path(e, t, n), i = z.parent(r);
	return U.node(e, i);
}, Yh = function(e, t) {
	var { affinity: n = "forward" } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		current: t,
		affinity: n,
		unref() {
			var { current: t } = r;
			return U.pathRefs(e).delete(r), r.current = null, t;
		}
	};
	return U.pathRefs(e).add(r), r;
}, Xh = (e) => {
	var t = Ip.get(e);
	return t || (t = /* @__PURE__ */ new Set(), Ip.set(e, t)), t;
}, Zh = function(e, t) {
	var { depth: n, edge: r } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	if (z.isPath(t)) {
		if (r === "start") {
			var [, i] = H.first(e, t);
			t = i;
		} else if (r === "end") {
			var [, a] = H.last(e, t);
			t = a;
		}
	}
	return B.isRange(t) && (t = r === "start" ? B.start(t) : r === "end" ? B.end(t) : z.common(t.anchor.path, t.focus.path)), W.isPoint(t) && (t = t.path), n != null && (t = t.slice(0, n)), t;
}, Qh = function(e, t) {
	var { affinity: n = "forward" } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		current: t,
		affinity: n,
		unref() {
			var { current: t } = r;
			return U.pointRefs(e).delete(r), r.current = null, t;
		}
	};
	return U.pointRefs(e).add(r), r;
}, $h = (e) => {
	var t = Lp.get(e);
	return t || (t = /* @__PURE__ */ new Set(), Lp.set(e, t)), t;
}, eg = function(e, t) {
	var { edge: n = "start" } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	if (z.isPath(t)) {
		var r;
		if (n === "end") {
			var [, i] = H.last(e, t);
			r = i;
		} else {
			var [, a] = H.first(e, t);
			r = a;
		}
		var o = H.get(e, r);
		if (!G.isText(o)) throw Error(`Cannot get the ${n} point in the node at path [${t}] because it has no ${n} text node.`);
		return {
			path: r,
			offset: n === "end" ? o.text.length : 0
		};
	}
	if (B.isRange(t)) {
		var [s, c] = B.edges(t);
		return n === "start" ? s : c;
	}
	return t;
};
function* tg(e) {
	var { at: t = e.selection, unit: n = "offset", reverse: r = !1, voids: i = !1, ignoreNonSelectable: a = !1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	if (!t) return;
	var o = U.range(e, t), [s, c] = B.edges(o), l = r ? c : s, u = !1, d = "", f = 0, p = 0, m = 0;
	for (var [h, g] of U.nodes(e, {
		at: t,
		reverse: r,
		voids: i,
		ignoreNonSelectable: a
	})) {
		if (V.isElement(h)) {
			if (!i && (e.isVoid(h) || e.isElementReadOnly(h))) {
				yield U.start(e, g);
				continue;
			}
			if (e.isInline(h)) continue;
			if (U.hasInlines(e, h)) {
				var _ = z.isAncestor(g, c.path) ? c : U.end(e, g), v = z.isAncestor(g, s.path) ? s : U.start(e, g);
				d = U.string(e, {
					anchor: v,
					focus: _
				}, { voids: i }), u = !0;
			}
		}
		if (G.isText(h)) {
			var y = z.equals(g, l.path);
			for (y ? (p = r ? l.offset : h.text.length - l.offset, m = l.offset) : (p = h.text.length, m = r ? p : 0), (y || u || n === "offset") && (yield {
				path: g,
				offset: m
			}, u = !1);;) {
				if (f === 0) {
					if (d === "") break;
					f = b(d, n, r), d = Cm(d, f, r)[1];
				}
				if (m = r ? m - f : m + f, p -= f, p < 0) {
					f = -p;
					break;
				}
				f = 0, yield {
					path: g,
					offset: m
				};
			}
		}
	}
	function b(e, t, n) {
		return t === "character" ? vm(e, n) : t === "word" ? Sm(e, n) : t === "line" || t === "block" ? e.length : 1;
	}
}
var ng = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { mode: n = "lowest", voids: r = !1 } = t, { match: i, at: a = e.selection } = t;
	if (a) {
		var o = U.before(e, a, { voids: r });
		if (o) {
			var [, s] = U.first(e, []), c = [o.path, s];
			if (z.isPath(a) && a.length === 0) throw Error("Cannot get the previous node from the root node!");
			if (i == null) {
				if (z.isPath(a)) {
					var [l] = U.parent(e, a);
					i = (e) => l.children.includes(e);
				} else i = () => !0;
			}
			var [u] = U.nodes(e, {
				reverse: !0,
				at: c,
				match: i,
				mode: n,
				voids: r
			});
			return u;
		}
	}
}, rg = function(e, t) {
	var { affinity: n = "forward" } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		current: t,
		affinity: n,
		unref() {
			var { current: t } = r;
			return U.rangeRefs(e).delete(r), r.current = null, t;
		}
	};
	return U.rangeRefs(e).add(r), r;
}, ig = (e) => {
	var t = Rp.get(e);
	return t || (t = /* @__PURE__ */ new Set(), Rp.set(e, t)), t;
}, ag = (e, t, n) => B.isRange(t) && !n ? t : {
	anchor: U.start(e, t),
	focus: U.end(e, n || t)
};
function og(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function sg(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? og(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : og(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var cg = (e, t) => {
	var { selection: n } = e;
	if (n) {
		var r = (t, n) => {
			if (!G.isText(t)) return !1;
			var [r, i] = U.parent(e, n);
			return !e.isVoid(r) || e.markableVoid(r);
		}, i = B.isExpanded(n), a = !1;
		if (!i) {
			var [o, s] = U.node(e, n);
			if (o && r(o, s)) {
				var [c] = U.parent(e, s);
				a = c && e.markableVoid(c);
			}
		}
		if (i || a) q.unsetNodes(e, t, {
			match: r,
			split: !0,
			voids: !0
		});
		else {
			var l = sg({}, U.marks(e) || {});
			delete l[t], e.marks = l, Pp.get(e) || e.onChange();
		}
	}
}, lg = (e, t) => {
	Fp.set(e, t);
}, ug = (e, t) => U.point(e, t, { edge: "start" }), dg = function(e, t) {
	var { voids: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = U.range(e, t), [i, a] = B.edges(r), o = "";
	for (var [s, c] of U.nodes(e, {
		at: r,
		match: G.isText,
		voids: n
	})) {
		var l = s.text;
		z.equals(c, a.path) && (l = l.slice(0, a.offset)), z.equals(c, i.path) && (l = l.slice(i.offset)), o += l;
	}
	return o;
}, fg = function(e, t) {
	var { voids: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, [r, i] = B.edges(t);
	if (r.offset !== 0 || i.offset !== 0 || B.isCollapsed(t) || z.hasPrevious(i.path)) return t;
	var a = U.above(e, {
		at: i,
		match: (t) => V.isElement(t) && U.isBlock(e, t),
		voids: n
	}), o = a ? a[1] : [], s = {
		anchor: U.start(e, r),
		focus: i
	}, c = !0;
	for (var [l, u] of U.nodes(e, {
		at: s,
		match: G.isText,
		reverse: !0,
		voids: n
	})) if (c) c = !1;
	else if (l.text !== "" || z.isBefore(u, o)) {
		i = {
			path: u,
			offset: l.text.length
		};
		break;
	}
	return {
		anchor: r,
		focus: i
	};
}, pg = (e, t) => {
	var n = U.isNormalizing(e);
	U.setNormalizing(e, !1);
	try {
		t();
	} finally {
		U.setNormalizing(e, n);
	}
	U.normalize(e);
}, mg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	U.withoutNormalizing(e, () => {
		var { reverse: n = !1, unit: r = "character", distance: i = 1, voids: a = !1 } = t, { at: o = e.selection, hanging: s = !1 } = t;
		if (o) {
			var c = !1;
			if (B.isRange(o) && B.isCollapsed(o) && (c = !0, o = o.anchor), W.isPoint(o)) {
				var l = U.void(e, {
					at: o,
					mode: "highest"
				});
				if (!a && l) {
					var [, u] = l;
					o = u;
				} else {
					var d = {
						unit: r,
						distance: i
					}, f = n ? U.before(e, o, d) || U.start(e, []) : U.after(e, o, d) || U.end(e, []);
					o = {
						anchor: o,
						focus: f
					}, s = !0;
				}
			}
			if (z.isPath(o)) q.removeNodes(e, {
				at: o,
				voids: a
			});
			else if (!B.isCollapsed(o)) {
				if (!s) {
					var [, p] = B.edges(o), m = U.end(e, []);
					W.equals(p, m) || (o = U.unhangRange(e, o, { voids: a }));
				}
				var [h, g] = B.edges(o), _ = U.above(e, {
					match: (t) => V.isElement(t) && U.isBlock(e, t),
					at: h,
					voids: a
				}), v = U.above(e, {
					match: (t) => V.isElement(t) && U.isBlock(e, t),
					at: g,
					voids: a
				}), y = _ && v && !z.equals(_[1], v[1]), b = z.equals(h.path, g.path), x = a ? null : U.void(e, {
					at: h,
					mode: "highest"
				}) ?? U.elementReadOnly(e, {
					at: h,
					mode: "highest"
				}), S = a ? null : U.void(e, {
					at: g,
					mode: "highest"
				}) ?? U.elementReadOnly(e, {
					at: g,
					mode: "highest"
				});
				if (x) {
					var C = U.before(e, h);
					C && _ && z.isAncestor(_[1], C.path) && (h = C);
				}
				if (S) {
					var w = U.after(e, g);
					w && v && z.isAncestor(v[1], w.path) && (g = w);
				}
				var T = [], E;
				for (var ee of U.nodes(e, {
					at: o,
					voids: a
				})) {
					var [D, O] = ee;
					E && z.compare(O, E) === 0 || (!a && V.isElement(D) && (U.isVoid(e, D) || U.isElementReadOnly(e, D)) || !z.isCommon(O, h.path) && !z.isCommon(O, g.path)) && (T.push(ee), E = O);
				}
				var te = Array.from(T, (t) => {
					var [, n] = t;
					return U.pathRef(e, n);
				}), k = U.pointRef(e, h), ne = U.pointRef(e, g), re = "";
				if (!b && !x) {
					var A = k.current, [ie] = U.leaf(e, A), { path: ae } = A, { offset: j } = h, M = ie.text.slice(j);
					M.length > 0 && (e.apply({
						type: "remove_text",
						path: ae,
						offset: j,
						text: M
					}), re = M);
				}
				if (te.reverse().map((e) => e.unref()).filter((e) => e !== null).forEach((t) => q.removeNodes(e, {
					at: t,
					voids: a
				})), !S) {
					var oe = ne.current, [N] = U.leaf(e, oe), { path: se } = oe, ce = b ? h.offset : 0, le = N.text.slice(ce, g.offset);
					le.length > 0 && (e.apply({
						type: "remove_text",
						path: se,
						offset: ce,
						text: le
					}), re = le);
				}
				!b && y && ne.current && k.current && q.mergeNodes(e, {
					at: ne.current,
					hanging: !0,
					voids: a
				}), c && n && r === "character" && re.length > 1 && re.match(/[\u0E00-\u0E7F]+/) && q.insertText(e, re.slice(0, re.length - i));
				var ue = k.unref(), de = ne.unref(), P = n ? ue || de : de || ue;
				t.at == null && P && q.select(e, P);
			}
		}
	});
}, hg = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	U.withoutNormalizing(e, () => {
		var { hanging: r = !1, voids: i = !1 } = n, { at: a = gm(e) } = n;
		if (t.length) {
			if (B.isRange(a)) {
				if (r || (a = U.unhangRange(e, a, { voids: i })), B.isCollapsed(a)) a = a.anchor;
				else {
					var [, o] = B.edges(a);
					if (!i && U.void(e, { at: o })) return;
					var s = U.pointRef(e, o);
					q.delete(e, { at: a }), a = s.unref();
				}
			} else z.isPath(a) && (a = U.start(e, a));
			if (i || !U.void(e, { at: a })) {
				var c = U.above(e, {
					at: a,
					match: (t) => V.isElement(t) && U.isInline(e, t),
					mode: "highest",
					voids: i
				});
				if (c) {
					var [, l] = c;
					U.isEnd(e, a, l) ? a = U.after(e, l) : U.isStart(e, a, l) && (a = U.before(e, l));
				}
				var [, u] = U.above(e, {
					match: (t) => V.isElement(t) && U.isBlock(e, t),
					at: a,
					voids: i
				}), d = U.isStart(e, a, u), f = U.isEnd(e, a, u), p = d && f, m = !d || d && f, h = !f, [, g] = H.first({ children: t }, []), [, _] = H.last({ children: t }, []), v = [], y = (t) => {
					var [n, r] = t;
					return r.length === 0 ? !1 : p ? !0 : !(m && z.isAncestor(r, g) && V.isElement(n) && !e.isVoid(n) && !e.isInline(n) || h && z.isAncestor(r, _) && V.isElement(n) && !e.isVoid(n) && !e.isInline(n));
				};
				for (var b of H.nodes({ children: t }, { pass: y })) y(b) && v.push(b);
				var x = [], S = [], C = [], w = !0, T = !1;
				for (var [E] of v) V.isElement(E) && !e.isInline(E) ? (w = !1, T = !0, S.push(E)) : w ? x.push(E) : C.push(E);
				var [ee] = U.nodes(e, {
					at: a,
					match: (t) => G.isText(t) || U.isInline(e, t),
					mode: "highest",
					voids: i
				}), [, D] = ee, O = U.isStart(e, a, D), te = U.isEnd(e, a, D), k = U.pathRef(e, f && !C.length ? z.next(u) : u), ne = U.pathRef(e, te ? z.next(D) : D);
				q.splitNodes(e, {
					at: a,
					match: (t) => T ? V.isElement(t) && U.isBlock(e, t) : G.isText(t) || U.isInline(e, t),
					mode: T ? "lowest" : "highest",
					always: T && (!d || x.length > 0) && (!f || C.length > 0),
					voids: i
				});
				var re = U.pathRef(e, !O || O && te ? z.next(D) : D);
				if (q.insertNodes(e, x, {
					at: re.current,
					match: (t) => G.isText(t) || U.isInline(e, t),
					mode: "highest",
					voids: i
				}), p && !x.length && S.length && !C.length && q.delete(e, {
					at: u,
					voids: i
				}), q.insertNodes(e, S, {
					at: k.current,
					match: (t) => V.isElement(t) && U.isBlock(e, t),
					mode: "lowest",
					voids: i
				}), q.insertNodes(e, C, {
					at: ne.current,
					match: (t) => G.isText(t) || U.isInline(e, t),
					mode: "highest",
					voids: i
				}), !n.at) {
					var A;
					if (C.length > 0 && ne.current ? A = z.previous(ne.current) : S.length > 0 && k.current ? A = z.previous(k.current) : re.current && (A = z.previous(re.current)), A) {
						var ie = U.end(e, A);
						q.select(e, ie);
					}
				}
				re.unref(), k.unref(), ne.unref();
			}
		}
	});
}, gg = function(e) {
	var { edge: t = "anchor" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { selection: n } = e;
	if (n) {
		if (t === "anchor") q.select(e, n.anchor);
		else if (t === "focus") q.select(e, n.focus);
		else if (t === "start") {
			var [r] = B.edges(n);
			q.select(e, r);
		} else if (t === "end") {
			var [, i] = B.edges(n);
			q.select(e, i);
		}
	}
}, _g = (e) => {
	var { selection: t } = e;
	t && e.apply({
		type: "set_selection",
		properties: t,
		newProperties: null
	});
}, vg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { selection: n } = e, { distance: r = 1, unit: i = "character", reverse: a = !1 } = t, { edge: o = null } = t;
	if (n) {
		o === "start" && (o = B.isBackward(n) ? "focus" : "anchor"), o === "end" && (o = B.isBackward(n) ? "anchor" : "focus");
		var { anchor: s, focus: c } = n, l = {
			distance: r,
			unit: i,
			ignoreNonSelectable: !0
		}, u = {};
		if (o == null || o === "anchor") {
			var d = a ? U.before(e, s, l) : U.after(e, s, l);
			d && (u.anchor = d);
		}
		if (o == null || o === "focus") {
			var f = a ? U.before(e, c, l) : U.after(e, c, l);
			f && (u.focus = f);
		}
		q.setSelection(e, u);
	}
}, yg = (e, t) => {
	var { selection: n } = e;
	if (t = U.range(e, t), n) q.setSelection(e, t);
	else {
		if (!B.isRange(t)) throw Error(`When setting the selection and the current selection is \`null\` you must provide at least an \`anchor\` and \`focus\`, but you passed: ${dm.stringify(t)}`);
		e.apply({
			type: "set_selection",
			properties: n,
			newProperties: t
		});
	}
};
function bg(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function xg(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? bg(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bg(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var Sg = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, { selection: r } = e, { edge: i = "both" } = n;
	if (r) {
		i === "start" && (i = B.isBackward(r) ? "focus" : "anchor"), i === "end" && (i = B.isBackward(r) ? "anchor" : "focus");
		var { anchor: a, focus: o } = r, s = i === "anchor" ? a : o;
		q.setSelection(e, { [i === "anchor" ? "anchor" : "focus"]: xg(xg({}, s), t) });
	}
}, Cg = (e, t) => {
	var { selection: n } = e, r = {}, i = {};
	if (n) {
		for (var a in t) (a === "anchor" && t.anchor != null && !W.equals(t.anchor, n.anchor) || a === "focus" && t.focus != null && !W.equals(t.focus, n.focus) || a !== "anchor" && a !== "focus" && t[a] !== n[a]) && (r[a] = n[a], i[a] = t[a]);
		Object.keys(r).length > 0 && e.apply({
			type: "set_selection",
			properties: r,
			newProperties: i
		});
	}
}, wg = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	U.withoutNormalizing(e, () => {
		var { hanging: r = !1, voids: i = !1, mode: a = "lowest" } = n, { at: o, match: s, select: c } = n;
		if (H.isNode(t) && (t = [t]), t.length !== 0) {
			var [l] = t;
			if (o || (o = gm(e), c = !0), c ??= !1, B.isRange(o)) {
				if (r || (o = U.unhangRange(e, o, { voids: i })), B.isCollapsed(o)) o = o.anchor;
				else {
					var [, u] = B.edges(o), d = U.pointRef(e, u);
					q.delete(e, { at: o }), o = d.unref();
				}
			}
			if (W.isPoint(o)) {
				s ??= G.isText(l) ? (e) => G.isText(e) : e.isInline(l) ? (t) => G.isText(t) || U.isInline(e, t) : (t) => V.isElement(t) && U.isBlock(e, t);
				var [f] = U.nodes(e, {
					at: o.path,
					match: s,
					mode: a,
					voids: i
				});
				if (f) {
					var [, p] = f, m = U.pathRef(e, p), h = U.isEnd(e, o, p);
					q.splitNodes(e, {
						at: o,
						match: s,
						mode: a,
						voids: i
					});
					var g = m.unref();
					o = h ? z.next(g) : g;
				} else return;
			}
			var _ = z.parent(o), v = o[o.length - 1];
			if (i || !U.void(e, { at: _ })) {
				for (var y of t) {
					var b = _.concat(v);
					v++, e.apply({
						type: "insert_node",
						path: b,
						node: y
					}), o = z.next(o);
				}
				if (o = z.previous(o), c) {
					var x = U.end(e, o);
					x && q.select(e, x);
				}
			}
		}
	});
}, Tg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	U.withoutNormalizing(e, () => {
		var { at: n = e.selection, mode: r = "lowest", voids: i = !1 } = t, { match: a } = t;
		if (a ??= z.isPath(n) ? _m(e, n) : (t) => V.isElement(t) && U.isBlock(e, t), n) {
			var o = U.nodes(e, {
				at: n,
				match: a,
				mode: r,
				voids: i
			});
			for (var s of Array.from(o, (t) => {
				var [, n] = t;
				return U.pathRef(e, n);
			})) {
				var c = s.unref();
				if (c.length < 2) throw Error(`Cannot lift node at a path [${c}] because it has a depth of less than \`2\`.`);
				var [l, u] = U.node(e, z.parent(c)), d = c[c.length - 1], { length: f } = l.children;
				if (f === 1) {
					var p = z.next(u);
					q.moveNodes(e, {
						at: c,
						to: p,
						voids: i
					}), q.removeNodes(e, {
						at: u,
						voids: i
					});
				} else if (d === 0) q.moveNodes(e, {
					at: c,
					to: u,
					voids: i
				});
				else if (d === f - 1) {
					var m = z.next(u);
					q.moveNodes(e, {
						at: c,
						to: m,
						voids: i
					});
				} else {
					var h = z.next(c), g = z.next(u);
					q.splitNodes(e, {
						at: h,
						voids: i
					}), q.moveNodes(e, {
						at: c,
						to: g,
						voids: i
					});
				}
			}
		}
	});
}, Eg = ["text"], Dg = ["children"], Og = (e, t) => {
	if (V.isElement(t)) {
		var n = t;
		return U.isVoid(e, t) ? !0 : n.children.length === 1 && Og(e, n.children[0]);
	}
	return !U.isEditor(t);
}, kg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	U.withoutNormalizing(e, () => {
		var { match: n, at: r = e.selection } = t, { hanging: i = !1, voids: a = !1, mode: o = "lowest" } = t;
		if (r) {
			if (n == null) {
				if (z.isPath(r)) {
					var [s] = U.parent(e, r);
					n = (e) => s.children.includes(e);
				} else n = (t) => V.isElement(t) && U.isBlock(e, t);
			}
			if (!i && B.isRange(r) && (r = U.unhangRange(e, r, { voids: a })), B.isRange(r)) {
				if (B.isCollapsed(r)) r = r.anchor;
				else {
					var [, c] = B.edges(r), l = U.pointRef(e, c);
					q.delete(e, { at: r }), r = l.unref(), t.at ?? q.select(e, r);
				}
			}
			var [u] = U.nodes(e, {
				at: r,
				match: n,
				voids: a,
				mode: o
			}), d = U.previous(e, {
				at: r,
				match: n,
				voids: a,
				mode: o
			});
			if (u && d) {
				var [f, p] = u, [m, h] = d;
				if (p.length !== 0 && h.length !== 0) {
					var g = z.next(h), _ = z.common(p, h), v = z.isSibling(p, h), y = Array.from(U.levels(e, { at: p }), (e) => {
						var [t] = e;
						return t;
					}).slice(_.length).slice(0, -1), b = U.above(e, {
						at: p,
						mode: "highest",
						match: (t) => y.includes(t) && Og(e, t)
					}), x = b && U.pathRef(e, b[1]), S, C;
					if (G.isText(f) && G.isText(m)) {
						var w = Jp(f, Eg);
						C = m.text.length, S = w;
					} else if (V.isElement(f) && V.isElement(m)) {
						var w = Jp(f, Dg);
						C = m.children.length, S = w;
					} else throw Error(`Cannot merge the node at path [${p}] with the previous sibling because it is not the same kind: ${dm.stringify(f)} ${dm.stringify(m)}`);
					v || q.moveNodes(e, {
						at: p,
						to: g,
						voids: a
					}), x && q.removeNodes(e, {
						at: x.current,
						voids: a
					}), V.isElement(m) && U.isEmpty(e, m) || G.isText(m) && m.text === "" && h[h.length - 1] !== 0 ? q.removeNodes(e, {
						at: h,
						voids: a
					}) : e.apply({
						type: "merge_node",
						path: g,
						position: C,
						properties: S
					}), x && x.unref();
				}
			}
		}
	});
}, Ag = (e, t) => {
	U.withoutNormalizing(e, () => {
		var { to: n, at: r = e.selection, mode: i = "lowest", voids: a = !1 } = t, { match: o } = t;
		if (r) {
			o ??= z.isPath(r) ? _m(e, r) : (t) => V.isElement(t) && U.isBlock(e, t);
			var s = U.pathRef(e, n), c = U.nodes(e, {
				at: r,
				match: o,
				mode: i,
				voids: a
			});
			for (var l of Array.from(c, (t) => {
				var [, n] = t;
				return U.pathRef(e, n);
			})) {
				var u = l.unref(), d = s.current;
				u.length !== 0 && e.apply({
					type: "move_node",
					path: u,
					newPath: d
				}), s.current && z.isSibling(d, u) && z.isAfter(d, u) && (s.current = z.next(s.current));
			}
			s.unref();
		}
	});
}, jg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	U.withoutNormalizing(e, () => {
		var { hanging: n = !1, voids: r = !1, mode: i = "lowest" } = t, { at: a = e.selection, match: o } = t;
		if (a) {
			o ??= z.isPath(a) ? _m(e, a) : (t) => V.isElement(t) && U.isBlock(e, t), !n && B.isRange(a) && (a = U.unhangRange(e, a, { voids: r }));
			var s = U.nodes(e, {
				at: a,
				match: o,
				mode: i,
				voids: r
			});
			for (var c of Array.from(s, (t) => {
				var [, n] = t;
				return U.pathRef(e, n);
			})) {
				var l = c.unref();
				if (l) {
					var [u] = U.node(e, l);
					e.apply({
						type: "remove_node",
						path: l,
						node: u
					});
				}
			}
		}
	});
}, Mg = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	U.withoutNormalizing(e, () => {
		var { match: r, at: i = e.selection, compare: a, merge: o } = n, { hanging: s = !1, mode: c = "lowest", split: l = !1, voids: u = !1 } = n;
		if (i) {
			if (r ??= z.isPath(i) ? _m(e, i) : (t) => V.isElement(t) && U.isBlock(e, t), !s && B.isRange(i) && (i = U.unhangRange(e, i, { voids: u })), l && B.isRange(i)) {
				if (B.isCollapsed(i) && U.leaf(e, i.anchor)[0].text.length > 0) return;
				var d = U.rangeRef(e, i, { affinity: "inward" }), [f, p] = B.edges(i), m = c === "lowest" ? "lowest" : "highest", h = U.isEnd(e, p, p.path);
				q.splitNodes(e, {
					at: p,
					match: r,
					mode: m,
					voids: u,
					always: !h
				});
				var g = U.isStart(e, f, f.path);
				q.splitNodes(e, {
					at: f,
					match: r,
					mode: m,
					voids: u,
					always: !g
				}), i = d.unref(), n.at ?? q.select(e, i);
			}
			a ||= (e, t) => e !== t;
			for (var [_, v] of U.nodes(e, {
				at: i,
				match: r,
				mode: c,
				voids: u
			})) {
				var y = {}, b = {};
				if (v.length !== 0) {
					var x = !1;
					for (var S in t) S !== "children" && S !== "text" && a(t[S], _[S]) && (x = !0, _.hasOwnProperty(S) && (y[S] = _[S]), o ? t[S] != null && (b[S] = o(_[S], t[S])) : t[S] != null && (b[S] = t[S]));
					x && e.apply({
						type: "set_node",
						path: v,
						properties: y,
						newProperties: b
					});
				}
			}
		}
	});
}, Ng = (e, t) => {
	if (B.isCollapsed(t)) return t.anchor;
	var [, n] = B.edges(t), r = U.pointRef(e, n);
	return q.delete(e, { at: t }), r.unref();
}, Pg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	U.withoutNormalizing(e, () => {
		var { mode: n = "lowest", voids: r = !1 } = t, { match: i, at: a = e.selection, height: o = 0, always: s = !1 } = t;
		if (i ??= (t) => V.isElement(t) && U.isBlock(e, t), B.isRange(a) && (a = Ng(e, a)), z.isPath(a)) {
			var c = a, l = U.point(e, c), [u] = U.parent(e, c);
			i = (e) => e === u, o = l.path.length - c.length + 1, a = l, s = !0;
		}
		if (a) {
			var d = U.pointRef(e, a, { affinity: "backward" }), f;
			try {
				var [p] = U.nodes(e, {
					at: a,
					match: i,
					mode: n,
					voids: r
				});
				if (!p) return;
				var m = U.void(e, {
					at: a,
					mode: "highest"
				}), h = 0;
				if (!r && m) {
					var [g, _] = m;
					if (V.isElement(g) && e.isInline(g)) {
						var v = U.after(e, _);
						if (!v) {
							var y = { text: "" }, b = z.next(_);
							q.insertNodes(e, y, {
								at: b,
								voids: r
							}), v = U.point(e, b);
						}
						a = v, s = !0;
					}
					o = a.path.length - _.length + 1, s = !0;
				}
				f = U.pointRef(e, a);
				var x = a.path.length - o, [, S] = p, C = a.path.slice(0, x), w = o === 0 ? a.offset : a.path[x] + h;
				for (var [T, E] of U.levels(e, {
					at: C,
					reverse: !0,
					voids: r
				})) {
					var ee = !1;
					if (E.length < S.length || E.length === 0 || !r && V.isElement(T) && U.isVoid(e, T)) break;
					var D = d.current, O = U.isEnd(e, D, E);
					if (s || !d || !U.isEdge(e, D, E)) {
						ee = !0;
						var te = H.extractProps(T);
						e.apply({
							type: "split_node",
							path: E,
							position: w,
							properties: te
						});
					}
					w = E[E.length - 1] + (ee || O ? 1 : 0);
				}
				if (t.at == null) {
					var k = f.current || U.end(e, []);
					q.select(e, k);
				}
			} finally {
				var ne;
				d.unref(), (ne = f) == null || ne.unref();
			}
		}
	});
}, Fg = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	Array.isArray(t) || (t = [t]);
	var r = {};
	for (var i of t) r[i] = null;
	q.setNodes(e, r, n);
}, Ig = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	U.withoutNormalizing(e, () => {
		var { mode: n = "lowest", split: r = !1, voids: i = !1 } = t, { at: a = e.selection, match: o } = t;
		if (a) {
			o ??= z.isPath(a) ? _m(e, a) : (t) => V.isElement(t) && U.isBlock(e, t), z.isPath(a) && (a = U.range(e, a));
			var s = B.isRange(a) ? U.rangeRef(e, a) : null, c = U.nodes(e, {
				at: a,
				match: o,
				mode: n,
				voids: i
			}), l = Array.from(c, (t) => {
				var [, n] = t;
				return U.pathRef(e, n);
			}).reverse(), u = function(t) {
				var n = t.unref(), [a] = U.node(e, n), o = U.range(e, n);
				r && s && (o = B.intersection(s.current, o)), q.liftNodes(e, {
					at: o,
					match: (e) => V.isAncestor(a) && a.children.includes(e),
					voids: i
				});
			};
			for (var d of l) u(d);
			s && s.unref();
		}
	});
};
function Lg(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Rg(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Lg(Object(n), !0).forEach(function(t) {
			zp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Lg(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var zg = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	U.withoutNormalizing(e, () => {
		var { mode: r = "lowest", split: i = !1, voids: a = !1 } = n, { match: o, at: s = e.selection } = n;
		if (s) {
			if (o ??= z.isPath(s) ? _m(e, s) : e.isInline(t) ? (t) => V.isElement(t) && U.isInline(e, t) || G.isText(t) : (t) => V.isElement(t) && U.isBlock(e, t), i && B.isRange(s)) {
				var [c, l] = B.edges(s), u = U.rangeRef(e, s, { affinity: "inward" });
				q.splitNodes(e, {
					at: l,
					match: o,
					voids: a
				}), q.splitNodes(e, {
					at: c,
					match: o,
					voids: a
				}), s = u.unref(), n.at ?? q.select(e, s);
			}
			for (var [, d] of Array.from(U.nodes(e, {
				at: s,
				match: e.isInline(t) ? (t) => V.isElement(t) && U.isBlock(e, t) : (e) => U.isEditor(e),
				mode: "lowest",
				voids: a
			}))) {
				var f = B.isRange(s) ? B.intersection(s, U.range(e, d)) : s;
				if (f) {
					var p = Array.from(U.nodes(e, {
						at: f,
						match: o,
						mode: r,
						voids: a
					}));
					p.length > 0 && function() {
						var [n] = p, r = p[p.length - 1], [, i] = n, [, o] = r;
						if (i.length === 0 && o.length === 0) return "continue";
						var s = z.equals(i, o) ? z.parent(i) : z.common(i, o), c = U.range(e, i, o), [l] = U.node(e, s), u = s.length + 1, d = z.next(o.slice(0, u)), f = Rg(Rg({}, t), {}, { children: [] });
						q.insertNodes(e, f, {
							at: d,
							voids: a
						}), q.moveNodes(e, {
							at: c,
							match: (e) => V.isAncestor(l) && l.children.includes(e),
							to: d.concat(0),
							voids: a
						});
					}();
				}
			}
		}
	});
}, Bg = () => {
	var e = {
		children: [],
		operations: [],
		selection: null,
		marks: null,
		isElementReadOnly: () => !1,
		isInline: () => !1,
		isSelectable: () => !0,
		isVoid: () => !1,
		markableVoid: () => !1,
		onChange: () => {},
		apply: function() {
			return Jm(e, ...arguments);
		},
		addMark: function() {
			return nh(e, ...arguments);
		},
		deleteBackward: function() {
			return lh(e, ...arguments);
		},
		deleteForward: function() {
			return uh(e, ...arguments);
		},
		deleteFragment: function() {
			return dh(e, ...arguments);
		},
		getFragment: function() {
			return Xm(e, ...arguments);
		},
		insertBreak: function() {
			return Eh(e, ...arguments);
		},
		insertSoftBreak: function() {
			return Oh(e, ...arguments);
		},
		insertFragment: function() {
			return hg(e, ...arguments);
		},
		insertNode: function() {
			return Dh(e, ...arguments);
		},
		insertText: function() {
			return jh(e, ...arguments);
		},
		normalizeNode: function() {
			return Zm(e, ...arguments);
		},
		removeMark: function() {
			return cg(e, ...arguments);
		},
		getDirtyPaths: function() {
			return Ym(e, ...arguments);
		},
		shouldNormalize: function() {
			return Qm(e, ...arguments);
		},
		above: function() {
			return $m(e, ...arguments);
		},
		after: function() {
			return ah(e, ...arguments);
		},
		before: function() {
			return ch(e, ...arguments);
		},
		collapse: function() {
			return gg(e, ...arguments);
		},
		delete: function() {
			return mg(e, ...arguments);
		},
		deselect: function() {
			return _g(e, ...arguments);
		},
		edges: function() {
			return fh(e, ...arguments);
		},
		elementReadOnly: function() {
			return hh(e, ...arguments);
		},
		end: function() {
			return gh(e, ...arguments);
		},
		first: function() {
			return _h(e, ...arguments);
		},
		fragment: function() {
			return vh(e, ...arguments);
		},
		getMarks: function() {
			return Uh(e, ...arguments);
		},
		hasBlocks: function() {
			return Sh(e, ...arguments);
		},
		hasInlines: function() {
			return Ch(e, ...arguments);
		},
		hasPath: function() {
			return wh(e, ...arguments);
		},
		hasTexts: function() {
			return Th(e, ...arguments);
		},
		insertNodes: function() {
			return wg(e, ...arguments);
		},
		isBlock: function() {
			return Mh(e, ...arguments);
		},
		isEdge: function() {
			return Nh(e, ...arguments);
		},
		isEmpty: function() {
			return Ph(e, ...arguments);
		},
		isEnd: function() {
			return Fh(e, ...arguments);
		},
		isNormalizing: function() {
			return Ih(e, ...arguments);
		},
		isStart: function() {
			return Lh(e, ...arguments);
		},
		last: function() {
			return Rh(e, ...arguments);
		},
		leaf: function() {
			return zh(e, ...arguments);
		},
		levels: function() {
			return Bh(e, ...arguments);
		},
		liftNodes: function() {
			return Tg(e, ...arguments);
		},
		mergeNodes: function() {
			return kg(e, ...arguments);
		},
		move: function() {
			return vg(e, ...arguments);
		},
		moveNodes: function() {
			return Ag(e, ...arguments);
		},
		next: function() {
			return Wh(e, ...arguments);
		},
		node: function() {
			return Gh(e, ...arguments);
		},
		nodes: function() {
			return Kh(e, ...arguments);
		},
		normalize: function() {
			return qh(e, ...arguments);
		},
		parent: function() {
			return Jh(e, ...arguments);
		},
		path: function() {
			return Zh(e, ...arguments);
		},
		pathRef: function() {
			return Yh(e, ...arguments);
		},
		pathRefs: function() {
			return Xh(e, ...arguments);
		},
		point: function() {
			return eg(e, ...arguments);
		},
		pointRef: function() {
			return Qh(e, ...arguments);
		},
		pointRefs: function() {
			return $h(e, ...arguments);
		},
		positions: function() {
			return tg(e, ...arguments);
		},
		previous: function() {
			return ng(e, ...arguments);
		},
		range: function() {
			return ag(e, ...arguments);
		},
		rangeRef: function() {
			return rg(e, ...arguments);
		},
		rangeRefs: function() {
			return ig(e, ...arguments);
		},
		removeNodes: function() {
			return jg(e, ...arguments);
		},
		select: function() {
			return yg(e, ...arguments);
		},
		setNodes: function() {
			return Mg(e, ...arguments);
		},
		setNormalizing: function() {
			return lg(e, ...arguments);
		},
		setPoint: function() {
			return Sg(e, ...arguments);
		},
		setSelection: function() {
			return Cg(e, ...arguments);
		},
		splitNodes: function() {
			return Pg(e, ...arguments);
		},
		start: function() {
			return ug(e, ...arguments);
		},
		string: function() {
			return dg(e, ...arguments);
		},
		unhangRange: function() {
			return fg(e, ...arguments);
		},
		unsetNodes: function() {
			return Fg(e, ...arguments);
		},
		unwrapNodes: function() {
			return Ig(e, ...arguments);
		},
		void: function() {
			return xh(e, ...arguments);
		},
		withoutNormalizing: function() {
			return pg(e, ...arguments);
		},
		wrapNodes: function() {
			return zg(e, ...arguments);
		}
	};
	return e;
}, Vg = { isHistory(e) {
	return Of(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (e.redos.length === 0 || im.isOperationList(e.redos[0].operations)) && (e.undos.length === 0 || im.isOperationList(e.undos[0].operations));
} }, Hg = /* @__PURE__ */ new WeakMap(), Ug = /* @__PURE__ */ new WeakMap(), Wg = {
	isHistoryEditor(e) {
		return Vg.isHistory(e.history) && U.isEditor(e);
	},
	isMerging(e) {
		return Ug.get(e);
	},
	isSaving(e) {
		return Hg.get(e);
	},
	redo(e) {
		e.redo();
	},
	undo(e) {
		e.undo();
	},
	withoutMerging(e, t) {
		var n = Wg.isMerging(e);
		Ug.set(e, !1), t(), Ug.set(e, n);
	},
	withoutSaving(e, t) {
		var n = Wg.isSaving(e);
		Hg.set(e, !1), t(), Hg.set(e, n);
	}
}, Gg = (e) => {
	var t = e, { apply: n } = t;
	return t.history = {
		undos: [],
		redos: []
	}, t.redo = () => {
		var { history: e } = t, { redos: n } = e;
		if (n.length > 0) {
			var r = n[n.length - 1];
			r.selectionBefore && q.setSelection(t, r.selectionBefore), Wg.withoutSaving(t, () => {
				U.withoutNormalizing(t, () => {
					for (var e of r.operations) t.apply(e);
				});
			}), e.redos.pop(), t.writeHistory("undos", r);
		}
	}, t.undo = () => {
		var { history: e } = t, { undos: n } = e;
		if (n.length > 0) {
			var r = n[n.length - 1];
			Wg.withoutSaving(t, () => {
				U.withoutNormalizing(t, () => {
					for (var e of r.operations.map(im.inverse).reverse()) t.apply(e);
					r.selectionBefore && q.setSelection(t, r.selectionBefore);
				});
			}), t.writeHistory("redos", r), e.undos.pop();
		}
	}, t.apply = (e) => {
		var { operations: r, history: i } = t, { undos: a } = i, o = a[a.length - 1], s = o && o.operations[o.operations.length - 1], c = Wg.isSaving(t), l = Wg.isMerging(t);
		if (c ??= qg(e), c) {
			if (l ??= o == null ? !1 : r.length !== 0 || Kg(e, s), o && l) o.operations.push(e);
			else {
				var u = {
					operations: [e],
					selectionBefore: t.selection
				};
				t.writeHistory("undos", u);
			}
			for (; a.length > 100;) a.shift();
			i.redos = [];
		}
		n(e);
	}, t.writeHistory = (e, n) => {
		t.history[e].push(n);
	}, t;
}, Kg = (e, t) => !!(t && e.type === "insert_text" && t.type === "insert_text" && e.offset === t.offset + t.text.length && z.equals(e.path, t.path) || t && e.type === "remove_text" && t.type === "remove_text" && e.offset + e.text.length === t.offset && z.equals(e.path, t.path)), qg = (e, t) => e.type !== "set_selection", Jg = Object.defineProperty, Yg = Object.defineProperties, Xg = Object.getOwnPropertyDescriptors, Zg = Object.getOwnPropertySymbols, Qg = Object.prototype.hasOwnProperty, $g = Object.prototype.propertyIsEnumerable, e_ = (e, t, n) => t in e ? Jg(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, t_ = (e, t) => {
	for (var n in t ||= {}) Qg.call(t, n) && e_(e, n, t[n]);
	if (Zg) for (var n of Zg(t)) $g.call(t, n) && e_(e, n, t[n]);
	return e;
}, n_ = (e, t) => Yg(e, Xg(t)), r_ = (e, t) => {
	var n = {};
	for (var r in e) Qg.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && Zg) for (var r of Zg(e)) t.indexOf(r) < 0 && $g.call(e, r) && (n[r] = e[r]);
	return n;
}, i_ = () => Bg(), a_ = (e) => e, o_ = (e, t, n) => U.pathRef(e, t, n), s_ = (e, t, n) => U.pointRef(e, t, n), c_ = (e) => V.isElement(e), l_ = (e, t) => c_(t) && U.isBlock(e, t);
function u_(e) {
	return Array.isArray(e) ? e : [e];
}
var d_ = (e, t, n) => n ? typeof n == "object" ? Object.entries(n).every(([t, n]) => u_(n).includes(e[t])) : n(e, t) : !0, f_ = (e, t = {}) => {
	let { block: n, match: r } = t;
	return n_(t_({}, t), { match: r || n ? (t, i) => d_(t, i, r) && (!n || l_(e, t)) : void 0 });
}, p_ = (e, t) => U.above(e, f_(e, t)), m_ = (e, t, n = {}) => {
	let { unhang: r = !0, voids: i } = n;
	return B.isRange(t) && r ? U.unhangRange(e, t, { voids: i }) : t;
}, h_ = (e, t) => (m_(e, t?.at, t), U.nodes(e, f_(e, t))), g_ = (e, t, n) => {
	try {
		return U.parent(e, t, n);
	} catch {}
}, __ = (e, t) => U.previous(e, t), v_ = (e, t) => U.isEmpty(e, t), J = (e, t) => {
	let n = !1;
	return U.withoutNormalizing(e, () => {
		n = !!t();
	}), n;
}, y_ = (e) => G.isText(e), b_ = (e) => y_(e) ? !0 : e.children.length === 1 && b_(e.children[0]), x_ = (e, t) => {
	q.delete(e, t);
}, S_ = (e, t) => q.moveNodes(e, t), C_ = (e, t) => q.removeNodes(e, t), w_ = (e, t) => {
	q.select(e, t);
}, T_ = (e, t = {}) => {
	J(e, () => {
		let { at: n = e.selection, match: r } = t, { hanging: i = !1, mergeNode: a, mode: o = "lowest", removeEmptyAncestor: s, voids: c = !1 } = t;
		if (!n) return;
		if (r == null) {
			if (z.isPath(n)) {
				let [t] = g_(e, n);
				r = (e) => t.children.includes(e);
			} else r = (t) => l_(e, t);
		}
		if (!i && B.isRange(n) && (n = U.unhangRange(e, n)), B.isRange(n)) {
			if (B.isCollapsed(n)) n = n.anchor;
			else {
				let [, r] = B.edges(n), i = s_(e, r);
				x_(e, { at: n }), n = i.unref(), t.at ?? w_(e, n);
			}
		}
		let l = h_(e, {
			at: n,
			match: r,
			mode: o,
			voids: c
		}), [u] = Array.from(l), d = __(e, {
			at: n,
			match: r,
			mode: o,
			voids: c
		});
		if (!u || !d) return;
		let [f, p] = u, [m, h] = d;
		if (p.length === 0 || h.length === 0) return;
		let g = z.next(h), _ = z.common(p, h), v = z.isSibling(p, h), y = U.levels(e, { at: p }), b = new Set(Array.from(y, ([e]) => e).slice(_.length).slice(0, -1)), x = p_(e, {
			at: p,
			match: (e) => b.has(e) && c_(e) && b_(e),
			mode: "highest"
		}), S = x && o_(e, x[1]), C, w;
		if (y_(f) && y_(m)) {
			let e = f, { text: t } = e, n = r_(e, ["text"]);
			w = m.text.length, C = n;
		} else if (c_(f) && c_(m)) {
			let e = f, { children: t } = e, n = r_(e, ["children"]);
			w = m.children.length, C = n;
		} else throw Error(`Cannot merge the node at path [${p}] with the previous sibling because it is not the same kind: ${JSON.stringify(f)} ${JSON.stringify(m)}`);
		if (!v && !a && S_(e, {
			at: p,
			to: g,
			voids: c
		}), S) {
			if (s) {
				let t = S.current;
				t && s(e, { at: t });
			} else C_(e, {
				at: S.current,
				voids: c
			});
		}
		a ? a(e, {
			at: p,
			to: g
		}) : c_(m) && v_(e, m) || y_(m) && m.text === "" ? C_(e, {
			at: h,
			voids: c
		}) : e.apply({
			path: g,
			position: w,
			properties: C,
			type: "merge_node"
		}), S && S.unref();
	});
}, E_ = (e, t) => U.end(e, t), D_ = (e, t, n) => U.leaf(e, t, n), O_ = (e, t, n) => U.after(e, t, n), k_ = (e, t, n) => U.before(e, t, n), A_ = (e, t) => U.start(e, t), j_ = (e, t) => U.void(e, t), M_ = (e, t) => c_(t) && U.isVoid(e, t), N_ = (e, t = {}) => {
	J(e, () => {
		let { distance: n = 1, reverse: r = !1, unit: i = "character", voids: a = !1 } = t, { at: o = e.selection, hanging: s = !1 } = t;
		if (!o) return;
		if (B.isRange(o) && B.isCollapsed(o) && (o = o.anchor), W.isPoint(o)) {
			let t = j_(e, {
				at: o,
				mode: "highest"
			});
			if (!a && t) {
				let [, e] = t;
				o = e;
			} else {
				let t = {
					distance: n,
					unit: i
				}, a = r ? k_(e, o, t) || A_(e, []) : O_(e, o, t) || E_(e, []);
				o = {
					anchor: o,
					focus: a
				}, s = !0;
			}
		}
		if (z.isPath(o)) {
			C_(e, {
				at: o,
				voids: a
			});
			return;
		}
		if (B.isCollapsed(o)) return;
		s || (o = U.unhangRange(e, o, { voids: a }));
		let [c, l] = B.edges(o), u = p_(e, {
			at: c,
			match: (t) => l_(e, t),
			voids: a
		}), d = p_(e, {
			at: l,
			match: (t) => l_(e, t),
			voids: a
		}), f = u && d && !z.equals(u[1], d[1]), p = z.equals(c.path, l.path), m = a ? null : j_(e, {
			at: c,
			mode: "highest"
		}), h = a ? null : j_(e, {
			at: l,
			mode: "highest"
		});
		if (m) {
			let t = k_(e, c);
			t && u && z.isAncestor(u[1], t.path) && (c = t);
		}
		if (h) {
			let t = O_(e, l);
			t && d && z.isAncestor(d[1], t.path) && (l = t);
		}
		let g = [], _, v = h_(e, {
			at: o,
			voids: a
		});
		for (let t of v) {
			let [n, r] = t;
			_ && z.compare(r, _) === 0 || (!a && M_(e, n) || !z.isCommon(r, c.path) && !z.isCommon(r, l.path)) && (g.push(t), _ = r);
		}
		let y = Array.from(g, ([, t]) => o_(e, t)), b = s_(e, c), x = s_(e, l);
		if (!p && !m) {
			let t = b.current, [n] = D_(e, t), { path: r } = t, { offset: i } = c, a = n.text.slice(i);
			e.apply({
				offset: i,
				path: r,
				text: a,
				type: "remove_text"
			});
		}
		for (let t of y) C_(e, {
			at: t.unref(),
			voids: a
		});
		if (!h) {
			let t = x.current, [n] = D_(e, t), { path: r } = t, i = p ? c.offset : 0, a = n.text.slice(i, l.offset);
			e.apply({
				offset: i,
				path: r,
				text: a,
				type: "remove_text"
			});
		}
		!p && f && x.current && b.current && T_(e, {
			at: x.current,
			hanging: !0,
			voids: a
		});
		let S = x.unref() || b.unref();
		t.at == null && S && w_(e, S);
	});
}, P_ = (e, t) => U.edges(e, t), F_ = (e, t, n) => {
	if (!t) return "";
	try {
		return U.string(e, t, n);
	} catch {
		return "";
	}
}, I_ = (e, t) => U.last(e, t), L_ = (e) => U.marks(e), R_ = (e, t) => U.next(e, t), z_ = (e, t, n) => {
	try {
		return U.node(e, t, n);
	} catch {}
}, B_ = (e, t, n) => U.path(e, t, n), V_ = (e, t, n) => U.point(e, t, n), H_ = (e, t, n) => !!t && U.isEnd(e, t, n), U_ = (e, t) => c_(t) && U.isInline(e, t), W_ = (e, t, n) => !!t && U.isStart(e, t, n), G_ = (e, t) => U.normalize(e, t), K_ = (e, t) => U.removeMark(e, t), q_ = (e, t, n) => H.common(e, t, n), J_ = (e, t) => {
	try {
		for (let n = 0; n < t.length; n++) {
			let r = t[n];
			if (y_(e) || !e.children[r]) return null;
			e = e.children[r];
		}
		return e;
	} catch {
		return null;
	}
}, Y_ = (e, t, n) => H.children(e, t, n), X_ = (e, t) => H.descendants(e, t), Z_ = (e, t) => H.leaf(e, t), Q_ = (e) => H.extractProps(e), $_ = (e) => H.string(e), ev = (e, t) => H.texts(e, t), tv = (e, t) => H.nodes(e, t), nv = (e, t) => H.has(e, t), rv = (e) => V.isAncestor(e), iv = (e) => !!e && B.isCollapsed(e), av = (e) => !!e && B.isExpanded(e), ov = (e, t) => {
	q.collapse(e, t);
}, sv = (e) => {
	q.deselect(e);
};
function cv(e) {
	return Array.isArray(e) ? e : [e];
}
var lv = (e, { allow: t, exclude: n, filter: r, level: i, maxLevel: a } = {}) => {
	if (!e) return !1;
	let [o, s] = e;
	if (i && !cv(i).includes(s.length) || a && s.length > a || r && !r(e)) return !1;
	if (t) {
		let e = cv(t);
		if (e.length > 0 && !e.includes(o.type)) return !1;
	}
	if (n) {
		let e = cv(n);
		if (e.length > 0 && e.includes(o.type)) return !1;
	}
	return !0;
}, uv = (e, t, n = {}) => {
	var r = n, { nextBlock: i, removeEmpty: a } = r, o = r_(r, ["nextBlock", "removeEmpty"]);
	pg(e, () => {
		if (a) {
			let t = p_(e, { at: o.at });
			if (t) {
				let n = a === !0 ? { allow: ["p"] } : a, { filter: r } = n;
				n.filter = ([t, n]) => $_(t) || t.children.some((t) => U_(e, t)) ? !1 : !r || r([t, n]), lv(t, n) && (jg(e, { at: t[1] }), i = !1);
			}
		}
		if (i) {
			let { at: t = e.selection } = o;
			if (t) {
				let n = p_(e, {
					at: E_(e, t),
					block: !0
				});
				n && (o.at = z.next(n[1]));
			}
		}
		q.insertNodes(e, t, o);
	});
}, dv = (e, t) => q.liftNodes(e, t), fv = (e, t) => {
	q.move(e, t);
}, pv = (e, t, n) => q.setNodes(e, t, n), mv = (e, t) => q.splitNodes(e, t), hv = (e, t, n) => q.unsetNodes(e, t, n), gv = (e, t) => {
	q.unwrapNodes(e, f_(e, t));
}, _v = (e, t, n) => {
	m_(e, n?.at, n), q.wrapNodes(e, t, n);
}, vv = (e, t = {}) => {
	try {
		let n = h_(e, t_({ at: e.selection || [] }, f_(e, t)));
		for (let [e, t] of n) return [e, t];
	} catch {
		return;
	}
}, yv = (e, t) => !!vv(e, t), bv = (e, t, n) => pv(e, t, n), xv = Ie, Sv = Le, Cv = Re, wv = ze, Tv = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), Ev = (e, t) => !e || e.nodeName === t ? e : Ev(e.parentElement, t), Dv = /^(?:\w+:)?\/\/(\S+)$/, Ov = /mailto:([^?\\]+)/, kv = /^localhost[\d:?]*(?:[^\d:?]\S*)?$/, Av = /^[^\s.]+\.\S{2,}$/, jv = (e) => {
	if (typeof e != "string") return !1;
	let t = e.match(Dv), n = e.match(Ov), r = t || n;
	if (!r) return !1;
	let i = r[1];
	if (!i) return !1;
	try {
		new URL(e);
	} catch {
		return !1;
	}
	return kv.test(i) || Av.test(i);
}, Mv = (e, { allowedSchemes: t, permitInvalid: n = !1 }) => {
	if (!e) return null;
	let r = null;
	try {
		r = new URL(e);
	} catch {
		return n ? e : null;
	}
	return t && !t.includes(r.protocol.slice(0, -1)) ? null : r.href;
}, Nv = (e) => e === void 0, Pv = (e) => e === null, Fv = (e) => Nv(e) || Pv(e), Iv = (e) => !Fv(e), Lv = Object.defineProperty, Rv = Object.defineProperties, zv = Object.getOwnPropertyDescriptors, Bv = Object.getOwnPropertySymbols, Vv = Object.prototype.hasOwnProperty, Hv = Object.prototype.propertyIsEnumerable, Uv = (e, t, n) => t in e ? Lv(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Wv = (e, t) => {
	for (var n in t ||= {}) Vv.call(t, n) && Uv(e, n, t[n]);
	if (Bv) for (var n of Bv(t)) Hv.call(t, n) && Uv(e, n, t[n]);
	return e;
}, Gv = (e, t) => Rv(e, zv(t)), Kv = (e, t) => {
	var n = {};
	for (var r in e) Vv.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && Bv) for (var r of Bv(e)) t.indexOf(r) < 0 && Hv.call(e, r) && (n[r] = e[r]);
	return n;
}, qv = (e, t) => {
	try {
		let { at: n = e.selection, match: r, reverse: i = !1, voids: a = !1 } = t;
		if (!n) return;
		let o, s;
		if (sm.isSpan(n)) [o, s] = n;
		else if (B.isRange(n)) {
			let t = B_(e, n, { edge: "start" }), r = B_(e, n, { edge: "end" });
			o = i ? r : t, s = i ? t : r;
		}
		let c = [e, []];
		z.isPath(n) && (c = z_(e, n));
		let l = X_(c[0], {
			from: o,
			pass: ([t]) => !a && M_(e, t),
			reverse: i,
			to: s
		});
		for (let [e, t] of l) if (d_(e, t, r)) return [e, n.concat(t)];
	} catch {
		return;
	}
}, Y = (e, t = {}) => p_(e, Gv(Wv({}, t), { block: !0 })), Jv = (e) => {
	let [t, n] = e;
	if (rv(t)) {
		let { children: e } = t;
		return e.map((e, t) => [e, n.concat([t])]);
	}
	return [];
}, Yv = (e, t = {}) => {
	var n = t, { at: r } = n, i = Kv(n, ["at"]);
	let a = r ?? e.selection;
	if (!a) return null;
	let [o, s] = P_(e, a ?? e.selection), c = Y(e, Wv({ at: o }, i));
	if (!c) return null;
	let l = Y(e, Wv({ at: s }, i));
	return l ? [c, l] : null;
}, Xv = (e) => {
	let [t, n] = e;
	if (y_(t) || t.children.length === 0) return null;
	let r = t.children;
	return [r.at(-1), n.concat([r.length - 1])];
}, Zv = (e) => {
	let t = Xv(e);
	return t ? t[1] : e[1].concat([-1]);
}, Qv = (e, t) => {
	let n = Zv(e);
	return z.equals(n, t);
}, $v = (e, t) => {
	if (!(t + 1) || !rv(e)) return e;
	let { children: n } = e;
	return $v(n.at(-1), t - 1);
}, ey = (e, t) => {
	let { children: n } = e, r = n.at(-1);
	if (!r) return;
	let [, i] = I_(e, []);
	return [$v(r, t - 1), i.slice(0, t + 1)];
}, ty = (e, t) => e ? L_(e)?.[t] : void 0, ny = (e, t) => {
	let n = R_(e, { at: t });
	if (n) return A_(e, n[1]);
}, ry = (e, t) => {
	let [n, r] = e, i = t[r.length], a = [], o = n.children;
	if (i + 1 < n.children.length) for (let e = i + 1; e < n.children.length; e++) a.push(o[e]);
	return a;
}, iy = (e, t = {}) => {
	var n = t, { at: r } = n, i = Kv(n, ["at"]);
	if (r ||= e.selection, !r) return;
	let [a, o] = B.edges(r), s = Y(e, Wv({ at: a }, i)), c = Y(e, Wv({ at: o }, i));
	if (s || c) return !s || !c || !z.equals(s[1], c[1]);
}, ay = (e, t, n) => {
	if (!n || !n.match && !n.matchString) return k_(e, t, n);
	let r = !n.unit || n.unit === "offset", i = n.matchString ? Cv(n.matchString) : [""], a = n.matchByRegex ?? !1, o;
	return i.some((i) => {
		let s = t, c = V_(e, t, { edge: "end" }), l = i.length + 1, u = Array.from({ length: l }), d = 0;
		for (;;) {
			let f = k_(e, s, n);
			if (!f || iy(e, { at: {
				anchor: f,
				focus: c
			} })) return;
			let p = F_(e, {
				anchor: f,
				focus: c
			}), m = p;
			if (r && l && (u.unshift({
				point: f,
				text: p
			}), u.pop(), m = wv(u.slice(0, -1), "text").join("")), (a ? i.match(m) : m === i) || n.match?.call(n, {
				at: t,
				beforePoint: f,
				beforeString: m
			})) return n.afterMatch ? l && r ? (o = u.at(-1)?.point, !!o) : (o = c, !0) : (o = f, !0);
			if (c = f, s = f, d += 1, !n.skipInvalid && (!i || d >= i.length)) return;
		}
	}), o;
}, oy = (e, { at: t = e.selection, focus: n } = {}) => {
	let r;
	return B.isRange(t) && (r = n ? t.focus : t.anchor), W.isPoint(t) && (r = t), z.isPath(t) && (r = {
		offset: 0,
		path: t
	}), r;
}, sy = (e, t) => {
	let n = __(e, { at: t });
	if (n) return E_(e, n[1]);
}, cy = (e) => {
	if (e.length === 0) return;
	let t = e.at(-1);
	if (!(t <= 0)) return e.slice(0, -1).concat(t - 1);
}, ly = (e, t, n) => {
	let r = ay(e, t, n);
	if (r) return {
		anchor: r,
		focus: V_(e, t, { edge: "end" })
	};
}, uy = (e, t = {}) => {
	let n = Y(e, t)?.[1];
	if (!n) return;
	let r = A_(e, n), i = oy(e, t);
	if (i) return {
		anchor: r,
		focus: i
	};
}, dy = (e, t) => !$_(t) && !t.children.some((t) => U_(e, t)), fy = (e) => {
	let t = Y(e)?.[0];
	return t ? dy(e, t) : !1;
}, py = (e) => {
	if (!e.selection) return !1;
	let t = Y(e);
	if (!t) return !1;
	let n = e.selection.focus, r = g_(e, e.selection);
	if (!r) return !1;
	let [, i] = r;
	if (!H_(e, n, i)) return !1;
	let a = ry(t, n.path);
	if (a.length > 0) {
		for (let e of a) if (y_(e) && e.text) return !1;
	} else return H_(e, n, t[1]);
	return !0;
}, my = (e) => e.at(-1) === 0, hy = (e, t) => Iv(ty(e, t)), gy = (e, t = {}) => {
	var n = t, { at: r } = n, i = Kv(n, ["at"]);
	if (r ||= e.selection, !r) return;
	let [a, o] = B.edges(r), s = Y(e, Wv({ at: a }, i)), c = Y(e, Wv({ at: o }, i));
	if (s && c) return z.equals(s[1], c[1]);
}, _y = (e, t) => {
	let n = Y(e, t)?.[1];
	return !!n && H_(e, e.selection?.focus, n);
}, vy = (e, t) => {
	let { selection: n } = e;
	if (!n) return !1;
	let r = Y(e, t)?.[1];
	return r ? W_(e, n.focus, r) || av(e.selection) && W_(e, n.anchor, r) : !1;
}, yy = (e, t, n) => {
	uv(e, t, n);
}, by = (e, t, n) => {
	yy(e, {
		children: [{ text: "" }],
		type: t
	}, f_(e, n));
}, xy = (e, { at: t, fromStartIndex: n = 0, match: r, to: i }) => {
	let a = 0, o = z.isPath(t) ? t : t[1], s = z.isPath(t) ? J_(e, o) : t[0];
	if (!s || !l_(e, s)) return a;
	for (let t = s.children.length - 1; t >= n; t--) {
		let n = [...o, t], s = J_(e, n);
		(!r || s && r([s, n])) && (S_(e, {
			at: n,
			to: i
		}), a++);
	}
	return a;
}, Sy = (e, t) => {
	var n = t, { at: r, key: i, shouldChange: a = !0 } = n, o = Kv(n, [
		"at",
		"key",
		"shouldChange"
	]);
	let s = r ?? e.selection;
	if (i = Cv(i), s) {
		if (B.isRange(s) && B.isExpanded(s)) hv(e, i, Wv({
			at: s,
			match: y_,
			split: !0
		}, o));
		else if (e.selection) {
			let t = L_(e) ?? {};
			i.forEach((e) => {
				delete t[e];
			}), e.marks = t, a && e.onChange();
		}
	}
}, Cy = (e, t, n) => {
	J(e, () => {
		for (let [, r] of Y_(e, t, { reverse: !0 })) C_(e, Gv(Wv({}, n), { at: r }));
	});
}, wy = (e, { at: t, insertOptions: n, nodes: r, removeOptions: i }) => {
	J(e, () => {
		Cy(e, t, i), uv(e, r, Gv(Wv({}, n), { at: t.concat([0]) }));
	});
}, Ty = (e, { clear: t, key: n }) => {
	e.selection && J(e, () => {
		hy(e, n) ? e.removeMark(n) : (t && Sy(e, { key: Cv(t) }), e.addMark(n, !0));
	});
}, Ey = (e, t, n) => {
	let r = n?.at, i = J_(e, r);
	i?.children && J(e, () => {
		let a = r.concat([0]);
		_v(e, t, Gv(Wv({}, n), { at: a })), i.children.length < 2 || xy(e, {
			at: r,
			fromStartIndex: 1,
			to: a.concat([1])
		});
	});
}, Dy = Be, Oy = Ve, ky = He;
// ../../../node_modules/@udecode/plate-core/node_modules/clsx/dist/clsx.m.js
function Ay(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = Ay(e[t])) && (r && (r += " "), r += n);
		else for (t in e) e[t] && (r && (r += " "), r += t);
	}
	return r;
}
function jy() {
	for (var e, t, n = 0, r = ""; n < arguments.length;) (e = arguments[n++]) && (t = Ay(e)) && (r && (r += " "), r += t);
	return r;
}
// \0callable-external:lodash/pick.js
var My = Ue, Ny = /* @__PURE__ */ s(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	for (var t = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
		alt: "altKey",
		control: "ctrlKey",
		meta: "metaKey",
		shift: "shiftKey"
	}, r = {
		add: "+",
		break: "pause",
		cmd: "meta",
		command: "meta",
		ctl: "control",
		ctrl: "control",
		del: "delete",
		down: "arrowdown",
		esc: "escape",
		ins: "insert",
		left: "arrowleft",
		mod: t ? "meta" : "control",
		opt: "alt",
		option: "alt",
		return: "enter",
		right: "arrowright",
		space: " ",
		spacebar: " ",
		up: "arrowup",
		win: "meta",
		windows: "meta"
	}, i = {
		backspace: 8,
		tab: 9,
		enter: 13,
		shift: 16,
		control: 17,
		alt: 18,
		pause: 19,
		capslock: 20,
		escape: 27,
		" ": 32,
		pageup: 33,
		pagedown: 34,
		end: 35,
		home: 36,
		arrowleft: 37,
		arrowup: 38,
		arrowright: 39,
		arrowdown: 40,
		insert: 45,
		delete: 46,
		meta: 91,
		numlock: 144,
		scrolllock: 145,
		";": 186,
		"=": 187,
		",": 188,
		"-": 189,
		".": 190,
		"/": 191,
		"`": 192,
		"[": 219,
		"\\": 220,
		"]": 221,
		"'": 222
	}, a = 1; a < 20; a++) i["f" + a] = 111 + a;
	function o(e, t, n) {
		t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
		var r = e.map(function(e) {
			return c(e, t);
		}), i = function(e) {
			return r.some(function(t) {
				return l(t, e);
			});
		};
		return n == null ? i : i(n);
	}
	function s(e, t) {
		return o(e, { byKey: !0 }, t);
	}
	function c(e, t) {
		var a = t && t.byKey, o = {};
		e = e.replace("++", "+add");
		var s = e.split("+"), c = s.length;
		for (var l in n) o[n[l]] = !1;
		var f = !0, p = !1, m = void 0;
		try {
			for (var h = s[Symbol.iterator](), g; !(f = (g = h.next()).done); f = !0) {
				var _ = g.value, v = _.endsWith("?") && _.length > 1;
				v && (_ = _.slice(0, -1));
				var y = d(_), b = n[y];
				if (_.length > 1 && !b && !r[_] && !i[y]) throw TypeError("Unknown modifier: \"" + _ + "\"");
				c !== 1 && b || (a ? o.key = y : o.which = u(_)), b && (o[b] = !v || null);
			}
		} catch (e) {
			p = !0, m = e;
		} finally {
			try {
				!f && h.return && h.return();
			} finally {
				if (p) throw m;
			}
		}
		return o;
	}
	function l(e, t) {
		for (var n in e) {
			var r = e[n], i = void 0;
			if (r != null && (i = n === "key" && t.key != null ? t.key.toLowerCase() : n === "which" ? r === 91 && t.which === 93 ? 91 : t.which : t[n], (i != null || r !== !1) && i !== r)) return !1;
		}
		return !0;
	}
	function u(e) {
		return e = d(e), i[e] || e.toUpperCase().charCodeAt(0);
	}
	function d(e) {
		return e = e.toLowerCase(), e = r[e] || e, e;
	}
	e.isHotkey = o, e.isKeyHotkey = s;
}));
// ../../../node_modules/slate-hyperscript/dist/index.es.js
function Py(e) {
	"@babel/helpers - typeof";
	return Py = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Py(e);
}
function Fy(e, t) {
	if (Py(e) !== "object" || e === null) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Py(r) !== "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Iy(e) {
	var t = Fy(e, "string");
	return Py(t) === "symbol" ? t : String(t);
}
function Ly(e, t, n) {
	return t = Iy(t), t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
var Ry = /* @__PURE__ */ new WeakMap(), zy = /* @__PURE__ */ new WeakMap(), By = class {}, Vy = class extends By {
	constructor() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		super(), Ly(this, "offset", void 0), Ly(this, "path", void 0);
		var { offset: t, path: n } = e;
		this.offset = t, this.path = n;
	}
}, Hy = class extends By {
	constructor() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		super(), Ly(this, "offset", void 0), Ly(this, "path", void 0);
		var { offset: t, path: n } = e;
		this.offset = t, this.path = n;
	}
}, Uy = (e, t) => {
	var n = e.text.length;
	Ry.set(e, [n, t]);
}, Wy = (e) => Ry.get(e), Gy = (e, t) => {
	var n = e.text.length;
	zy.set(e, [n, t]);
}, Ky = (e) => zy.get(e);
function qy(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Jy(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? qy(Object(n), !0).forEach(function(t) {
			Ly(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qy(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var Yy = /* @__PURE__ */ new WeakSet(), Xy = (e) => {
	var t = [], n = (e) => {
		if (e != null) {
			var r = t[t.length - 1];
			if (typeof e == "string") {
				var i = { text: e };
				Yy.add(i), e = i;
			}
			if (G.isText(e)) {
				var a = e;
				G.isText(r) && Yy.has(r) && Yy.has(a) && G.equals(r, a, { loose: !0 }) ? r.text += a.text : t.push(a);
			} else if (V.isElement(e)) t.push(e);
			else if (e instanceof By) {
				var o = t[t.length - 1];
				G.isText(o) || (n(""), o = t[t.length - 1]), e instanceof Vy ? Uy(o, e) : e instanceof Hy && Gy(o, e);
			} else throw Error(`Unexpected hyperscript child object: ${e}`);
		}
	};
	for (var r of e.flat(Infinity)) n(r);
	return t;
};
function Zy(e, t, n) {
	return new Vy(t);
}
function Qy(e, t, n) {
	return [new Vy(t), new Hy(t)];
}
function $y(e, t, n) {
	return Jy(Jy({}, t), {}, { children: Xy(n) });
}
function eb(e, t, n) {
	return new Hy(t);
}
function tb(e, t, n) {
	return Xy(n);
}
function nb(e, t, n) {
	var r = n.find((e) => e instanceof Vy), i = n.find((e) => e instanceof Hy);
	if (!r || r.offset == null || r.path == null) throw Error("The <selection> hyperscript tag must have an <anchor> tag as a child with `path` and `offset` attributes defined.");
	if (!i || i.offset == null || i.path == null) throw Error("The <selection> hyperscript tag must have a <focus> tag as a child with `path` and `offset` attributes defined.");
	return Jy({
		anchor: {
			offset: r.offset,
			path: r.path
		},
		focus: {
			offset: i.offset,
			path: i.path
		}
	}, t);
}
function rb(e, t, n) {
	var r = Xy(n);
	if (r.length > 1) throw Error("The <text> hyperscript tag must only contain a single node's worth of children.");
	var [i] = r;
	if (i ??= { text: "" }, !G.isText(i)) throw Error("\n    The <text> hyperscript tag can only contain text content as children.");
	return Yy.delete(i), Object.assign(i, t), i;
}
var ib = (e) => (t, n, r) => {
	var i = [], a;
	for (var o of r) B.isRange(o) ? a = o : i.push(o);
	var s = Xy(i), c = {}, l = e();
	Object.assign(l, n), l.children = s;
	for (var [u, d] of H.texts(l)) {
		var f = Wy(u), p = Ky(u);
		if (f != null) {
			var [m] = f;
			c.anchor = {
				path: d,
				offset: m
			};
		}
		if (p != null) {
			var [h] = p;
			c.focus = {
				path: d,
				offset: h
			};
		}
	}
	if (c.anchor && !c.focus) throw Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<anchor />`. For collapsed selections, use `<cursor />` instead.");
	if (!c.anchor && c.focus) throw Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<focus />`. For collapsed selections, use `<cursor />` instead.");
	return a == null ? B.isRange(c) && (l.selection = c) : l.selection = a, l;
};
function ab(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ob(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ab(Object(n), !0).forEach(function(t) {
			Ly(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ab(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var sb = {
	anchor: Zy,
	cursor: Qy,
	editor: ib(Bg),
	element: $y,
	focus: eb,
	fragment: tb,
	selection: nb,
	text: rb
}, cb = function() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { elements: t = {} } = e, n = ub(t);
	return lb(ob(ob(ob({}, sb), n), e.creators));
}, lb = (e) => function(t, n) {
	var r = [...arguments].slice(2), i = e[t];
	if (!i) throw Error(`No hyperscript creator found for tag: <${t}>`);
	return n ??= {}, Of(n) || (r = [n].concat(r), n = {}), r = r.filter((e) => !!e).flat(), i(t, n, r);
}, ub = (e) => {
	var t = {}, n = function() {
		var n = e[r];
		if (typeof n != "object") throw Error(`Properties specified for a hyperscript shorthand should be an object, but for the custom element <${r}>  tag you passed: ${n}`);
		t[r] = (e, t, r) => $y("element", ob(ob({}, n), t), r);
	};
	for (var r in e) n();
	return t;
}, db = cb(), fb = /* @__PURE__ */ c((/* @__PURE__ */ s(((e, t) => {
	t.exports = o;
	var n = "֑-߿יִ-﷽ﹰ-ﻼ", r = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", i = RegExp("^[^" + r + "]*[" + n + "]"), a = RegExp("^[^" + n + "]*[" + r + "]");
	function o(e) {
		return e = String(e || ""), i.test(e) ? "rtl" : a.test(e) ? "ltr" : "neutral";
	}
})))()), pb = We, mb = Ge;
// ../../../node_modules/compute-scroll-into-view/dist/index.mjs
function hb(e) {
	return typeof e == "object" && !!e && e.nodeType === 1;
}
function gb(e, t) {
	return (!t || e !== "hidden") && e !== "visible" && e !== "clip";
}
function _b(e, t) {
	if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
		var n = getComputedStyle(e, null);
		return gb(n.overflowY, t) || gb(n.overflowX, t) || function(e) {
			var t = function(e) {
				if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
				try {
					return e.ownerDocument.defaultView.frameElement;
				} catch {
					return null;
				}
			}(e);
			return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
		}(e);
	}
	return !1;
}
function vb(e, t, n, r, i, a, o, s) {
	return a < e && o > t || a > e && o < t ? 0 : a <= e && s <= n || o >= t && s >= n ? a - e - r : o > t && s < n || a < e && s > n ? o - t + i : 0;
}
var yb = function(e, t) {
	var n = window, r = t.scrollMode, i = t.block, a = t.inline, o = t.boundary, s = t.skipOverflowHiddenElements, c = typeof o == "function" ? o : function(e) {
		return e !== o;
	};
	if (!hb(e)) throw TypeError("Invalid target");
	for (var l, u = document.scrollingElement || document.documentElement, d = [], f = e; hb(f) && c(f);) {
		if ((f = (l = f).parentElement ?? (l.getRootNode().host || null)) === u) {
			d.push(f);
			break;
		}
		f != null && f === document.body && _b(f) && !_b(document.documentElement) || f != null && _b(f, s) && d.push(f);
	}
	for (var p = n.visualViewport ? n.visualViewport.width : innerWidth, m = n.visualViewport ? n.visualViewport.height : innerHeight, h = window.scrollX || pageXOffset, g = window.scrollY || pageYOffset, _ = e.getBoundingClientRect(), v = _.height, y = _.width, b = _.top, x = _.right, S = _.bottom, C = _.left, w = i === "start" || i === "nearest" ? b : i === "end" ? S : b + v / 2, T = a === "center" ? C + y / 2 : a === "end" ? x : C, E = [], ee = 0; ee < d.length; ee++) {
		var D = d[ee], O = D.getBoundingClientRect(), te = O.height, k = O.width, ne = O.top, re = O.right, A = O.bottom, ie = O.left;
		if (r === "if-needed" && b >= 0 && C >= 0 && S <= m && x <= p && b >= ne && S <= A && C >= ie && x <= re) return E;
		var ae = getComputedStyle(D), j = parseInt(ae.borderLeftWidth, 10), M = parseInt(ae.borderTopWidth, 10), oe = parseInt(ae.borderRightWidth, 10), N = parseInt(ae.borderBottomWidth, 10), se = 0, ce = 0, le = "offsetWidth" in D ? D.offsetWidth - D.clientWidth - j - oe : 0, ue = "offsetHeight" in D ? D.offsetHeight - D.clientHeight - M - N : 0, de = "offsetWidth" in D ? D.offsetWidth === 0 ? 0 : k / D.offsetWidth : 0, P = "offsetHeight" in D ? D.offsetHeight === 0 ? 0 : te / D.offsetHeight : 0;
		if (u === D) se = i === "start" ? w : i === "end" ? w - m : i === "nearest" ? vb(g, g + m, m, M, N, g + w, g + w + v, v) : w - m / 2, ce = a === "start" ? T : a === "center" ? T - p / 2 : a === "end" ? T - p : vb(h, h + p, p, j, oe, h + T, h + T + y, y), se = Math.max(0, se + g), ce = Math.max(0, ce + h);
		else {
			se = i === "start" ? w - ne - M : i === "end" ? w - A + N + ue : i === "nearest" ? vb(ne, A, te, M, N + ue, w, w + v, v) : w - (ne + te / 2) + ue / 2, ce = a === "start" ? T - ie - j : a === "center" ? T - (ie + k / 2) + le / 2 : a === "end" ? T - re + oe + le : vb(ie, re, k, j, oe + le, T, T + y, y);
			var fe = D.scrollLeft, pe = D.scrollTop;
			w += pe - (se = Math.max(0, Math.min(pe + se / P, D.scrollHeight - te / P + ue))), T += fe - (ce = Math.max(0, Math.min(fe + ce / de, D.scrollWidth - k / de + le)));
		}
		E.push({
			el: D,
			top: se,
			left: ce
		});
	}
	return E;
};
// ../../../node_modules/slate-react/node_modules/scroll-into-view-if-needed/es/index.js
function bb(e) {
	return e === Object(e) && Object.keys(e).length !== 0;
}
function xb(e, t) {
	t === void 0 && (t = "auto");
	var n = "scrollBehavior" in document.body.style;
	e.forEach(function(e) {
		var r = e.el, i = e.top, a = e.left;
		r.scroll && n ? r.scroll({
			top: i,
			left: a,
			behavior: t
		}) : (r.scrollTop = i, r.scrollLeft = a);
	});
}
function Sb(e) {
	return e === !1 ? {
		block: "end",
		inline: "nearest"
	} : bb(e) ? e : {
		block: "start",
		inline: "nearest"
	};
}
function Cb(e, t) {
	var n = e.isConnected || e.ownerDocument.documentElement.contains(e);
	if (bb(t) && typeof t.behavior == "function") return t.behavior(n ? yb(e, t) : []);
	if (n) {
		var r = Sb(t);
		return xb(yb(e, r), r.behavior);
	}
}
// ../../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js
var wb = [], Tb = function() {
	return wb.some(function(e) {
		return e.activeTargets.length > 0;
	});
}, Eb = function() {
	return wb.some(function(e) {
		return e.skippedTargets.length > 0;
	});
}, Db = "ResizeObserver loop completed with undelivered notifications.", Ob = function() {
	var e;
	typeof ErrorEvent == "function" ? e = new ErrorEvent("error", { message: Db }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = Db), window.dispatchEvent(e);
}, kb;
(function(e) {
	e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(kb ||= {});
// ../../../node_modules/@juggle/resize-observer/lib/utils/freeze.js
var Ab = function(e) {
	return Object.freeze(e);
}, jb = function() {
	function e(e, t) {
		this.inlineSize = e, this.blockSize = t, Ab(this);
	}
	return e;
}(), Mb = function() {
	function e(e, t, n, r) {
		return this.x = e, this.y = t, this.width = n, this.height = r, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Ab(this);
	}
	return e.prototype.toJSON = function() {
		var e = this;
		return {
			x: e.x,
			y: e.y,
			top: e.top,
			right: e.right,
			bottom: e.bottom,
			left: e.left,
			width: e.width,
			height: e.height
		};
	}, e.fromRect = function(t) {
		return new e(t.x, t.y, t.width, t.height);
	}, e;
}(), Nb = function(e) {
	return e instanceof SVGElement && "getBBox" in e;
}, Pb = function(e) {
	if (Nb(e)) {
		var t = e.getBBox(), n = t.width, r = t.height;
		return !n && !r;
	}
	var i = e, a = i.offsetWidth, o = i.offsetHeight;
	return !(a || o || e.getClientRects().length);
}, Fb = function(e) {
	if (e instanceof Element) return !0;
	var t = e?.ownerDocument?.defaultView;
	return !!(t && e instanceof t.Element);
}, Ib = function(e) {
	switch (e.tagName) {
		case "INPUT": if (e.type !== "image") break;
		case "VIDEO":
		case "AUDIO":
		case "EMBED":
		case "OBJECT":
		case "CANVAS":
		case "IFRAME":
		case "IMG": return !0;
	}
	return !1;
}, Lb = typeof window < "u" ? window : {}, Rb = /* @__PURE__ */ new WeakMap(), zb = /auto|scroll/, Bb = /^tb|vertical/, Vb = /msie|trident/i.test(Lb.navigator && Lb.navigator.userAgent), Hb = function(e) {
	return parseFloat(e || "0");
}, Ub = function(e, t, n) {
	return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = !1), new jb((n ? t : e) || 0, (n ? e : t) || 0);
}, Wb = Ab({
	devicePixelContentBoxSize: Ub(),
	borderBoxSize: Ub(),
	contentBoxSize: Ub(),
	contentRect: new Mb(0, 0, 0, 0)
}), Gb = function(e, t) {
	if (t === void 0 && (t = !1), Rb.has(e) && !t) return Rb.get(e);
	if (Pb(e)) return Rb.set(e, Wb), Wb;
	var n = getComputedStyle(e), r = Nb(e) && e.ownerSVGElement && e.getBBox(), i = !Vb && n.boxSizing === "border-box", a = Bb.test(n.writingMode || ""), o = !r && zb.test(n.overflowY || ""), s = !r && zb.test(n.overflowX || ""), c = r ? 0 : Hb(n.paddingTop), l = r ? 0 : Hb(n.paddingRight), u = r ? 0 : Hb(n.paddingBottom), d = r ? 0 : Hb(n.paddingLeft), f = r ? 0 : Hb(n.borderTopWidth), p = r ? 0 : Hb(n.borderRightWidth), m = r ? 0 : Hb(n.borderBottomWidth), h = r ? 0 : Hb(n.borderLeftWidth), g = d + l, _ = c + u, v = h + p, y = f + m, b = s ? e.offsetHeight - y - e.clientHeight : 0, x = o ? e.offsetWidth - v - e.clientWidth : 0, S = i ? g + v : 0, C = i ? _ + y : 0, w = r ? r.width : Hb(n.width) - S - x, T = r ? r.height : Hb(n.height) - C - b, E = w + g + x + v, ee = T + _ + b + y, D = Ab({
		devicePixelContentBoxSize: Ub(Math.round(w * devicePixelRatio), Math.round(T * devicePixelRatio), a),
		borderBoxSize: Ub(E, ee, a),
		contentBoxSize: Ub(w, T, a),
		contentRect: new Mb(d, c, w, T)
	});
	return Rb.set(e, D), D;
}, Kb = function(e, t, n) {
	var r = Gb(e, n), i = r.borderBoxSize, a = r.contentBoxSize, o = r.devicePixelContentBoxSize;
	switch (t) {
		case kb.DEVICE_PIXEL_CONTENT_BOX: return o;
		case kb.BORDER_BOX: return i;
		default: return a;
	}
}, qb = function() {
	function e(e) {
		var t = Gb(e);
		this.target = e, this.contentRect = t.contentRect, this.borderBoxSize = Ab([t.borderBoxSize]), this.contentBoxSize = Ab([t.contentBoxSize]), this.devicePixelContentBoxSize = Ab([t.devicePixelContentBoxSize]);
	}
	return e;
}(), Jb = function(e) {
	if (Pb(e)) return Infinity;
	for (var t = 0, n = e.parentNode; n;) t += 1, n = n.parentNode;
	return t;
}, Yb = function() {
	var e = Infinity, t = [];
	wb.forEach(function(n) {
		if (n.activeTargets.length !== 0) {
			var r = [];
			n.activeTargets.forEach(function(t) {
				var n = new qb(t.target), i = Jb(t.target);
				r.push(n), t.lastReportedSize = Kb(t.target, t.observedBox), i < e && (e = i);
			}), t.push(function() {
				n.callback.call(n.observer, r, n.observer);
			}), n.activeTargets.splice(0, n.activeTargets.length);
		}
	});
	for (var n = 0, r = t; n < r.length; n++) {
		var i = r[n];
		i();
	}
	return e;
}, Xb = function(e) {
	wb.forEach(function(t) {
		t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function(n) {
			n.isActive() && (Jb(n.target) > e ? t.activeTargets.push(n) : t.skippedTargets.push(n));
		});
	});
}, Zb = function() {
	var e = 0;
	for (Xb(e); Tb();) e = Yb(), Xb(e);
	return Eb() && Ob(), e > 0;
}, Qb, $b = [], ex = function() {
	return $b.splice(0).forEach(function(e) {
		return e();
	});
}, tx = function(e) {
	if (!Qb) {
		var t = 0, n = document.createTextNode("");
		new MutationObserver(function() {
			return ex();
		}).observe(n, { characterData: !0 }), Qb = function() {
			n.textContent = `${t ? t-- : t++}`;
		};
	}
	$b.push(e), Qb();
}, nx = function(e) {
	tx(function() {
		requestAnimationFrame(e);
	});
}, rx = 0, ix = function() {
	return !!rx;
}, ax = 250, ox = {
	attributes: !0,
	characterData: !0,
	childList: !0,
	subtree: !0
}, sx = [
	"resize",
	"load",
	"transitionend",
	"animationend",
	"animationstart",
	"animationiteration",
	"keyup",
	"keydown",
	"mouseup",
	"mousedown",
	"mouseover",
	"mouseout",
	"blur",
	"focus"
], cx = function(e) {
	return e === void 0 && (e = 0), Date.now() + e;
}, lx = !1, ux = new (function() {
	function e() {
		var e = this;
		this.stopped = !0, this.listener = function() {
			return e.schedule();
		};
	}
	return e.prototype.run = function(e) {
		var t = this;
		if (e === void 0 && (e = ax), !lx) {
			lx = !0;
			var n = cx(e);
			nx(function() {
				var r = !1;
				try {
					r = Zb();
				} finally {
					if (lx = !1, e = n - cx(), !ix()) return;
					r ? t.run(1e3) : e > 0 ? t.run(e) : t.start();
				}
			});
		}
	}, e.prototype.schedule = function() {
		this.stop(), this.run();
	}, e.prototype.observe = function() {
		var e = this, t = function() {
			return e.observer && e.observer.observe(document.body, ox);
		};
		document.body ? t() : Lb.addEventListener("DOMContentLoaded", t);
	}, e.prototype.start = function() {
		var e = this;
		this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), sx.forEach(function(t) {
			return Lb.addEventListener(t, e.listener, !0);
		}));
	}, e.prototype.stop = function() {
		var e = this;
		this.stopped ||= (this.observer && this.observer.disconnect(), sx.forEach(function(t) {
			return Lb.removeEventListener(t, e.listener, !0);
		}), !0);
	}, e;
}())(), dx = function(e) {
	!rx && e > 0 && ux.start(), rx += e, !rx && ux.stop();
}, fx = function(e) {
	return !Nb(e) && !Ib(e) && getComputedStyle(e).display === "inline";
}, px = function() {
	function e(e, t) {
		this.target = e, this.observedBox = t || kb.CONTENT_BOX, this.lastReportedSize = {
			inlineSize: 0,
			blockSize: 0
		};
	}
	return e.prototype.isActive = function() {
		var e = Kb(this.target, this.observedBox, !0);
		return fx(this.target) && (this.lastReportedSize = e), this.lastReportedSize.inlineSize !== e.inlineSize || this.lastReportedSize.blockSize !== e.blockSize;
	}, e;
}(), mx = function() {
	function e(e, t) {
		this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = t;
	}
	return e;
}(), hx = /* @__PURE__ */ new WeakMap(), gx = function(e, t) {
	for (var n = 0; n < e.length; n += 1) if (e[n].target === t) return n;
	return -1;
}, _x = function() {
	function e() {}
	return e.connect = function(e, t) {
		var n = new mx(e, t);
		hx.set(e, n);
	}, e.observe = function(e, t, n) {
		var r = hx.get(e), i = r.observationTargets.length === 0;
		gx(r.observationTargets, t) < 0 && (i && wb.push(r), r.observationTargets.push(new px(t, n && n.box)), dx(1), ux.schedule());
	}, e.unobserve = function(e, t) {
		var n = hx.get(e), r = gx(n.observationTargets, t), i = n.observationTargets.length === 1;
		r >= 0 && (i && wb.splice(wb.indexOf(n), 1), n.observationTargets.splice(r, 1), dx(-1));
	}, e.disconnect = function(e) {
		var t = this, n = hx.get(e);
		n.observationTargets.slice().forEach(function(n) {
			return t.unobserve(e, n.target);
		}), n.activeTargets.splice(0, n.activeTargets.length);
	}, e;
}(), vx = function() {
	function e(e) {
		if (arguments.length === 0) throw TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
		if (typeof e != "function") throw TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
		_x.connect(this, e);
	}
	return e.prototype.observe = function(e, t) {
		if (arguments.length === 0) throw TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
		if (!Fb(e)) throw TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
		_x.observe(this, e, t);
	}, e.prototype.unobserve = function(e) {
		if (arguments.length === 0) throw TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
		if (!Fb(e)) throw TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
		_x.unobserve(this, e);
	}, e.prototype.disconnect = function() {
		_x.disconnect(this);
	}, e.toString = function() {
		return "function ResizeObserver () { [polyfill code] }";
	}, e;
}(), yx = (/* @__PURE__ */ s(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	for (var t = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
		alt: "altKey",
		control: "ctrlKey",
		meta: "metaKey",
		shift: "shiftKey"
	}, r = {
		add: "+",
		break: "pause",
		cmd: "meta",
		command: "meta",
		ctl: "control",
		ctrl: "control",
		del: "delete",
		down: "arrowdown",
		esc: "escape",
		ins: "insert",
		left: "arrowleft",
		mod: t ? "meta" : "control",
		opt: "alt",
		option: "alt",
		return: "enter",
		right: "arrowright",
		space: " ",
		spacebar: " ",
		up: "arrowup",
		win: "meta",
		windows: "meta"
	}, i = {
		backspace: 8,
		tab: 9,
		enter: 13,
		shift: 16,
		control: 17,
		alt: 18,
		pause: 19,
		capslock: 20,
		escape: 27,
		" ": 32,
		pageup: 33,
		pagedown: 34,
		end: 35,
		home: 36,
		arrowleft: 37,
		arrowup: 38,
		arrowright: 39,
		arrowdown: 40,
		insert: 45,
		delete: 46,
		meta: 91,
		numlock: 144,
		scrolllock: 145,
		";": 186,
		"=": 187,
		",": 188,
		"-": 189,
		".": 190,
		"/": 191,
		"`": 192,
		"[": 219,
		"\\": 220,
		"]": 221,
		"'": 222
	}, a = 1; a < 20; a++) i["f" + a] = 111 + a;
	function o(e, t, n) {
		t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
		var r = e.map(function(e) {
			return s(e, t);
		}), i = function(e) {
			return r.some(function(t) {
				return c(t, e);
			});
		};
		return n == null ? i : i(n);
	}
	function s(e, t) {
		var r = t && t.byKey, i = {};
		e = e.replace("++", "+add");
		var a = e.split("+"), o = a.length;
		for (var s in n) i[n[s]] = !1;
		var c = !0, d = !1, f = void 0;
		try {
			for (var p = a[Symbol.iterator](), m; !(c = (m = p.next()).done); c = !0) {
				var h = m.value, g = h.endsWith("?") && h.length > 1;
				g && (h = h.slice(0, -1));
				var _ = u(h), v = n[_];
				o !== 1 && v || (r ? i.key = _ : i.which = l(h)), v && (i[v] = !g || null);
			}
		} catch (e) {
			d = !0, f = e;
		} finally {
			try {
				!c && p.return && p.return();
			} finally {
				if (d) throw f;
			}
		}
		return i;
	}
	function c(e, t) {
		for (var n in e) {
			var r = e[n], i = void 0;
			if (r != null && (i = n === "key" && t.key != null ? t.key.toLowerCase() : n === "which" ? r === 91 && t.which === 93 ? 91 : t.which : t[n], (i != null || r !== !1) && i !== r)) return !1;
		}
		return !0;
	}
	function l(e) {
		return e = u(e), i[e] || e.toUpperCase().charCodeAt(0);
	}
	function u(e) {
		return e = e.toLowerCase(), e = r[e] || e, e;
	}
	e.isHotkey = o;
})))();
function bx(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function xx(e, t) {
	if (e == null) return {};
	for (var n = {}, r = Object.keys(e), i, a = 0; a < r.length; a++) i = r[a], t.indexOf(i) >= 0 || (n[i] = e[i]);
	return n;
}
function Sx(e, t) {
	if (e == null) return {};
	var n = xx(e, t), r, i;
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (i = 0; i < a.length; i++) r = a[i], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
	}
	return n;
}
var Cx = /*#__PURE__*/ ce(null), wx = () => {
	var e = fe(Cx);
	if (!e) throw Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
	return e;
}, Tx = parseInt(N.version.split(".")[0], 10), Ex = typeof navigator < "u" && typeof window < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Dx = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), Ox = typeof navigator < "u" && /Android/.test(navigator.userAgent), kx = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), Ax = typeof navigator < "u" && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent), jx = typeof navigator < "u" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent), Mx = typeof navigator < "u" && /Chrome/i.test(navigator.userAgent), Nx = typeof navigator < "u" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent), Px = Ox && typeof navigator < "u" && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent), Fx = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent), Ix = typeof navigator < "u" && /.*UCBrowser/.test(navigator.userAgent), Lx = typeof navigator < "u" && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent), Rx = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, zx = (!Nx || !Px) && !jx && typeof globalThis < "u" && globalThis.InputEvent && typeof globalThis.InputEvent.prototype.getTargetRanges == "function", Bx = /* @__PURE__ */ new WeakMap(), Vx = /* @__PURE__ */ new WeakMap(), Hx = /* @__PURE__ */ new WeakMap(), Ux = /* @__PURE__ */ new WeakMap(), Wx = /* @__PURE__ */ new WeakMap(), Gx = /* @__PURE__ */ new WeakMap(), Kx = /* @__PURE__ */ new WeakMap(), qx = /* @__PURE__ */ new WeakMap(), Jx = /* @__PURE__ */ new WeakMap(), Yx = /* @__PURE__ */ new WeakMap(), Xx = /* @__PURE__ */ new WeakMap(), Zx = /* @__PURE__ */ new WeakMap(), Qx = /* @__PURE__ */ new WeakMap(), $x = /* @__PURE__ */ new WeakMap(), eS = /* @__PURE__ */ new WeakMap(), tS = /* @__PURE__ */ new WeakMap(), nS = /* @__PURE__ */ new WeakMap(), rS = /* @__PURE__ */ new WeakMap(), iS = /* @__PURE__ */ new WeakMap(), aS = /* @__PURE__ */ new WeakMap(), oS = /* @__PURE__ */ new WeakMap(), sS = Symbol("placeholder"), cS = Symbol("mark-placeholder"), lS = globalThis.Text, uS = (e) => e && e.ownerDocument && e.ownerDocument.defaultView || null, dS = (e) => pS(e) && e.nodeType === 8, fS = (e) => pS(e) && e.nodeType === 1, pS = (e) => {
	var t = uS(e);
	return !!t && e instanceof t.Node;
}, mS = (e) => {
	var t = e && e.anchorNode && uS(e.anchorNode);
	return !!t && e instanceof t.Selection;
}, hS = (e) => pS(e) && e.nodeType === 3, gS = (e) => e.clipboardData && e.clipboardData.getData("text/plain") !== "" && e.clipboardData.types.length === 1, _S = (e) => {
	var [t, n] = e;
	if (fS(t) && t.childNodes.length) {
		var r = n === t.childNodes.length, i = r ? n - 1 : n;
		for ([t, i] = yS(t, i, r ? "backward" : "forward"), r = i < n; fS(t) && t.childNodes.length;) {
			var a = r ? t.childNodes.length - 1 : 0;
			t = bS(t, a, r ? "backward" : "forward");
		}
		n = r && t.textContent != null ? t.textContent.length : 0;
	}
	return [t, n];
}, vS = (e) => {
	for (var t = e && e.parentNode; t;) {
		if (t.toString() === "[object ShadowRoot]") return !0;
		t = t.parentNode;
	}
	return !1;
}, yS = (e, t, n) => {
	for (var { childNodes: r } = e, i = r[t], a = t, o = !1, s = !1; (dS(i) || fS(i) && i.childNodes.length === 0 || fS(i) && i.getAttribute("contenteditable") === "false") && !(o && s);) a >= r.length ? (o = !0, a = t - 1, n = "backward") : a < 0 ? (s = !0, a = t + 1, n = "forward") : (i = r[a], t = a, a += n === "forward" ? 1 : -1);
	return [i, t];
}, bS = (e, t, n) => {
	var [r] = yS(e, t, n);
	return r;
}, xS = (e) => {
	var t = "";
	if (hS(e) && e.nodeValue) return e.nodeValue;
	if (fS(e)) {
		for (var n of Array.from(e.childNodes)) t += xS(n);
		var r = getComputedStyle(e).getPropertyValue("display");
		(r === "block" || r === "list" || e.tagName === "BR") && (t += "\n");
	}
	return t;
}, SS = /data-slate-fragment="(.+?)"/m, CS = (e) => {
	var [, t] = e.getData("text/html").match(SS) || [];
	return t;
}, wS = (e, t, n) => {
	var { target: r } = t;
	if (fS(r) && r.matches("[contentEditable=\"false\"]")) return !1;
	var { document: i } = X.getWindow(e);
	if (i.contains(r)) return X.hasDOMNode(e, r, { editable: !0 });
	var a = n.find((e) => {
		var { addedNodes: t, removedNodes: n } = e;
		for (var i of t) if (i === r || i.contains(r)) return !0;
		for (var a of n) if (a === r || a.contains(r)) return !0;
	});
	return !a || a === t ? !1 : wS(e, a, n);
}, TS = 0, ES = class {
	constructor() {
		this.id = `${TS++}`;
	}
}, X = {
	androidPendingDiffs: (e) => rS.get(e),
	androidScheduleFlush: (e) => {
		var t;
		(t = eS.get(e)) == null || t();
	},
	blur: (e) => {
		var t = X.toDOMNode(e, e), n = X.findDocumentOrShadowRoot(e);
		Xx.set(e, !1), n.activeElement === t && t.blur();
	},
	deselect: (e) => {
		var { selection: t } = e, n = X.findDocumentOrShadowRoot(e).getSelection();
		n && n.rangeCount > 0 && n.removeAllRanges(), t && q.deselect(e);
	},
	findDocumentOrShadowRoot: (e) => {
		var t = X.toDOMNode(e, e), n = t.getRootNode();
		return (n instanceof Document || n instanceof ShadowRoot) && n.getSelection != null ? n : t.ownerDocument;
	},
	findEventRange: (e, t) => {
		"nativeEvent" in t && (t = t.nativeEvent);
		var { clientX: n, clientY: r, target: i } = t;
		if (n == null || r == null) throw Error(`Cannot resolve a Slate range from a DOM event: ${t}`);
		var a = X.toSlateNode(e, t.target), o = X.findPath(e, a);
		if (V.isElement(a) && U.isVoid(e, a)) {
			var s = i.getBoundingClientRect(), c = e.isInline(a) ? n - s.left < s.left + s.width - n : r - s.top < s.top + s.height - r, l = U.point(e, o, { edge: c ? "start" : "end" }), u = c ? U.before(e, l) : U.after(e, l);
			if (u) return U.range(e, u);
		}
		var d, { document: f } = X.getWindow(e);
		if (f.caretRangeFromPoint) d = f.caretRangeFromPoint(n, r);
		else {
			var p = f.caretPositionFromPoint(n, r);
			p && (d = f.createRange(), d.setStart(p.offsetNode, p.offset), d.setEnd(p.offsetNode, p.offset));
		}
		if (!d) throw Error(`Cannot resolve a Slate range from a DOM event: ${t}`);
		return X.toSlateRange(e, d, {
			exactMatch: !1,
			suppressThrow: !1
		});
	},
	findKey: (e, t) => {
		var n = qx.get(t);
		return n || (n = new ES(), qx.set(t, n)), n;
	},
	findPath: (e, t) => {
		for (var n = [], r = t;;) {
			var i = Vx.get(r);
			if (i == null) {
				if (U.isEditor(r)) return n;
				break;
			}
			var a = Bx.get(r);
			if (a == null) break;
			n.unshift(a), r = i;
		}
		throw Error(`Unable to find the path for Slate node: ${dm.stringify(t)}`);
	},
	focus: (e) => {
		var t = X.toDOMNode(e, e), n = X.findDocumentOrShadowRoot(e);
		if (Xx.set(e, !0), n.activeElement !== t) {
			if (e.selection && n instanceof Document) {
				var r = n.getSelection(), i = X.toDOMRange(e, e.selection);
				r?.removeAllRanges(), r?.addRange(i);
			}
			t.focus({ preventScroll: !0 });
		}
	},
	getWindow: (e) => {
		var t = Hx.get(e);
		if (!t) throw Error("Unable to find a host window element for this editor");
		return t;
	},
	hasDOMNode: function(e, t) {
		var { editable: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = X.toDOMNode(e, e), i;
		try {
			i = fS(t) ? t : t.parentElement;
		} catch (e) {
			if (!e.message.includes("Permission denied to access property \"nodeType\"")) throw e;
		}
		return i ? i.closest("[data-slate-editor]") === r && (!n || i.isContentEditable ? !0 : typeof i.isContentEditable == "boolean" && i.closest("[contenteditable=\"false\"]") === r || !!i.getAttribute("data-slate-zero-width")) : !1;
	},
	hasEditableTarget: (e, t) => pS(t) && X.hasDOMNode(e, t, { editable: !0 }),
	hasRange: (e, t) => {
		var { anchor: n, focus: r } = t;
		return U.hasPath(e, n.path) && U.hasPath(e, r.path);
	},
	hasSelectableTarget: (e, t) => X.hasEditableTarget(e, t) || X.isTargetInsideNonReadonlyVoid(e, t),
	hasTarget: (e, t) => pS(t) && X.hasDOMNode(e, t),
	insertData: (e, t) => {
		e.insertData(t);
	},
	insertFragmentData: (e, t) => e.insertFragmentData(t),
	insertTextData: (e, t) => e.insertTextData(t),
	isComposing: (e) => !!Zx.get(e),
	isFocused: (e) => !!Xx.get(e),
	isReadOnly: (e) => !!Yx.get(e),
	isTargetInsideNonReadonlyVoid: (e, t) => {
		if (Yx.get(e)) return !1;
		var n = X.hasTarget(e, t) && X.toSlateNode(e, t);
		return V.isElement(n) && U.isVoid(e, n);
	},
	setFragmentData: (e, t, n) => e.setFragmentData(t, n),
	toDOMNode: (e, t) => {
		var n = Jx.get(e), r = U.isEditor(t) ? Ux.get(e) : n?.get(X.findKey(e, t));
		if (!r) throw Error(`Cannot resolve a DOM node from Slate node: ${dm.stringify(t)}`);
		return r;
	},
	toDOMPoint: (e, t) => {
		var [n] = U.node(e, t.path), r = X.toDOMNode(e, n), i;
		U.void(e, { at: t }) && (t = {
			path: t.path,
			offset: 0
		});
		for (var a = Array.from(r.querySelectorAll("[data-slate-string], [data-slate-zero-width]")), o = 0, s = 0; s < a.length; s++) {
			var c = a[s], l = c.childNodes[0];
			if (l != null && l.textContent != null) {
				var { length: u } = l.textContent, d = c.getAttribute("data-slate-length"), f = o + (d == null ? u : parseInt(d, 10)), p = a[s + 1];
				if (t.offset === f && p != null && p.hasAttribute("data-slate-mark-placeholder")) {
					var m, h = p.childNodes[0];
					i = [h instanceof lS ? h : p, (m = p.textContent) != null && m.startsWith("﻿") ? 1 : 0];
					break;
				}
				if (t.offset <= f) {
					i = [l, Math.min(u, Math.max(0, t.offset - o))];
					break;
				}
				o = f;
			}
		}
		if (!i) throw Error(`Cannot resolve a DOM point from Slate point: ${dm.stringify(t)}`);
		return i;
	},
	toDOMRange: (e, t) => {
		var { anchor: n, focus: r } = t, i = B.isBackward(t), a = X.toDOMPoint(e, n), o = B.isCollapsed(t) ? a : X.toDOMPoint(e, r), s = X.getWindow(e).document.createRange(), [c, l] = i ? o : a, [u, d] = i ? a : o, f = !!(fS(c) ? c : c.parentElement).getAttribute("data-slate-zero-width"), p = !!(fS(u) ? u : u.parentElement).getAttribute("data-slate-zero-width");
		return s.setStart(c, f ? 1 : l), s.setEnd(u, p ? 1 : d), s;
	},
	toSlateNode: (e, t) => {
		var n = fS(t) ? t : t.parentElement;
		n && !n.hasAttribute("data-slate-node") && (n = n.closest("[data-slate-node]"));
		var r = n ? Gx.get(n) : null;
		if (!r) throw Error(`Cannot resolve a Slate node from DOM node: ${n}`);
		return r;
	},
	toSlatePoint: (e, t, n) => {
		var { exactMatch: r, suppressThrow: i } = n, [a, o] = r ? t : _S(t), s = a.parentNode, c = null, l = 0;
		if (s) {
			var u, d, f = X.toDOMNode(e, e), p = s.closest("[data-slate-void=\"true\"]"), m = p && f.contains(p) ? p : null, h = s.closest("[data-slate-leaf]"), g = null;
			if (h) {
				if (c = h.closest("[data-slate-node=\"text\"]"), c) {
					var _ = X.getWindow(e).document.createRange();
					_.setStart(c, 0), _.setEnd(a, o);
					var v = _.cloneContents();
					[...Array.prototype.slice.call(v.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(v.querySelectorAll("[contenteditable=false]"))].forEach((e) => {
						Ox && !r && e.hasAttribute("data-slate-zero-width") && e.textContent.length > 0 && e.textContext !== "﻿" ? e.textContent.startsWith("﻿") && (e.textContent = e.textContent.slice(1)) : e.parentNode.removeChild(e);
					}), l = v.textContent.length, g = c;
				}
			} else if (m) {
				for (var y = m.querySelectorAll("[data-slate-leaf]"), b = 0; b < y.length; b++) {
					var x = y[b];
					if (X.hasDOMNode(e, x)) {
						h = x;
						break;
					}
				}
				h ? (c = h.closest("[data-slate-node=\"text\"]"), g = h, l = g.textContent.length, g.querySelectorAll("[data-slate-zero-width]").forEach((e) => {
					l -= e.textContent.length;
				})) : l = 1;
			}
			g && l === g.textContent.length && Ox && g.getAttribute("data-slate-zero-width") === "z" && (u = g.textContent) != null && u.startsWith("﻿") && (s.hasAttribute("data-slate-zero-width") || kx && (d = g.textContent) != null && d.endsWith("\n\n")) && l--;
		}
		if (Ox && !c && !r) {
			var S = s.hasAttribute("data-slate-node") ? s : s.closest("[data-slate-node]");
			if (S && X.hasDOMNode(e, S, { editable: !0 })) {
				var C = X.toSlateNode(e, S), { path: w, offset: T } = U.start(e, X.findPath(e, C));
				return S.querySelector("[data-slate-leaf]") || (T = o), {
					path: w,
					offset: T
				};
			}
		}
		if (!c) {
			if (i) return null;
			throw Error(`Cannot resolve a Slate point from DOM point: ${t}`);
		}
		var E = X.toSlateNode(e, c);
		return {
			path: X.findPath(e, E),
			offset: l
		};
	},
	toSlateRange: (e, t, n) => {
		var { exactMatch: r, suppressThrow: i } = n, a = mS(t) ? t.anchorNode : t.startContainer, o, s, c, l, u;
		if (a) {
			if (mS(t)) {
				if (kx && t.rangeCount > 1) {
					c = t.focusNode;
					var d = t.getRangeAt(0), f = t.getRangeAt(t.rangeCount - 1);
					if (c instanceof HTMLTableRowElement && d.startContainer instanceof HTMLTableRowElement && f.startContainer instanceof HTMLTableRowElement) {
						function e(t) {
							return t.childElementCount > 0 ? e(t.children[0]) : t;
						}
						var p = d.startContainer, m = f.startContainer, h = e(p.children[d.startOffset]), g = e(m.children[f.startOffset]);
						l = 0, o = g.childNodes.length > 0 ? g.childNodes[0] : g, c = h.childNodes.length > 0 ? h.childNodes[0] : h, s = g instanceof HTMLElement ? g.innerHTML.length : 0;
					} else d.startContainer === c ? (o = f.endContainer, s = f.endOffset, l = d.startOffset) : (o = d.startContainer, s = d.endOffset, l = f.startOffset);
				} else o = t.anchorNode, s = t.anchorOffset, c = t.focusNode, l = t.focusOffset;
				u = Mx && vS(o) || kx ? t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset : t.isCollapsed;
			} else o = t.startContainer, s = t.startOffset, c = t.endContainer, l = t.endOffset, u = t.collapsed;
		}
		if (o == null || c == null || s == null || l == null) throw Error(`Cannot resolve a Slate range from DOM range: ${t}`);
		"getAttribute" in c && c.getAttribute("contenteditable") === "false" && c.getAttribute("data-slate-void") !== "true" && (c = o, l = o.textContent?.length || 0);
		var _ = X.toSlatePoint(e, [o, s], {
			exactMatch: r,
			suppressThrow: i
		});
		if (!_) return null;
		var v = u ? _ : X.toSlatePoint(e, [c, l], {
			exactMatch: r,
			suppressThrow: i
		});
		if (!v) return null;
		var y = {
			anchor: _,
			focus: v
		};
		return B.isExpanded(y) && B.isForward(y) && fS(c) && U.void(e, {
			at: y.focus,
			mode: "highest"
		}) && (y = U.unhangRange(e, y, { voids: !0 })), y;
	}
};
function DS(e, t) {
	var { path: n, diff: r } = t;
	if (!U.hasPath(e, n)) return !1;
	var i = H.get(e, n);
	if (!G.isText(i)) return !1;
	if (r.start !== i.text.length || r.text.length === 0) return i.text.slice(r.start, r.start + r.text.length) === r.text;
	var a = z.next(n);
	if (!U.hasPath(e, a)) return !1;
	var o = H.get(e, a);
	return G.isText(o) && o.text.startsWith(r.text);
}
function OS(e) {
	return [...arguments].slice(1).reduce((e, t) => e.slice(0, t.start) + t.text + e.slice(t.end), e);
}
function kS(e, t) {
	for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) if (e.charAt(r) !== t.charAt(r)) return r;
	return n;
}
function AS(e, t, n) {
	for (var r = Math.min(e.length, t.length, n), i = 0; i < r; i++) if (e.charAt(e.length - i - 1) !== t.charAt(t.length - i - 1)) return i;
	return r;
}
function jS(e, t) {
	var { start: n, end: r, text: i } = t, a = e.slice(n, r), o = kS(a, i), s = AS(a, i, Math.min(a.length - o, i.length - o)), c = {
		start: n + o,
		end: r - s,
		text: i.slice(o, i.length - s)
	};
	return c.start === c.end && c.text.length === 0 ? null : c;
}
function MS(e, t, n) {
	var r = Math.min(t.start, n.start), i = Math.max(0, Math.min(t.start + t.text.length, n.end) - n.start), a = OS(e, t, n), o = Math.max(n.start + n.text.length, t.start + t.text.length + (t.start + t.text.length > n.start ? n.text.length : 0) - i), s = a.slice(r, o);
	return jS(e, {
		start: r,
		end: Math.max(t.end, n.end - t.text.length + (t.end - t.start)),
		text: s
	});
}
function NS(e) {
	var { path: t, diff: n } = e;
	return {
		anchor: {
			path: t,
			offset: n.start
		},
		focus: {
			path: t,
			offset: n.end
		}
	};
}
function PS(e, t) {
	var { path: n, offset: r } = t;
	if (!U.hasPath(e, n)) return null;
	var i = H.get(e, n);
	if (!G.isText(i)) return null;
	var a = U.above(e, {
		match: (t) => V.isElement(t) && U.isBlock(e, t),
		at: n
	});
	if (!a) return null;
	for (; r > i.text.length;) {
		var o = U.next(e, {
			at: n,
			match: G.isText
		});
		if (!o || !z.isDescendant(o[1], a[1])) return null;
		r -= i.text.length, i = o[0], n = o[1];
	}
	return {
		path: n,
		offset: r
	};
}
function FS(e, t) {
	var n = PS(e, t.anchor);
	if (!n) return null;
	if (B.isCollapsed(t)) return {
		anchor: n,
		focus: n
	};
	var r = PS(e, t.focus);
	return r ? {
		anchor: n,
		focus: r
	} : null;
}
function IS(e, t, n) {
	var r = rS.get(e)?.find((e) => {
		var { path: n } = e;
		return z.equals(n, t.path);
	});
	if (!r || t.offset <= r.diff.start) return W.transform(t, n, { affinity: "backward" });
	var { diff: i } = r;
	if (t.offset <= i.start + i.text.length) {
		var a = {
			path: t.path,
			offset: i.start
		}, o = W.transform(a, n, { affinity: "backward" });
		return o ? {
			path: o.path,
			offset: o.offset + t.offset - i.start
		} : null;
	}
	var s = {
		path: t.path,
		offset: t.offset - i.text.length + i.end - i.start
	}, c = W.transform(s, n, { affinity: "backward" });
	return c ? n.type === "split_node" && z.equals(n.path, t.path) && s.offset < n.position && i.start < n.position ? c : {
		path: c.path,
		offset: c.offset + i.text.length - i.end + i.start
	} : null;
}
function LS(e, t, n) {
	var r = IS(e, t.anchor, n);
	if (!r) return null;
	if (B.isCollapsed(t)) return {
		anchor: r,
		focus: r
	};
	var i = IS(e, t.focus, n);
	return i ? {
		anchor: r,
		focus: i
	} : null;
}
function RS(e, t) {
	var { path: n, diff: r, id: i } = e;
	switch (t.type) {
		case "insert_text": return !z.equals(t.path, n) || t.offset >= r.end ? e : t.offset <= r.start ? {
			diff: {
				start: t.text.length + r.start,
				end: t.text.length + r.end,
				text: r.text
			},
			id: i,
			path: n
		} : {
			diff: {
				start: r.start,
				end: r.end + t.text.length,
				text: r.text
			},
			id: i,
			path: n
		};
		case "remove_text": return !z.equals(t.path, n) || t.offset >= r.end ? e : t.offset + t.text.length <= r.start ? {
			diff: {
				start: r.start - t.text.length,
				end: r.end - t.text.length,
				text: r.text
			},
			id: i,
			path: n
		} : {
			diff: {
				start: r.start,
				end: r.end - t.text.length,
				text: r.text
			},
			id: i,
			path: n
		};
		case "split_node": return !z.equals(t.path, n) || t.position >= r.end ? {
			diff: r,
			id: i,
			path: z.transform(n, t, { affinity: "backward" })
		} : t.position > r.start ? {
			diff: {
				start: r.start,
				end: Math.min(t.position, r.end),
				text: r.text
			},
			id: i,
			path: n
		} : {
			diff: {
				start: r.start - t.position,
				end: r.end - t.position,
				text: r.text
			},
			id: i,
			path: z.transform(n, t, { affinity: "forward" })
		};
		case "merge_node": return z.equals(t.path, n) ? {
			diff: {
				start: r.start + t.position,
				end: r.end + t.position,
				text: r.text
			},
			id: i,
			path: z.transform(n, t)
		} : {
			diff: r,
			id: i,
			path: z.transform(n, t)
		};
	}
	var a = z.transform(n, t);
	return a ? {
		diff: r,
		path: a,
		id: i
	} : null;
}
function zS(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function BS(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? zS(Object(n), !0).forEach(function(t) {
			bx(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zS(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var VS = 25, HS = 200, US = (e) => e?.constructor.name === "DataTransfer";
function WS(e) {
	var { editor: t, scheduleOnDOMSelectionChange: n, onDOMSelectionChange: r } = e, i = !1, a = null, o = null, s = null, c = 0, l = !1, u = () => {
		var e = aS.get(t);
		if (aS.delete(t), e) {
			var { selection: n } = t, r = FS(t, e);
			!r || n && B.equals(r, n) || q.select(t, r);
		}
	}, d = () => {
		var e = iS.get(t);
		if (iS.delete(t), e) {
			if (e.at) {
				var n = W.isPoint(e.at) ? PS(t, e.at) : FS(t, e.at);
				if (!n) return;
				var r = U.range(t, n);
				t.selection && B.equals(t.selection, r) || q.select(t, n);
			}
			e.run();
		}
	}, f = () => {
		if (o &&= (clearTimeout(o), null), s &&= (clearTimeout(s), null), !b() && !y()) u();
		else {
			i || (i = !0, setTimeout(() => i = !1)), y() && (i = "action");
			var e = t.selection && U.rangeRef(t, t.selection, { affinity: "forward" });
			nS.set(t, t.marks), iS.get(t), rS.get(t);
			for (var a = b(), c; c = (f = rS.get(t))?.[0];) {
				var f, p = tS.get(t);
				p !== void 0 && (tS.delete(t), t.marks = p), p && l === !1 && (l = null);
				var m = NS(c);
				t.selection && B.equals(t.selection, m) || q.select(t, m), c.diff.text ? U.insertText(t, c.diff.text) : U.deleteFragment(t), rS.set(t, rS.get(t)?.filter((e) => {
					var { id: t } = e;
					return t !== c.id;
				})), DS(t, c) || (a = !1, iS.delete(t), nS.delete(t), i = "action", aS.delete(t), n.cancel(), r.cancel(), e?.unref());
			}
			var h = e?.unref();
			if (!h || aS.get(t) || t.selection && B.equals(h, t.selection) || q.select(t, h), y()) d();
			else {
				a && n(), n.flush(), r.flush(), u();
				var g = nS.get(t);
				nS.delete(t), g !== void 0 && (t.marks = g, t.onChange());
			}
		}
	}, p = (e) => {
		a && clearTimeout(a), a = setTimeout(() => {
			Zx.set(t, !1), f();
		}, VS);
	}, m = (e) => {
		Zx.set(t, !0), a &&= (clearTimeout(a), null);
	}, h = function() {
		var e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], n = Wx.get(t);
		n && (b() || e ? n.style.display = "none" : n.style.removeProperty("display"));
	}, g = (e, n) => {
		var r = rS.get(t) ?? [];
		rS.set(t, r);
		var i = H.leaf(t, e), a = r.findIndex((t) => z.equals(t.path, e));
		if (a < 0) jS(i.text, n) && r.push({
			path: e,
			diff: n,
			id: c++
		}), h();
		else {
			var o = MS(i.text, r[a].diff, n);
			o ? r[a] = BS(BS({}, r[a]), {}, { diff: o }) : (r.splice(a, 1), h());
		}
	}, _ = function(e) {
		var { at: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		l = !1, aS.delete(t), n.cancel(), r.cancel(), y() && f(), iS.set(t, {
			at: i,
			run: e
		}), s = setTimeout(f);
	}, v = (e) => {
		o &&= (clearTimeout(o), null);
		var { inputType: n } = e, r = null, i = e.dataTransfer || e.data || void 0;
		l !== !1 && n !== "insertText" && n !== "insertCompositionText" && (l = !1);
		var [a] = e.getTargetRanges();
		a && (r = X.toSlateRange(t, a, {
			exactMatch: !1,
			suppressThrow: !0
		}));
		var s = X.getWindow(t).getSelection();
		if (!r && s && (a = s, r = X.toSlateRange(t, s, {
			exactMatch: !1,
			suppressThrow: !0
		})), r ??= t.selection, r) {
			var c = !0;
			if (n.startsWith("delete")) {
				if (B.isExpanded(r)) {
					var [u, d] = B.edges(r);
					if (H.leaf(t, u.path).text.length === u.offset && d.offset === 0) {
						var f = U.next(t, {
							at: u.path,
							match: G.isText
						});
						f && z.equals(f[1], d.path) && (r = {
							anchor: d,
							focus: d
						});
					}
				}
				var p = n.endsWith("Backward") ? "backward" : "forward", [m, h] = B.edges(r), [v, y] = U.leaf(t, m.path), b = {
					text: "",
					start: m.offset,
					end: h.offset
				}, x = rS.get(t)?.find((e) => z.equals(e.path, y)), S = x ? [x.diff, b] : [b];
				if (OS(v.text, ...S).length === 0 && (c = !1), B.isExpanded(r)) {
					if (c && z.equals(r.anchor.path, r.focus.path)) {
						var w = {
							path: r.anchor.path,
							offset: m.offset
						};
						return C(U.range(t, w, w)), g(r.anchor.path, {
							text: "",
							end: h.offset,
							start: m.offset
						});
					}
					return _(() => U.deleteFragment(t, { direction: p }), { at: r });
				}
			}
			switch (n) {
				case "deleteByComposition":
				case "deleteByCut":
				case "deleteByDrag": return _(() => U.deleteFragment(t), { at: r });
				case "deleteContent":
				case "deleteContentForward":
					var { anchor: T } = r;
					if (c && B.isCollapsed(r)) {
						var ee = H.leaf(t, T.path);
						if (T.offset < ee.text.length) return g(T.path, {
							text: "",
							start: T.offset,
							end: T.offset + 1
						});
					}
					return _(() => U.deleteForward(t), { at: r });
				case "deleteContentBackward":
					var D, { anchor: O } = r, te = mS(a) ? a.isCollapsed : !!((D = a) != null && D.collapsed);
					return c && te && B.isCollapsed(r) && O.offset > 0 ? g(O.path, {
						text: "",
						start: O.offset - 1,
						end: O.offset
					}) : _(() => U.deleteBackward(t), { at: r });
				case "deleteEntireSoftLine": return _(() => {
					U.deleteBackward(t, { unit: "line" }), U.deleteForward(t, { unit: "line" });
				}, { at: r });
				case "deleteHardLineBackward": return _(() => U.deleteBackward(t, { unit: "block" }), { at: r });
				case "deleteSoftLineBackward": return _(() => U.deleteBackward(t, { unit: "line" }), { at: r });
				case "deleteHardLineForward": return _(() => U.deleteForward(t, { unit: "block" }), { at: r });
				case "deleteSoftLineForward": return _(() => U.deleteForward(t, { unit: "line" }), { at: r });
				case "deleteWordBackward": return _(() => U.deleteBackward(t, { unit: "word" }), { at: r });
				case "deleteWordForward": return _(() => U.deleteForward(t, { unit: "word" }), { at: r });
				case "insertLineBreak": return _(() => U.insertSoftBreak(t), { at: r });
				case "insertParagraph": return _(() => U.insertBreak(t), { at: r });
				case "insertCompositionText":
				case "deleteCompositionText":
				case "insertFromComposition":
				case "insertFromDrop":
				case "insertFromPaste":
				case "insertFromYank":
				case "insertReplacementText":
				case "insertText":
					if (US(i)) return _(() => X.insertData(t, i), { at: r });
					var k = i ?? "";
					if (tS.get(t) && (k = k.replace("﻿", "")), n === "insertText" && /.*\n.*\n$/.test(k) && (k = k.slice(0, -1)), k.includes("\n")) return _(() => {
						var e = k.split("\n");
						e.forEach((n, r) => {
							n && U.insertText(t, n), r !== e.length - 1 && U.insertSoftBreak(t);
						});
					}, { at: r });
					if (z.equals(r.anchor.path, r.focus.path)) {
						var [ne, re] = B.edges(r), A = {
							start: ne.offset,
							end: re.offset,
							text: k
						};
						if (k && l && n === "insertCompositionText") {
							var ie = l.start + l.text.search(/\S|$/);
							A.start + A.text.search(/\S|$/) === ie + 1 && A.end === l.start + l.text.length ? (--A.start, l = null, E()) : l = !1;
						} else l = n === "insertText" ? l === null ? A : l && B.isCollapsed(r) && l.end + l.text.length === ne.offset ? BS(BS({}, l), {}, { text: l.text + k }) : !1 : !1;
						if (c) {
							g(ne.path, A);
							return;
						}
					}
					return _(() => U.insertText(t, k), { at: r });
			}
		}
	}, y = () => !!iS.get(t), b = () => {
		var e;
		return !!((e = rS.get(t)) != null && e.length);
	}, x = () => y() || b(), S = () => i, C = (e) => {
		aS.set(t, e), o &&= (clearTimeout(o), null);
		var { selection: n } = t;
		if (e) {
			var r = !n || !z.equals(n.anchor.path, e.anchor.path), i = !n || !z.equals(n.anchor.path.slice(0, -1), e.anchor.path.slice(0, -1));
			(r && l || i) && (l = !1), (r || b()) && (o = setTimeout(f, HS));
		}
	}, w = () => {
		(y() || !b()) && f();
	}, T = (e) => {
		b() || (h(!0), setTimeout(h));
	}, E = () => {
		y() || (s = setTimeout(f));
	};
	return {
		flush: f,
		scheduleFlush: E,
		hasPendingDiffs: b,
		hasPendingAction: y,
		hasPendingChanges: x,
		isFlushing: S,
		handleUserSelect: C,
		handleCompositionEnd: p,
		handleCompositionStart: m,
		handleDOMBeforeInput: v,
		handleKeyDown: T,
		handleDomMutations: (e) => {
			if (!(b() || y()) && e.some((n) => wS(t, n, e))) {
				var n;
				(n = oS.get(t)) == null || n();
			}
		},
		handleInput: w
	};
}
function GS() {
	var e = ve(!1);
	return me(() => (e.current = !0, () => {
		e.current = !1;
	}), []), e.current;
}
var KS = Rx ? he : me;
function qS(e, t, n) {
	var [r] = ye(() => new MutationObserver(t));
	KS(() => {
		r.takeRecords();
	}), me(() => {
		if (!e.current) throw Error("Failed to attach MutationObserver, `node` is undefined");
		return r.observe(e.current, n), () => r.disconnect();
	}, [
		r,
		e,
		n
	]);
}
var JS = ["node"];
function YS(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function XS(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? YS(Object(n), !0).forEach(function(t) {
			bx(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YS(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var ZS = {
	subtree: !0,
	childList: !0,
	characterData: !0
}, QS = Ox ? (e) => {
	var { node: t } = e, n = Sx(e, JS);
	if (!Ox) return null;
	var r = wx(), i = GS(), [a] = ye(() => WS(XS({ editor: r }, n)));
	return qS(t, a.handleDomMutations, ZS), eS.set(r, a.scheduleFlush), i && a.flush(), a;
} : () => null, $S = ["anchor", "focus"], eC = ["anchor", "focus"], tC = (e, t) => Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((n) => t.hasOwnProperty(n) && e[n] === t[n]), nC = (e, t) => {
	var n = Sx(e, $S), r = Sx(t, eC);
	return e[sS] === t[sS] && tC(n, r);
}, rC = (e, t) => {
	if (e.length !== t.length) return !1;
	for (var n = 0; n < e.length; n++) {
		var r = e[n], i = t[n];
		if (!B.equals(r, i) || !nC(r, i)) return !1;
	}
	return !0;
}, iC = (e, t) => {
	if (e.length !== t.length) return !1;
	for (var n = 0; n < e.length; n++) {
		var r = e[n], i = t[n];
		if (r.anchor.offset !== i.anchor.offset || r.focus.offset !== i.focus.offset || !nC(r, i)) return !1;
	}
	return !0;
}, aC = (e) => {
	var { isLast: t, leaf: n, parent: r, text: i } = e, a = wx(), o = X.findPath(a, i), s = z.parent(o), c = n[cS] === !0;
	return a.isVoid(r) ? /*#__PURE__*/ N.createElement(cC, { length: H.string(r).length }) : n.text === "" && r.children[r.children.length - 1] === i && !a.isInline(r) && U.string(a, s) === "" ? /*#__PURE__*/ N.createElement(cC, {
		isLineBreak: !0,
		isMarkPlaceholder: c
	}) : n.text === "" ? /*#__PURE__*/ N.createElement(cC, { isMarkPlaceholder: c }) : t && n.text.slice(-1) === "\n" ? /*#__PURE__*/ N.createElement(oC, {
		isTrailing: !0,
		text: n.text
	}) : /*#__PURE__*/ N.createElement(oC, { text: n.text });
}, oC = (e) => {
	var { text: t, isTrailing: n = !1 } = e, r = ve(null), i = () => `${t ?? ""}${n ? "\n" : ""}`, [a] = ye(i);
	return KS(() => {
		var e = i();
		r.current && r.current.textContent !== e && (r.current.textContent = e);
	}), /*#__PURE__*/ N.createElement(sC, { ref: r }, a);
}, sC = /*#__PURE__*/ de(/*#__PURE__*/ le((e, t) => /*#__PURE__*/ N.createElement("span", {
	"data-slate-string": !0,
	ref: t
}, e.children))), cC = (e) => {
	var { length: t = 0, isLineBreak: n = !1, isMarkPlaceholder: r = !1 } = e, i = {
		"data-slate-zero-width": n ? "n" : "z",
		"data-slate-length": t
	};
	return r && (i["data-slate-mark-placeholder"] = !0), /*#__PURE__*/ N.createElement("span", Object.assign({}, i), !Ox || !n ? "﻿" : null, n ? /*#__PURE__*/ N.createElement("br", null) : null);
};
function lC(e, t) {
	e.current && (e.current.disconnect(), t && (e.current = null));
}
function uC(e) {
	e.current &&= (clearTimeout(e.current), null);
}
var dC = /*#__PURE__*/ N.memo((e) => {
	var { leaf: t, isLast: n, text: r, parent: i, renderPlaceholder: a, renderLeaf: o = (e) => /*#__PURE__*/ N.createElement(fC, Object.assign({}, e)) } = e, s = wx(), c = ve(null), l = ve(null), [u, d] = ye(!1), f = ve(null), p = P((e) => {
		if (lC(c, e == null), e == null) {
			var n;
			Wx.delete(s), (n = t.onPlaceholderResize) == null || n.call(t, null);
		} else Wx.set(s, e), c.current ||= new (window.ResizeObserver || vx)(() => {
			var n;
			(n = t.onPlaceholderResize) == null || n.call(t, e);
		}), c.current.observe(e), l.current = e;
	}, [
		l,
		t,
		s
	]), m = /*#__PURE__*/ N.createElement(aC, {
		isLast: n,
		leaf: t,
		parent: i,
		text: r
	}), h = t[sS];
	if (me(() => (h ? f.current ||= setTimeout(() => {
		d(!0), f.current = null;
	}, 300) : (uC(f), d(!1)), () => uC(f)), [h, d]), h && u) {
		var g = {
			children: t.placeholder,
			attributes: {
				"data-slate-placeholder": !0,
				style: {
					position: "absolute",
					top: 0,
					pointerEvents: "none",
					width: "100%",
					maxWidth: "100%",
					display: "block",
					opacity: "0.333",
					userSelect: "none",
					textDecoration: "none",
					WebkitUserModify: Ax ? "inherit" : void 0
				},
				contentEditable: !1,
				ref: p
			}
		};
		m = /*#__PURE__*/ N.createElement(N.Fragment, null, a(g), m);
	}
	return o({
		attributes: { "data-slate-leaf": !0 },
		children: m,
		leaf: t,
		text: r
	});
}, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && G.equals(t.leaf, e.leaf) && t.leaf[sS] === e.leaf[sS]), fC = (e) => {
	var { attributes: t, children: n } = e;
	return /*#__PURE__*/ N.createElement("span", Object.assign({}, t), n);
}, pC = /*#__PURE__*/ N.memo((e) => {
	for (var { decorations: t, isLast: n, parent: r, renderPlaceholder: i, renderLeaf: a, text: o } = e, s = wx(), c = ve(null), l = G.decorations(o, t), u = X.findKey(s, o), d = [], f = 0; f < l.length; f++) {
		var p = l[f];
		d.push(/*#__PURE__*/ N.createElement(dC, {
			isLast: n && f === l.length - 1,
			key: `${u.id}-${f}`,
			renderPlaceholder: i,
			leaf: p,
			text: o,
			parent: r,
			renderLeaf: a
		}));
	}
	var m = P((e) => {
		var t = Jx.get(s);
		e ? (t?.set(u, e), Kx.set(o, e), Gx.set(e, o)) : (t?.delete(u), Kx.delete(o), c.current && Gx.delete(c.current)), c.current = e;
	}, [
		c,
		s,
		u,
		o
	]);
	return /*#__PURE__*/ N.createElement("span", {
		"data-slate-node": "text",
		ref: m
	}, d);
}, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && iC(t.decorations, e.decorations)), mC = /*#__PURE__*/ N.memo((e) => {
	var { decorations: t, element: n, renderElement: r = (e) => /*#__PURE__*/ N.createElement(hC, Object.assign({}, e)), renderPlaceholder: i, renderLeaf: a, selection: o } = e, s = wx(), c = xC(), l = s.isInline(n), u = X.findKey(s, n), d = P((e) => {
		var t = Jx.get(s);
		e ? (t?.set(u, e), Kx.set(n, e), Gx.set(e, n)) : (t?.delete(u), Kx.delete(n));
	}, [
		s,
		u,
		n
	]), f = yC({
		decorations: t,
		node: n,
		renderElement: r,
		renderPlaceholder: i,
		renderLeaf: a,
		selection: o
	}), p = {
		"data-slate-node": "element",
		ref: d
	};
	if (l && (p["data-slate-inline"] = !0), !l && U.hasInlines(s, n)) {
		var m = H.string(n), h = (0, fb.default)(m);
		h === "rtl" && (p.dir = h);
	}
	if (U.isVoid(s, n)) {
		p["data-slate-void"] = !0, !c && l && (p.contentEditable = !1);
		var g = l ? "span" : "div", [[_]] = H.texts(n);
		f = /*#__PURE__*/ N.createElement(g, {
			"data-slate-spacer": !0,
			style: {
				height: "0",
				color: "transparent",
				outline: "none",
				position: "absolute"
			}
		}, /*#__PURE__*/ N.createElement(pC, {
			renderPlaceholder: i,
			decorations: [],
			isLast: !1,
			parent: n,
			text: _
		})), Bx.set(_, 0), Vx.set(_, n);
	}
	return r({
		attributes: p,
		children: f,
		element: n
	});
}, (e, t) => e.element === t.element && e.renderElement === t.renderElement && e.renderLeaf === t.renderLeaf && e.renderPlaceholder === t.renderPlaceholder && rC(e.decorations, t.decorations) && (e.selection === t.selection || !!e.selection && !!t.selection && B.equals(e.selection, t.selection))), hC = (e) => {
	var { attributes: t, children: n, element: r } = e, i = wx().isInline(r) ? "span" : "div";
	return /*#__PURE__*/ N.createElement(i, Object.assign({}, t, { style: { position: "relative" } }), n);
}, gC = /*#__PURE__*/ ce(() => []), _C = () => fe(gC), vC = /*#__PURE__*/ ce(!1), yC = (e) => {
	for (var { decorations: t, node: n, renderElement: r, renderPlaceholder: i, renderLeaf: a, selection: o } = e, s = _C(), c = wx(), l = X.findPath(c, n), u = [], d = V.isElement(n) && !c.isInline(n) && U.hasInlines(c, n), f = 0; f < n.children.length; f++) {
		var p = l.concat(f), m = n.children[f], h = X.findKey(c, m), g = U.range(c, p), _ = o && B.intersection(g, o), v = s([m, p]);
		for (var y of t) {
			var b = B.intersection(y, g);
			b && v.push(b);
		}
		V.isElement(m) ? u.push(/*#__PURE__*/ N.createElement(vC.Provider, {
			key: `provider-${h.id}`,
			value: !!_
		}, /*#__PURE__*/ N.createElement(mC, {
			decorations: v,
			element: m,
			key: h.id,
			renderElement: r,
			renderPlaceholder: i,
			renderLeaf: a,
			selection: _
		}))) : u.push(/*#__PURE__*/ N.createElement(pC, {
			decorations: v,
			key: h.id,
			isLast: d && f === n.children.length - 1,
			parent: n,
			renderPlaceholder: i,
			renderLeaf: a,
			text: m
		})), Bx.set(m, f), Vx.set(m, n);
	}
	return u;
}, bC = /*#__PURE__*/ ce(!1), xC = () => fe(bC), SC = /*#__PURE__*/ ce(null), CC = () => {
	var e = fe(SC);
	if (!e) throw Error("The `useSlate` hook must be used inside the <Slate> component's context.");
	var { editor: t } = e;
	return t;
};
function wC() {
	var e = wx(), t = ve(!1), n = ve(0), r = P(() => {
		if (!t.current) {
			t.current = !0;
			var r = X.getWindow(e);
			r.cancelAnimationFrame(n.current), n.current = r.requestAnimationFrame(() => {
				t.current = !1;
			});
		}
	}, [e]);
	return me(() => () => cancelAnimationFrame(n.current), []), {
		receivedUserInput: t,
		onUserInput: r
	};
}
var TC = 3, EC = {
	bold: "mod+b",
	compose: [
		"down",
		"left",
		"right",
		"up",
		"backspace",
		"enter"
	],
	moveBackward: "left",
	moveForward: "right",
	moveWordBackward: "ctrl+left",
	moveWordForward: "ctrl+right",
	deleteBackward: "shift?+backspace",
	deleteForward: "shift?+delete",
	extendBackward: "shift+left",
	extendForward: "shift+right",
	italic: "mod+i",
	insertSoftBreak: "shift+enter",
	splitBlock: "enter",
	undo: "mod+z"
}, DC = {
	moveLineBackward: "opt+up",
	moveLineForward: "opt+down",
	moveWordBackward: "opt+left",
	moveWordForward: "opt+right",
	deleteBackward: ["ctrl+backspace", "ctrl+h"],
	deleteForward: ["ctrl+delete", "ctrl+d"],
	deleteLineBackward: "cmd+shift?+backspace",
	deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
	deleteWordBackward: "opt+shift?+backspace",
	deleteWordForward: "opt+shift?+delete",
	extendLineBackward: "opt+shift+up",
	extendLineForward: "opt+shift+down",
	redo: "cmd+shift+z",
	transposeCharacter: "ctrl+t"
}, OC = {
	deleteWordBackward: "ctrl+shift?+backspace",
	deleteWordForward: "ctrl+shift?+delete",
	redo: ["ctrl+y", "ctrl+shift+z"]
}, kC = (e) => {
	var t = EC[e], n = DC[e], r = OC[e], i = t && (0, yx.isHotkey)(t), a = n && (0, yx.isHotkey)(n), o = r && (0, yx.isHotkey)(r);
	return (e) => !!(i && i(e) || Dx && a && a(e) || !Dx && o && o(e));
}, AC = {
	isBold: kC("bold"),
	isCompose: kC("compose"),
	isMoveBackward: kC("moveBackward"),
	isMoveForward: kC("moveForward"),
	isDeleteBackward: kC("deleteBackward"),
	isDeleteForward: kC("deleteForward"),
	isDeleteLineBackward: kC("deleteLineBackward"),
	isDeleteLineForward: kC("deleteLineForward"),
	isDeleteWordBackward: kC("deleteWordBackward"),
	isDeleteWordForward: kC("deleteWordForward"),
	isExtendBackward: kC("extendBackward"),
	isExtendForward: kC("extendForward"),
	isExtendLineBackward: kC("extendLineBackward"),
	isExtendLineForward: kC("extendLineForward"),
	isItalic: kC("italic"),
	isMoveLineBackward: kC("moveLineBackward"),
	isMoveLineForward: kC("moveLineForward"),
	isMoveWordBackward: kC("moveWordBackward"),
	isMoveWordForward: kC("moveWordForward"),
	isRedo: kC("redo"),
	isSoftBreak: kC("insertSoftBreak"),
	isSplitBlock: kC("splitBlock"),
	isTransposeCharacter: kC("transposeCharacter"),
	isUndo: kC("undo")
}, jC = (e, t) => {
	var n = [], r = () => {
		n = [];
	}, i = (r) => {
		if (t.current) {
			var i = r.filter((t) => wS(e, t, r));
			n.push(...i);
		}
	};
	function a() {
		n.length > 0 && (n.reverse().forEach((e) => {
			e.type !== "characterData" && (e.removedNodes.forEach((t) => {
				e.target.insertBefore(t, e.nextSibling);
			}), e.addedNodes.forEach((t) => {
				e.target.removeChild(t);
			}));
		}), r());
	}
	return {
		registerMutations: i,
		restoreDOM: a,
		clear: r
	};
}, MC = {
	subtree: !0,
	childList: !0,
	characterData: !0,
	characterDataOldValue: !0
}, NC = class extends se {
	constructor() {
		super(...arguments), this.context = null, this.manager = null, this.mutationObserver = null;
	}
	observe() {
		var e, { node: t } = this.props;
		if (!t.current) throw Error("Failed to attach MutationObserver, `node` is undefined");
		(e = this.mutationObserver) == null || e.observe(t.current, MC);
	}
	componentDidMount() {
		var { receivedUserInput: e } = this.props, t = this.context;
		this.manager = jC(t, e), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
	}
	getSnapshotBeforeUpdate() {
		var e, t, n = this.mutationObserver?.takeRecords();
		if (n != null && n.length) {
			var r;
			(r = this.manager) == null || r.registerMutations(n);
		}
		return (e = this.mutationObserver) == null || e.disconnect(), (t = this.manager) == null || t.restoreDOM(), null;
	}
	componentDidUpdate() {
		var e;
		(e = this.manager) == null || e.clear(), this.observe();
	}
	componentWillUnmount() {
		var e;
		(e = this.mutationObserver) == null || e.disconnect();
	}
	render() {
		return this.props.children;
	}
};
NC.contextType = Cx;
var PC = Ox ? NC : (e) => {
	var { children: t } = e;
	return /*#__PURE__*/ N.createElement(N.Fragment, null, t);
}, FC = [
	"autoFocus",
	"decorate",
	"onDOMBeforeInput",
	"placeholder",
	"readOnly",
	"renderElement",
	"renderLeaf",
	"renderPlaceholder",
	"scrollSelectionIntoView",
	"style",
	"as",
	"disableDefaultStyles"
], IC = ["text"];
function LC(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function RC(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? LC(Object(n), !0).forEach(function(t) {
			bx(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : LC(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var zC = (e) => /*#__PURE__*/ N.createElement(N.Fragment, null, yC(e)), BC = (e) => {
	var t = P((e) => /*#__PURE__*/ N.createElement(VC, Object.assign({}, e)), []), { autoFocus: n, decorate: r = HC, onDOMBeforeInput: i, placeholder: a, readOnly: o = !1, renderElement: s, renderLeaf: c, renderPlaceholder: l = t, scrollSelectionIntoView: u = UC, style: d = {}, as: f = "div", disableDefaultStyles: p = !1 } = e, m = Sx(e, FC), h = CC(), [g, _] = ye(!1), v = ve(null), y = ve([]), [b, x] = ye(), { onUserInput: S, receivedUserInput: C } = wC(), [, w] = _e((e) => e + 1, 0);
	oS.set(h, w), Yx.set(h, o);
	var T = ge(() => ({
		isDraggingInternally: !1,
		isUpdatingSelection: !1,
		latestElement: null,
		hasMarkPlaceholder: !1
	}), []);
	me(() => {
		v.current && n && v.current.focus();
	}, [n]);
	var E = ve(), ee = ge(() => mb(() => {
		var e = E.current;
		if ((Ox || !X.isComposing(h)) && (!T.isUpdatingSelection || e != null && e.isFlushing()) && !T.isDraggingInternally) {
			var t = X.findDocumentOrShadowRoot(h), { activeElement: n } = t, r = X.toDOMNode(h, h), i = t.getSelection();
			if (n === r ? (T.latestElement = n, Xx.set(h, !0)) : Xx.delete(h), !i) return q.deselect(h);
			var { anchorNode: a, focusNode: s } = i, c = X.hasEditableTarget(h, a) || X.isTargetInsideNonReadonlyVoid(h, a), l = X.hasEditableTarget(h, s) || X.isTargetInsideNonReadonlyVoid(h, s);
			if (c && l) {
				var u = X.toSlateRange(h, i, {
					exactMatch: !1,
					suppressThrow: !0
				});
				u && (!X.isComposing(h) && !(e != null && e.hasPendingChanges()) && !(e != null && e.isFlushing()) ? q.select(h, u) : e?.handleUserSelect(u));
			}
			!o || c && l || q.deselect(h);
		}
	}, 100), [
		h,
		o,
		T
	]), D = ge(() => pb(ee, 0), [ee]);
	E.current = QS({
		node: v,
		onDOMSelectionChange: ee,
		scheduleOnDOMSelectionChange: D
	}), KS(() => {
		var e, t;
		v.current && (t = uS(v.current)) ? (Hx.set(h, t), Ux.set(h, v.current), Kx.set(h, v.current), Gx.set(v.current, h)) : Kx.delete(h);
		var { selection: n } = h, r = X.findDocumentOrShadowRoot(h).getSelection();
		if (!(!r || !X.isFocused(h) || (e = E.current) != null && e.hasPendingAction())) {
			var i = (e) => {
				var t = r.type !== "None";
				if (n || t) {
					var i = r.focusNode, a;
					if (kx && r.rangeCount > 1) {
						var o = r.getRangeAt(0), s = r.getRangeAt(r.rangeCount - 1);
						a = o.startContainer === i ? s.endContainer : o.startContainer;
					} else a = r.anchorNode;
					var c = Ux.get(h), l = !1;
					if (c.contains(a) && c.contains(i) && (l = !0), t && l && n && !e) {
						var d = X.toSlateRange(h, r, {
							exactMatch: !0,
							suppressThrow: !0
						});
						if (d && B.equals(d, n)) {
							var f, p;
							if (!T.hasMarkPlaceholder || (f = a) != null && (p = f.parentElement) != null && p.hasAttribute("data-slate-mark-placeholder")) return;
						}
					}
					if (n && !X.hasRange(h, n)) h.selection = X.toSlateRange(h, r, {
						exactMatch: !1,
						suppressThrow: !0
					});
					else {
						T.isUpdatingSelection = !0;
						var m = n && X.toDOMRange(h, n);
						return m ? (X.isComposing(h) && !Ox ? r.collapseToEnd() : B.isBackward(n) ? r.setBaseAndExtent(m.endContainer, m.endOffset, m.startContainer, m.startOffset) : r.setBaseAndExtent(m.startContainer, m.startOffset, m.endContainer, m.endOffset), u(h, m)) : r.removeAllRanges(), m;
					}
				}
			};
			r.rangeCount <= 1 && i();
			var a = E.current?.isFlushing() === "action";
			if (!Ox || !a) setTimeout(() => {
				T.isUpdatingSelection = !1;
			});
			else {
				var o = null, s = requestAnimationFrame(() => {
					if (a) {
						var e = (e) => {
							try {
								X.toDOMNode(h, h).focus(), i(e);
							} catch {}
						};
						e(), o = setTimeout(() => {
							e(!0), T.isUpdatingSelection = !1;
						});
					}
				});
				return () => {
					cancelAnimationFrame(s), o && clearTimeout(o);
				};
			}
		}
	});
	var O = P((e) => {
		if (S(), !o && X.hasEditableTarget(h, e.target) && !KC(e, i)) {
			if (E.current) return E.current.handleDOMBeforeInput(e);
			D.flush(), ee.flush();
			var { selection: t } = h, { inputType: n } = e, r = e.dataTransfer || e.data || void 0, a = n === "insertCompositionText" || n === "deleteCompositionText";
			if (a && X.isComposing(h)) return;
			var s = !1;
			if (n === "insertText" && t && B.isCollapsed(t) && e.data && e.data.length === 1 && /[a-z ]/i.test(e.data) && t.anchor.offset !== 0) {
				s = !0, h.marks && (s = !1);
				var { anchor: c } = t, [l, u] = X.toDOMPoint(h, c), d = l.parentElement?.closest("a"), f = X.getWindow(h);
				if (s && d && X.hasDOMNode(h, d)) {
					var p = f?.document.createTreeWalker(d, NodeFilter.SHOW_TEXT).lastChild();
					p === l && p.textContent?.length === u && (s = !1);
				}
				if (s && l.parentElement && f?.getComputedStyle(l.parentElement)?.whiteSpace === "pre") {
					var m = U.above(h, {
						at: c.path,
						match: (e) => V.isElement(e) && U.isBlock(h, e)
					});
					m && H.string(m[0]).includes("	") && (s = !1);
				}
			}
			if (!n.startsWith("delete") || n.startsWith("deleteBy")) {
				var [g] = e.getTargetRanges();
				if (g) {
					var v = X.toSlateRange(h, g, {
						exactMatch: !1,
						suppressThrow: !1
					});
					if (!t || !B.equals(t, v)) {
						s = !1;
						var b = !a && h.selection && U.rangeRef(h, h.selection);
						q.select(h, v), b && Qx.set(h, b);
					}
				}
			}
			if (a) return;
			if (s || e.preventDefault(), t && B.isExpanded(t) && n.startsWith("delete")) {
				var x = n.endsWith("Backward") ? "backward" : "forward";
				U.deleteFragment(h, { direction: x });
				return;
			}
			switch (n) {
				case "deleteByComposition":
				case "deleteByCut":
				case "deleteByDrag":
					U.deleteFragment(h);
					break;
				case "deleteContent":
				case "deleteContentForward":
					U.deleteForward(h);
					break;
				case "deleteContentBackward":
					U.deleteBackward(h);
					break;
				case "deleteEntireSoftLine":
					U.deleteBackward(h, { unit: "line" }), U.deleteForward(h, { unit: "line" });
					break;
				case "deleteHardLineBackward":
					U.deleteBackward(h, { unit: "block" });
					break;
				case "deleteSoftLineBackward":
					U.deleteBackward(h, { unit: "line" });
					break;
				case "deleteHardLineForward":
					U.deleteForward(h, { unit: "block" });
					break;
				case "deleteSoftLineForward":
					U.deleteForward(h, { unit: "line" });
					break;
				case "deleteWordBackward":
					U.deleteBackward(h, { unit: "word" });
					break;
				case "deleteWordForward":
					U.deleteForward(h, { unit: "word" });
					break;
				case "insertLineBreak":
					U.insertSoftBreak(h);
					break;
				case "insertParagraph":
					U.insertBreak(h);
					break;
				case "insertFromComposition":
				case "insertFromDrop":
				case "insertFromPaste":
				case "insertFromYank":
				case "insertReplacementText":
				case "insertText": n === "insertFromComposition" && X.isComposing(h) && (_(!1), Zx.set(h, !1)), r?.constructor.name === "DataTransfer" ? X.insertData(h, r) : typeof r == "string" && (s ? y.current.push(() => U.insertText(h, r)) : U.insertText(h, r));
			}
			var C = Qx.get(h)?.unref();
			Qx.delete(h), !C || h.selection && B.equals(h.selection, C) || q.select(h, C);
		}
	}, [
		h,
		ee,
		S,
		i,
		o,
		D
	]), te = P((e) => {
		e == null ? (ee.cancel(), D.cancel(), Ux.delete(h), Kx.delete(h), v.current && zx && v.current.removeEventListener("beforeinput", O)) : zx && e.addEventListener("beforeinput", O), v.current = e;
	}, [
		ee,
		D,
		h,
		O
	]);
	KS(() => {
		var e = X.getWindow(h);
		return e.document.addEventListener("selectionchange", D), () => {
			e.document.removeEventListener("selectionchange", D);
		};
	}, [D]);
	var k = r([h, []]), ne = a && h.children.length === 1 && Array.from(H.texts(h)).length === 1 && H.string(h) === "" && !g, re = P((e) => {
		x(e && ne ? e.getBoundingClientRect()?.height : void 0);
	}, [ne]);
	if (ne) {
		var A = U.start(h, []);
		k.push({
			[sS]: !0,
			placeholder: a,
			onPlaceholderResize: re,
			anchor: A,
			focus: A
		});
	}
	var { marks: ie } = h;
	if (T.hasMarkPlaceholder = !1, h.selection && B.isCollapsed(h.selection) && ie) {
		var { anchor: ae } = h.selection, j = H.leaf(h, ae.path), M = Sx(j, IC);
		if (!G.equals(j, ie, { loose: !0 })) {
			T.hasMarkPlaceholder = !0;
			var oe = Object.fromEntries(Object.keys(M).map((e) => [e, null]));
			k.push(RC(RC(RC({ [cS]: !0 }, oe), ie), {}, {
				anchor: ae,
				focus: ae
			}));
		}
	}
	return me(() => {
		setTimeout(() => {
			var { selection: e } = h;
			if (e) {
				var { anchor: t } = e, n = H.leaf(h, t.path);
				if (ie && !G.equals(n, ie, { loose: !0 })) {
					tS.set(h, ie);
					return;
				}
			}
			tS.delete(h);
		});
	}), /*#__PURE__*/ N.createElement(bC.Provider, { value: o }, /*#__PURE__*/ N.createElement(gC.Provider, { value: r }, /*#__PURE__*/ N.createElement(PC, {
		node: v,
		receivedUserInput: C
	}, /*#__PURE__*/ N.createElement(f, Object.assign({
		role: o ? void 0 : "textbox",
		"aria-multiline": !o || void 0
	}, m, {
		spellCheck: zx || !Rx ? m.spellCheck : !1,
		autoCorrect: zx || !Rx ? m.autoCorrect : "false",
		autoCapitalize: zx || !Rx ? m.autoCapitalize : "false",
		"data-slate-editor": !0,
		"data-slate-node": "value",
		contentEditable: !o,
		zindex: -1,
		suppressContentEditableWarning: !0,
		ref: te,
		style: RC(RC({}, p ? {} : RC({
			position: "relative",
			whiteSpace: "pre-wrap",
			wordWrap: "break-word"
		}, b ? { minHeight: b } : {})), d),
		onBeforeInput: P((e) => {
			if (!zx && !o && !WC(e, m.onBeforeInput) && X.hasSelectableTarget(h, e.target) && (e.preventDefault(), !X.isComposing(h))) {
				var t = e.data;
				U.insertText(h, t);
			}
		}, [
			m.onBeforeInput,
			h,
			o
		]),
		onInput: P((e) => {
			if (!WC(e, m.onInput)) {
				if (E.current) E.current.handleInput();
				else {
					for (var t of y.current) t();
					y.current = [];
				}
			}
		}, [m.onInput]),
		onBlur: P((e) => {
			if (!(o || T.isUpdatingSelection || !X.hasSelectableTarget(h, e.target) || WC(e, m.onBlur))) {
				var t = X.findDocumentOrShadowRoot(h);
				if (T.latestElement !== t.activeElement) {
					var { relatedTarget: n } = e;
					if (n !== X.toDOMNode(h, h) && !(fS(n) && n.hasAttribute("data-slate-spacer"))) {
						if (n != null && pS(n) && X.hasDOMNode(h, n)) {
							var r = X.toSlateNode(h, n);
							if (V.isElement(r) && !h.isVoid(r)) return;
						}
						Ax && t.getSelection()?.removeAllRanges(), Xx.delete(h);
					}
				}
			}
		}, [
			o,
			T.isUpdatingSelection,
			T.latestElement,
			h,
			m.onBlur
		]),
		onClick: P((e) => {
			if (X.hasTarget(h, e.target) && !WC(e, m.onClick) && pS(e.target)) {
				var t = X.toSlateNode(h, e.target), n = X.findPath(h, t);
				if (!U.hasPath(h, n) || H.get(h, n) !== t) return;
				if (e.detail === TC && n.length >= 1) {
					var r = n;
					V.isElement(t) && U.isBlock(h, t) || (r = U.above(h, {
						match: (e) => V.isElement(e) && U.isBlock(h, e),
						at: n
					})?.[1] ?? n.slice(0, 1));
					var i = U.range(h, r);
					q.select(h, i);
					return;
				}
				if (o) return;
				var a = U.start(h, n), s = U.end(h, n), c = U.void(h, { at: a }), l = U.void(h, { at: s });
				if (c && l && z.equals(c[1], l[1])) {
					var u = U.range(h, a);
					q.select(h, u);
				}
			}
		}, [
			h,
			m.onClick,
			o
		]),
		onCompositionEnd: P((e) => {
			if (X.hasSelectableTarget(h, e.target)) {
				var t;
				if (X.isComposing(h) && (_(!1), Zx.set(h, !1)), (t = E.current) == null || t.handleCompositionEnd(e), WC(e, m.onCompositionEnd) || Ox) return;
				if (!Ax && !Fx && !Ex && !Lx && !Ix && e.data) {
					var n = tS.get(h);
					tS.delete(h), n !== void 0 && (nS.set(h, h.marks), h.marks = n), U.insertText(h, e.data);
					var r = nS.get(h);
					nS.delete(h), r !== void 0 && (h.marks = r);
				}
			}
		}, [m.onCompositionEnd, h]),
		onCompositionUpdate: P((e) => {
			X.hasSelectableTarget(h, e.target) && !WC(e, m.onCompositionUpdate) && (X.isComposing(h) || (_(!0), Zx.set(h, !0)));
		}, [m.onCompositionUpdate, h]),
		onCompositionStart: P((e) => {
			if (X.hasSelectableTarget(h, e.target)) {
				var t;
				if ((t = E.current) == null || t.handleCompositionStart(e), WC(e, m.onCompositionStart) || Ox) return;
				_(!0);
				var { selection: n } = h;
				if (n) {
					if (B.isExpanded(n)) {
						U.deleteFragment(h);
						return;
					}
					var r = U.above(h, {
						match: (e) => V.isElement(e) && U.isInline(h, e),
						mode: "highest"
					});
					if (r) {
						var [, i] = r;
						if (U.isEnd(h, n.anchor, i)) {
							var a = U.after(h, i);
							q.setSelection(h, {
								anchor: a,
								focus: a
							});
						}
					}
				}
			}
		}, [m.onCompositionStart, h]),
		onCopy: P((e) => {
			X.hasSelectableTarget(h, e.target) && !WC(e, m.onCopy) && !GC(e) && (e.preventDefault(), X.setFragmentData(h, e.clipboardData, "copy"));
		}, [m.onCopy, h]),
		onCut: P((e) => {
			if (!o && X.hasSelectableTarget(h, e.target) && !WC(e, m.onCut) && !GC(e)) {
				e.preventDefault(), X.setFragmentData(h, e.clipboardData, "cut");
				var { selection: t } = h;
				if (t) {
					if (B.isExpanded(t)) U.deleteFragment(h);
					else {
						var n = H.parent(h, t.anchor.path);
						U.isVoid(h, n) && q.delete(h);
					}
				}
			}
		}, [
			o,
			h,
			m.onCut
		]),
		onDragOver: P((e) => {
			if (X.hasTarget(h, e.target) && !WC(e, m.onDragOver)) {
				var t = X.toSlateNode(h, e.target);
				V.isElement(t) && U.isVoid(h, t) && e.preventDefault();
			}
		}, [m.onDragOver, h]),
		onDragStart: P((e) => {
			if (!o && X.hasTarget(h, e.target) && !WC(e, m.onDragStart)) {
				var t = X.toSlateNode(h, e.target), n = X.findPath(h, t);
				if (V.isElement(t) && U.isVoid(h, t) || U.void(h, {
					at: n,
					voids: !0
				})) {
					var r = U.range(h, n);
					q.select(h, r);
				}
				T.isDraggingInternally = !0, X.setFragmentData(h, e.dataTransfer, "drag");
			}
		}, [
			o,
			h,
			m.onDragStart,
			T
		]),
		onDrop: P((e) => {
			if (!o && X.hasTarget(h, e.target) && !WC(e, m.onDrop)) {
				e.preventDefault();
				var t = h.selection, n = X.findEventRange(h, e), r = e.dataTransfer;
				q.select(h, n), T.isDraggingInternally && t && !B.equals(t, n) && !U.void(h, {
					at: n,
					voids: !0
				}) && q.delete(h, { at: t }), X.insertData(h, r), X.isFocused(h) || X.focus(h);
			}
			T.isDraggingInternally = !1;
		}, [
			o,
			h,
			m.onDrop,
			T
		]),
		onDragEnd: P((e) => {
			!o && T.isDraggingInternally && m.onDragEnd && X.hasTarget(h, e.target) && m.onDragEnd(e), T.isDraggingInternally = !1;
		}, [
			o,
			T,
			m,
			h
		]),
		onFocus: P((e) => {
			if (!o && !T.isUpdatingSelection && X.hasEditableTarget(h, e.target) && !WC(e, m.onFocus)) {
				var t = X.toDOMNode(h, h);
				if (T.latestElement = X.findDocumentOrShadowRoot(h).activeElement, kx && e.target !== t) {
					t.focus();
					return;
				}
				Xx.set(h, !0);
			}
		}, [
			o,
			T,
			h,
			m.onFocus
		]),
		onKeyDown: P((e) => {
			if (!o && X.hasEditableTarget(h, e.target)) {
				var t;
				(t = E.current) == null || t.handleKeyDown(e);
				var { nativeEvent: n } = e;
				if (X.isComposing(h) && n.isComposing === !1 && (Zx.set(h, !1), _(!1)), WC(e, m.onKeyDown) || X.isComposing(h)) return;
				var { selection: r } = h, i = h.children[r === null ? 0 : r.focus.path[0]], a = (0, fb.default)(H.string(i)) === "rtl";
				if (AC.isRedo(n)) {
					e.preventDefault();
					var s = h;
					typeof s.redo == "function" && s.redo();
					return;
				}
				if (AC.isUndo(n)) {
					e.preventDefault();
					var c = h;
					typeof c.undo == "function" && c.undo();
					return;
				}
				if (AC.isMoveLineBackward(n)) {
					e.preventDefault(), q.move(h, {
						unit: "line",
						reverse: !0
					});
					return;
				}
				if (AC.isMoveLineForward(n)) {
					e.preventDefault(), q.move(h, { unit: "line" });
					return;
				}
				if (AC.isExtendLineBackward(n)) {
					e.preventDefault(), q.move(h, {
						unit: "line",
						edge: "focus",
						reverse: !0
					});
					return;
				}
				if (AC.isExtendLineForward(n)) {
					e.preventDefault(), q.move(h, {
						unit: "line",
						edge: "focus"
					});
					return;
				}
				if (AC.isMoveBackward(n)) {
					e.preventDefault(), r && B.isCollapsed(r) ? q.move(h, { reverse: !a }) : q.collapse(h, { edge: "start" });
					return;
				}
				if (AC.isMoveForward(n)) {
					e.preventDefault(), r && B.isCollapsed(r) ? q.move(h, { reverse: a }) : q.collapse(h, { edge: "end" });
					return;
				}
				if (AC.isMoveWordBackward(n)) {
					e.preventDefault(), r && B.isExpanded(r) && q.collapse(h, { edge: "focus" }), q.move(h, {
						unit: "word",
						reverse: !a
					});
					return;
				}
				if (AC.isMoveWordForward(n)) {
					e.preventDefault(), r && B.isExpanded(r) && q.collapse(h, { edge: "focus" }), q.move(h, {
						unit: "word",
						reverse: a
					});
					return;
				}
				if (!zx) {
					if (AC.isBold(n) || AC.isItalic(n) || AC.isTransposeCharacter(n)) {
						e.preventDefault();
						return;
					}
					if (AC.isSoftBreak(n)) {
						e.preventDefault(), U.insertSoftBreak(h);
						return;
					}
					if (AC.isSplitBlock(n)) {
						e.preventDefault(), U.insertBreak(h);
						return;
					}
					if (AC.isDeleteBackward(n)) {
						e.preventDefault(), r && B.isExpanded(r) ? U.deleteFragment(h, { direction: "backward" }) : U.deleteBackward(h);
						return;
					}
					if (AC.isDeleteForward(n)) {
						e.preventDefault(), r && B.isExpanded(r) ? U.deleteFragment(h, { direction: "forward" }) : U.deleteForward(h);
						return;
					}
					if (AC.isDeleteLineBackward(n)) {
						e.preventDefault(), r && B.isExpanded(r) ? U.deleteFragment(h, { direction: "backward" }) : U.deleteBackward(h, { unit: "line" });
						return;
					}
					if (AC.isDeleteLineForward(n)) {
						e.preventDefault(), r && B.isExpanded(r) ? U.deleteFragment(h, { direction: "forward" }) : U.deleteForward(h, { unit: "line" });
						return;
					}
					if (AC.isDeleteWordBackward(n)) {
						e.preventDefault(), r && B.isExpanded(r) ? U.deleteFragment(h, { direction: "backward" }) : U.deleteBackward(h, { unit: "word" });
						return;
					}
					if (AC.isDeleteWordForward(n)) {
						e.preventDefault(), r && B.isExpanded(r) ? U.deleteFragment(h, { direction: "forward" }) : U.deleteForward(h, { unit: "word" });
						return;
					}
				} else if ((Mx || Ax) && r && (AC.isDeleteBackward(n) || AC.isDeleteForward(n)) && B.isCollapsed(r)) {
					var l = H.parent(h, r.anchor.path);
					if (V.isElement(l) && U.isVoid(h, l) && (U.isInline(h, l) || U.isBlock(h, l))) {
						e.preventDefault(), U.deleteBackward(h, { unit: "block" });
						return;
					}
				}
			}
		}, [
			o,
			h,
			m.onKeyDown
		]),
		onPaste: P((e) => {
			!o && X.hasEditableTarget(h, e.target) && !WC(e, m.onPaste) && (!zx || gS(e.nativeEvent) || Ax) && (e.preventDefault(), X.insertData(h, e.clipboardData));
		}, [
			o,
			h,
			m.onPaste
		])
	}), /*#__PURE__*/ N.createElement(zC, {
		decorations: k,
		node: h,
		renderElement: s,
		renderPlaceholder: l,
		renderLeaf: c,
		selection: h.selection
	})))));
}, VC = (e) => {
	var { attributes: t, children: n } = e;
	return /*#__PURE__*/ N.createElement("span", Object.assign({}, t), n, Ox && /*#__PURE__*/ N.createElement("br", null));
}, HC = () => [], UC = (e, t) => {
	if (t.getBoundingClientRect && (!e.selection || e.selection && B.isCollapsed(e.selection))) {
		var n = t.startContainer.parentElement;
		n.getBoundingClientRect = t.getBoundingClientRect.bind(t), Cb(n, { scrollMode: "if-needed" }), delete n.getBoundingClientRect;
	}
}, WC = (e, t) => t ? t(e) ?? (e.isDefaultPrevented() || e.isPropagationStopped()) : !1, GC = (e) => pS(e.target) && (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement), KC = (e, t) => t ? t(e) ?? e.defaultPrevented : !1, qC = /*#__PURE__*/ ce(!1), JC = () => fe(qC), YC = /*#__PURE__*/ ce({});
function XC(e) {
	var t = ve([]).current, n = ve({ editor: e }).current, r = P((e) => {
		n.editor = e, t.forEach((t) => t(e));
	}, [t, n]);
	return {
		selectorContext: ge(() => ({
			getSlate: () => n.editor,
			addEventListener: (e) => (t.push(e), () => {
				t.splice(t.indexOf(e), 1);
			})
		}), [t, n]),
		onChange: r
	};
}
var ZC = [
	"editor",
	"children",
	"onChange",
	"initialValue"
], QC = (e) => {
	var { editor: t, children: n, onChange: r, initialValue: i } = e, a = Sx(e, ZC), [o, s] = N.useState(() => {
		if (!H.isNodeList(i)) throw Error(`[Slate] initialValue is invalid! Expected a list of elements but got: ${dm.stringify(i)}`);
		if (!U.isEditor(t)) throw Error(`[Slate] editor is invalid! You passed: ${dm.stringify(t)}`);
		return t.children = i, Object.assign(t, a), {
			v: 0,
			editor: t
		};
	}), { selectorContext: c, onChange: l } = XC(t), u = P(() => {
		r && r(t.children), s((e) => ({
			v: e.v + 1,
			editor: t
		})), l(t);
	}, [
		t,
		l,
		r
	]);
	me(() => ($x.set(t, u), () => {
		$x.set(t, () => {});
	}), [t, u]);
	var [d, f] = ye(X.isFocused(t));
	return me(() => {
		f(X.isFocused(t));
	}, [t]), KS(() => {
		var e = () => f(X.isFocused(t));
		return Tx >= 17 ? (document.addEventListener("focusin", e), document.addEventListener("focusout", e), () => {
			document.removeEventListener("focusin", e), document.removeEventListener("focusout", e);
		}) : (document.addEventListener("focus", e, !0), document.addEventListener("blur", e, !0), () => {
			document.removeEventListener("focus", e, !0), document.removeEventListener("blur", e, !0);
		});
	}, []), /*#__PURE__*/ N.createElement(YC.Provider, { value: c }, /*#__PURE__*/ N.createElement(SC.Provider, { value: o }, /*#__PURE__*/ N.createElement(Cx.Provider, { value: o.editor }, /*#__PURE__*/ N.createElement(qC.Provider, { value: d }, n))));
}, $C = (e, t) => {
	var n = (t.top + t.bottom) / 2;
	return e.top <= n && e.bottom >= n;
}, ew = (e, t, n) => {
	var r = X.toDOMRange(e, t).getBoundingClientRect(), i = X.toDOMRange(e, n).getBoundingClientRect();
	return $C(r, i) && $C(i, r);
}, tw = (e, t) => {
	var n = U.range(e, B.end(t)), r = Array.from(U.positions(e, { at: t })), i = 0, a = r.length, o = Math.floor(a / 2);
	if (ew(e, U.range(e, r[i]), n)) return U.range(e, r[i], n);
	if (r.length < 2) return U.range(e, r[r.length - 1], n);
	for (; o !== r.length && o !== i;) ew(e, U.range(e, r[o]), n) ? a = o : i = o, o = Math.floor((i + a) / 2);
	return U.range(e, r[a], n);
};
function nw(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function rw(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? nw(Object(n), !0).forEach(function(t) {
			bx(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nw(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var iw = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x-slate-fragment", n = e, { apply: r, onChange: i, deleteBackward: a, addMark: o, removeMark: s } = n;
	return Jx.set(n, /* @__PURE__ */ new WeakMap()), n.addMark = (e, t) => {
		var r, i;
		(r = eS.get(n)) == null || r(), !tS.get(n) && (i = rS.get(n)) != null && i.length && tS.set(n, null), nS.delete(n), o(e, t);
	}, n.removeMark = (e) => {
		var t;
		!tS.get(n) && (t = rS.get(n)) != null && t.length && tS.set(n, null), nS.delete(n), s(e);
	}, n.deleteBackward = (e) => {
		if (e !== "line") return a(e);
		if (n.selection && B.isCollapsed(n.selection)) {
			var t = U.above(n, {
				match: (e) => V.isElement(e) && U.isBlock(n, e),
				at: n.selection
			});
			if (t) {
				var [, r] = t, i = tw(n, U.range(n, r, n.selection.anchor));
				B.isCollapsed(i) || q.delete(n, { at: i });
			}
		}
	}, n.apply = (t) => {
		var i = [], a = [], o = rS.get(n);
		if (o != null && o.length) {
			var s = o.map((e) => RS(e, t)).filter(Boolean);
			rS.set(n, s);
		}
		var c = aS.get(n);
		c && aS.set(n, LS(n, c, t));
		var l = iS.get(n);
		if (l != null && l.at) {
			var u = W.isPoint(l?.at) ? IS(n, l.at, t) : LS(n, l.at, t);
			iS.set(n, u ? rw(rw({}, l), {}, { at: u }) : null);
		}
		switch (t.type) {
			case "insert_text":
			case "remove_text":
			case "set_node":
			case "split_node":
				i.push(...aw(n, t.path));
				break;
			case "set_selection":
				var d;
				(d = Qx.get(n)) == null || d.unref(), Qx.delete(n);
				break;
			case "insert_node":
			case "remove_node":
				i.push(...aw(n, z.parent(t.path)));
				break;
			case "merge_node":
				var f = z.previous(t.path);
				i.push(...aw(n, f));
				break;
			case "move_node":
				var p = z.common(z.parent(t.path), z.parent(t.newPath));
				i.push(...aw(n, p));
				var m;
				z.isBefore(t.path, t.newPath) ? (i.push(...aw(n, z.parent(t.path))), m = t.newPath) : (i.push(...aw(n, z.parent(t.newPath))), m = t.path);
				var h = H.get(e, z.parent(m)), g = X.findKey(n, h), _ = U.pathRef(n, z.parent(m));
				a.push([_, g]);
		}
		r(t);
		for (var [v, y] of i) {
			var [b] = U.node(n, v);
			qx.set(b, y);
		}
		for (var [x, S] of a) if (x.current) {
			var [C] = U.node(n, x.current);
			qx.set(C, S);
		}
	}, n.setFragmentData = (e) => {
		var { selection: r } = n;
		if (r) {
			var [i, a] = B.edges(r), o = U.void(n, { at: i.path }), s = U.void(n, { at: a.path });
			if (!B.isCollapsed(r) || o) {
				var c = X.toDOMRange(n, r), l = c.cloneContents(), u = l.childNodes[0];
				if (l.childNodes.forEach((e) => {
					e.textContent && e.textContent.trim() !== "" && (u = e);
				}), s) {
					var [d] = s, f = c.cloneRange(), p = X.toDOMNode(n, d);
					f.setEndAfter(p), l = f.cloneContents();
				}
				if (o && (u = l.querySelector("[data-slate-spacer]")), Array.from(l.querySelectorAll("[data-slate-zero-width]")).forEach((e) => {
					e.textContent = e.getAttribute("data-slate-zero-width") === "n" ? "\n" : "";
				}), hS(u)) {
					var m = u.ownerDocument.createElement("span");
					m.style.whiteSpace = "pre", m.appendChild(u), l.appendChild(m), u = m;
				}
				var h = n.getFragment(), g = JSON.stringify(h), _ = window.btoa(encodeURIComponent(g));
				u.setAttribute("data-slate-fragment", _), e.setData(`application/${t}`, _);
				var v = l.ownerDocument.createElement("div");
				return v.appendChild(l), v.setAttribute("hidden", "true"), l.ownerDocument.body.appendChild(v), e.setData("text/html", v.innerHTML), e.setData("text/plain", xS(v)), l.ownerDocument.body.removeChild(v), e;
			}
		}
	}, n.insertData = (e) => {
		n.insertFragmentData(e) || n.insertTextData(e);
	}, n.insertFragmentData = (e) => {
		var r = e.getData(`application/${t}`) || CS(e);
		if (r) {
			var i = decodeURIComponent(window.atob(r)), a = JSON.parse(i);
			return n.insertFragment(a), !0;
		}
		return !1;
	}, n.insertTextData = (e) => {
		var t = e.getData("text/plain");
		if (t) {
			var r = t.split(/\r\n|\r|\n/), i = !1;
			for (var a of r) i && q.splitNodes(n, { always: !0 }), n.insertText(a), i = !0;
			return !0;
		}
		return !1;
	}, n.onChange = (e) => {
		(Tx < 18 ? xe.unstable_batchedUpdates : (e) => e())(() => {
			var t = $x.get(n);
			t && t(), i(e);
		});
	}, n;
}, aw = (e, t) => {
	var n = [];
	for (var [r, i] of U.levels(e, { at: t })) {
		var a = X.findKey(e, r);
		n.push([i, a]);
	}
	return n;
}, ow = (e, t) => {
	try {
		return X.findPath(e, t);
	} catch {}
}, sw = (e, t) => {
	t && J(e, () => {
		sv(e), w_(e, t);
	}), X.focus(e);
}, cw = (e) => X.isComposing(e), lw = (e) => X.isFocused(e), uw = (e, { edge: t = "start" } = {}) => {
	sw(e, t === "start" ? A_(e, []) : E_(e, []));
}, dw = Ke, fw = Object.prototype.hasOwnProperty;
function pw(e, t, n) {
	for (n of e.keys()) if (mw(n, t)) return n;
}
function mw(e, t) {
	var n, r, i;
	if (e === t) return !0;
	if (e && t && (n = e.constructor) === t.constructor) {
		if (n === Date) return e.getTime() === t.getTime();
		if (n === RegExp) return e.toString() === t.toString();
		if (n === Array) {
			if ((r = e.length) === t.length) for (; r-- && mw(e[r], t[r]););
			return r === -1;
		}
		if (n === Set) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r, i && typeof i == "object" && (i = pw(t, i), !i) || !t.has(i)) return !1;
			return !0;
		}
		if (n === Map) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r[0], i && typeof i == "object" && (i = pw(t, i), !i) || !mw(r[1], t.get(i))) return !1;
			return !0;
		}
		if (n === ArrayBuffer) e = new Uint8Array(e), t = new Uint8Array(t);
		else if (n === DataView) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e.getInt8(r) === t.getInt8(r););
			return r === -1;
		}
		if (ArrayBuffer.isView(e)) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e[r] === t[r];);
			return r === -1;
		}
		if (!n || typeof e == "object") {
			for (n in r = 0, e) if (fw.call(e, n) && ++r && !fw.call(t, n) || !(n in t) || !mw(e[n], t[n])) return !1;
			return Object.keys(t).length === r;
		}
	}
	return e !== e && t !== t;
}
// ../../../node_modules/use-deep-compare/dist-web/index.js
function hw(e) {
	let t = N.useRef(e), n = N.useRef(0);
	return mw(e, t.current) || (t.current = e, n.current += 1), N.useMemo(() => t.current, [n.current]);
}
function gw(e, t) {
	return N.useMemo(e, hw(t));
}
var _w = (e) => e, vw = (e) => ({
	_tag: "Left",
	value: e
}), yw = (e) => ({
	_tag: "Right",
	value: e
}), bw = (e, t, n) => n._tag === "Left" ? e(n.value) : t(n.value), xw = {
	dimap: (e, t, n) => (r) => t(n(e(r))),
	first: (e) => ([t, n]) => [e(t), n],
	right: (e) => (t) => t._tag === "Left" ? t : yw(e(t.value)),
	wander: (e) => (t) => t.map(e)
}, Sw = {
	empty: () => void 0,
	foldMap: (e, t) => {
		for (let n = 0; n < t.length; n++) {
			let r = e(t[n]);
			if (r != null) return r;
		}
	}
}, Cw = {
	empty: () => [],
	foldMap: (e, t) => {
		let n = [];
		return t.forEach((t) => {
			n = n.concat(e(t));
		}), n;
	}
}, ww = (e) => ({
	dimap: (e, t, n) => (t) => n(e(t)),
	first: (e) => ([t, n]) => e(t),
	right: (t) => (n) => n._tag === "Left" ? e.empty() : t(n.value),
	wander: (t) => (n) => e.foldMap(t, n)
}), Tw = {
	Equivalence: {
		Equivalence: "Equivalence",
		Iso: "Iso",
		Lens: "Lens",
		Prism: "Prism",
		Traversal: "Traversal",
		Getter: "Getter",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Iso: {
		Equivalence: "Iso",
		Iso: "Iso",
		Lens: "Lens",
		Prism: "Prism",
		Traversal: "Traversal",
		Getter: "Getter",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Lens: {
		Equivalence: "Lens",
		Iso: "Lens",
		Lens: "Lens",
		Prism: "Prism",
		Traversal: "Traversal",
		Getter: "Getter",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Prism: {
		Equivalence: "Prism",
		Iso: "Prism",
		Lens: "Prism",
		Prism: "Prism",
		Traversal: "Traversal",
		Getter: "AffineFold",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Traversal: {
		Equivalence: "Traversal",
		Iso: "Traversal",
		Lens: "Traversal",
		Prism: "Traversal",
		Traversal: "Traversal",
		Getter: "Fold",
		AffineFold: "Fold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Getter: {
		Equivalence: "Getter",
		Iso: "Getter",
		Lens: "Getter",
		Prism: "AffineFold",
		Traversal: "Fold",
		Getter: "Getter",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: void 0
	},
	AffineFold: {
		Equivalence: "AffineFold",
		Iso: "AffineFold",
		Lens: "AffineFold",
		Prism: "AffineFold",
		Traversal: "Fold",
		Getter: "AffineFold",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: void 0
	},
	Fold: {
		Equivalence: "Fold",
		Iso: "Fold",
		Lens: "Fold",
		Prism: "Fold",
		Traversal: "Fold",
		Getter: "Fold",
		AffineFold: "Fold",
		Fold: "Fold",
		Setter: void 0
	},
	Setter: {
		Equivalence: void 0,
		Iso: void 0,
		Lens: void 0,
		Prism: void 0,
		Traversal: void 0,
		Getter: void 0,
		AffineFold: void 0,
		Fold: void 0,
		Setter: void 0
	}
}, Ew = (e, t) => {
	let n = t;
	return n._tag = e, n;
}, Dw = (e) => (e._removable = !0, e);
function Z(e, t, n) {
	switch (arguments.length) {
		case 2: {
			let n = (n, r) => e(n, t(n, r));
			return n._tag = Tw[e._tag][t._tag], n._removable = t._removable || !1, n;
		}
		default: {
			let r = Tw[e._tag][t._tag], i = (r, i) => e(r, t(r, n(r, i)));
			return i._tag = Tw[r][n._tag], i._removable = n._removable || !1, i;
		}
	}
}
var Ow = /* @__PURE__ */ Ew("Equivalence", (e, t) => t), kw = (e, t) => Ew("Iso", (n, r) => n.dimap(e, t, r)), Aw = (e, t) => Ew("Lens", (n, r) => n.dimap((t) => [e(t), t], t, n.first(r))), jw = (e, t) => Ew("Prism", (n, r) => n.dimap(e, (e) => bw(_w, t, e), n.right(r))), Mw = /* @__PURE__ */ Ew("Traversal", (e, t) => e.dimap(_w, _w, e.wander(t))), Nw = (e) => Ew("Getter", (t, n) => t.dimap(e, _w, n)), Pw = (e, t, n) => e(xw, t)(n), Fw = (e, t, n) => e(xw, () => t)(n), Iw = (e, t) => e(ww({}), _w)(t), Lw = (e, t) => e(ww(Sw), _w)(t), Rw = (e, t) => e(ww(Cw), (e) => [e])(t), zw = /* @__PURE__ */ kw((e) => e.map((e, t) => [t, e]), (e) => {
	let t = [...e].sort((e, t) => e[0] - t[0]), n = [];
	for (let e = 0; e < t.length; ++e) (e === t.length - 1 || t[e][0] !== t[e + 1][0]) && n.push(t[e][1]);
	return n;
}), Bw = (e) => Aw((t) => t[e], ([t, n]) => Object.assign(Object.assign({}, n), { [e]: t })), Vw = (e) => Aw((t) => {
	let n = {};
	for (let r of e) n[r] = t[r];
	return n;
}, ([t, n]) => {
	let r = Object.assign({}, n);
	for (let t of e) delete r[t];
	return Object.assign(r, t);
}), Hw = (e) => Aw((t) => t[e], ([t, n]) => {
	let r = n.slice();
	return r[e] = t, r;
}), Uw = /* @__PURE__ */ Hw(0), Ww = (e) => jw((t) => e(t) ? yw(t) : vw(t), _w), Gw = /* @__PURE__ */ Symbol("__no_match__"), Kw = /* @__PURE__ */ Ww((e) => e !== Gw), qw = /* @__PURE__ */ Symbol("__remove_me__"), Jw = (e) => Dw(Z(Aw((t) => 0 <= e && e < t.length ? t[e] : Gw, ([t, n]) => {
	if (t === Gw) return n;
	if (t === qw) return typeof n == "string" ? n.substring(0, e) + n.substring(e + 1) : [...n.slice(0, e), ...n.slice(e + 1)];
	if (typeof n == "string") return e === 0 ? t + n.substring(1) : e === n.length ? n.substring(0, e - 1) + t : n.substring(0, e) + t + n.substring(e + 1);
	{
		let r = n.slice();
		return r[e] = t, r;
	}
}), Kw)), Yw = /* @__PURE__ */ jw((e) => e === void 0 ? vw(void 0) : yw(e), _w), Xw = (e) => jw((t) => e(t) ? yw(t) : vw(t), _w), Zw = (e) => Dw(Z(Aw((t) => {
	let n = t.findIndex(e);
	return n === -1 ? [Gw, -1] : [t[n], n];
}, ([[e, t], n]) => {
	if (e === Gw) return n;
	if (e === qw) return [...n.slice(0, t), ...n.slice(t + 1)];
	let r = n.slice();
	return r[t] = e, r;
}), Uw, Kw)), Qw = (e) => Z(Aw((t) => {
	let n = t.map((t, n) => e(t) ? n : null).filter((e) => e != null);
	return [n.map((e) => t[e]), n];
}, ([[e, t], n]) => {
	let r = n.length, i = e.length, a = 0, o = 0, s = 0, c = [];
	for (; a < r;) t[o] === a ? (++o, s < i && (c.push(e[s]), ++s)) : c.push(n[a]), ++a;
	for (; s < i;) c.push(e[s++]);
	return c;
}), Uw), $w = (e) => Aw((t) => t === void 0 ? e : t, ([e, t]) => e), eT = (e) => Z(Aw((t) => {
	let n = Rw(e, t);
	return [n, n.length];
}, ([[t, n], r]) => {
	if (t.length !== n) throw Error("cannot add/remove elements through partsOf");
	let i = 0;
	return Pw(e, () => t[i++], r);
}), Uw), tT = (e) => Aw((t) => e(t), ([e, t]) => e), nT = (e) => Aw((e) => e, ([t, n]) => e(t)), rT = /* @__PURE__ */ Aw((e) => void 0, ([e, t]) => e === void 0 ? t : [e, ...t]), iT = /* @__PURE__ */ Aw((e) => void 0, ([e, t]) => e === void 0 ? t : [...t, e]), aT = /* @__PURE__ */ Z(kw((e) => e.split(""), (e) => e.join("")), Mw), oT = /* @__PURE__ */ Z(kw((e) => e.split(/\b/), (e) => e.join("")), Mw, Ww((e) => !/\s+/.test(e))), sT = /* @__PURE__ */ new class e {
	constructor(e) {
		this._ref = e;
	}
	get _tag() {
		return this._ref._tag;
	}
	get _removable() {
		return this._ref._removable;
	}
	compose(t) {
		return new e(Z(this._ref, t._ref));
	}
	iso(t, n) {
		return new e(Z(this._ref, kw(t, n)));
	}
	lens(t, n) {
		return new e(Z(this._ref, Aw(t, ([e, t]) => n(t, e))));
	}
	indexed() {
		return new e(Z(this._ref, zw));
	}
	prop(t) {
		return new e(Z(this._ref, Bw(t)));
	}
	path(...t) {
		return t.length === 1 && (t = t[0].split(".")), new e(t.reduce((e, t) => Z(e, Bw(t)), this._ref));
	}
	pick(t) {
		return new e(Z(this._ref, Vw(t)));
	}
	nth(t) {
		return new e(Z(this._ref, Hw(t)));
	}
	filter(t) {
		return new e(Z(this._ref, Qw(t)));
	}
	valueOr(t) {
		return new e(Z(this._ref, $w(t)));
	}
	partsOf(t) {
		let n = typeof t == "function" ? t(sT) : t;
		return new e(Z(this._ref, eT(n._ref)));
	}
	reread(t) {
		return new e(Z(this._ref, tT(t)));
	}
	rewrite(t) {
		return new e(Z(this._ref, nT(t)));
	}
	optional() {
		return new e(Z(this._ref, Yw));
	}
	guard_() {
		return (e) => this.guard(e);
	}
	guard(t) {
		return new e(Z(this._ref, Xw(t)));
	}
	at(t) {
		return new e(Z(this._ref, Jw(t)));
	}
	head() {
		return new e(Z(this._ref, Jw(0)));
	}
	index(t) {
		return new e(Z(this._ref, Jw(t)));
	}
	find(t) {
		return new e(Z(this._ref, Zw(t)));
	}
	elems() {
		return new e(Z(this._ref, Mw));
	}
	to(t) {
		return new e(Z(this._ref, Nw(t)));
	}
	when(t) {
		return new e(Z(this._ref, Ww(t)));
	}
	chars() {
		return new e(Z(this._ref, aT));
	}
	words() {
		return new e(Z(this._ref, oT));
	}
	prependTo() {
		return new e(Z(this._ref, rT));
	}
	appendTo() {
		return new e(Z(this._ref, iT));
	}
}(Ow);
// ../../../node_modules/optics-ts/dist/mjs/index.js
function cT() {
	return sT;
}
function lT(e) {
	return (t) => Iw(e._ref, t);
}
function uT(e) {
	return (t) => Lw(e._ref, t);
}
function dT(e) {
	return (t) => Rw(e._ref, t);
}
function fT(e) {
	return (t) => (n) => Pw(e._ref, t, n);
}
function pT(e) {
	return (t) => (n) => Fw(e._ref, t, n);
}
// ../../../node_modules/@udecode/plate-core/node_modules/jotai-optics/dist/index.modern.mjs
var mT = (e, t, n) => (t.has(n) ? t : t.set(n, e())).get(n), hT = /* @__PURE__ */ new WeakMap();
function gT(e, t) {
	return ((n, r, i) => mT(() => {
		let n = t(cT());
		return Ne((t) => {
			let r = t(e);
			return r instanceof Promise ? r.then((e) => _T(n, e)) : _T(n, r);
		}, (t, r, i) => {
			let a = typeof i == "function" ? fT(n)(i) : pT(n)(i), o = t(e);
			return r(e, o instanceof Promise ? o.then(a) : a(o));
		});
	}, mT(() => /* @__PURE__ */ new WeakMap(), hT, r), i))(0, e, t);
}
var _T = (e, t) => e._tag === "Traversal" ? dT(e)(t) : e._tag === "Prism" ? uT(e)(t) : lT(e)(t), vT = Ny(), yT = Object.defineProperty, bT = Object.defineProperties, xT = Object.getOwnPropertyDescriptors, ST = Object.getOwnPropertySymbols, CT = Object.prototype.hasOwnProperty, wT = Object.prototype.propertyIsEnumerable, TT = (e, t, n) => t in e ? yT(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Q = (e, t) => {
	for (var n in t ||= {}) CT.call(t, n) && TT(e, n, t[n]);
	if (ST) for (var n of ST(t)) wT.call(t, n) && TT(e, n, t[n]);
	return e;
}, ET = (e, t) => bT(e, xT(t)), DT = (e, t) => {
	var n = {};
	for (var r in e) CT.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && ST) for (var r of ST(e)) t.indexOf(r) < 0 && wT.call(e, r) && (n[r] = e[r]);
	return n;
}, OT = [
	"readOnly",
	"plugins",
	"onChange",
	"decorate",
	"renderElement",
	"renderLeaf"
], kT = "element", { ElementProvider: AT, useElementStore: jT } = su({ element: null }, { name: "element" }), MT = (e = kT) => jT(e).get.element() || (console.warn("The `useElement(pluginKey)` hook must be used inside the node component's context"), {}), NT = Zd("event-editor")({
	blur: null,
	focus: null,
	last: null
}), PT = NT.set, FT = NT.get;
NT.use;
var IT = (e, t = {}, n = !1) => {
	if (t[e.key]) {
		let r = t[e.key], { plugins: i, then: a } = r;
		e = Sv(DT(r, ["plugins", "then"]), e), n || i?.forEach((t) => {
			e.plugins || (e.plugins = []), e.plugins.find((e) => e.key === t.key) || e.plugins.push(t);
		});
	}
	e.plugins && (e.plugins = e.plugins.map((e) => IT(e, t, !0)));
	let { then: r } = e;
	return r ? (e._thenReplaced === void 0 && (e._thenReplaced = 0), e._thenReplaced < 3 && (e.then = (n, i) => {
		let a = Q({ key: e.key }, r(n, i));
		return Sv(IT(a, t), a);
	}, e._thenReplaced++)) : t[e.key]?.then && (e.then = t[e.key].then), e;
}, LT = (e, { components: t, overrideByKey: n } = {}) => {
	let r = {};
	return n && (r = xv(n)), t && Object.keys(t).forEach((e) => {
		r[e] || (r[e] = {}), r[e].component = t[e];
	}), Object.keys(r).length > 0 ? e.map((e) => IT(e, r)) : e;
}, RT = (e, t) => {
	wy(e, Q({
		at: [],
		nodes: e.childrenFactory()
	}, t));
}, zT = (e) => {
	RT(e), e.history.undos = [], e.history.redos = [], e.operations = [];
}, BT = (e) => e?.pluginsByKey ?? {}, VT = (e, t) => BT(e)[t] ?? { key: t }, HT = (e, t) => VT(e, t).type ?? t ?? "", UT = (e) => (t, n = {}) => (n[e.key] = t, IT(Q({}, e), n)), WT = UT({
	editor: { insertData: {
		format: "application/x-slate-fragment",
		getFragment: ({ data: e }) => {
			let t = decodeURIComponent(window.atob(e)), n;
			try {
				n = JSON.parse(t);
			} catch {}
			return Cv(n);
		}
	} },
	key: "deserializeAst"
}), GT = (e, t = {}) => p_(e, ET(Q({}, t), { block: !0 })), KT = (e, t) => {
	let { selection: n } = e;
	if (!n) return !1;
	let r = GT(e, t)?.[1];
	return r ? W_(e, n.focus, r) || av(e.selection) && W_(e, n.anchor, r) : !1;
}, qT = (e) => {
	let t = L_(e);
	t && Object.keys(t).forEach((t) => {
		K_(e, t);
	});
}, JT = UT({
	key: "editorProtocol",
	withOverrides: (e) => {
		let { deleteBackward: t, deleteForward: n, deleteFragment: r } = e, i = () => {
			KT(e) && qT(e);
		};
		return e.deleteBackward = (e) => {
			t(e), i();
		}, e.deleteForward = (e) => {
			n(e), i();
		}, e.deleteFragment = (e) => {
			r(e), i();
		}, e;
	}
}), YT = UT({
	key: "history",
	withOverrides: (e) => Gg(e)
}), XT = UT({
	key: "inline-void",
	withOverrides: (e) => {
		let { isInline: t, isVoid: n, markableVoid: r } = e, i = [], a = [], o = [];
		return e.plugins.forEach((e) => {
			e.isInline && a.push(e.type), e.isVoid && i.push(e.type), e.isMarkableVoid && o.push(e.type);
		}), e.isInline = (e) => a.includes(e.type) ? !0 : t(e), e.isVoid = (e) => i.includes(e.type) ? !0 : n(e), e.markableVoid = (e) => o.includes(e.type) ? !0 : r(e), e;
	}
}), ZT = (e, t) => {
	let n = [];
	return [...e.plugins].reverse().forEach((e) => {
		let r = e.inject.pluginsByKey?.[t.key];
		r && n.push(r);
	}), [t, ...n];
}, QT = (e, { data: t, dataTransfer: n }) => e.every((e) => {
	let r = e.editor?.insertData?.query;
	return !r || r({
		data: t,
		dataTransfer: n
	});
}), $T = (e, t, n) => {
	var r = n, { fragment: i } = r, a = DT(r, ["fragment"]);
	J(e, () => {
		t.some((e) => {
			var t;
			return ((t = e.editor?.insertData)?.preInsert)?.call(t, i, a) === !0;
		}), e.insertFragment(i);
	});
}, eE = (e, { data: t, dataTransfer: n }) => (e.forEach((e) => {
	let r = e.editor?.insertData?.transformData;
	r && (t = r(t, { dataTransfer: n }));
}), t), tE = (e, t) => {
	var n = t, { fragment: r } = n, i = DT(n, ["fragment"]);
	return e.forEach((e) => {
		let t = e.editor?.insertData?.transformFragment;
		t && (r = t(r, i));
	}), r;
}, nE = UT({
	key: "insertData",
	withOverrides: (e) => {
		let { insertData: t } = e;
		return e.insertData = (n) => {
			[...e.plugins].reverse().some((t) => {
				let r = t.editor.insertData;
				if (!r) return !1;
				let i = ZT(e, t), { format: a, getFragment: o } = r;
				if (!a) return !1;
				let s = n.getData(a);
				if (!s) return;
				if (!QT(i, {
					data: s,
					dataTransfer: n
				})) return !1;
				s = eE(i, {
					data: s,
					dataTransfer: n
				});
				let c = o?.({
					data: s,
					dataTransfer: n
				});
				return !c?.length || (c = tE(i, {
					data: s,
					dataTransfer: n,
					fragment: c
				}), c.length === 0) ? !1 : ($T(e, i, {
					data: s,
					dataTransfer: n,
					fragment: c
				}), !0);
			}) || t(n);
		}, e;
	}
}), rE = UT({
	key: "length",
	withOverrides: (e, { options: t }) => {
		let { apply: n } = e;
		return e.apply = (r) => {
			J(e, () => {
				if (n(r), t.maxLength) {
					let n = F_(e, []).length;
					if (n > t.maxLength) {
						let r = n - t.maxLength;
						e.delete({
							distance: r,
							reverse: !0,
							unit: "character"
						});
					}
				}
			});
		}, e;
	}
}), iE = ({ apply: e, node: t, path: n = [], query: r, source: i }) => {
	lv([t, n], r) && (i instanceof Function ? e(t, i()) : e(t, i)), rv(t) && t.children.forEach((t, a) => {
		iE({
			apply: e,
			node: t,
			path: n.concat([a]),
			query: r,
			source: i
		});
	});
}, aE = (e, t) => {
	let n = Q({}, t), { then: r } = n;
	if (r) {
		delete n.then;
		let { plugins: t } = n, i = aE(e, Sv(r(e, n), n));
		return t && i.plugins && (i.plugins = ky(Oy(Dy(t, "key"), Dy(i.plugins, "key")))), i;
	}
	return n;
}, oE = (e) => (e.type === void 0 && (e.type = e.key), e.options ||= {}, e.inject ||= {}, e.editor ||= {}, e), sE = (e, t) => {
	t && t.forEach((t) => {
		let n = oE(t);
		if (n = aE(e, n), n.enabled !== !1) {
			if (e.pluginsByKey[n.key]) {
				let t = e.plugins.indexOf(e.pluginsByKey[n.key]), r = Sv(n, e.pluginsByKey[n.key]);
				t >= 0 && (e.plugins[t] = r), e.pluginsByKey[n.key] = r;
			} else e.plugins.push(n), e.pluginsByKey[n.key] = n;
			sE(e, n.plugins);
		}
	});
}, cE = (e) => `slate-${e}`, lE = ({ attributes: e, dangerouslyAllowAttributes: t, nodeProps: n, props: r, type: i }) => {
	let a = {};
	r && (a = (typeof r == "function" ? r(n) : r) ?? {}), !a.nodeProps && e && (a.nodeProps = My(e, t ?? [])), n = Q(Q({}, n), a), n.nodeProps && Object.keys(n.nodeProps).forEach((e) => {
		var t;
		n.nodeProps?.[e] === void 0 && ((t = n.nodeProps) == null || delete t[e]);
	});
	let { className: o } = n;
	return ET(Q({}, n), { className: jy(cE(i), o) });
}, uE = (e) => {
	iE(ET(Q({}, e), { apply: Oy }));
}, dE = (e) => Q({
	editor: {},
	inject: {},
	key: "",
	options: {},
	type: ""
}, e), fE = (e) => (t) => y_(t) || c_(t) && e.isInline(t), pE = (e) => () => ({
	children: [],
	type: e
}), mE = (e, t) => e.some((e, n, r) => {
	let i = r[n - 1];
	return n !== 0 && t(e) !== t(i);
}), hE = (e, t, n) => {
	let r = mE(e, t), { fragment: i } = e.reduce((e, i) => {
		if (r && t(i)) {
			let t = e.precedingBlock;
			t || (t = n(), e.precedingBlock = t, e.fragment.push(t)), t.children.push(i);
		} else e.fragment.push(i), e.precedingBlock = null;
		return e;
	}, {
		fragment: [],
		precedingBlock: null
	});
	return i;
}, gE = (e) => e.length === 0 ? [{ text: "" }] : e, _E = (e, t, n) => (e = gE(e), e = hE(e, t, n), e = e.map((e) => c_(e) ? ET(Q({}, e), { children: _E(e.children, t, n) }) : e), e), vE = (e, { descendants: t }) => _E(t, fE(e), pE(HT(e, "p"))), yE = (e, t) => {
	let n = e.plugins.flatMap((t) => t.decorate?.call(t, e, t) ?? []);
	if (t && n.push(t), n.length !== 0) return (e) => {
		let t = [], r = (e) => {
			e?.length && (t = [...t, ...e]);
		};
		return n.forEach((t) => {
			r(t(e));
		}), t;
	};
}, bE = (e) => {
	let t = !1;
	return ET(Q({}, e), {
		bubbles: e.bubbles,
		cancelable: e.cancelable,
		currentTarget: e.currentTarget,
		defaultPrevented: e.defaultPrevented,
		eventPhase: e.eventPhase,
		isDefaultPrevented: () => e.defaultPrevented,
		isPropagationStopped: () => t,
		isTrusted: e.isTrusted,
		nativeEvent: e,
		persist: () => {
			throw Error("persist is not implemented for synthetic events created using convertDomEventToSyntheticEvent");
		},
		preventDefault: () => e.preventDefault(),
		stopPropagation: () => {
			t = !0, e.stopPropagation();
		},
		target: e.target,
		timeStamp: e.timeStamp,
		type: e.type
	});
}, xE = (e, t) => t ? t(e) ?? e.isPropagationStopped() : !1, SE = (e, { editableProps: t, handlerKey: n }) => {
	let r = [];
	r = e.plugins.flatMap((t) => {
		var r;
		return ((r = t.handlers)?.[n])?.call(r, e, t) ?? [];
	});
	let i = t?.[n];
	if (r.length !== 0 || i) return (e) => {
		let t = e instanceof Event ? bE(e) : e;
		return r.some((e) => xE(t, e)) ? !0 : xE(t, i);
	};
}, CE = (e, { inject: { props: t }, key: n }, r) => {
	let { className: i, element: a, style: o, text: s } = r, c = a ?? s;
	if (!c || !t) return;
	let { classNames: l, defaultNodeValue: u, nodeKey: d = n, query: f, styleKey: p = d, transformClassName: m, transformNodeValue: h, transformProps: g, transformStyle: _, validNodeValues: v, validTypes: y } = t, b = f?.(t, r);
	if (!b && y && c_(c) && c.type && !y.includes(c.type)) return;
	let x = c[d];
	if (!b && (!Iv(x) || v && !v.includes(x) || x === u)) return;
	let S = ET(Q({}, r), { nodeValue: x }), C = h?.(S) ?? x;
	S.value = C;
	let w = {};
	return a && (w.className = jy(i, `slate-${d}-${x}`)), (l?.[x] || m) && (w.className = m?.(S) ?? jy(i, l?.[C])), p && (w.style = _?.(S) ?? ET(Q({}, o), { [p]: C })), g && (w = g(S, w) ?? w), w;
}, wE = (e, t) => (e.plugins.forEach((n) => {
	if (n.inject.props) {
		let r = CE(e, n, t);
		r && (t = Q(Q({}, t), r));
	}
}), ET(Q({}, t), { editor: e })), TE = (e) => {
	let t = e.plugins.flatMap((t) => {
		var n;
		return ((n = t.handlers)?.onChange)?.call(n, e, t) ?? [];
	});
	return (e) => t.some((t) => t ? t(e) ?? !1 : !1);
}, EE = {
	bold: "mod+b",
	compose: [
		"down",
		"left",
		"right",
		"up",
		"backspace",
		"enter"
	],
	deleteBackward: "shift?+backspace",
	deleteForward: "shift?+delete",
	extendBackward: "shift+left",
	extendForward: "shift+right",
	insertSoftBreak: "shift+enter",
	italic: "mod+i",
	moveBackward: "left",
	moveForward: "right",
	moveWordBackward: "ctrl+left",
	moveWordForward: "ctrl+right",
	splitBlock: "enter",
	tab: "tab",
	undo: "mod+z",
	untab: "shift+tab"
}, DE = {
	deleteBackward: ["ctrl+backspace", "ctrl+h"],
	deleteForward: ["ctrl+delete", "ctrl+d"],
	deleteLineBackward: "cmd+shift?+backspace",
	deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
	deleteWordBackward: "opt+shift?+backspace",
	deleteWordForward: "opt+shift?+delete",
	extendLineBackward: "opt+shift+up",
	extendLineForward: "opt+shift+down",
	moveLineBackward: "opt+up",
	moveLineForward: "opt+down",
	moveWordBackward: "opt+left",
	moveWordForward: "opt+right",
	redo: "cmd+shift+z",
	transposeCharacter: "ctrl+t"
}, OE = {
	deleteWordBackward: "ctrl+shift?+backspace",
	deleteWordForward: "ctrl+shift?+delete",
	redo: ["ctrl+y", "ctrl+shift+z"]
}, kE = (e) => {
	let t = EE[e], n = DE[e], r = OE[e], i = t && (0, vT.isKeyHotkey)(t), a = n && (0, vT.isKeyHotkey)(n), o = r && (0, vT.isKeyHotkey)(r);
	return (e) => !!(i?.(e) || Tv && a?.(e) || !Tv && o?.(e));
}, AE = {
	isBold: kE("bold"),
	isCompose: kE("compose"),
	isDeleteBackward: kE("deleteBackward"),
	isDeleteForward: kE("deleteForward"),
	isDeleteLineBackward: kE("deleteLineBackward"),
	isDeleteLineForward: kE("deleteLineForward"),
	isDeleteWordBackward: kE("deleteWordBackward"),
	isDeleteWordForward: kE("deleteWordForward"),
	isExtendBackward: kE("extendBackward"),
	isExtendForward: kE("extendForward"),
	isExtendLineBackward: kE("extendLineBackward"),
	isExtendLineForward: kE("extendLineForward"),
	isItalic: kE("italic"),
	isMoveBackward: kE("moveBackward"),
	isMoveForward: kE("moveForward"),
	isMoveLineBackward: kE("moveLineBackward"),
	isMoveLineForward: kE("moveLineForward"),
	isMoveWordBackward: kE("moveWordBackward"),
	isMoveWordForward: kE("moveWordForward"),
	isRedo: kE("redo"),
	isSoftBreak: kE("insertSoftBreak"),
	isSplitBlock: kE("splitBlock"),
	isTransposeCharacter: kE("transposeCharacter"),
	isUndo: kE("undo")
}, jE = UT({
	key: "nodeFactory",
	withOverrides: (e) => (e.blockFactory = (t) => Q({
		children: [{ text: "" }],
		type: HT(e, "p")
	}, t), e.childrenFactory = () => [e.blockFactory()], e)
}), ME = UT({
	handlers: { onKeyDown: (e) => (t) => {
		t.persist(), e.currentKeyboardEvent = t;
	} },
	key: "prevSelection",
	withOverrides: (e) => {
		let { apply: t } = e;
		return e.apply = (n) => {
			if (n.type === "set_selection") {
				let { properties: r } = n;
				e.prevSelection = r, t(n), e.currentKeyboardEvent = null;
			} else t(n);
		}, e;
	}
}), NE = "focus-editor-event", PE = "blur-editor-event", FE = UT({
	handlers: {
		onBlur: (e) => () => {
			FT.focus() === e.id && PT.focus(null), PT.blur(e.id), document.dispatchEvent(new CustomEvent(PE, { detail: { id: e.id } }));
		},
		onFocus: (e) => () => {
			PT.focus(e.id), document.dispatchEvent(new CustomEvent(NE, { detail: { id: e.id } }));
		}
	},
	key: "event-editor"
}), IE = (e, { shouldCollapseWhiteSpace: t = !0, trimEnd: n = "collapse", trimStart: r = "collapse", whiteSpaceIncludesNewlines: i = !0 } = {}) => (r === "all" && (e = e.replace(/^\s+/, "")), n === "single-newline" && (e = e.replace(/\n$/, "")), t && (i ? e = e.replaceAll(/\s+/g, " ") : (e = e.replaceAll(/[^\S\n\r]+/g, " "), e = e.replaceAll(/^[^\S\n\r]+/gm, ""), e = e.replaceAll(/[^\S\n\r]+$/gm, ""))), e), LE = /* @__PURE__ */ new Set(/* @__PURE__ */ "A.ABBR.B.BDI.BDO.BR.CITE.CODE.DATA.DFN.EM.I.KBD.MARK.Q.S.SAMP.SMALL.SPAN.STRONG.SUB.SUP.TIME.U.VAR.WBR.IMG.MAP.TRACK.VIDEO.EMBED.IFRAME.OBJECT.PICTURE.PORTAL.SOURCE.svg.math.CANVAS.DEL.INS.BUTTON.INPUT.LABEL.METER.OUTPUT.PROGRESS.SELECT.TEXTAREA.ACRONYM.BIG.CONTENT.FONT.IMG.MARQUEE.MENUITEM.NOBR.SHADOW.STRIKE.TT".split(".")), RE = (e) => e.nodeType === Node.ELEMENT_NODE, zE = (e) => {
	if (!RE(e)) return !1;
	let t = e, n = LE.has(t.tagName), r = t.style.display.split(" ")[0];
	return r === "" ? n : r.startsWith("inline") ? !0 : r === "inherit" && t.parentElement ? zE(t.parentElement) : [
		"contents",
		"initial",
		"none",
		"revert",
		"revert-layer",
		"unset"
	].includes(r) ? n : !1;
}, BE = (e) => e.nodeType === Node.TEXT_NODE, VE = (e) => RE(e) ? !zE(e) : !1, HE = (e) => {
	let t = e;
	for (;;) {
		if (t.nextSibling) t = t.nextSibling;
		else {
			if (t = t.parentElement, t && VE(t)) return !0;
			t = t?.nextSibling || null;
		}
		if (!t || VE(t)) return !0;
		if ((t.textContent || "").length > 0) return !1;
	}
}, UE = (e) => {
	e.inlineFormattingContext ? e.inlineFormattingContext.atStart = !1 : e.inlineFormattingContext = {
		atStart: !0,
		lastHasTrailingWhiteSpace: !1
	};
}, WE = (e) => {
	e.inlineFormattingContext = null;
}, GE = (e, t) => {
	let n = e.textContent || "", r = n.trim() === "";
	(t.inlineFormattingContext || !r) && UE(t);
	let { whiteSpaceRule: i } = t, a = i === "normal" && (!t.inlineFormattingContext || t.inlineFormattingContext.atStart || t.inlineFormattingContext.lastHasTrailingWhiteSpace) ? "all" : "collapse", o = i === "normal" ? "collapse" : HE(e) ? "single-newline" : "collapse", s = {
		normal: !0,
		pre: !1,
		"pre-line": !0
	}[i], c = IE(n || "", {
		shouldCollapseWhiteSpace: s,
		trimEnd: o,
		trimStart: a,
		whiteSpaceIncludesNewlines: i !== "pre-line"
	});
	t.inlineFormattingContext && s && (t.inlineFormattingContext.lastHasTrailingWhiteSpace = c.endsWith(" ")), e.textContent = c;
}, KE = (e, t) => {
	RE(e) ? YE(e, t) : BE(e) ? GE(e, t) : qE(e, t);
}, qE = (e, t) => {
	let n = Array.from(e.childNodes);
	for (let e of n) KE(e, t);
}, JE = (e) => {
	let t = e.style.whiteSpace;
	switch (t) {
		case "normal":
		case "nowrap": return "normal";
		case "pre":
		case "pre-wrap":
		case "break-spaces": return "pre";
		case "pre-line": return "pre-line";
	}
	return e.tagName === "PRE" ? "pre" : t === "initial" ? "normal" : null;
}, YE = (e, t) => {
	let n = zE(e), r = t.whiteSpaceRule, i = JE(e);
	i && (t.whiteSpaceRule = i), n || WE(t), qE(e, t), n || WE(t), t.whiteSpaceRule = r;
}, XE = (e) => {
	let t = e.cloneNode(!0);
	return YE(t, {
		inlineFormattingContext: null,
		whiteSpaceRule: "normal"
	}), t;
}, ZE = (e, t) => Array.from(t.childNodes).flatMap(oD(e)), QE = (e, t) => {
	if (t.nodeName === "BODY") return db("fragment", {}, ZE(e, t));
}, $E = (e) => {
	if (e.nodeName === "BR") return "\n";
}, eD = (e, t, { deserializeLeaf: n, element: r }) => {
	let { deserializeHtml: i, isElement: a, isLeaf: o, type: s } = t;
	if (!i) return;
	let { attributeNames: c, isElement: l, isLeaf: u, query: d, rules: f } = i, { getNode: p } = i, m = l || a, h = u || o;
	if (!n && !m || n && !h || f && !f.some(({ validAttribute: e, validClassName: n, validNodeName: i = "*", validStyle: a }) => {
		if (i) {
			let e = Cv(i);
			if (e.length > 0 && !e.includes(r.nodeName) && i !== "*") return !1;
		}
		if (n && !r.classList.contains(n)) return !1;
		if (a) for (let [e, n] of Object.entries(a)) {
			if (!Cv(n).includes(r.style[e]) && n !== "*" || n === "*" && !r.style[e]) return;
			let i = t.inject.props?.defaultNodeValue;
			if (i && i === r.style[e]) return !1;
		}
		if (e) {
			if (typeof e == "string") {
				if (!r.getAttributeNames().includes(e)) return !1;
			} else for (let [t, n] of Object.entries(e)) {
				let e = Cv(n), i = r.getAttribute(t);
				if (!Iv(i) || !e.includes(i)) return !1;
			}
		}
		return !0;
	}) || d && !d(r)) return;
	if (!p) {
		if (m) p = () => ({ type: s });
		else if (h) p = () => ({ [s]: !0 });
		else return;
	}
	let g = p(r, {}) ?? {};
	if (Object.keys(g).length !== 0) {
		if (ZT(e, t).forEach((e) => {
			var t;
			let n = ((t = e.deserializeHtml)?.getNode)?.call(t, r, g);
			n && (g = Q(Q({}, g), n));
		}), c) {
			let e = {}, t = r.getAttributeNames();
			for (let n of t) c.includes(n) && (e[n] = r.getAttribute(n));
			Object.keys(e).length > 0 && (g.attributes = e);
		}
		return ET(Q({}, i), { node: g });
	}
}, tD = (e, t) => {
	let n;
	return [...e.plugins].reverse().some((r) => (n = eD(e, r, { element: t }), !!n)), n;
}, nD = (e, t) => {
	let n = tD(e, t);
	if (n) {
		let { node: r, withoutChildren: i } = n, a = r.children ?? ZE(e, t);
		return (a.length === 0 || i) && (a = [{ text: "" }]), db("element", r, a);
	}
}, rD = (e, t) => {
	let n = {};
	return [...e.plugins].reverse().forEach((r) => {
		let i = eD(e, r, {
			deserializeLeaf: !0,
			element: t
		});
		i && (n = Q(Q({}, n), i.node));
	}), n;
}, iD = (e, t) => {
	let n = rD(e, t);
	return ZE(e, t).reduce((e, t) => {
		if (!t) return e;
		if (c_(t)) Object.keys(n).length > 0 && uE({
			node: t,
			query: { filter: ([e]) => y_(e) },
			source: n
		}), e.push(t);
		else {
			let r = Q({}, n);
			y_(t) && t.text && Object.keys(r).forEach((e) => {
				r[e] && t[e] && (r[e] = t[e]);
			}), e.push(db("text", r, t));
		}
		return e;
	}, []);
}, aD = (e) => {
	if (BE(e)) return e.textContent || "";
}, oD = (e) => (t) => aD(t) || (RE(t) ? $E(t) || QE(e, t) || nD(e, t) || iD(e, t) : null), sD = (e, t) => oD(e)(t), cD = (e) => {
	let t = document.createElement("body");
	return t.innerHTML = e, t;
}, lD = (e, { collapseWhiteSpace: t = !0, element: n }) => (typeof n == "string" && (n = cD(n)), t && (n = XE(n)), vE(e, { descendants: sD(e, n) })), uD = (e) => new DOMParser().parseFromString(e, "text/html"), dD = UT({
	key: "deserializeHtml",
	then: (e) => ({ editor: { insertData: {
		format: "text/html",
		getFragment: ({ data: t }) => lD(e, { element: uD(t).body })
	} } })
}), fD = UT({
	key: "react",
	withOverrides: (e) => {
		let t = iw(e), { reset: n } = t;
		return t.reset = () => {
			let t = lw(e);
			n(), t && uw(e, { edge: "start" });
		}, t;
	}
}), pD = (e, { disableCorePlugins: t, maxLength: n, plugins: r = [] }) => {
	let i = [];
	if (t !== !0) {
		let r = t;
		typeof r == "object" && r?.react || i.push(e?.pluginsByKey?.react ?? fD()), typeof r == "object" && r?.history || i.push(e?.pluginsByKey?.history ?? YT()), typeof r == "object" && r?.nodeFactory || i.push(e?.pluginsByKey?.nodeFactory ?? jE()), typeof r == "object" && r?.eventEditor || i.push(e?.pluginsByKey?.["event-editor"] ?? FE()), typeof r == "object" && r?.inlineVoid || i.push(e?.pluginsByKey?.["inline-void"] ?? XT()), typeof r == "object" && r?.insertData || i.push(e?.pluginsByKey?.insertData ?? nE()), typeof r == "object" && r?.selection || i.push(e?.pluginsByKey?.prevSelection ?? ME()), (typeof r != "object" || !r?.length) && Iv(n) && i.push(e?.pluginsByKey?.length ?? rE({ options: { maxLength: n } })), typeof r == "object" && r?.deserializeHtml || i.push(e?.pluginsByKey?.deserializeHtml ?? dD()), typeof r == "object" && r?.deserializeAst || i.push(e?.pluginsByKey?.deserializeAst ?? WT()), typeof r == "object" && r?.editorProtocol || i.push(e?.pluginsByKey?.editorProtocol ?? JT());
	}
	i = [...i, ...r], e.plugins = [], e.pluginsByKey = {}, sE(e, i), e.plugins.forEach((t) => {
		if (t.overrideByKey) {
			let n = e.plugins.map((e) => IT(e, t.overrideByKey));
			e.plugins = [], e.pluginsByKey = {}, sE(e, n);
		}
	});
}, mD = (e) => () => {
	console.warn(`editor.${e} should have been overriden but was not. Please report this issue here: https://github.com/udecode/plate/issues`);
}, hD = (e, { disableCorePlugins: t, id: n, maxLength: r, plugins: i = [] } = {}) => {
	let a = e;
	return a.id = n ?? a.id, a.prevSelection = null, a.isFallback = !1, a.currentKeyboardEvent = null, a.reset = () => zT(a), a.redecorate = () => mD("redecorate"), a.plate = { get set() {
		return null;
	} }, a.key || (a.key = Math.random()), pD(a, {
		disableCorePlugins: t,
		maxLength: r,
		plugins: i
	}), a.plugins.forEach((e) => {
		e.withOverrides && (a = e.withOverrides(a, e));
	}), a;
}, gD = (e = {}) => {
	var t = e, { components: n, editor: r = i_(), normalizeInitialValue: i, overrideByKey: a, plugins: o = [] } = t, s = DT(t, [
		"components",
		"editor",
		"normalizeInitialValue",
		"overrideByKey",
		"plugins"
	]);
	o = LT(o, {
		components: n,
		overrideByKey: a
	});
	let c = hD(r, Q({ plugins: o }, s));
	return i && G_(c, { force: !0 }), c;
}, _D = (e = {}) => {
	let t = gD(e);
	return t.isFallback = !0, t.apply = () => {
		throw Error("Cannot apply operations on the fallback editor. The fallback editor is used when a hook that depends on the Plate store was unable to locate a valid store. If you are using PlateController, use `useEditorMounted(id?: PlateId)` or `!editor.isFallback` to ensure that a valid Plate store is available before attempting to call operations on the editor.");
	}, t;
}, vD = (e) => (t, n, { composing: r } = {}) => !(!kE(e)(n) || !!r !== cw(t)), yD = ET(Q({}, AE), {
	isTab: vD("tab"),
	isUntab: vD("untab")
}), bD = (e, { component: t, dangerouslyAllowAttributes: n, key: r, props: i, type: a }) => function(o) {
	let { children: s, element: c } = o;
	if (c.type === a) {
		let l = t ?? hC, u = e.plugins.flatMap((e) => e.inject?.aboveComponent ?? []), d = e.plugins.flatMap((e) => e.inject?.belowComponent ?? []);
		o = lE({
			attributes: c.attributes,
			dangerouslyAllowAttributes: n,
			nodeProps: o,
			props: i,
			type: a
		});
		let f = s;
		d.forEach((e) => {
			let t = e(ET(Q({}, o), { key: r }));
			t && (f = t(ET(Q({}, o), { children: f })));
		});
		let p = /* @__PURE__ */ N.createElement(l, Q({}, o), f);
		return u.forEach((e) => {
			let t = e(ET(Q({}, o), { key: r }));
			t && (p = t(ET(Q({}, o), { children: p })));
		}), /* @__PURE__ */ N.createElement(AT, {
			element: c,
			scope: r
		}, p);
	}
}, xD = (e, t) => {
	let n = [];
	return e.plugins.forEach((t) => {
		t.isElement && n.push(bD(e, t));
	}), function(r) {
		let i = wE(e, r), a;
		return n.some((e) => (a = e(i), !!a)), a || (t ? t(i) : /* @__PURE__ */ N.createElement(hC, Q({}, i)));
	};
};
function SD(e) {
	var t = e, { attributes: n, children: r, editor: i, leaf: a, nodeProps: o, text: s } = t, c = DT(t, [
		"attributes",
		"children",
		"editor",
		"leaf",
		"nodeProps",
		"text"
	]);
	return /* @__PURE__ */ N.createElement("span", Q(Q({}, n), c), r);
}
var CD = /* @__PURE__ */ "onCopy.onCopyCapture.onCut.onCutCapture.onPaste.onPasteCapture.onCompositionEnd.onCompositionEndCapture.onCompositionStart.onCompositionStartCapture.onCompositionUpdate.onCompositionUpdateCapture.onFocus.onFocusCapture.onBlur.onBlurCapture.onDOMBeforeInput.onBeforeInput.onBeforeInputCapture.onInput.onInputCapture.onReset.onResetCapture.onSubmit.onSubmitCapture.onInvalid.onInvalidCapture.onLoad.onLoadCapture.onKeyDown.onKeyDownCapture.onKeyPress.onKeyPressCapture.onKeyUp.onKeyUpCapture.onAbort.onAbortCapture.onCanPlay.onCanPlayCapture.onCanPlayThrough.onCanPlayThroughCapture.onDurationChange.onDurationChangeCapture.onEmptied.onEmptiedCapture.onEncrypted.onEncryptedCapture.onEnded.onEndedCapture.onLoadedData.onLoadedDataCapture.onLoadedMetadata.onLoadedMetadataCapture.onLoadStart.onLoadStartCapture.onPause.onPauseCapture.onPlay.onPlayCapture.onPlaying.onPlayingCapture.onProgress.onProgressCapture.onRateChange.onRateChangeCapture.onSeeked.onSeekedCapture.onSeeking.onSeekingCapture.onStalled.onStalledCapture.onSuspend.onSuspendCapture.onTimeUpdate.onTimeUpdateCapture.onVolumeChange.onVolumeChangeCapture.onWaiting.onWaitingCapture.onAuxClick.onAuxClickCapture.onClick.onClickCapture.onContextMenu.onContextMenuCapture.onDoubleClick.onDoubleClickCapture.onDrag.onDragCapture.onDragEnd.onDragEndCapture.onDragEnter.onDragEnterCapture.onDragExit.onDragExitCapture.onDragLeave.onDragLeaveCapture.onDragOver.onDragOverCapture.onDragStart.onDragStartCapture.onDrop.onDropCapture.onMouseDown.onMouseDownCapture.onMouseEnter.onMouseLeave.onMouseMove.onMouseMoveCapture.onMouseOut.onMouseOutCapture.onMouseOver.onMouseOverCapture.onMouseUp.onMouseUpCapture.onSelect.onSelectCapture.onTouchCancel.onTouchCancelCapture.onTouchEnd.onTouchEndCapture.onTouchMove.onTouchMoveCapture.onTouchStart.onTouchStartCapture.onPointerDown.onPointerDownCapture.onPointerMove.onPointerUp.onPointerUpCapture.onPointerCancel.onPointerCancelCapture.onPointerEnter.onPointerLeave.onPointerOver.onPointerOverCapture.onPointerOut.onPointerOutCapture.onGotPointerCapture.onGotPointerCaptureCapture.onLostPointerCapture.onLostPointerCaptureCapture.onScroll.onScrollCapture.onWheel.onWheelCapture.onAnimationStart.onAnimationStartCapture.onAnimationEnd.onAnimationEndCapture.onAnimationIteration.onAnimationIterationCapture.onTransitionEnd.onTransitionEndCapture".split("."), wD = (e, { component: t, dangerouslyAllowAttributes: n, key: r, props: i, type: a = r }) => function(e) {
	let { children: r, leaf: o } = e;
	if (o[a]) {
		let s = t ?? SD;
		return e = lE({
			attributes: o.attributes,
			dangerouslyAllowAttributes: n,
			nodeProps: e,
			props: i,
			type: a
		}), /* @__PURE__ */ N.createElement(s, Q({}, e), r);
	}
	return r;
}, TD = (e, t) => {
	let n = [];
	return e.plugins.forEach((t) => {
		t.isLeaf && t.key && n.push(wD(e, t));
	}), function(r) {
		let i = wE(e, r);
		return n.forEach((e) => {
			let t = e(i);
			t !== void 0 && (i.children = t);
		}), t ? t(i) : /* @__PURE__ */ N.createElement(SD, Q({}, i));
	};
}, { PlateControllerProvider: ED, plateControllerStore: DD, usePlateControllerStore: OD } = su({
	activeId: De(null),
	editorStores: De({}),
	primaryEditorIds: De([])
}, { name: "plateController" }), kD = () => OD().get, AD = () => OD().set, jD = () => !!OD().store({ warnIfNoStore: !1 }), MD = (e) => {
	let t = N.useMemo(() => De((t) => {
		let n = t(DD.atom.editorStores), r = (e) => e ? n[e] ?? null : null;
		if (e) return r(e);
		let i = [t(DD.atom.activeId), ...t(DD.atom.primaryEditorIds)];
		for (let e of i) {
			let t = r(e);
			if (t) return t;
		}
		return null;
	}), [e]);
	return kD().atom(t);
}, { PlateProvider: ND, plateStore: PD, usePlateStore: FD } = ((e = {}) => {
	var t = e, { decorate: n = null, editor: r = _D(), editorRef: i = null, id: a, isMounted: o = !1, onChange: s = null, onSelectionChange: c = null, onValueChange: l = null, plugins: u = [], primary: d = !0, rawPlugins: f = [], readOnly: p = null, renderElement: m = null, renderLeaf: h = null, value: g = null, versionDecorate: _ = 1, versionEditor: v = 1, versionSelection: y = 1 } = t, b = DT(t, [
		"decorate",
		"editor",
		"editorRef",
		"id",
		"isMounted",
		"onChange",
		"onSelectionChange",
		"onValueChange",
		"plugins",
		"primary",
		"rawPlugins",
		"readOnly",
		"renderElement",
		"renderLeaf",
		"value",
		"versionDecorate",
		"versionEditor",
		"versionSelection"
	]);
	return su(Q({
		decorate: n,
		editor: r,
		editorRef: i,
		id: a,
		isMounted: o,
		onChange: s,
		onSelectionChange: c,
		onValueChange: l,
		plugins: u,
		primary: d,
		rawPlugins: f,
		readOnly: p,
		renderElement: m,
		renderLeaf: h,
		value: g,
		versionDecorate: _,
		versionEditor: v,
		versionSelection: y
	}, b), {
		extend: (e) => ({
			trackedEditor: De((t) => ({
				editor: t(e.editor),
				version: t(e.versionEditor)
			})),
			trackedSelection: De((t) => ({
				selection: t(e.editor).selection,
				version: t(e.versionSelection)
			}))
		}),
		name: "plate"
	});
})(), ID = (e, { debugHookName: t = "usePlateEditorStore" } = {}) => {
	let n = FD(e).store({ warnIfNoStore: !1 }) ?? null, [r] = N.useState(!!n), i = r ? n : MD(e), a = jD(), o = N.useMemo(() => ke(), []);
	if (!i) {
		if (a) return o;
		throw Error(`${t} must be used inside a Plate or PlateController`);
	}
	return i;
}, LD = (e, t) => FD({ store: ID(e, Q({ debugHookName: "usePlateSelectors" }, t)) }).get, RD = (e, t) => FD({ store: ID(e, Q({ debugHookName: "usePlateActions" }, t)) }).set, zD = () => LD(void 0, { debugHookName: "usePlateId" }).id(), BD = (e, t, n = {}) => {
	let r = N.useRef(1), i = RD(t, Q({ debugHookName: "useIncrementVersion" }, n))[e]();
	return N.useCallback(() => {
		let e = r.current + 1;
		i(e), r.current = e;
	}, [i]);
}, VD = (e, t = {}) => {
	let n = BD("versionDecorate", e, Q({ debugHookName: "useRedecorate" }, t));
	return N.useCallback(() => {
		n();
	}, [n]);
}, HD = (e, t = {}) => LD(e, Q({ debugHookName: "useEditorRef" }, t)).editor(), UD = (e, t = {}) => LD(e, Q({ debugHookName: "useEditorSelection" }, t)).trackedSelection().selection, WD = ({ id: e }) => {
	let t = HD(e), n = VD(e), r = FD(e), i = Object.fromEntries(OT.map((e) => [e, r.set[e]()])), a = N.useMemo(() => i, []);
	return N.useEffect(() => {
		t.redecorate = n, t.plate = { set: a };
	}, [
		t,
		n,
		a
	]), null;
};
function GD({ id: e, plugin: t }) {
	var n;
	let r = HD(e);
	return (n = t.useHooks) == null || n.call(t, r, t), null;
}
function KD({ id: e }) {
	let t = RD(e).isMounted(), n = LD(e).plugins(), r = HD(e), i = LD(e).editorRef();
	return N.useEffect(() => (t(!0), () => {
		t(!1);
	}), [t]), N.useEffect(() => {
		if (typeof i == "function") return i(r), () => i(null);
		if (i) return i.current = r, () => {
			i.current = null;
		};
	}, [i, r]), /* @__PURE__ */ N.createElement(N.Fragment, null, n.map((t) => /* @__PURE__ */ N.createElement(GD, {
		id: e,
		key: t.key,
		plugin: t
	})));
}
var qD = N.memo(({ id: e }) => {
	let t = CC(), n = BD("versionEditor", e);
	N.useEffect(() => {
		n();
	});
	let r = BD("versionSelection", e), i = N.useRef(t.selection), a = JD(i.current, t.selection);
	return N.useEffect(() => {
		a || r(), i.current = t.selection;
	}, [
		t.selection,
		a,
		r
	]), null;
}), JD = (e, t) => !e && !t ? !0 : !e || !t ? !1 : B.equals(e, t), YD = (e = {}) => {
	let { id: t } = e, n = HD(t), r = LD(t), i = r.versionDecorate(), a = r.readOnly(), o = r.decorate(), s = r.renderLeaf(), c = r.renderElement(), l = N.useMemo(() => yE(n, o ?? e?.decorate), [
		e?.decorate,
		n,
		o
	]), u = N.useMemo(() => {
		if (i && l) return (e) => l(e);
	}, [l, i]), d = N.useMemo(() => xD(n, c ?? e?.renderElement), [
		e?.renderElement,
		n,
		c
	]), f = N.useMemo(() => TD(n, s ?? e?.renderLeaf), [
		e?.renderLeaf,
		n,
		s
	]), p = gw(() => {
		let t = {
			decorate: u,
			renderElement: d,
			renderLeaf: f
		};
		return Iv(a) && (t.readOnly = a), CD.forEach((r) => {
			let i = SE(n, {
				editableProps: e,
				handlerKey: r
			});
			i && (t[r] = i);
		}), t;
	}, [
		u,
		e,
		d,
		f,
		a
	]);
	return gw(() => Q(Q({}, dw(e, [
		...CD,
		"renderElement",
		"renderLeaf"
	])), p), [e, p]);
}, XD = ({ id: e }) => {
	let t = HD(e), n = LD(e).value(), r = RD(e).value(), i = LD(e).onChange(), a = LD(e).onValueChange(), o = LD(e).onSelectionChange(), s = N.useCallback((e) => {
		TE(t)(e) || i?.(e), r(e);
	}, [
		t,
		r,
		i
	]), c = N.useMemo(() => a, [a]), l = N.useMemo(() => o, [o]);
	return N.useMemo(() => ({
		editor: t,
		initialValue: n,
		key: t.key,
		onChange: s,
		onSelectionChange: l,
		onValueChange: c,
		value: n
	}), [
		t,
		s,
		l,
		c,
		n
	]);
}, ZD = ({ id: e }) => {
	let t = zD(), n = e ?? t, r = N.useMemo(() => gT(DD.atom.editorStores, (e) => e.prop(n)), [n]), i = AD().atom(r, { warnIfNoStore: !1 }), a = FD(n).store(), o = LD(n).primary(), s = AD().primaryEditorIds({ warnIfNoStore: !1 }), c = JC(), l = AD().activeId({ warnIfNoStore: !1 });
	return N.useEffect(() => (i(a ?? null), () => {
		i(null), l((e) => e === n ? null : e);
	}), [
		a,
		i,
		l,
		n
	]), N.useEffect(() => {
		if (o) return s((e) => [...e, n]), () => {
			s((e) => e.filter((e) => e !== n));
		};
	}, [
		n,
		o,
		s
	]), N.useEffect(() => {
		n && c && l(n);
	}, [
		n,
		c,
		l
	]), null;
};
function QD({ children: e, id: t }) {
	var n;
	let r = XD({ id: t }), i = HD(t), a = /* @__PURE__ */ N.createElement(QC, Q({}, r), e);
	return (n = i.plugins) == null || n.forEach((e) => {
		let { renderAboveSlate: t } = e;
		t && (a = /* @__PURE__ */ N.createElement(t, null, a));
	}), a;
}
var $D = N.forwardRef((e, t) => {
	var n = e, { renderEditable: r } = n, i = DT(n, ["renderEditable"]);
	let { id: a } = i, o = HD(a);
	if (!o) throw Error("Editor not found. Please ensure that PlateContent is rendered below Plate.");
	let s = YD(i), c = /* @__PURE__ */ N.createElement(BC, Q({ ref: t }, s)), l = null, u = null;
	o.plugins.forEach((e) => {
		let { renderAfterEditable: t, renderBeforeEditable: n } = e;
		t && (l = /* @__PURE__ */ N.createElement(N.Fragment, null, l, /* @__PURE__ */ N.createElement(t, Q({}, s)))), n && (u = /* @__PURE__ */ N.createElement(N.Fragment, null, u, /* @__PURE__ */ N.createElement(n, Q({}, s))));
	});
	let d = /* @__PURE__ */ N.createElement(N.Fragment, null, u, r ? r(c) : c, /* @__PURE__ */ N.createElement(WD, { id: a }), /* @__PURE__ */ N.createElement(qD, { id: a }), /* @__PURE__ */ N.createElement(KD, { id: a }), /* @__PURE__ */ N.createElement(ZD, { id: a }), l);
	return o.plugins.forEach((e) => {
		let { renderAboveEditable: t } = e;
		t && (d = /* @__PURE__ */ N.createElement(t, null, d));
	}), /* @__PURE__ */ N.createElement(QD, { id: a }, d);
});
$D.displayName = "PlateContent";
// ../../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var eO = Object.defineProperty, tO = (e, t) => eO(e, "name", {
	value: t,
	configurable: !0
});
function nO(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
tO(nO, "setRef");
function rO(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = nO(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : nO(e[t], null);
			}
		};
	};
}
tO(rO, "composeRefs");
function iO(...e) {
	return oe.useCallback(rO(...e), e);
}
tO(iO, "useComposedRefs");
// ../../../node_modules/@radix-ui/react-slot/dist/index.mjs
var aO = Object.defineProperty, oO = (e, t) => aO(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function sO(e) {
	let t = oe.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		gO(r) && typeof bO == "function" && (r = bO(r._payload)), oe.Children.forEach(r, (e) => {
			if (mO(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				gO(n) && typeof bO == "function" && (n = bO(n._payload)), a = dO(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = oe.cloneElement(a, void 0, s) : !o && oe.Children.count(r) === 1 && oe.isValidElement(r) && (a = r);
		let c = a ? pO(a) : void 0, l = iO(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? yO(e) : vO(e));
			return r;
		}
		let u = fO(i, a.props ?? {});
		return a.type !== oe.Fragment && (u.ref = n ? l : c), oe.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
oO(sO, "createSlot");
var cO = /* @__PURE__ */ sO("Slot"), lO = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function uO(e) {
	let t = /* @__PURE__ */ oO((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = lO, t;
}
oO(uO, "createSlottable");
var dO = /* @__PURE__ */ oO((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return oe.isValidElement(t) ? oe.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return oe.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function fO(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
oO(fO, "mergeProps");
function pO(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
oO(pO, "getElementRef");
function mO(e) {
	return oe.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === lO;
}
oO(mO, "isSlottable");
var hO = Symbol.for("react.lazy");
function gO(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === hO && "_payload" in e && _O(e._payload);
}
oO(gO, "isLazyComponent");
function _O(e) {
	return typeof e == "object" && !!e && "then" in e;
}
oO(_O, "isPromiseLike");
var vO = /* @__PURE__ */ oO((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), yO = /* @__PURE__ */ oO((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), bO = oe.use;
// ../../../node_modules/@udecode/react-utils/node_modules/clsx/dist/clsx.m.js
function xO(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = xO(e[t])) && (r && (r += " "), r += n);
		else for (t in e) e[t] && (r && (r += " "), r += t);
	}
	return r;
}
function SO() {
	for (var e, t, n = 0, r = ""; n < arguments.length;) (e = arguments[n++]) && (t = xO(e)) && (r && (r += " "), r += t);
	return r;
}
// ../../../node_modules/@udecode/react-utils/dist/index.mjs
var CO = Object.defineProperty, wO = Object.defineProperties, TO = Object.getOwnPropertyDescriptors, EO = Object.getOwnPropertySymbols, DO = Object.prototype.hasOwnProperty, OO = Object.prototype.propertyIsEnumerable, kO = (e, t, n) => t in e ? CO(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, AO = (e, t) => {
	for (var n in t ||= {}) DO.call(t, n) && kO(e, n, t[n]);
	if (EO) for (var n of EO(t)) OO.call(t, n) && kO(e, n, t[n]);
	return e;
}, jO = (e, t) => wO(e, TO(t)), MO = (e, t) => {
	var n = {};
	for (var r in e) DO.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && EO) for (var r of EO(e)) t.indexOf(r) < 0 && OO.call(e, r) && (n[r] = e[r]);
	return n;
}, NO = (e) => N.forwardRef((t, n) => {
	var r = t, { as: i, asChild: a = !1 } = r, o = MO(r, ["as", "asChild"]);
	let s = a ? cO : i || e;
	return /* @__PURE__ */ N.createElement(s, AO({ ref: n }, o));
}), PO = NO("div"), FO = NO("span"), IO = (e, t) => {
	typeof e == "function" ? e(t) : e != null && (e.current = t);
}, LO = (...e) => (t) => e.forEach((e) => IO(e, t)), RO = (...e) => N.useCallback(LO(...e), e), zO = (e) => {
	let t = NO(e);
	return ({ propsHook: e, stateHook: n } = {}) => N.forwardRef((r, i) => {
		var a = r, { asChild: o, className: s, getClassName: c, options: l, state: u } = a, d = MO(a, [
			"asChild",
			"className",
			"getClassName",
			"options",
			"state"
		]);
		let f = Iv(u) ? u : n ? n(l) : void 0, { hidden: p, props: m, ref: h } = e ? e(f) : {
			hidden: !1,
			props: {},
			ref: null
		}, g = RO(i, h), _ = Iv(m?.className) || Iv(s) ? SO(m?.className, s) : void 0, v = m?.style || d.style ? AO(AO({}, m?.style), d.style) : void 0;
		return !o && p ? null : /* @__PURE__ */ N.createElement(t, AO(AO(jO(AO({
			asChild: o,
			ref: g
		}, m), {
			className: _,
			style: v
		}), d), d.setProps?.call(d, m ?? {}) ?? {}));
	});
};
typeof window < "u" && window.document?.createElement !== void 0 ? N.useLayoutEffect : N.useEffect;
// ../../../node_modules/@udecode/plate-utils/node_modules/clsx/dist/clsx.m.js
function BO(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = BO(e[t])) && (r && (r += " "), r += n);
		else for (t in e) e[t] && (r && (r += " "), r += t);
	}
	return r;
}
function VO() {
	for (var e, t, n = 0, r = ""; n < arguments.length;) (e = arguments[n++]) && (t = BO(e)) && (r && (r += " "), r += t);
	return r;
}
// ../../../node_modules/@udecode/plate-core/dist/server.mjs
var HO = Object.defineProperty, UO = Object.defineProperties, WO = Object.getOwnPropertyDescriptors, GO = Object.getOwnPropertySymbols, KO = Object.prototype.hasOwnProperty, qO = Object.prototype.propertyIsEnumerable, JO = (e, t, n) => t in e ? HO(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, YO = (e, t) => {
	for (var n in t ||= {}) KO.call(t, n) && JO(e, n, t[n]);
	if (GO) for (var n of GO(t)) qO.call(t, n) && JO(e, n, t[n]);
	return e;
}, XO = (e, t) => UO(e, WO(t)), ZO = (e, t) => {
	var n = {};
	for (var r in e) KO.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && GO) for (var r of GO(e)) t.indexOf(r) < 0 && qO.call(e, r) && (n[r] = e[r]);
	return n;
}, QO = (e, t = {}, n = !1) => {
	if (t[e.key]) {
		let r = t[e.key], { plugins: i, then: a } = r;
		e = Sv(ZO(r, ["plugins", "then"]), e), n || i?.forEach((t) => {
			e.plugins || (e.plugins = []), e.plugins.find((e) => e.key === t.key) || e.plugins.push(t);
		});
	}
	e.plugins && (e.plugins = e.plugins.map((e) => QO(e, t, !0)));
	let { then: r } = e;
	return r ? (e._thenReplaced === void 0 && (e._thenReplaced = 0), e._thenReplaced < 3 && (e.then = (n, i) => {
		let a = YO({ key: e.key }, r(n, i));
		return Sv(QO(a, t), a);
	}, e._thenReplaced++)) : t[e.key]?.then && (e.then = t[e.key].then), e;
}, $O = (e) => e?.pluginsByKey ?? {}, ek = (e, t) => $O(e)[t] ?? { key: t }, $ = (e, t) => ek(e, t).type ?? t ?? "", tk = (e, t, n) => {
	let { activeType: r, inactiveType: i = $(e, "p") } = t, a = n?.at ?? e.selection;
	if (!r || !a) return;
	let o = yv(e, XO(YO({}, n), { match: { type: r } }));
	o && r === i || bv(e, { type: o ? i : r }, { at: a });
}, nk = (e) => (t, n = {}) => (n[e.key] = t, QO(YO({}, e), n)), rk = (e, t) => {
	let n = [];
	return [...e.plugins].reverse().forEach((e) => {
		let r = e.inject.pluginsByKey?.[t.key];
		r && n.push(r);
	}), [t, ...n];
}, ik = (e, { data: t, dataTransfer: n }) => e.every((e) => {
	let r = e.editor?.insertData?.query;
	return !r || r({
		data: t,
		dataTransfer: n
	});
}), ak = ({ apply: e, node: t, path: n = [], query: r, source: i }) => {
	lv([t, n], r) && (i instanceof Function ? e(t, i()) : e(t, i)), rv(t) && t.children.forEach((t, a) => {
		ak({
			apply: e,
			node: t,
			path: n.concat([a]),
			query: r,
			source: i
		});
	});
}, ok = (e, t) => ek(e, t).options ?? {}, sk = (e, t) => t.map((t) => $(e, t)), ck = (e) => {
	ak(XO(YO({}, e), { apply: Oy }));
}, lk = (e) => YO({
	editor: {},
	inject: {},
	key: "",
	options: {},
	type: ""
}, e), uk = {
	bold: "mod+b",
	compose: [
		"down",
		"left",
		"right",
		"up",
		"backspace",
		"enter"
	],
	deleteBackward: "shift?+backspace",
	deleteForward: "shift?+delete",
	extendBackward: "shift+left",
	extendForward: "shift+right",
	insertSoftBreak: "shift+enter",
	italic: "mod+i",
	moveBackward: "left",
	moveForward: "right",
	moveWordBackward: "ctrl+left",
	moveWordForward: "ctrl+right",
	splitBlock: "enter",
	tab: "tab",
	undo: "mod+z",
	untab: "shift+tab"
}, dk = {
	deleteBackward: ["ctrl+backspace", "ctrl+h"],
	deleteForward: ["ctrl+delete", "ctrl+d"],
	deleteLineBackward: "cmd+shift?+backspace",
	deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
	deleteWordBackward: "opt+shift?+backspace",
	deleteWordForward: "opt+shift?+delete",
	extendLineBackward: "opt+shift+up",
	extendLineForward: "opt+shift+down",
	moveLineBackward: "opt+up",
	moveLineForward: "opt+down",
	moveWordBackward: "opt+left",
	moveWordForward: "opt+right",
	redo: "cmd+shift+z",
	transposeCharacter: "ctrl+t"
}, fk = {
	deleteWordBackward: "ctrl+shift?+backspace",
	deleteWordForward: "ctrl+shift?+delete",
	redo: ["ctrl+y", "ctrl+shift+z"]
}, pk = (e) => {
	let t = uk[e], n = dk[e], r = fk[e], i = t && (0, vT.isKeyHotkey)(t), a = n && (0, vT.isKeyHotkey)(n), o = r && (0, vT.isKeyHotkey)(r);
	return (e) => !!(i?.(e) || Tv && a?.(e) || !Tv && o?.(e));
};
pk("bold"), pk("compose"), pk("deleteBackward"), pk("deleteForward"), pk("deleteLineBackward"), pk("deleteLineForward"), pk("deleteWordBackward"), pk("deleteWordForward"), pk("extendBackward"), pk("extendForward"), pk("extendLineBackward"), pk("extendLineForward"), pk("italic"), pk("moveBackward"), pk("moveForward"), pk("moveLineBackward"), pk("moveLineForward"), pk("moveWordBackward"), pk("moveWordForward"), pk("redo"), pk("insertSoftBreak"), pk("splitBlock"), pk("transposeCharacter"), pk("undo");
var mk = Zd("event-editor")({
	blur: null,
	focus: null,
	last: null
});
mk.set, mk.get, mk.use;
var hk = (e, { shouldCollapseWhiteSpace: t = !0, trimEnd: n = "collapse", trimStart: r = "collapse", whiteSpaceIncludesNewlines: i = !0 } = {}) => (r === "all" && (e = e.replace(/^\s+/, "")), n === "single-newline" && (e = e.replace(/\n$/, "")), t && (i ? e = e.replaceAll(/\s+/g, " ") : (e = e.replaceAll(/[^\S\n\r]+/g, " "), e = e.replaceAll(/^[^\S\n\r]+/gm, ""), e = e.replaceAll(/[^\S\n\r]+$/gm, ""))), e), gk = /* @__PURE__ */ new Set(/* @__PURE__ */ "A.ABBR.B.BDI.BDO.BR.CITE.CODE.DATA.DFN.EM.I.KBD.MARK.Q.S.SAMP.SMALL.SPAN.STRONG.SUB.SUP.TIME.U.VAR.WBR.IMG.MAP.TRACK.VIDEO.EMBED.IFRAME.OBJECT.PICTURE.PORTAL.SOURCE.svg.math.CANVAS.DEL.INS.BUTTON.INPUT.LABEL.METER.OUTPUT.PROGRESS.SELECT.TEXTAREA.ACRONYM.BIG.CONTENT.FONT.IMG.MARQUEE.MENUITEM.NOBR.SHADOW.STRIKE.TT".split(".")), _k = (e) => e.nodeType === Node.ELEMENT_NODE, vk = (e) => {
	if (!_k(e)) return !1;
	let t = e, n = gk.has(t.tagName), r = t.style.display.split(" ")[0];
	return r === "" ? n : r.startsWith("inline") ? !0 : r === "inherit" && t.parentElement ? vk(t.parentElement) : [
		"contents",
		"initial",
		"none",
		"revert",
		"revert-layer",
		"unset"
	].includes(r) ? n : !1;
}, yk = (e) => e.nodeType === Node.TEXT_NODE, bk = (e) => _k(e) ? !vk(e) : !1, xk = (e) => {
	let t = e;
	for (;;) {
		if (t.nextSibling) t = t.nextSibling;
		else {
			if (t = t.parentElement, t && bk(t)) return !0;
			t = t?.nextSibling || null;
		}
		if (!t || bk(t)) return !0;
		if ((t.textContent || "").length > 0) return !1;
	}
}, Sk = (e) => {
	e.inlineFormattingContext ? e.inlineFormattingContext.atStart = !1 : e.inlineFormattingContext = {
		atStart: !0,
		lastHasTrailingWhiteSpace: !1
	};
}, Ck = (e) => {
	e.inlineFormattingContext = null;
}, wk = (e, t) => {
	let n = e.textContent || "", r = n.trim() === "";
	(t.inlineFormattingContext || !r) && Sk(t);
	let { whiteSpaceRule: i } = t, a = i === "normal" && (!t.inlineFormattingContext || t.inlineFormattingContext.atStart || t.inlineFormattingContext.lastHasTrailingWhiteSpace) ? "all" : "collapse", o = i === "normal" ? "collapse" : xk(e) ? "single-newline" : "collapse", s = {
		normal: !0,
		pre: !1,
		"pre-line": !0
	}[i], c = hk(n || "", {
		shouldCollapseWhiteSpace: s,
		trimEnd: o,
		trimStart: a,
		whiteSpaceIncludesNewlines: i !== "pre-line"
	});
	t.inlineFormattingContext && s && (t.inlineFormattingContext.lastHasTrailingWhiteSpace = c.endsWith(" ")), e.textContent = c;
}, Tk = (e, t) => {
	_k(e) ? Ok(e, t) : yk(e) ? wk(e, t) : Ek(e, t);
}, Ek = (e, t) => {
	let n = Array.from(e.childNodes);
	for (let e of n) Tk(e, t);
}, Dk = (e) => {
	let t = e.style.whiteSpace;
	switch (t) {
		case "normal":
		case "nowrap": return "normal";
		case "pre":
		case "pre-wrap":
		case "break-spaces": return "pre";
		case "pre-line": return "pre-line";
	}
	return e.tagName === "PRE" ? "pre" : t === "initial" ? "normal" : null;
}, Ok = (e, t) => {
	let n = vk(e), r = t.whiteSpaceRule, i = Dk(e);
	i && (t.whiteSpaceRule = i), n || Ck(t), Ek(e, t), n || Ck(t), t.whiteSpaceRule = r;
}, kk = (e, t) => Array.from(t.childNodes).flatMap(Rk(e)), Ak = (e, t) => {
	if (t.nodeName === "BODY") return db("fragment", {}, kk(e, t));
}, jk = (e) => {
	if (e.nodeName === "BR") return "\n";
}, Mk = (e, t, { deserializeLeaf: n, element: r }) => {
	let { deserializeHtml: i, isElement: a, isLeaf: o, type: s } = t;
	if (!i) return;
	let { attributeNames: c, isElement: l, isLeaf: u, query: d, rules: f } = i, { getNode: p } = i, m = l || a, h = u || o;
	if (!n && !m || n && !h || f && !f.some(({ validAttribute: e, validClassName: n, validNodeName: i = "*", validStyle: a }) => {
		if (i) {
			let e = Cv(i);
			if (e.length > 0 && !e.includes(r.nodeName) && i !== "*") return !1;
		}
		if (n && !r.classList.contains(n)) return !1;
		if (a) for (let [e, n] of Object.entries(a)) {
			if (!Cv(n).includes(r.style[e]) && n !== "*" || n === "*" && !r.style[e]) return;
			let i = t.inject.props?.defaultNodeValue;
			if (i && i === r.style[e]) return !1;
		}
		if (e) {
			if (typeof e == "string") {
				if (!r.getAttributeNames().includes(e)) return !1;
			} else for (let [t, n] of Object.entries(e)) {
				let e = Cv(n), i = r.getAttribute(t);
				if (!Iv(i) || !e.includes(i)) return !1;
			}
		}
		return !0;
	}) || d && !d(r)) return;
	if (!p) {
		if (m) p = () => ({ type: s });
		else if (h) p = () => ({ [s]: !0 });
		else return;
	}
	let g = p(r, {}) ?? {};
	if (Object.keys(g).length !== 0) {
		if (rk(e, t).forEach((e) => {
			var t;
			let n = ((t = e.deserializeHtml)?.getNode)?.call(t, r, g);
			n && (g = YO(YO({}, g), n));
		}), c) {
			let e = {}, t = r.getAttributeNames();
			for (let n of t) c.includes(n) && (e[n] = r.getAttribute(n));
			Object.keys(e).length > 0 && (g.attributes = e);
		}
		return XO(YO({}, i), { node: g });
	}
}, Nk = (e, t) => {
	let n;
	return [...e.plugins].reverse().some((r) => (n = Mk(e, r, { element: t }), !!n)), n;
}, Pk = (e, t) => {
	let n = Nk(e, t);
	if (n) {
		let { node: r, withoutChildren: i } = n, a = r.children ?? kk(e, t);
		return (a.length === 0 || i) && (a = [{ text: "" }]), db("element", r, a);
	}
}, Fk = (e, t) => {
	let n = {};
	return [...e.plugins].reverse().forEach((r) => {
		let i = Mk(e, r, {
			deserializeLeaf: !0,
			element: t
		});
		i && (n = YO(YO({}, n), i.node));
	}), n;
}, Ik = (e, t) => {
	let n = Fk(e, t);
	return kk(e, t).reduce((e, t) => {
		if (!t) return e;
		if (c_(t)) Object.keys(n).length > 0 && ck({
			node: t,
			query: { filter: ([e]) => y_(e) },
			source: n
		}), e.push(t);
		else {
			let r = YO({}, n);
			y_(t) && t.text && Object.keys(r).forEach((e) => {
				r[e] && t[e] && (r[e] = t[e]);
			}), e.push(db("text", r, t));
		}
		return e;
	}, []);
}, Lk = (e) => {
	if (yk(e)) return e.textContent || "";
}, Rk = (e) => (t) => Lk(t) || (_k(t) ? jk(t) || Ak(e, t) || Pk(e, t) || Ik(e, t) : null), zk = "deserializeHtml", Bk = (e, t) => {
	if (!t(e)) return;
	let n = e.firstChild;
	for (; n;) {
		let r = n, i = n.previousSibling;
		n = n.nextSibling, Bk(r, t), !r.previousSibling && !r.nextSibling && !r.parentNode && n && i !== n.previousSibling && n.parentNode ? n = i ? i.nextSibling : e.firstChild : r.previousSibling || r.nextSibling || r.parentNode || !n || n.previousSibling || n.nextSibling || n.parentNode || (i ? n = i.nextSibling ? i.nextSibling.nextSibling : null : e.firstChild && (n = e.firstChild.nextSibling));
	}
}, Vk = (e, t) => {
	Bk(e, (e) => !_k(e) || t(e));
}, Hk = (e, t) => {
	let n = null;
	return Vk(e, (e) => !t(e) || (n = e, !1)), n;
}, Uk = (e, t) => !!Hk(e, t), Wk = qe, Gk = Object.defineProperty, Kk = Object.defineProperties, qk = Object.getOwnPropertyDescriptors, Jk = Object.getOwnPropertySymbols, Yk = Object.prototype.hasOwnProperty, Xk = Object.prototype.propertyIsEnumerable, Zk = (e, t, n) => t in e ? Gk(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Qk = (e, t) => {
	for (var n in t ||= {}) Yk.call(t, n) && Zk(e, n, t[n]);
	if (Jk) for (var n of Jk(t)) Xk.call(t, n) && Zk(e, n, t[n]);
	return e;
}, $k = (e, t) => Kk(e, qk(t)), eA = (e, t) => {
	var n = {};
	for (var r in e) Yk.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && Jk) for (var r of Jk(e)) t.indexOf(r) < 0 && Xk.call(e, r) && (n[r] = e[r]);
	return n;
}, tA = (e) => {
	let t = e, { attributes: n, editor: r, element: i, elementToAttributes: a, nodeProps: o } = t, s = eA(t, [
		"attributes",
		"editor",
		"element",
		"elementToAttributes",
		"nodeProps"
	]);
	return {
		props: $k(Qk(Qk(Qk(Qk({}, n), s), o), a?.(i)), { className: VO(e.className, o?.className) }),
		ref: RO(e.ref, n.ref)
	};
}, nA = N.forwardRef((e, t) => {
	let { props: n, ref: r } = tA($k(Qk({}, e), { ref: t }));
	return /* @__PURE__ */ N.createElement(PO, $k(Qk({}, n), { ref: r }));
});
nA.displayName = "PlateElement";
var rA = (e) => {
	let t = e, { attributes: n, editor: r, leaf: i, leafToAttributes: a, nodeProps: o, text: s } = t, c = eA(t, [
		"attributes",
		"editor",
		"leaf",
		"leafToAttributes",
		"nodeProps",
		"text"
	]);
	return {
		props: $k(Qk(Qk(Qk(Qk({}, n), c), o), a?.(i)), { className: VO(e.className, o?.className) }),
		ref: RO(e.ref, n.ref)
	};
}, iA = N.forwardRef((e, t) => {
	let { props: n, ref: r } = rA($k(Qk({}, e), { ref: t }));
	return /* @__PURE__ */ N.createElement(FO, $k(Qk({}, n), { ref: r }));
});
iA.displayName = "PlateLeaf";
var aA = (e, t, n) => {
	let r = Cv(n), i = [];
	return r.forEach((t) => i.push($(e, t))), i.includes(t?.type);
}, oA = (e, { options: { hotkey: t }, type: n }) => (r) => {
	if (r.defaultPrevented) return;
	let i = $(e, "p");
	if (!t) return;
	let a = Cv(t);
	for (let t of a) if ((0, vT.isHotkey)(t, r)) {
		r.preventDefault(), tk(e, {
			activeType: n,
			inactiveType: i
		});
		return;
	}
}, sA = Object.defineProperty, cA = Object.defineProperties, lA = Object.getOwnPropertyDescriptors, uA = Object.getOwnPropertySymbols, dA = Object.prototype.hasOwnProperty, fA = Object.prototype.propertyIsEnumerable, pA = (e, t, n) => t in e ? sA(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, mA = (e, t) => {
	for (var n in t ||= {}) dA.call(t, n) && pA(e, n, t[n]);
	if (uA) for (var n of uA(t)) fA.call(t, n) && pA(e, n, t[n]);
	return e;
}, hA = (e, t) => cA(e, lA(t)), gA = (e, t) => {
	var n = {};
	for (var r in e) dA.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && uA) for (var r of uA(e)) t.indexOf(r) < 0 && fA.call(e, r) && (n[r] = e[r]);
	return n;
}, _A = (e) => {
	let t = e, { attributes: n, editor: r, element: i, elementToAttributes: a, nodeProps: o } = t, s = gA(t, [
		"attributes",
		"editor",
		"element",
		"elementToAttributes",
		"nodeProps"
	]);
	return {
		props: hA(mA(mA(mA(mA({}, n), s), o), a?.(i)), { className: VO(e.className, o?.className) }),
		ref: RO(e.ref, n.ref)
	};
}, vA = N.forwardRef((e, t) => {
	let { props: n, ref: r } = _A(hA(mA({}, e), { ref: t }));
	return /* @__PURE__ */ N.createElement(PO, hA(mA({}, n), { ref: r }));
});
vA.displayName = "PlateElement";
var yA = (e) => {
	let t = e, { attributes: n, editor: r, leaf: i, leafToAttributes: a, nodeProps: o, text: s } = t, c = gA(t, [
		"attributes",
		"editor",
		"leaf",
		"leafToAttributes",
		"nodeProps",
		"text"
	]);
	return {
		props: hA(mA(mA(mA(mA({}, n), c), o), a?.(i)), { className: VO(e.className, o?.className) }),
		ref: RO(e.ref, n.ref)
	};
}, bA = N.forwardRef((e, t) => {
	let { props: n, ref: r } = yA(hA(mA({}, e), { ref: t }));
	return /* @__PURE__ */ N.createElement(FO, hA(mA({}, n), { ref: r }));
});
bA.displayName = "PlateLeaf";
var xA = (e) => {
	ak(hA(mA({}, e), { apply: Wk }));
}, SA = (e, { options: { hotkey: t }, type: n }) => (r) => {
	if (r.defaultPrevented) return;
	let i = $(e, "p");
	if (!t) return;
	let a = Cv(t);
	for (let t of a) if ((0, vT.isHotkey)(t, r)) {
		r.preventDefault(), tk(e, {
			activeType: n,
			inactiveType: i
		});
		return;
	}
}, CA = (e, { options: { clear: t, hotkey: n }, type: r }) => (i) => {
	i.defaultPrevented || n && (0, vT.isHotkey)(n, i) && (i.preventDefault(), Ty(e, {
		clear: t,
		key: r
	}));
}, wA = nk({
	deserializeHtml: {
		query: (e) => !Uk(e, (e) => e.style.fontWeight === "normal"),
		rules: [{ validNodeName: ["STRONG", "B"] }, { validStyle: { fontWeight: [
			"600",
			"700",
			"bold"
		] } }]
	},
	handlers: { onKeyDown: CA },
	isLeaf: !0,
	key: "bold",
	options: { hotkey: "mod+b" }
}), TA = nk({
	deserializeHtml: {
		query(e) {
			return Ev(e, "P")?.style.fontFamily !== "Consolas" && !Ev(e, "PRE");
		},
		rules: [{ validNodeName: ["CODE"] }, { validStyle: { fontFamily: "Consolas" } }]
	},
	handlers: { onKeyDown: CA },
	isLeaf: !0,
	key: "code",
	options: { hotkey: "mod+e" }
}), EA = nk({
	deserializeHtml: {
		query: (e) => !Uk(e, (e) => e.style.fontStyle === "normal"),
		rules: [{ validNodeName: ["EM", "I"] }, { validStyle: { fontStyle: "italic" } }]
	},
	handlers: { onKeyDown: CA },
	isLeaf: !0,
	key: "italic",
	options: { hotkey: "mod+i" }
}), DA = nk({
	deserializeHtml: {
		query: (e) => !Uk(e, (e) => e.style.textDecoration === "none"),
		rules: [{ validNodeName: [
			"S",
			"DEL",
			"STRIKE"
		] }, { validStyle: { textDecoration: "line-through" } }]
	},
	handlers: { onKeyDown: CA },
	isLeaf: !0,
	key: "strikethrough",
	options: { hotkey: "mod+shift+x" }
}), OA = nk({
	deserializeHtml: { rules: [{ validNodeName: ["SUB"] }, { validStyle: { verticalAlign: "sub" } }] },
	handlers: { onKeyDown: CA },
	isLeaf: !0,
	key: "subscript",
	options: {
		clear: "superscript",
		hotkey: "mod+,"
	}
}), kA = nk({
	deserializeHtml: { rules: [{ validNodeName: ["SUP"] }, { validStyle: { verticalAlign: "super" } }] },
	handlers: { onKeyDown: CA },
	isLeaf: !0,
	key: "superscript",
	options: {
		clear: "subscript",
		hotkey: "mod+."
	}
}), AA = nk({
	deserializeHtml: {
		query: (e) => !Uk(e, (e) => e.style.textDecoration === "none"),
		rules: [{ validNodeName: ["U"] }, { validStyle: { textDecoration: ["underline"] } }]
	},
	handlers: { onKeyDown: CA },
	isLeaf: !0,
	key: "underline",
	options: { hotkey: "mod+u" }
});
wA(), TA(), EA(), DA(), OA(), kA(), AA();
var jA = nk({
	deserializeHtml: { rules: [{ validNodeName: "BLOCKQUOTE" }] },
	handlers: { onKeyDown: SA },
	isElement: !0,
	key: "blockquote",
	options: { hotkey: "mod+shift+." },
	withOverrides: (e) => {
		let { shouldMergeNodesRemovePrevNode: t } = e;
		return t && (e.shouldMergeNodesRemovePrevNode = (e, n) => e[0].type !== "blockquote" && t(e, n)), e;
	}
}), MA = Object.getOwnPropertySymbols, NA = Object.prototype.hasOwnProperty, PA = Object.prototype.propertyIsEnumerable, FA = (e, t) => {
	var n = {};
	for (var r in e) NA.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && MA) for (var r of MA(e)) t.indexOf(r) < 0 && PA.call(e, r) && (n[r] = e[r]);
	return n;
}, IA = (e, { end: t, start: n }) => {
	let r = !1, i = !1, a = !1;
	return (n || t) && (r = !0, n && vy(e) && (i = !0, a = !0), t && _y(e) && (i = !0), i && av(e.selection) && e.deleteFragment()), {
		isEdge: i,
		isStart: a,
		queryEdge: r
	};
}, LA = (e, { before: t, defaultType: n = $(e, "p"), level: r = 0, query: i = {}, relative: a = !1 }) => {
	if (!e.selection) return;
	let { isEdge: o, isStart: s, queryEdge: c } = IA(e, i);
	if (s && (t = !0), c && !o) return;
	let l = B_(e, e.selection), u = a ? l.slice(0, -r) : l.slice(0, r + 1), d = t ? u : z.next(u);
	return yy(e, e.blockFactory({
		children: [{ text: "" }],
		type: n
	}), {
		at: d,
		select: !s
	}), !0;
}, RA = nk({
	handlers: { onKeyDown: (e, { options: { rules: t = [] } }) => (n) => {
		if (n.defaultPrevented) return;
		let r = Y(e);
		r && t.forEach((t) => {
			var i = t, { hotkey: a } = i, o = FA(i, ["hotkey"]);
			(0, vT.isHotkey)(a, n) && lv(r, o.query) && LA(e, o) && (n.preventDefault(), n.stopPropagation());
		});
	} },
	key: "exitBreak",
	options: { rules: [{ hotkey: "mod+enter" }, {
		before: !0,
		hotkey: "mod+shift+enter"
	}] }
}), zA = nk({
	handlers: { onKeyDown: (e, { options: { rules: t = [] } }) => (n) => {
		if (n.defaultPrevented) return;
		let r = Y(e);
		r && t.forEach(({ hotkey: t, query: i }) => {
			(0, vT.isHotkey)(t, n) && lv(r, i) && (n.preventDefault(), n.stopPropagation(), e.insertText("\n"));
		});
	} },
	key: "softBreak",
	options: { rules: [{ hotkey: "shift+enter" }] }
}), BA = nk({
	deserializeHtml: { rules: [{ validNodeName: "HR" }] },
	isElement: !0,
	isVoid: !0,
	key: "hr"
}), VA = (e, { options: { types: t } }) => {
	let n = Cv(t), { normalizeNode: r } = e;
	return e.normalizeNode = ([t, i]) => {
		c_(t) && t.type && n.includes(t.type) && $_(t) === "" ? C_(e, { at: i }) : r([t, i]);
	}, e;
}, HA = Object.defineProperty, UA = Object.defineProperties, WA = Object.getOwnPropertyDescriptors, GA = Object.getOwnPropertySymbols, KA = Object.prototype.hasOwnProperty, qA = Object.prototype.propertyIsEnumerable, JA = (e, t, n) => t in e ? HA(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, YA = (e, t) => {
	for (var n in t ||= {}) KA.call(t, n) && JA(e, n, t[n]);
	if (GA) for (var n of GA(t)) qA.call(t, n) && JA(e, n, t[n]);
	return e;
}, XA = (e, t) => UA(e, WA(t)), ZA = (e, t) => {
	var n = {};
	for (var r in e) KA.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && GA) for (var r of GA(e)) t.indexOf(r) < 0 && qA.call(e, r) && (n[r] = e[r]);
	return n;
}, QA = (e, { children: t, target: n, text: r = "", url: i }) => {
	let a = $(e, "a");
	return {
		children: t ?? [{ text: r }],
		target: n,
		type: a,
		url: i
	};
}, $A = (e) => {
	try {
		return e === decodeURIComponent(e) ? encodeURI(e) : e;
	} catch (t) {
		if (t instanceof URIError) return e;
		throw t;
	}
}, ej = (e, t) => {
	let { allowedSchemes: n, dangerouslySkipSanitization: r, defaultLinkAttributes: i } = ok(e, "a"), a = YA({}, i), o = r ? t.url : Mv(t.url, { allowedSchemes: n }) || void 0;
	return o !== void 0 && (a.href = o), "target" in t && (a.target = t.target), a;
}, tj = (e) => {
	try {
		return decodeURI(e);
	} catch (t) {
		if (t instanceof URIError) return e;
		throw t;
	}
}, nj = Zd("floatingLink")({
	isEditing: !1,
	mode: "",
	mouseDown: !1,
	newTab: !1,
	openEditorId: null,
	text: "",
	updated: !1,
	url: ""
}).extendActions((e) => ({ reset: () => {
	e.url(""), e.text(""), e.newTab(!1), e.mode(""), e.isEditing(!1);
} })).extendActions((e) => ({
	hide: () => {
		e.openEditorId(null), e.reset();
	},
	show: (t, n) => {
		e.mode(t), e.isEditing(!1), e.openEditorId(n);
	}
})).extendSelectors((e) => ({ isOpen: (t) => e.openEditorId === t })), rj = nj.set, ij = nj.get, aj = () => nj.use;
zO("input")({
	propsHook: ({ checked: e, ref: t, setChecked: n }) => ({
		props: {
			checked: e,
			onChange: N.useCallback((e) => {
				n(e.target.checked), rj.newTab(e.target.checked);
			}, [n]),
			type: "checkbox"
		},
		ref: t
	}),
	stateHook: () => {
		let e = aj().updated(), t = N.useRef(null), [n, r] = N.useState(ij.newTab());
		return N.useEffect(() => {
			t.current && e && setTimeout(() => {
				var e;
				(e = t.current) == null || e.focus();
			}, 0);
		}, [e]), {
			checked: n,
			ref: t,
			setChecked: r
		};
	}
}), zO("input")({
	propsHook: (e) => {
		let t = N.useCallback((e) => {
			let t = $A(e.target.value);
			rj.url(t);
		}, []);
		return {
			props: {
				defaultValue: ij.url(),
				onChange: t
			},
			ref: e.ref
		};
	},
	stateHook: () => {
		let e = aj().updated(), t = N.useRef(null);
		return N.useEffect(() => {
			t.current && e && setTimeout(() => {
				let e = t.current;
				e && (e.focus(), e.value = ij.url() ? tj(ij.url()) : "");
			}, 0);
		}, [e]), { ref: t };
	}
}), zO("a")({
	propsHook: ({ element: e }) => {
		let t = HD();
		return e ? { props: XA(YA({}, ej(t, e)), {
			"aria-label": "Open link in a new tab",
			onMouseOver: (e) => {
				e.stopPropagation();
			},
			target: "_blank"
		}) } : { props: {} };
	},
	stateHook: () => {
		let e = HD(), t = UD(), n = N.useMemo(() => vv(e, { match: { type: $(e, "a") } }), [e, t]);
		if (!n) return {};
		let [r] = n;
		return { element: r };
	}
});
var oj = (e, t, n) => {
	uv(e, [QA(e, t)], n);
}, sj = (e, t) => J(e, () => {
	if (t?.split) {
		if (p_(e, {
			at: e.selection?.anchor,
			match: { type: $(e, "a") }
		})) return mv(e, {
			at: e.selection?.anchor,
			match: (t) => c_(t) && t.type === $(e, "a")
		}), sj(e, { at: e.selection?.anchor }), !0;
		if (p_(e, {
			at: e.selection?.focus,
			match: { type: $(e, "a") }
		})) return mv(e, {
			at: e.selection?.focus,
			match: (t) => c_(t) && t.type === $(e, "a")
		}), sj(e, { at: e.selection?.focus }), !0;
	}
	gv(e, YA({ match: { type: $(e, "a") } }, t));
}), cj = (e, { text: t }) => {
	let n = p_(e, { match: { type: $(e, "a") } });
	if (n) {
		let [r, i] = n;
		if (t?.length && t !== F_(e, i)) {
			let n = r.children[0];
			wy(e, {
				at: i,
				insertOptions: { select: !0 },
				nodes: XA(YA({}, n), { text: t })
			});
		}
	}
}, lj = (e, t) => {
	var n = t, { target: r, url: i } = n, a = ZA(n, ["target", "url"]);
	_v(e, {
		children: [],
		target: r,
		type: $(e, "a"),
		url: i
	}, YA({ split: !0 }, a));
}, uj = (e, { insertNodesOptions: t, insertTextInLink: n, skipValidation: r = !1, target: i, text: a, url: o }) => {
	let s = e.selection;
	if (!s) return;
	let c = p_(e, {
		at: s,
		match: { type: $(e, "a") }
	});
	if (n && c) return e.insertText(o), !0;
	if (!r && !dj(e, o)) return;
	if (Iv(a) && a.length === 0 && (a = o), c) return (o !== c[0]?.url || i !== c[0]?.target) && pv(e, {
		target: i,
		url: o
	}, { at: c[1] }), cj(e, {
		target: i,
		text: a,
		url: o
	}), !0;
	let [l, u] = vv(e, {
		at: s,
		match: { type: $(e, "a") }
	}) ?? [], d = !1;
	if (u && a?.length) {
		let t = F_(e, u);
		a !== t && (d = !0);
	}
	if (av(s)) return c ? sj(e, { at: c[1] }) : sj(e, { split: !0 }), lj(e, {
		target: i,
		url: o
	}), cj(e, {
		target: i,
		text: a,
		url: o
	}), !0;
	d && C_(e, { at: u });
	let f = Q_(l ?? {}), p = e.selection?.focus.path;
	if (!p) return;
	let m = Z_(e, p);
	return a?.length || (a = o), oj(e, XA(YA({}, f), {
		children: [XA(YA({}, m), { text: a })],
		target: i,
		url: o
	}), t), !0;
}, dj = (e, t) => {
	let { allowedSchemes: n, dangerouslySkipSanitization: r, isUrl: i } = ok(e, "a");
	return !(i && !i(t) || !r && !Mv(t, {
		allowedSchemes: n,
		permitInvalid: !0
	}));
}, fj = nk({
	dangerouslyAllowAttributes: ["target"],
	isElement: !0,
	isInline: !0,
	key: "a",
	options: {
		allowedSchemes: [
			"http",
			"https",
			"mailto",
			"tel"
		],
		dangerouslySkipSanitization: !1,
		defaultLinkAttributes: {},
		isUrl: jv,
		keepSelectedTextOnPaste: !0,
		rangeBeforeOptions: {
			afterMatch: !0,
			matchString: " ",
			skipInvalid: !0
		},
		triggerFloatingLinkHotkeys: "meta+k, ctrl+k"
	},
	then: (e, { type: t }) => ({
		deserializeHtml: {
			getNode: (n) => {
				let r = n.getAttribute("href");
				if (r && dj(e, r)) return {
					target: n.getAttribute("target") || "_blank",
					type: t,
					url: r
				};
			},
			rules: [{ validNodeName: "A" }]
		},
		props: ({ element: t }) => ({ nodeProps: ej(e, t) })
	}),
	withOverrides: (e, { options: { getUrlHref: t, isUrl: n, keepSelectedTextOnPaste: r, rangeBeforeOptions: i }, type: a }) => {
		let { apply: o, insertBreak: s, insertData: c, insertText: l, normalizeNode: u } = e, d = () => {
			J(e, () => {
				let r = e.selection, a = ly(e, r, i);
				if (a ||= uy(e), !a || yv(e, {
					at: a,
					match: { type: $(e, "a") }
				})) return;
				let o = F_(e, a);
				o = t?.(o) ?? o, n(o) && (w_(e, a), uj(e, { url: o }), ov(e, { edge: "end" }));
			});
		};
		return e.insertBreak = () => {
			if (!iv(e.selection)) return s();
			d(), s();
		}, e.insertText = (t) => {
			t === " " && iv(e.selection) && d(), l(t);
		}, e.insertData = (n) => {
			let i = n.getData("text/plain"), a = t?.(i);
			if (i) {
				let t = a || i;
				if (uj(e, {
					insertTextInLink: !0,
					text: r ? void 0 : t,
					url: t
				})) return;
			}
			c(n);
		}, e.apply = (t) => {
			if (t.type === "set_selection") {
				let n = t.newProperties;
				if (n?.focus && n.anchor && iv(n)) {
					let r = p_(e, {
						at: n,
						match: { type: $(e, "a") }
					});
					if (r) {
						let [, i] = r, a;
						W_(e, n.focus, i) && (a = sy(e, i)), H_(e, n.focus, i) && (a = ny(e, i)), a && (t.newProperties = {
							anchor: a,
							focus: a
						});
					}
				}
			}
			o(t);
		}, e.normalizeNode = ([t, n]) => {
			if (t.type === $(e, "a")) {
				let t = e.selection;
				if (t && iv(t) && H_(e, t.focus, n)) {
					let t = ny(e, n);
					if (t) w_(e, t);
					else {
						let t = z.next(n);
						uv(e, { text: "" }, { at: t }), w_(e, t);
					}
				}
			}
			u([t, n]);
		}, e = VA(e, lk({ options: { types: a } })), e;
	}
}), pj = {
	key: "",
	which: 8
}, mj = (e, { options: { rules: t } }) => (n) => {
	if (n.defaultPrevented) return;
	let r;
	if (e.selection) return iv(e.selection) && t.forEach(({ defaultType: t, hotkey: i, onReset: a, predicate: o, types: s }) => {
		var c;
		i && (0, vT.isHotkey)(i, n) && o(e) && yv(e, { match: { type: s } }) && ((c = n.preventDefault) == null || c.call(n), bv(e, { type: t }), a && a(e), r = !0);
	}), r;
}, hj = Object.defineProperty, gj = Object.defineProperties, _j = Object.getOwnPropertyDescriptors, vj = Object.getOwnPropertySymbols, yj = Object.prototype.hasOwnProperty, bj = Object.prototype.propertyIsEnumerable, xj = (e, t, n) => t in e ? hj(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Sj = (e, t) => {
	for (var n in t ||= {}) yj.call(t, n) && xj(e, n, t[n]);
	if (vj) for (var n of vj(t)) bj.call(t, n) && xj(e, n, t[n]);
	return e;
}, Cj = (e, t) => gj(e, _j(t)), wj = (e, t) => g_(e, t)?.[0]?.type === $(e, "li"), Tj = (e) => $(e, "ul"), Ej = (e) => $(e, "ol"), Dj = (e) => [Ej(e), Tj(e)], Oj = (e) => $(e, "li"), kj = (e) => $(e, "lic"), Aj = (e, { diffListPath: t, liPath: n }) => {
	let r = p_(e, {
		at: n,
		match: { type: Dj(e) }
	});
	if (!r) return;
	let [i, a] = r;
	if (!t || !z.equals(a, t)) {
		if (i.children.length < 2) {
			let n = p_(e, {
				at: a,
				match: { type: $(e, "li") }
			});
			if (n) return Aj(e, {
				diffListPath: t,
				liPath: n[1]
			}) || a;
		}
		return n;
	}
}, jj = (e, { at: t = e.selection } = {}) => {
	let n = $(e, "li"), r;
	if (r = B.isRange(t) && !iv(t) ? t.focus.path : B.isRange(t) ? t.anchor.path : t, r && J_(e, r)) {
		let t = p_(e, {
			at: r,
			match: { type: n }
		});
		if (t) return {
			list: g_(e, t[1]),
			listItem: t
		};
	}
}, Mj = (e, t = e.selection) => {
	if (!t) return;
	let n = p_(e, {
		at: t,
		match: { type: [$(e, "ul"), $(e, "ol")] }
	});
	if (n) {
		let [, t] = n;
		return Mj(e, t) ?? n;
	}
}, Nj = (e, t) => t.children.some((t) => d_(t, [], { type: Dj(e) })), Pj = (e) => {
	let { selection: t } = e;
	return !t || iv(t) || !iy(e) ? !1 : yv(e, { match: { type: $(e, "li") } });
}, Fj = (e, t) => c_(t) && Dj(e).includes(t.type), Ij = (e, { list: t, listItem: n }) => {
	let r = !1, [i] = t, [, a] = n, o;
	try {
		o = z.previous(a);
	} catch {
		return;
	}
	let s = z_(e, o);
	if (s) {
		let [t, n] = s, o = t.children.find((t) => d_(t, [], { type: Dj(e) })), c = n.concat(o ? [1, o.children.length] : [1]);
		J(e, () => {
			o || _v(e, {
				children: [],
				type: i.type
			}, { at: a }), S_(e, {
				at: a,
				to: c
			}), r = !0;
		});
	}
	return r;
}, Lj = (e, { deleteFromList: t = !0, fromList: n, fromListItem: r, fromStartIndex: i, to: a, toList: o, toListIndex: s = null }) => {
	let c, l;
	return J(e, () => {
		if (r) {
			let t = qv(e, {
				at: r[1],
				match: { type: Dj(e) }
			});
			if (!t) return;
			c = t?.[1];
		} else if (n) c = n[1];
		else return;
		let u = null;
		if (a && (u = a), o) {
			if (s === null) {
				let e = Zv(o);
				u = z.next(e);
			} else u = o[1].concat([s]);
		}
		u && (l = xy(e, {
			at: c,
			fromStartIndex: i,
			to: u
		}), t && x_(e, { at: c }));
	}), l;
}, Rj = (e, { at: t } = {}) => {
	let n = () => {
		if (p_(e, { match: {
			at: t,
			type: Dj(e)
		} })) return !0;
		if (!t && e.selection) {
			let t = q_(e, e.selection.anchor.path, e.selection.focus.path);
			if (c_(t[0]) && Dj(e).includes(t[0].type)) return !0;
		}
		return !1;
	};
	J(e, () => {
		do
			Y(e, {
				at: t,
				match: { type: $(e, "lic") }
			}) && bv(e, {
				at: t,
				type: $(e, "p")
			}), gv(e, {
				at: t,
				match: { type: $(e, "li") },
				split: !0
			}), gv(e, {
				at: t,
				match: { type: [$(e, "ul"), $(e, "ol")] },
				split: !0
			});
		while (n());
	});
}, zj = (e, { list: t, listItem: n }) => {
	let r = () => {
		let [r, i] = t, [a, o] = n, s = p_(e, {
			at: i,
			match: { type: $(e, "li") }
		});
		if (!s) {
			let s;
			try {
				s = z.next(i);
			} catch {
				return;
			}
			let c = Nj(e, a), l = !Qv(t, o);
			if ((c || l) && yy(e, {
				children: [],
				type: r.type
			}, { at: s }), c) {
				let t = J_(e, s);
				if (!t) return;
				Lj(e, {
					fromListItem: n,
					toList: [t, s]
				});
			}
			if (l) {
				let n = J_(e, s);
				if (!n) return;
				Lj(e, {
					deleteFromList: !1,
					fromList: t,
					fromStartIndex: o.at(-1) + 1,
					toList: [n, s]
				});
			}
			return Rj(e, { at: o.concat(0) }), !0;
		}
		let [, c] = s, l = o.concat([1]);
		if (!Qv(t, o)) {
			Nj(e, a) || yy(e, {
				children: [],
				type: r.type
			}, { at: l });
			let t = J_(e, l);
			if (!t) return;
			Lj(e, {
				deleteFromList: !1,
				fromListItem: s,
				fromStartIndex: o.at(-1) + 1,
				toList: [t, l]
			});
		}
		return S_(e, {
			at: o,
			to: z.next(c)
		}), !0;
	}, i = !1;
	return J(e, () => {
		i = r();
	}), i;
}, Bj = (e, { list: t, listItem: n }) => {
	let [, r] = t;
	return !wj(e, r) && (zj(e, {
		list: t,
		listItem: n
	}), !0);
}, Vj = (e, { at: t = ((t) => (t = e.selection) ?? void 0)(), enableResetOnShiftTab: n, increase: r = !0 } = {}) => {
	let i = h_(e, {
		at: t,
		match: { type: $(e, "lic") }
	}), a = Array.from(i);
	if (a.length === 0) return;
	let o = [], s = [];
	a.forEach((t) => {
		let n = t[1], r = z.parent(n);
		o.some((e) => {
			let t = z.parent(e);
			return z.isAncestor(t, r);
		}) || (o.push(n), s.push(o_(e, n)));
	});
	let c = r ? s : s.reverse();
	return J(e, () => {
		let t = !1;
		return c.forEach((i) => {
			let a = i.unref();
			if (!a) return;
			let o = g_(e, a);
			if (!o) return;
			let s = g_(e, o[1]);
			if (!s) return;
			let c;
			r ? c = Ij(e, {
				list: s,
				listItem: o
			}) : wj(e, s[1]) ? c = zj(e, {
				list: s,
				listItem: o
			}) : n && (c = Bj(e, {
				list: s,
				listItem: o
			})), t = c || t;
		}), t;
	});
}, Hj = (e) => {
	let t = $(e, "li"), n = $(e, "lic");
	if (!e.selection) return !1;
	let r = p_(e, { match: { type: n } });
	if (!r) return !1;
	let [, i] = r, a = g_(e, i);
	if (!a) return !1;
	let [o, s] = a;
	if (o.type !== t) return !1;
	let c = !1;
	return J(e, () => {
		B.isCollapsed(e.selection) || x_(e);
		let r = W_(e, e.selection.focus, i), a = py(e), l = z.next(i), u = z.next(s);
		r ? (yy(e, {
			children: [{
				children: [{ text: "" }],
				type: n
			}],
			type: t
		}, { at: s }), c = !0) : (a ? (yy(e, {
			children: [{
				children: [Sj({ text: "" }, L_(e) || {})],
				type: n
			}],
			type: t
		}, { at: u }), w_(e, u)) : J(e, () => {
			mv(e), _v(e, {
				children: [],
				type: t
			}, { at: l }), S_(e, {
				at: l,
				to: u
			}), w_(e, u), ov(e, { edge: "start" });
		}), o.children.length > 1 && S_(e, {
			at: l,
			to: u.concat(1)
		}), c = !0);
	}), c;
}, Uj = (e, { fromListItem: t, start: n, toListItem: r }) => {
	let [, i] = t, [, a] = r, o = 0;
	return J(e, () => {
		let t = qv(e, {
			at: i,
			match: { type: Dj(e) }
		});
		if (!t) return;
		let [, r] = t, s = qv(e, {
			at: a,
			match: { type: Dj(e) }
		}), c;
		if (!s) {
			let t = g_(e, i);
			if (!t) return;
			let [n] = t, r = n.type, o = a.concat([1]);
			yy(e, {
				children: [],
				type: r
			}, { at: o }), c = o.concat([0]);
		} else if (n) {
			let [, e] = s;
			c = e.concat([0]);
		} else c = z.next(Zv(s));
		o = xy(e, {
			at: r,
			to: c
		}), x_(e, { at: r });
	}), o;
}, Wj = (e, { list: t, listItem: n, reverse: r = !0 }) => {
	let [i, a] = n;
	if (av(e.selection) || !Nj(e, i)) return !1;
	let o = cy(a), s = !1;
	return J(e, () => {
		if (o) {
			let t = z_(e, o);
			if (!t) return;
			let i = z.next(a);
			yy(e, {
				children: [{
					children: [{ text: "" }],
					type: $(e, "lic")
				}],
				type: $(e, "li")
			}, { at: i });
			let c = z_(e, i);
			if (!c) return;
			let l = o_(e, c[1]);
			Uj(e, {
				fromListItem: n,
				toListItem: c
			}), N_(e, { reverse: r }), i = l.unref(), Uj(e, {
				fromListItem: [c[0], i],
				toListItem: t
			}), C_(e, { at: i }), s = !0;
		} else Lj(e, {
			fromListItem: n,
			toList: t,
			toListIndex: 1
		});
	}), s;
}, Gj = (e, { type: t, pluginKey: n = t }) => J(e, () => {
	if (!e.selection) return;
	let { validLiChildrenTypes: r } = ok(e, n);
	if (iv(e.selection) || !iy(e)) {
		let n = jj(e);
		if (n) {
			let { list: r } = n;
			r[0].type === t ? Rj(e) : bv(e, { type: t }, {
				at: e.selection,
				match: (t) => c_(t) && Dj(e).includes(t.type),
				mode: "lowest"
			});
		} else {
			_v(e, {
				children: [],
				type: t
			});
			let n = h_(e, { match: { type: $(e, "p") } }), i = Array.from(n);
			Y(e, { match: { type: r } }) || bv(e, { type: $(e, "lic") });
			let a = {
				children: [],
				type: $(e, "li")
			};
			for (let [, t] of i) _v(e, a, { at: t });
		}
	} else {
		let [n, i] = B.edges(e.selection), a = q_(e, n.path, i.path);
		if (Dj(e).includes(a[0].type) || a[0].type === $(e, "li")) {
			if (a[0].type === t) Rj(e);
			else {
				let n = vv(e, {
					at: B.start(e.selection),
					match: { type: Dj(e) },
					mode: "lowest"
				}), r = vv(e, {
					at: B.end(e.selection),
					match: { type: Dj(e) },
					mode: "lowest"
				}), i = Math.min(n[1].length, r[1].length);
				bv(e, { type: t }, {
					at: e.selection,
					match: (t, n) => c_(t) && Dj(e).includes(t.type) && n.length >= i,
					mode: "all"
				});
			}
		} else {
			let n = a[1].length, i = h_(e, { mode: "all" });
			Array.from(i).filter(([, e]) => e.length === n + 1).forEach((n) => {
				Dj(e).includes(n[0].type) ? bv(e, { type: t }, {
					at: n[1],
					match: (t) => c_(t) && Dj(e).includes(t.type),
					mode: "all"
				}) : (r?.includes(n[0].type) || bv(e, { type: $(e, "lic") }, { at: n[1] }), _v(e, {
					children: [],
					type: $(e, "li")
				}, { at: n[1] }), _v(e, {
					children: [],
					type: t
				}, { at: n[1] }));
			});
		}
	}
}), Kj = (e, { options: { enableResetOnShiftTab: t, hotkey: n }, type: r }) => (i) => {
	if (i.defaultPrevented) return;
	let a = yD.isTab(e, i), o = yD.isUntab(e, i), s = e.selection;
	if (e.selection && (a || o)) {
		let { selection: n } = e;
		if (!iv(e.selection)) {
			let { anchor: t, focus: r } = B.isBackward(n) ? {
				anchor: Sj({}, n.focus),
				focus: Sj({}, n.anchor)
			} : {
				anchor: Sj({}, n.anchor),
				focus: Sj({}, n.focus)
			}, i = m_(e, {
				anchor: t,
				focus: r
			});
			i && (s = i, w_(e, i));
		}
		let r = yv(e, { match: { type: $(e, "li") } });
		if (s && r) return i.preventDefault(), Vj(e, {
			at: s,
			enableResetOnShiftTab: t,
			increase: a
		}), !0;
	}
	if (!n) return;
	let c = Cv(n);
	for (let t of c) (0, vT.isHotkey)(t)(i) && Gj(e, { type: r });
}, qj = (e, t) => {
	let n = jj(e, {}), r = !1;
	if (n) {
		let { list: i, listItem: a } = n;
		vy(e, { match: (t) => t.type === $(e, "li") }) && J(e, () => {
			if (r = Bj(e, {
				list: i,
				listItem: a
			}), r || (r = Wj(e, {
				list: i,
				listItem: a
			}), r)) return !0;
			if (my(a[1]) && !wj(e, i[1])) {
				mj(e, lk({ options: { rules: [{
					defaultType: $(e, "p"),
					hotkey: "backspace",
					onReset: (e) => Rj(e),
					predicate: () => vy(e),
					types: [$(e, "li")]
				}] } }))(pj), r = !0;
				return;
			}
			let n = k_(e, e.selection.focus), o, s = !1;
			if (n && Pj(Cj(Sj({}, e), { selection: {
				anchor: e.selection.anchor,
				focus: n
			} }))) {
				let t = $(e, "lic");
				o = [...h_(e, {
					at: a[1],
					match: (e) => e.type === t,
					mode: "lowest"
				})][0], s = o[0].children.length > 1;
			}
			if (N_(e, {
				reverse: !0,
				unit: t
			}), r = !0, !o || !s) return;
			let c = z_(e, z.parent(o[1]));
			c && c[0].children.length === 0 && C_(e, { at: c[1] });
		});
	}
	return r;
}, Jj = (e) => {
	let t = O_(e, e.selection.focus.path);
	if (t) {
		let n = jj(e, { at: t });
		if (n) {
			let { listItem: t } = n;
			if (!F_(e, Y(e, { at: e.selection.anchor })[1])) return C_(e), !0;
			Nj(e, t[0]) && zj(e, jj(e, { at: [
				...t[1],
				1,
				0,
				0
			] }));
		}
	}
	return !1;
}, Yj = (e, t, n, r) => {
	let { listItem: i } = t;
	if (!Nj(e, i[0])) {
		let t = $(e, "li"), a = h_(e, {
			at: i[1],
			match: (n, r) => {
				if (r.length === 0) return !1;
				let i = n.type === t, a = J_(e, z.next(r))?.type === t;
				return i && a;
			},
			mode: "lowest"
		}), o = Array.from(a, (e) => e[1])[0];
		if (!o) {
			let t = O_(e, i[1]);
			if (t) {
				let n = jj(e, { at: t });
				if (n) {
					let t = Mj(e, i[1]);
					return Lj(e, {
						deleteFromList: !0,
						fromList: n.list,
						toList: t
					}), !0;
				}
			}
			return !1;
		}
		let s = z_(e, z.next(o));
		if (!s) return !1;
		let c = g_(e, s[1]);
		if (c && Wj(e, {
			list: c,
			listItem: s,
			reverse: !1
		})) return !0;
		let l = O_(e, e.selection.focus);
		if (!l || !Pj(Cj(Sj({}, e), { selection: {
			anchor: e.selection.anchor,
			focus: l
		} }))) return !1;
		let u = $(e, "lic"), d = [...h_(e, {
			at: l.path,
			match: (e) => e.type === u,
			mode: "lowest"
		})][0];
		if (d[0].children.length < 2) return !1;
		n(r);
		let f = z_(e, z.parent(d[1]));
		return f && f[0].children.length === 0 && C_(e, { at: f[1] }), !0;
	}
	let a = z_(e, z.next([...i[1], 0]));
	if (!a) return !1;
	let o = Jv(a)[0];
	return !!(Bj(e, {
		list: a,
		listItem: o
	}) || Wj(e, {
		list: a,
		listItem: o
	}));
}, Xj = (e, t, n) => {
	let r = !1;
	return !e?.selection || !_y(e) || J(e, () => {
		let i = jj(e, {});
		r = i ? Yj(e, i, t, n) : Jj(e);
	}), r;
}, Zj = (e) => p_(e, {
	at: A_(e, e.selection),
	match: { type: $(e, "li") }
}), Qj = (e) => {
	let t = !1;
	return J(e, () => {
		if (!Pj(e)) return;
		let n = p_(e, {
			at: E_(e, e.selection),
			match: { type: $(e, "li") }
		}), r = n && !Nj(e, n[0]) ? o_(e, n[1]) : void 0;
		if (!Zj(e) || !n) {
			t = !1;
			return;
		}
		N_(e);
		let i = Zj(e);
		if (r) {
			let n = r.unref(), a = Aj(e, {
				diffListPath: (i && g_(e, i[1]))?.[1],
				liPath: n
			});
			a && C_(e, { at: a }), t = !0;
		}
	}), t;
}, $j = (e) => {
	if (!e.selection) return;
	let t = jj(e, {}), n;
	if (t) {
		let { list: r, listItem: i } = t;
		if (fy(e) && (n = zj(e, {
			list: r,
			listItem: i
		}), n)) return !0;
	}
	if (mj(e, lk({ options: { rules: [{
		defaultType: $(e, "p"),
		onReset: (e) => Rj(e),
		predicate: () => !n && fy(e),
		types: [$(e, "li")]
	}] } }))(pj) || !n && Hj(e)) return !0;
}, eM = (e) => {
	let { insertFragment: t } = e, n = ek(e, "li"), r = Oj(e), i = kj(e), a = (e, t, { type: n }) => {
		let r = z.parent(t[1]);
		for (; J_(e, r).type !== n;) r = z.parent(r);
		return [J_(e, r), r];
	}, o = (t) => {
		let n = null, a = t;
		for (; Fj(e, a) || a.type === r && a.children[0].type !== i;) n = a, [a] = a.children;
		return n ? n.children : [a];
	}, s = (t) => {
		if (!Fj(e, t)) return [t];
		let r = ev(t), i = Array.from(r), s = i.reduce((e, n) => z.isAncestor(e[1], n[1]) ? e : q_(t, n[1], e[1]), a(t, i[0], n)), [c, ...l] = Fj(e, s[0]) ? s[0].children : [s[0]];
		return [...o(c), ...l];
	}, c = (e) => e.type === r ? e : {
		children: [e],
		type: r
	}, l = (t) => t.length === 1 && Fj(e, t[0]) && [...tv({ children: t })].filter((e) => c_(e[0])).filter(([e]) => e.type === i).length === 1, u = (t, n, r) => {
		let [, i] = n, [a, o] = r, u = !$_(a), [d, ...f] = t.flatMap(s).map(c), p, m;
		if (Fj(e, t[0])) {
			if (l(t)) p = d, m = f;
			else if (u) {
				let [, ...t] = J_(e, i).children, [n, ...r] = d.children;
				if (yy(e, n, {
					at: z.next(o),
					select: !0
				}), C_(e, { at: o }), r?.length) {
					if (t?.length) {
						let t = [
							...i,
							1,
							0
						];
						yy(e, r[0].children, {
							at: t,
							select: !0
						});
					} else yy(e, r, {
						at: z.next(o),
						select: !0
					});
				}
				p = { text: "" }, m = f;
			} else p = { text: "" }, m = [d, ...f];
		} else p = d, m = f;
		return {
			listItemNodes: m,
			textNode: p
		};
	};
	return (n) => {
		let a = vv(e, {
			match: { type: r },
			mode: "lowest"
		});
		if (!a || (t([{ text: "" }]), a = vv(e, {
			match: { type: r },
			mode: "lowest"
		}), !a)) return t(Fj(e, n[0]) ? [{ text: "" }, ...n] : n);
		let o = vv(e, {
			match: { type: i },
			mode: "lowest"
		});
		if (!o) return t(Fj(e, n[0]) ? [{ text: "" }, ...n] : n);
		let { listItemNodes: s, textNode: c } = u(n, a, o);
		t([c]);
		let [, l] = a;
		return yy(e, s, {
			at: z.next(l),
			select: !0
		});
	};
}, tM = (e, { children: t }) => {
	let n = [];
	for (let r of t) l_(e, r[0]) ? n.push(...tM(e, { children: Jv(r) })) : n.push(r);
	return n;
}, nM = (e, { listItem: t, validLiChildrenTypes: n = [] }) => {
	let r = !1, i = /* @__PURE__ */ new Set([
		$(e, "ul"),
		$(e, "ol"),
		$(e, "lic"),
		...n
	]), [, a] = t, o = Jv(t), s = o.filter(([e]) => !i.has(e.type)).map(([, t]) => o_(e, t)), c = o[0], [l, u] = c ?? [];
	if (!c || !l_(e, l)) return by(e, $(e, "lic"), { at: a.concat([0]) }), !0;
	if (l_(e, l) && !d_(l, [], { type: $(e, "lic") })) {
		if (d_(l, [], { type: Dj(e) })) {
			let n = g_(e, t[1]), r = c;
			return Jv(c).reverse().forEach((t) => {
				zj(e, {
					list: r,
					listItem: t
				});
			}), C_(e, { at: [...n[1], 0] }), !0;
		}
		if (n.includes(l.type)) return !0;
		bv(e, { type: $(e, "lic") }, { at: u }), r = !0;
	}
	let d = Jv(c);
	if (d.length > 0) {
		let t = [], n = [];
		for (let r of d) {
			if (!l_(e, r[0])) break;
			t.push(o_(e, r[1])), n.push(...tM(e, { children: Jv(r) }));
		}
		let i = z.next(d.at(-1)[1]);
		n.reverse().forEach(([, t]) => {
			S_(e, {
				at: t,
				to: i
			});
		}), t.forEach((t) => {
			let n = t.unref();
			n && C_(e, { at: n });
		}), t.length > 0 && (r = !0);
	}
	return r ? !0 : (s.reverse().forEach((t) => {
		let n = t.unref();
		n && S_(e, {
			at: n,
			to: u.concat([0])
		});
	}), s.length > 0);
}, rM = (e, { nestedListItem: t }) => {
	let [, n] = t, r = g_(e, n);
	if (!(r && d_(r[0], [], { type: Dj(e) }))) return !1;
	let i;
	try {
		i = z.previous(n);
	} catch {
		return !1;
	}
	let a = z_(e, i);
	if (a) {
		let [, t] = a;
		return S_(e, {
			at: n,
			to: t.concat([1])
		}), !0;
	}
}, iM = (e, { validLiChildrenTypes: t }) => {
	let { normalizeNode: n } = e, r = $(e, "li"), i = $(e, "lic"), a = $(e, "p");
	return ([o, s]) => {
		if (!c_(o)) return n([o, s]);
		if (Fj(e, o)) {
			let t = Jv([o, s]).find(([e]) => e.type !== r);
			if (t) return _v(e, {
				children: [],
				type: r
			}, { at: t[1] });
		}
		if (d_(o, [], { type: Dj(e) })) {
			if (o.children.length === 0 || !o.children.some((e) => e.type === r)) return C_(e, { at: s });
			let t = z.next(s), n = J_(e, t);
			n?.type === o.type && Lj(e, {
				deleteFromList: !0,
				fromList: [n, t],
				toList: [o, s]
			});
			let i = cy(s), a = J_(e, i);
			if (a?.type === o.type) {
				e.normalizeNode([a, i]);
				return;
			}
			if (rM(e, { nestedListItem: [o, s] })) return;
		}
		o.type === $(e, "li") && nM(e, {
			listItem: [o, s],
			validLiChildrenTypes: t
		}) || (o.type === i && i !== a && g_(e, s)?.[0].type !== r ? bv(e, { type: a }, { at: s }) : n([o, s]));
	};
}, aM = nk({
	key: "list",
	plugins: [
		{
			deserializeHtml: { rules: [{ validNodeName: "UL" }] },
			handlers: { onKeyDown: Kj },
			isElement: !0,
			key: "ul",
			withOverrides: (e, { options: { validLiChildrenTypes: t } }) => {
				let { deleteBackward: n, deleteForward: r, deleteFragment: i, insertBreak: a } = e;
				return e.insertBreak = () => {
					$j(e) || a();
				}, e.deleteBackward = (t) => {
					qj(e, t) || n(t);
				}, e.deleteForward = (t) => {
					Xj(e, r, t) || r(t);
				}, e.deleteFragment = (t) => {
					Qj(e) || i(t);
				}, e.insertFragment = eM(e), e.normalizeNode = iM(e, { validLiChildrenTypes: t }), e;
			}
		},
		{
			deserializeHtml: { rules: [{ validNodeName: "OL" }] },
			handlers: { onKeyDown: Kj },
			isElement: !0,
			key: "ol"
		},
		{
			deserializeHtml: { rules: [{ validNodeName: "LI" }] },
			isElement: !0,
			key: "li",
			then: (e, { type: t }) => ({ inject: { pluginsByKey: { [zk]: { editor: { insertData: { preInsert: () => yv(e, { match: { type: t } }) } } } } } })
		},
		{
			isElement: !0,
			key: "lic"
		}
	]
});
(/* @__PURE__ */ s(((e, t, n) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n ||= self, n.urlParser = r());
	})(n, (function() {
		function e(t) {
			"@babel/helpers - typeof";
			return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
				return typeof e;
			} : function(e) {
				return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
			}, e(t);
		}
		var t = function(e) {
			if (typeof e != "string") return {};
			e = e.split("+").join(" ");
			var t = {}, n = e.match(/(?:[?](?:[^=]+)=(?:[^&#]*)(?:[&](?:[^=]+)=(?:[^&#]*))*(?:[#].*)?)|(?:[#].*)/), r;
			if (n === null) return {};
			r = n[0].substr(1).split(/[&#=]/);
			for (var i = 0; i < r.length; i += 2) t[decodeURIComponent(r[i])] = decodeURIComponent(r[i + 1] || "");
			return t;
		}, n = function(t, n) {
			if (e(t) !== "object") return "";
			var r = "", i = 0, a = Object.keys(t);
			if (a.length === 0) return "";
			for (a.sort(), n || (r += "?" + a[0] + "=" + t[a[0]], i += 1); i < a.length; i += 1) r += "&" + a[i] + "=" + t[a[i]];
			return r;
		};
		function r(e) {
			var t = 0, n = {
				s: 1,
				m: 60,
				h: 3600,
				d: 86400,
				w: 604800
			}, r;
			e = e.replace(/([smhdw])/g, " $1 ").trim(), r = e.split(" ");
			for (var i = 0; i < r.length; i += 2) t += parseInt(r[i], 10) * n[r[i + 1] || "s"];
			return t;
		}
		function i(e) {
			for (var t = 0, n = [
				1,
				60,
				3600,
				86400,
				604800
			], r = e.split(":"), i = 0; i < r.length; i++) t += parseInt(r[i], 10) * n[r.length - i - 1];
			return t;
		}
		var a = {
			getQueryParams: t,
			combineParams: n,
			getTime: function(e) {
				return e === void 0 ? 0 : e.match(/^(\d+[smhdw]?)+$/) ? r(e) : e.match(/^(\d+:?)+$/) ? i(e) : 0;
			}
		}, o = a.getQueryParams;
		function s() {
			for (var e = 0, t = [
				"parseProvider",
				"parse",
				"bind",
				"create"
			]; e < t.length; e++) {
				var n = t[e];
				this[n] = this[n].bind(this);
			}
			this.plugins = {};
		}
		var c = s;
		s.prototype.parseProvider = function(e) {
			var t = e.match(/(?:(?:https?:)?\/\/)?(?:[^.]+\.)?(\w+)\./i);
			return t ? t[1] : void 0;
		}, s.prototype.parse = function(e) {
			if (e !== void 0) {
				var t = this.parseProvider(e), n, r = this.plugins[t];
				if (t && r && r.parse) return n = r.parse.call(r, e, o(e)), n && (n = l(n), n.provider = r.provider), n;
			}
		}, s.prototype.bind = function(e) {
			if (this.plugins[e.provider] = e, e.alternatives) for (var t = 0; t < e.alternatives.length; t += 1) this.plugins[e.alternatives[t]] = e;
		}, s.prototype.create = function(t) {
			if (e(t) === "object" && e(t.videoInfo) === "object") {
				var n = t.videoInfo, r = t.params, i = this.plugins[n.provider];
				if (r = r === "internal" ? n.params : r || {}, i && (t.format = t.format || i.defaultFormat, i.formats.hasOwnProperty(t.format))) return i.formats[t.format].apply(i, [n, Object.assign({}, r)]);
			}
		};
		function l(e) {
			return e.params && Object.keys(e.params).length === 0 && delete e.params, e;
		}
		var u = new c();
		function d() {
			this.provider = "allocine", this.alternatives = [], this.defaultFormat = "embed", this.formats = { embed: this.createEmbedUrl }, this.mediaTypes = { VIDEO: "video" };
		}
		d.prototype.parseUrl = function(e) {
			var t = e.match(/(?:\/video\/player_gen_cmedia=)([A-Za-z0-9]+)/i);
			return t ? t[1] : void 0;
		}, d.prototype.parse = function(e) {
			var t = {
				mediaType: this.mediaTypes.VIDEO,
				id: this.parseUrl(e)
			};
			return t.id ? t : void 0;
		}, d.prototype.createEmbedUrl = function(e) {
			if (e.id && e.mediaType === this.mediaTypes.VIDEO) return "https://player.allocine.fr/" + e.id + ".html";
		}, u.bind(new d());
		var f = a.combineParams;
		function p() {
			this.provider = "canalplus", this.defaultFormat = "embed", this.formats = { embed: this.createEmbedUrl }, this.mediaTypes = { VIDEO: "video" };
		}
		p.prototype.parseParameters = function(e) {
			return delete e.vid, e;
		}, p.prototype.parse = function(e, t) {
			var n = this, r = {
				mediaType: this.mediaTypes.VIDEO,
				id: t.vid
			};
			if (r.params = n.parseParameters(t), r.id) return r;
		}, p.prototype.createEmbedUrl = function(e, t) {
			if (e.id && e.mediaType === this.mediaTypes.VIDEO) {
				var n = "http://player.canalplus.fr/embed/";
				return t.vid = e.id, n += f(t), n;
			}
		}, u.bind(new p());
		var m = a.combineParams;
		function h() {
			this.provider = "coub", this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		h.prototype.parseUrl = function(e) {
			var t = e.match(/(?:embed|view)\/([a-zA-Z\d]+)/i);
			return t ? t[1] : void 0;
		}, h.prototype.parse = function(e, t) {
			var n = {
				mediaType: this.mediaTypes.VIDEO,
				params: t,
				id: this.parseUrl(e)
			};
			if (n.id) return n;
		}, h.prototype.createUrl = function(e, t, n) {
			if (t.id && t.mediaType === this.mediaTypes.VIDEO) {
				var r = e + t.id;
				return r += m(n), r;
			}
		}, h.prototype.createLongUrl = function(e, t) {
			return this.createUrl("https://coub.com/view/", e, t);
		}, h.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("//coub.com/embed/", e, t);
		}, u.bind(new h());
		var g = a.combineParams, _ = a.getTime;
		function v() {
			this.provider = "dailymotion", this.alternatives = ["dai"], this.defaultFormat = "long", this.formats = {
				short: this.createShortUrl,
				long: this.createLongUrl,
				embed: this.createEmbedUrl,
				image: this.createImageUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		v.prototype.parseParameters = function(e) {
			return this.parseTime(e);
		}, v.prototype.parseTime = function(e) {
			return e.start &&= _(e.start), e;
		}, v.prototype.parseUrl = function(e) {
			var t = e.match(/(?:\/video|ly)\/([A-Za-z0-9]+)/i);
			return t ? t[1] : void 0;
		}, v.prototype.parse = function(e, t) {
			var n = this, r = {
				mediaType: this.mediaTypes.VIDEO,
				params: n.parseParameters(t),
				id: n.parseUrl(e)
			};
			return r.id ? r : void 0;
		}, v.prototype.createUrl = function(e, t, n) {
			if (t.id && t.mediaType === this.mediaTypes.VIDEO) return e + t.id + g(n);
		}, v.prototype.createShortUrl = function(e, t) {
			return this.createUrl("https://dai.ly/", e, t);
		}, v.prototype.createLongUrl = function(e, t) {
			return this.createUrl("https://dailymotion.com/video/", e, t);
		}, v.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("https://www.dailymotion.com/embed/video/", e, t);
		}, v.prototype.createImageUrl = function(e, t) {
			return delete t.start, this.createUrl("https://www.dailymotion.com/thumbnail/video/", e, t);
		}, u.bind(new v());
		var y = a.combineParams;
		function b() {
			this.provider = "loom", this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		b.prototype.parseUrl = function(e) {
			var t = e.match(/(?:share|embed)\/([a-zA-Z\d]+)/i);
			return t ? t[1] : void 0;
		}, b.prototype.parse = function(e, t) {
			var n = {
				mediaType: this.mediaTypes.VIDEO,
				params: t,
				id: this.parseUrl(e)
			};
			return n.id ? n : void 0;
		}, b.prototype.createUrl = function(e, t, n) {
			if (t.id && t.mediaType === this.mediaTypes.VIDEO) {
				var r = e + t.id;
				return r += y(n), r;
			}
		}, b.prototype.createLongUrl = function(e, t) {
			return this.createUrl("https://loom.com/share/", e, t);
		}, b.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("//loom.com/embed/", e, t);
		}, u.bind(new b());
		var x = a.combineParams, S = a.getTime;
		function C() {
			this.provider = "twitch", this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = {
				VIDEO: "video",
				STREAM: "stream",
				CLIP: "clip"
			};
		}
		C.prototype.seperateId = function(e) {
			return {
				pre: e[0],
				id: e.substr(1)
			};
		}, C.prototype.parseChannel = function(e, t) {
			var n = t.channel || t.utm_content || e.channel;
			return delete t.utm_content, delete t.channel, n;
		}, C.prototype.parseUrl = function(e, t, n) {
			var r = e.match(/(clips\.)?twitch\.tv\/(?:(?:videos\/(\d+))|(\w+(?:-[\w\d-]+)?)(?:\/clip\/(\w+))?)/i);
			return r && r[2] ? t.id = "v" + r[2] : n.video ? (t.id = n.video, delete n.video) : n.clip ? (t.id = n.clip, t.isClip = !0, delete n.clip) : r && r[1] && r[3] ? (t.id = r[3], t.isClip = !0) : r && r[3] && r[4] ? (t.channel = r[3], t.id = r[4], t.isClip = !0) : r && r[3] && (t.channel = r[3]), t;
		}, C.prototype.parseMediaType = function(e) {
			var t;
			return e.id ? e.isClip ? (t = this.mediaTypes.CLIP, delete e.isClip) : t = this.mediaTypes.VIDEO : e.channel && (t = this.mediaTypes.STREAM), t;
		}, C.prototype.parseParameters = function(e) {
			return e.t && (e.start = S(e.t), delete e.t), e;
		}, C.prototype.parse = function(e, t) {
			var n = this, r = {};
			return r = n.parseUrl(e, r, t), r.channel = n.parseChannel(r, t), r.mediaType = n.parseMediaType(r), r.params = n.parseParameters(t), r.channel || r.id ? r : void 0;
		}, C.prototype.createLongUrl = function(e, t) {
			var n = "";
			if (e.mediaType === this.mediaTypes.STREAM && e.channel) n = "https://twitch.tv/" + e.channel;
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) n = "https://twitch.tv/videos/" + this.seperateId(e.id).id, t.start && (t.t = t.start + "s", delete t.start);
			else if (e.mediaType === this.mediaTypes.CLIP && e.id) n = e.channel ? "https://www.twitch.tv/" + e.channel + "/clip/" + e.id : "https://clips.twitch.tv/" + e.id;
			else return;
			return n += x(t), n;
		}, C.prototype.createEmbedUrl = function(e, t) {
			var n = "https://player.twitch.tv/";
			if (e.mediaType === this.mediaTypes.STREAM && e.channel) t.channel = e.channel;
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) t.video = e.id, t.start && (t.t = t.start + "s", delete t.start);
			else if (e.mediaType === this.mediaTypes.CLIP && e.id) n = "https://clips.twitch.tv/embed", t.clip = e.id;
			else return;
			return n += x(t), n;
		}, u.bind(new C());
		var w = a.combineParams, T = a.getTime;
		function E() {
			this.provider = "vimeo", this.alternatives = ["vimeopro"], this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		E.prototype.parseUrl = function(e) {
			var t = e.match(/(?:\/showcase\/\d+)?(?:\/(?:channels\/[\w]+|(?:(?:album\/\d+|groups\/[\w]+)\/)?videos?))?\/(\d+)/i);
			return t ? t[1] : void 0;
		}, E.prototype.parseHash = function(e) {
			var t = e.match(/\/\d+\/(\w+)$/i);
			return t ? t[1] : void 0;
		}, E.prototype.parseParameters = function(e) {
			return e.t && (e.start = T(e.t), delete e.t), e.h && (e.hash = e.h, delete e.h), e;
		}, E.prototype.parse = function(e, t) {
			var n = {
				mediaType: this.mediaTypes.VIDEO,
				params: this.parseParameters(t),
				id: this.parseUrl(e)
			}, r = this.parseHash(e, t);
			return r && (n.params.hash = r), n.id ? n : void 0;
		}, E.prototype.createUrl = function(e, t, n, r) {
			if (t.id && t.mediaType === this.mediaTypes.VIDEO) {
				var i = e + t.id, a = n.start;
				return delete n.start, n.hash && (r === "embed" ? n.h = n.hash : r === "long" && (i += "/" + n.hash), delete n.hash), i += w(n), a && (i += "#t=" + a), i;
			}
		}, E.prototype.createLongUrl = function(e, t) {
			return this.createUrl("https://vimeo.com/", e, t, "long");
		}, E.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("//player.vimeo.com/video/", e, t, "embed");
		}, u.bind(new E());
		var ee = a.combineParams, D = a.getTime;
		function O() {
			this.provider = "wistia", this.alternatives = [], this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl,
				embedjsonp: this.createEmbedJsonpUrl
			}, this.mediaTypes = {
				VIDEO: "video",
				EMBEDVIDEO: "embedvideo"
			};
		}
		O.prototype.parseUrl = function(e) {
			var t = e.match(/(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/);
			return t ? t[1] : void 0;
		}, O.prototype.parseChannel = function(e) {
			var t = e.match(/(?:(?:https?:)?\/\/)?([^.]*)\.wistia\./), n = t ? t[1] : void 0;
			if (n !== "fast" && n !== "content") return n;
		}, O.prototype.parseParameters = function(e, t) {
			return e.wtime && (e.start = D(e.wtime), delete e.wtime), e.wvideo === t.id && delete e.wvideo, e;
		}, O.prototype.parseMediaType = function(e) {
			if (e.id && e.channel) return this.mediaTypes.VIDEO;
			if (e.id) return delete e.channel, this.mediaTypes.EMBEDVIDEO;
		}, O.prototype.parse = function(e, t) {
			var n = {
				id: this.parseUrl(e),
				channel: this.parseChannel(e)
			};
			if (n.params = this.parseParameters(t, n), n.mediaType = this.parseMediaType(n), n.id) return n;
		}, O.prototype.createUrl = function(e, t, n) {
			return t.start && (t.wtime = t.start, delete t.start), n += ee(t), n;
		}, O.prototype.createLongUrl = function(e, t) {
			if (e.id && e.mediaType === this.mediaTypes.VIDEO) {
				var n = "https://" + e.channel + ".wistia.com/medias/" + e.id;
				return this.createUrl(e, t, n);
			}
		}, O.prototype.createEmbedUrl = function(e, t) {
			if (!(!e.id || e.mediaType !== this.mediaTypes.VIDEO && e.mediaType !== this.mediaTypes.EMBEDVIDEO)) {
				var n = "https://fast.wistia.com/embed/iframe/" + e.id;
				return this.createUrl(e, t, n);
			}
		}, O.prototype.createEmbedJsonpUrl = function(e) {
			if (!(!e.id || e.mediaType !== this.mediaTypes.VIDEO && e.mediaType !== this.mediaTypes.EMBEDVIDEO)) return "https://fast.wistia.com/embed/medias/" + e.id + ".jsonp";
		}, u.bind(new O());
		var te = a.combineParams;
		function k() {
			this.provider = "youku", this.defaultFormat = "long", this.formats = {
				embed: this.createEmbedUrl,
				long: this.createLongUrl,
				flash: this.createFlashUrl,
				static: this.createStaticUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		k.prototype.parseUrl = function(e) {
			var t = e.match(/(?:(?:embed|sid)\/|v_show\/id_|VideoIDS=)([a-zA-Z0-9]+)/);
			return t ? t[1] : void 0;
		}, k.prototype.parseParameters = function(e) {
			return e.VideoIDS && delete e.VideoIDS, e;
		}, k.prototype.parse = function(e, t) {
			var n = this, r = {
				mediaType: this.mediaTypes.VIDEO,
				id: n.parseUrl(e),
				params: n.parseParameters(t)
			};
			if (r.id) return r;
		}, k.prototype.createUrl = function(e, t, n) {
			if (t.id && t.mediaType === this.mediaTypes.VIDEO) {
				var r = e + t.id;
				return r += te(n), r;
			}
		}, k.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("http://player.youku.com/embed/", e, t);
		}, k.prototype.createLongUrl = function(e, t) {
			return this.createUrl("http://v.youku.com/v_show/id_", e, t);
		}, k.prototype.createStaticUrl = function(e, t) {
			return this.createUrl("http://static.youku.com/v1.0.0638/v/swf/loader.swf?VideoIDS=", e, t);
		}, k.prototype.createFlashUrl = function(e, t) {
			if (e.id && e.mediaType === this.mediaTypes.VIDEO) {
				var n = "http://player.youku.com/player.php/sid/" + e.id + "/v.swf";
				return n += te(t), n;
			}
		}, u.bind(new k());
		var ne = a.combineParams, re = a.getTime;
		function A() {
			this.provider = "youtube", this.alternatives = ["youtu", "ytimg"], this.defaultFormat = "long", this.formats = {
				short: this.createShortUrl,
				long: this.createLongUrl,
				embed: this.createEmbedUrl,
				shortImage: this.createShortImageUrl,
				longImage: this.createLongImageUrl
			}, this.imageQualities = {
				0: "0",
				1: "1",
				2: "2",
				3: "3",
				DEFAULT: "default",
				HQDEFAULT: "hqdefault",
				SDDEFAULT: "sddefault",
				MQDEFAULT: "mqdefault",
				MAXRESDEFAULT: "maxresdefault"
			}, this.defaultImageQuality = this.imageQualities.HQDEFAULT, this.mediaTypes = {
				VIDEO: "video",
				PLAYLIST: "playlist",
				SHARE: "share",
				CHANNEL: "channel"
			};
		}
		A.prototype.parseVideoUrl = function(e) {
			var t = e.match(/(?:(?:v|vi|be|videos|embed)\/(?!videoseries)|(?:v|ci)=)([\w-]{11})/i);
			return t ? t[1] : void 0;
		}, A.prototype.parseChannelUrl = function(e) {
			var t = e.match(/\/channel\/([\w-]+)/);
			if (t) return {
				id: t[1],
				mediaType: this.mediaTypes.CHANNEL
			};
			if (t = e.match(/\/(?:c|user)\/([\w-]+)/), t) return {
				name: t[1],
				mediaType: this.mediaTypes.CHANNEL
			};
		}, A.prototype.parseParameters = function(e, t) {
			return (e.start || e.t) && (e.start = re(e.start || e.t), delete e.t), e.v === t.id && delete e.v, e.list === t.id && delete e.list, e;
		}, A.prototype.parseMediaType = function(e) {
			if (e.params.list && (e.list = e.params.list, delete e.params.list), e.id && !e.params.ci) e.mediaType = this.mediaTypes.VIDEO;
			else if (e.list) delete e.id, e.mediaType = this.mediaTypes.PLAYLIST;
			else if (e.params.ci) delete e.params.ci, e.mediaType = this.mediaTypes.SHARE;
			else return;
			return e;
		}, A.prototype.parse = function(e, t) {
			var n = this.parseChannelUrl(e);
			if (n) return n;
			var r = {
				params: t,
				id: this.parseVideoUrl(e)
			};
			return r.params = this.parseParameters(t, r), r = this.parseMediaType(r), r;
		}, A.prototype.createShortUrl = function(e, t) {
			if (e.id && e.mediaType === this.mediaTypes.VIDEO) {
				var n = "https://youtu.be/" + e.id;
				return t.start && (n += "#t=" + t.start), n;
			}
		}, A.prototype.createLongUrl = function(e, t) {
			var n = "", r = t.start;
			if (delete t.start, e.mediaType === this.mediaTypes.CHANNEL) {
				if (e.id) n += "https://www.youtube.com/channel/" + e.id;
				else if (e.name) n += "https://www.youtube.com/c/" + e.name;
				else return;
			} else if (e.mediaType === this.mediaTypes.PLAYLIST && e.list) t.feature = "share", n += "https://www.youtube.com/playlist";
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) t.v = e.id, n += "https://www.youtube.com/watch";
			else if (e.mediaType === this.mediaTypes.SHARE && e.id) t.ci = e.id, n += "https://www.youtube.com/shared";
			else return;
			return e.list && (t.list = e.list), n += ne(t), e.mediaType !== this.mediaTypes.PLAYLIST && r && (n += "#t=" + r), n;
		}, A.prototype.createEmbedUrl = function(e, t) {
			var n = "https://www.youtube.com/embed";
			if (e.mediaType === this.mediaTypes.PLAYLIST && e.list) t.listType = "playlist";
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) n += "/" + e.id, t.loop === "1" && (t.playlist = e.id);
			else return;
			return e.list && (t.list = e.list), n += ne(t), n;
		}, A.prototype.createImageUrl = function(e, t, n) {
			if (t.id && t.mediaType === this.mediaTypes.VIDEO) return e + t.id + "/" + (n.imageQuality || this.defaultImageQuality) + ".jpg";
		}, A.prototype.createShortImageUrl = function(e, t) {
			return this.createImageUrl("https://i.ytimg.com/vi/", e, t);
		}, A.prototype.createLongImageUrl = function(e, t) {
			return this.createImageUrl("https://img.youtube.com/vi/", e, t);
		}, u.bind(new A());
		var ie = a.combineParams, ae = a.getTime;
		function j() {
			this.provider = "soundcloud", this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = {
				TRACK: "track",
				PLAYLIST: "playlist",
				APITRACK: "apitrack",
				APIPLAYLIST: "apiplaylist"
			};
		}
		j.prototype.parseUrl = function(e, t) {
			var n = e.match(/(?:m\.)?soundcloud\.com\/(?:([\w-]+)\/(sets\/)?)([\w-]+)/i);
			return n && (t.channel = n[1], n[1] === "playlists" || n[2] ? t.list = n[3] : t.id = n[3]), t;
		}, j.prototype.parseParameters = function(e) {
			return e.t && (e.start = ae(e.t), delete e.t), e;
		}, j.prototype.parseMediaType = function(e) {
			return e.id && (e.channel === "tracks" ? (delete e.channel, delete e.params.url, e.mediaType = this.mediaTypes.APITRACK) : e.mediaType = this.mediaTypes.TRACK), e.list && (e.channel === "playlists" ? (delete e.channel, delete e.params.url, e.mediaType = this.mediaTypes.APIPLAYLIST) : e.mediaType = this.mediaTypes.PLAYLIST), e;
		}, j.prototype.parse = function(e, t) {
			var n = {};
			if (n = this.parseUrl(e, n), n.params = this.parseParameters(t), n = this.parseMediaType(n), n.id || n.list) return n;
		}, j.prototype.createLongUrl = function(e, t) {
			var n = "", r = t.start;
			if (delete t.start, e.mediaType === this.mediaTypes.TRACK && e.id && e.channel) n = "https://soundcloud.com/" + e.channel + "/" + e.id;
			else if (e.mediaType === this.mediaTypes.PLAYLIST && e.list && e.channel) n = "https://soundcloud.com/" + e.channel + "/sets/" + e.list;
			else if (e.mediaType === this.mediaTypes.APITRACK && e.id) n = "https://api.soundcloud.com/tracks/" + e.id;
			else if (e.mediaType === this.mediaTypes.APIPLAYLIST && e.list) n = "https://api.soundcloud.com/playlists/" + e.list;
			else return;
			return n += ie(t), r && (n += "#t=" + r), n;
		}, j.prototype.createEmbedUrl = function(e, t) {
			var n = "https://w.soundcloud.com/player/";
			if (delete t.start, e.mediaType === this.mediaTypes.APITRACK && e.id) t.url = "https%3A//api.soundcloud.com/tracks/" + e.id;
			else if (e.mediaType === this.mediaTypes.APIPLAYLIST && e.list) t.url = "https%3A//api.soundcloud.com/playlists/" + e.list;
			else return;
			return n += ie(t), n;
		}, u.bind(new j());
		var M = a.combineParams;
		function oe() {
			this.provider = "teachertube", this.alternatives = [], this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = {
				VIDEO: "video",
				AUDIO: "audio",
				DOCUMENT: "document",
				CHANNEL: "channel",
				COLLECTION: "collection",
				GROUP: "group"
			};
		}
		oe.prototype.parse = function(e, t) {
			var n = {};
			n.list = this.parsePlaylist(t), n.params = t;
			var r = e.match(/\/(audio|video|document|user\/channel|collection|group)\/(?:[\w-]+-)?(\w+)/);
			if (r) return n.mediaType = this.parseMediaType(r[1]), n.id = r[2], n;
		}, oe.prototype.parsePlaylist = function(e) {
			if (e["playlist-id"]) {
				var t = e["playlist-id"];
				return delete e["playlist-id"], t;
			}
		}, oe.prototype.parseMediaType = function(e) {
			switch (e) {
				case "audio": return this.mediaTypes.AUDIO;
				case "video": return this.mediaTypes.VIDEO;
				case "document": return this.mediaTypes.DOCUMENT;
				case "user/channel": return this.mediaTypes.CHANNEL;
				case "collection": return this.mediaTypes.COLLECTION;
				case "group": return this.mediaTypes.GROUP;
			}
		}, oe.prototype.createLongUrl = function(e, t) {
			if (e.id) {
				var n = "https://www.teachertube.com/";
				return e.list && (t["playlist-id"] = e.list), e.mediaType === this.mediaTypes.CHANNEL ? n += "user/channel/" : n += e.mediaType + "/", n += e.id, n += M(t), n;
			}
		}, oe.prototype.createEmbedUrl = function(e, t) {
			if (e.id) {
				var n = "https://www.teachertube.com/embed/";
				if (e.mediaType === this.mediaTypes.VIDEO || e.mediaType === this.mediaTypes.AUDIO) n += e.mediaType + "/" + e.id;
				else return;
				return n += M(t), n;
			}
		}, u.bind(new oe());
		var N = a.combineParams;
		function se() {
			this.provider = "tiktok", this.defaultFormat = "long", this.formats = { long: this.createLongUrl }, this.mediaTypes = { VIDEO: "video" };
		}
		se.prototype.parse = function(e, t) {
			var n = {
				params: t,
				mediaType: this.mediaTypes.VIDEO
			}, r = e.match(/@([^/]+)\/video\/(\d{19})/);
			if (r) return n.channel = r[1], n.id = r[2], n;
		}, se.prototype.createLongUrl = function(e, t) {
			var n = "";
			if (e.mediaType === this.mediaTypes.VIDEO && e.id && e.channel) n += `https://www.tiktok.com/@${e.channel}/video/${e.id}`;
			else return;
			return n += N(t), n;
		}, u.bind(new se());
		var ce = a.combineParams;
		function le() {
			this.provider = "ted", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = {
				VIDEO: "video",
				PLAYLIST: "playlist"
			};
		}
		le.prototype.parseUrl = function(e, t) {
			var n = e.match(/\/(talks|playlists\/(\d+))\/([\w-]+)/i), r = n ? n[1] : void 0;
			return r && (t.channel = r.split("/")[0], t.id = n[3], t.channel === "playlists" && (t.list = n[2])), t;
		}, le.prototype.parseMediaType = function(e) {
			return e.id && e.channel === "playlists" && (delete e.channel, e.mediaType = this.mediaTypes.PLAYLIST), e.id && e.channel === "talks" && (delete e.channel, e.mediaType = this.mediaTypes.VIDEO), e;
		}, le.prototype.parse = function(e, t) {
			var n = { params: t };
			if (n = this.parseUrl(e, n), n = this.parseMediaType(n), n.id) return n;
		}, le.prototype.createLongUrl = function(e, t) {
			var n = "";
			if (e.mediaType === this.mediaTypes.VIDEO && e.id) n += "https://ted.com/talks/" + e.id;
			else if (e.mediaType === this.mediaTypes.PLAYLIST && e.id) n += "https://ted.com/playlists/" + e.list + "/" + e.id;
			else return;
			return n += ce(t), n;
		}, le.prototype.createEmbedUrl = function(e, t) {
			var n = "https://embed.ted.com/";
			if (e.mediaType === this.mediaTypes.PLAYLIST && e.id) n += "playlists/" + e.list + "/" + e.id;
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) n += "talks/" + e.id;
			else return;
			return n += ce(t), n;
		}, u.bind(new le());
		var ue = a.combineParams;
		function de() {
			this.provider = "facebook", this.alternatives = [], this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				watch: this.createWatchUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		return de.prototype.parse = function(e, t) {
			var n = {
				params: t,
				mediaType: this.mediaTypes.VIDEO
			}, r = e.match(/(?:\/(\d+))?\/videos(?:\/.*?)?\/(\d+)/i);
			if (r && (r[1] && (n.pageId = r[1]), n.id = r[2]), t.v && !n.id && (n.id = t.v, delete t.v, n.params = t), n.id) return n;
		}, de.prototype.createWatchUrl = function(e, t) {
			var n = "https://facebook.com/watch/";
			if (e.mediaType === this.mediaTypes.VIDEO && e.id) return t = { v: e.id }, n += ue(t), n;
		}, de.prototype.createLongUrl = function(e, t) {
			var n = "https://facebook.com/";
			if (e.pageId) n += e.pageId;
			else return;
			if (e.mediaType === this.mediaTypes.VIDEO && e.id) n += "/videos/" + e.id;
			else return;
			return n += ue(t), n;
		}, u.bind(new de()), u;
	}));
})))();
var oM = Object.defineProperty, sM = Object.getOwnPropertySymbols, cM = Object.prototype.hasOwnProperty, lM = Object.prototype.propertyIsEnumerable, uM = (e, t, n) => t in e ? oM(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, dM = (e, t) => {
	for (var n in t ||= {}) cM.call(t, n) && uM(e, n, t[n]);
	if (sM) for (var n of sM(t)) lM.call(t, n) && uM(e, n, t[n]);
	return e;
}, fM = (e, t, n = {}) => {
	uv(e, {
		children: [{ text: "" }],
		type: $(e, "img"),
		url: t
	}, dM({ nextBlock: !0 }, n));
}, pM = /* @__PURE__ */ new Set(/* @__PURE__ */ "ase.art.bmp.blp.cd5.cit.cpt.cr2.cut.dds.dib.djvu.egt.exif.gif.gpl.grf.icns.ico.iff.jng.jpeg.jpg.jfif.jp2.jps.lbm.max.miff.mng.msp.nitf.ota.pbm.pc1.pc2.pc3.pcf.pcx.pdn.pgm.PI1.PI2.PI3.pict.pct.pnm.pns.ppm.psb.psd.pdd.psp.px.pxm.pxr.qfx.raw.rle.sct.sgi.rgb.int.bw.tga.tiff.tif.vtf.xbm.xcf.xpm.3dv.amf.ai.awg.cgm.cdr.cmx.dxf.e2d.egt.eps.fs.gbr.odg.svg.stl.vrml.x3d.sxd.v2d.vnd.wmf.emf.art.xar.png.webp.jxr.hdp.wdp.cur.ecw.iff.lbm.liff.nrrd.pam.pcx.pgf.sgi.rgb.rgba.bw.int.inta.sid.ras.sun.tga".split(".")), mM = (e) => {
	if (!jv(e)) return !1;
	let t = new URL(e).pathname.split(".").pop();
	return pM.has(t);
}, hM = (e, t) => {
	let { insertData: n } = e;
	return e.insertData = (t) => {
		let r = t.getData("text/plain");
		mM(r) ? fM(e, r) : n(t);
	}, e;
}, gM = (e, t) => {
	let { options: { uploadImage: n } } = t, { insertData: r } = e;
	return e.insertData = (i) => {
		let a = i.getData("text/plain"), { files: o } = i;
		if (!a && o && o.length > 0) {
			if (!ik(rk(e, t), {
				data: a,
				dataTransfer: i
			})) return r(i);
			for (let t of o) {
				let r = new FileReader(), [i] = t.type.split("/");
				i === "image" && (r.addEventListener("load", async () => {
					r.result && fM(e, n ? await n(r.result) : r.result);
				}), r.readAsDataURL(t));
			}
		} else r(i);
	}, e;
}, _M = nk({
	dangerouslyAllowAttributes: [
		"alt",
		"width",
		"height"
	],
	isElement: !0,
	isVoid: !0,
	key: "img",
	then: (e, { type: t }) => ({ deserializeHtml: {
		getNode: (e) => ({
			type: t,
			url: e.getAttribute("src")
		}),
		rules: [{ validNodeName: "IMG" }]
	} }),
	withOverrides: (e, t) => {
		let { options: { disableEmbedInsert: n, disableUploadInsert: r } } = t;
		return r || (e = gM(e, t)), n || (e = hM(e, t)), e;
	}
}), vM = Zd("imagePreview")({
	boundingClientRect: {},
	currentPreview: null,
	isEditingScale: !1,
	openEditorId: null,
	previewList: [],
	scale: 1,
	translate: {
		x: 0,
		y: 0
	}
}).extendActions((e) => ({ close: () => {
	e.currentPreview(null), e.previewList([]), e.openEditorId(null), e.scale(1), e.translate({
		x: 0,
		y: 0
	}), e.isEditingScale(!1);
} })).extendSelectors((e) => ({ isOpen: (t) => e.openEditorId === t })), yM = vM.set;
vM.get;
var bM = () => vM.use, xM = (e) => {
	let t = h_(e, {
		at: [],
		match: (e) => e.type === "img"
	});
	return Array.from(t, (e) => ({
		id: e[0].id,
		url: e[0].url
	}));
}, SM = (e, t) => {
	let { id: n, url: r } = t, i = xM(e);
	document.documentElement.style.overflowY = "hidden", yM.openEditorId(e.id), yM.currentPreview({
		id: n,
		url: r
	}), yM.previewList(i);
};
zO("img")({ propsHook: () => {
	let e = MT(), t = HD();
	return { props: {
		draggable: !0,
		onDoubleClickCapture: () => {
			SM(t, e);
		},
		src: e.url
	} };
} });
var CM = () => {
	let e = bM().scale(), t = yM.scale, n = yM.translate;
	return {
		zoomIn: P(() => {
			if (e >= 2) return;
			let n = [
				0,
				.5,
				1,
				1.5,
				2
			].find((t) => e < t);
			n && t(n);
		}, [e]),
		zoomOut: P(() => {
			if (e <= 0) return;
			let r = [
				0,
				.5,
				1,
				1.5,
				2
			].reverse().find((t) => e > t);
			r === 1 && n({
				x: 0,
				y: 0
			}), r && t(r);
		}, [e])
	};
};
zO("img")({
	propsHook: ({ currentPreview: e, imageRef: t, scale: n, setBoundingClientRect: r, translate: i }) => {
		let a = ge(() => n <= 1, [n]), { zoomIn: o, zoomOut: s } = CM();
		return me(() => {
			if (n <= 1) return;
			let e = t.current?.getBoundingClientRect();
			e && r(e);
		}, [
			i.x,
			i.y,
			n
		]), { props: {
			draggable: !1,
			onClick: (e) => {
				e.stopPropagation(), a ? o() : s();
			},
			ref: t,
			src: e?.url,
			style: {
				cursor: a ? "zoom-in" : "zoom-out",
				transform: `scale(${n}) translate(${i.x + "px"}, ${i.y + "px"})`
			}
		} };
	},
	stateHook: () => {
		let e = bM().currentPreview(), t = bM().translate(), n = bM().scale();
		return {
			currentPreview: e,
			imageRef: N.useRef(null),
			scale: n,
			setBoundingClientRect: yM.boundingClientRect,
			translate: t
		};
	}
});
var { MediaProvider: wM, mediaStore: TM, useMediaStore: EM } = su({ showCaption: !1 }, { name: "media" }), DM = "media", OM = Zd("floatingMedia")({
	isEditing: !1,
	url: ""
}).extendActions((e) => ({ reset: () => {
	e.url(""), e.isEditing(!1);
} })), kM = OM.set, AM = OM.get;
zO("button")({ propsHook: () => {
	let e = MT();
	return { props: { onClick: N.useCallback(() => {
		kM.url(e.url), kM.isEditing(!0);
	}, [e.url]) } };
} });
var jM = (e, { element: t, pluginKey: n = DM }) => {
	let r = AM.url();
	if (r === t.url) return kM.reset(), !0;
	let { isUrl: i = jv, transformUrl: a } = ok(e, n);
	if (i(r)) return a && (r = a(r)), pv(e, { url: r }), kM.reset(), sw(e, e.selection), !0;
};
zO("input")({
	propsHook: ({ defaultValue: e }) => ({ props: {
		autoFocus: !0,
		defaultValue: e,
		onChange: N.useCallback((e) => {
			kM.url(e.target.value);
		}, [])
	} }),
	stateHook: ({ pluginKey: e } = {}) => {
		let t = HD(), n = MT();
		return Ef("enter", (r) => {
			jM(t, {
				element: n,
				pluginKey: e
			}) && r.preventDefault();
		}, { enableOnFormTags: ["INPUT"] }, []), Ef("escape", () => {
			AM.isEditing() && (kM.reset(), sw(t, t.selection));
		}, {
			enableOnContentEditable: !0,
			enableOnFormTags: ["INPUT"]
		}, []), { defaultValue: AM.url() };
	}
});
var { PlaceholderProvider: MM, placeholderStore: NM, usePlaceholderStore: PM } = su({
	isUploading: !1,
	progresses: {},
	updatedFiles: []
}, { name: "placeholder" }), FM = Object.defineProperty, IM = Object.defineProperties, LM = Object.getOwnPropertyDescriptors, RM = Object.getOwnPropertySymbols, zM = Object.prototype.hasOwnProperty, BM = Object.prototype.propertyIsEnumerable, VM = (e, t, n) => t in e ? FM(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, HM = (e, t) => {
	for (var n in t ||= {}) zM.call(t, n) && VM(e, n, t[n]);
	if (RM) for (var n of RM(t)) BM.call(t, n) && VM(e, n, t[n]);
	return e;
}, UM = (e, t) => IM(e, LM(t)), WM = nk({
	key: "nodeId",
	options: {
		filter: () => !0,
		filterText: !0,
		idCreator: () => Math.random().toString(36).slice(2, 7),
		idKey: "id"
	},
	withOverrides: (e, { options: { allow: t, disableInsertOverrides: n, exclude: r, filter: i, filterText: a, idCreator: o, idKey: s = "", reuseId: c } }) => {
		let { apply: l, insertNode: u, insertNodes: d } = e, f = () => ({ [s]: o() }), p = (e) => i(e) && (!a || e[0]?.type !== void 0), m = (t) => {
			(!c || yv(e, {
				at: [],
				match: { [s]: t[s] }
			})) && delete t[s];
		}, h = (t) => {
			if (Iv(t._id)) {
				let n = t._id;
				delete t._id, yv(e, {
					at: [],
					match: { [s]: n }
				}) || (t[s] = n);
			}
		}, g = {
			allow: t,
			exclude: r,
			filter: p
		};
		return e.insertNodes = (e, t) => {
			let r = Cv(e).filter((e) => !!e);
			r.length !== 0 && d(r.map((e) => (!n && e[s] && (e._id = e[s]), e)), t);
		}, e.insertNode = (e) => {
			!n && e[s] && (e._id = e[s]), u(e);
		}, e.apply = (t) => {
			if (t.type === "insert_node") {
				let e = xv(t.node);
				return ak({
					apply: m,
					node: e,
					query: g,
					source: {}
				}), xA({
					node: e,
					path: t.path,
					query: g,
					source: f
				}), n || ak({
					apply: h,
					node: e,
					query: g,
					source: {}
				}), l(UM(HM({}, t), { node: e }));
			}
			if (t.type === "split_node") {
				let n = t.properties, r = t.properties[s];
				if (lv([n, t.path], g)) return (!c || r === void 0 || yv(e, {
					at: [],
					match: { [s]: r }
				})) && (r = o()), l(UM(HM({}, t), { properties: UM(HM({}, t.properties), { [s]: r }) }));
				r && delete t.properties[s];
			}
			return l(t);
		}, e;
	}
}), GM = nk({
	deserializeHtml: {
		query: (e) => e.style.fontFamily !== "Consolas",
		rules: [{ validNodeName: "P" }]
	},
	handlers: { onKeyDown: SA },
	isElement: !0,
	key: "p",
	options: { hotkey: ["mod+opt+0", "mod+shift+0"] }
}), KM = nk({
	key: "selectOnBackspace",
	options: { removeNodeIfEmpty: !1 },
	withOverrides: (e, { options: { query: t, removeNodeIfEmpty: n } }) => {
		let { deleteBackward: r } = e;
		return e.deleteBackward = (i) => {
			let { selection: a } = e;
			if (i === "character" && iv(a)) {
				let o = k_(e, a, { unit: i });
				if (o) {
					let [s] = h_(e, {
						at: o,
						match: (e) => lv([e, o.path], t)
					});
					if (s && o) {
						let t = J_(e, V_(e, a).path);
						n && t && !$_(t) && C_(e), w_(e, o);
					} else r(i);
				} else r(i);
			} else r(i);
		}, e;
	}
}), qM = Object.defineProperty, JM = Object.defineProperties, YM = Object.getOwnPropertyDescriptors, XM = Object.getOwnPropertySymbols, ZM = Object.prototype.hasOwnProperty, QM = Object.prototype.propertyIsEnumerable, $M = (e, t, n) => t in e ? qM(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, eN = (e, t) => {
	for (var n in t ||= {}) ZM.call(t, n) && $M(e, n, t[n]);
	if (XM) for (var n of XM(t)) QM.call(t, n) && $M(e, n, t[n]);
	return e;
}, tN = (e, t) => JM(e, YM(t)), nN = (e, t) => {
	var n = {};
	for (var r in e) ZM.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && XM) for (var r of XM(e)) t.indexOf(r) < 0 && QM.call(e, r) && (n[r] = e[r]);
	return n;
}, rN = {
	"shift+down": "bottom",
	"shift+left": "left",
	"shift+right": "right",
	"shift+up": "top"
}, iN = (e, t) => {
	let n = z_(e, z.next(t));
	if (!n) return;
	let [r, i] = n, a = r?.children?.[0], o = i.concat(0);
	if (a && o) return z_(e, o);
}, aN = (e, t) => {
	let n = cy(t);
	if (!n) return;
	let r = z_(e, n);
	if (!r) return;
	let [i, a] = r, o = i?.children?.[i.children.length - 1], s = a.concat(i.children.length - 1);
	if (o && s) return z_(e, s);
}, oN = (e) => e.colSpan || Number(e.attributes?.colspan) || 1, sN = (e) => sk(e, ["td", "th"]), cN = (e, { children: t, header: n, row: r } = {}) => (n ??= r ? r.children.every((t) => t.type === $(e, "th")) : !1, {
	children: t ?? [e.blockFactory()],
	type: n ? $(e, "th") : $(e, "td")
}), lN = (e, t = {}) => {
	var n = t, { colCount: r = 1 } = n, i = nN(n, ["colCount"]);
	let { cellFactory: a } = ok(e, HN);
	return {
		children: Array.from({ length: r }).fill(r).map(() => a(i)),
		type: $(e, "tr")
	};
}, uN = (e, t = {}) => {
	var n = t, { colCount: r, header: i, rowCount: a = 0 } = n, o = nN(n, [
		"colCount",
		"header",
		"rowCount"
	]);
	return {
		children: Array.from({ length: a }).fill(a).map((t, n) => lN(e, tN(eN({ colCount: r }, o), { header: i && n === 0 }))),
		type: $(e, HN)
	};
}, dN = (e, t, n, r) => {
	let i = z_(e, z.next(n));
	if (i) return i;
	let [, a] = r;
	return iN(e, a);
}, fN = (e, t, n, r) => {
	let i = cy(n);
	if (!i) {
		let [, t] = r;
		return aN(e, t);
	}
	let a = z_(e, i);
	if (a) return a;
}, pN = (e) => e.rowSpan || Number(e.attributes?.rowspan) || 1, mN = (e, t) => Y(e, eN({ match: { type: $(e, HN) } }, t)), hN = (e) => e.children?.[0]?.children ? e.children[0].children.map((e) => e.colSpan || e?.attributes?.colspan || 1).reduce((e, t) => Number(e) + Number(t)) : 0, gN = (e, { at: t = e.selection } = {}) => {
	if (!t) return;
	let n = vv(e, {
		at: t,
		match: { type: sN(e) }
	});
	if (!n) return;
	let [, r] = n, i = p_(e, {
		at: r,
		match: { type: $(e, "tr") }
	});
	if (!i) return;
	let [, a] = i, o = p_(e, {
		at: a,
		match: { type: $(e, HN) }
	});
	if (o) return {
		cell: n,
		row: i,
		table: o
	};
};
function _N(e, t, n) {
	var r;
	let i = ok(e, HN), a = t.children, o = -1, s = -1;
	for (let e = 0; e < a.length; e++) {
		let t = a[e], r = 0;
		for (let i of t.children) {
			let t = i;
			if (n === t) {
				s = r, o = e;
				break;
			}
			r += oN(t);
		}
	}
	if (a.slice(0, o).forEach((e, t) => {
		e.children.forEach((e) => {
			let n = e, r = (i?._cellIndices)?.get(n), a = pN(n);
			if (r) {
				let { col: e } = r;
				e <= s && a && a > 1 && o - t < a && (s += oN(n));
			}
		});
	}), o === -1 || s === -1) return null;
	let c = {
		col: s,
		row: o
	};
	return (r = i?._cellIndices) == null || r.set(n, c), c;
}
var vN = (e, t) => e?.get(t), yN = ({ col: e, row: t }, n) => ({
	col: e + oN(n) - 1,
	row: t + pN(n) - 1
}), bN = (e, t, n, r) => {
	let { _cellIndices: i } = ok(e, HN);
	return t.children.flatMap((e) => e.children).find((a) => {
		let o = a, s = vN(i, o) || _N(e, t, o), { col: c, row: l } = s, { col: u, row: d } = yN(s, o);
		return r >= c && r <= u && n >= l && n <= d;
	});
}, xN = (e, { at: t, format: n }) => {
	var r;
	let { _cellIndices: i, getCellChildren: a } = ok(e, HN), o = vv(e, {
		at: t.anchor.path,
		match: { type: sN(e) }
	}), s = vv(e, {
		at: t.focus.path,
		match: { type: sN(e) }
	}), c = o[0], l = s[0], u = t.anchor.path.slice(0, -2), d = vv(e, {
		at: u,
		match: { type: $(e, HN) }
	})[0], { col: f, row: p } = yN(vN(i, c) || _N(e, d, c), c), { col: m, row: h } = yN(vN(i, l) || _N(e, d, l), l), g = Math.min(p, h), _ = Math.max(p, h), v = Math.min(f, m), y = Math.max(f, m), b = _ - g, x = uN(e, {
		children: [],
		colCount: y - v + 1,
		rowCount: b + 1
	}), S = [], C = /* @__PURE__ */ new WeakSet(), w = g, T = v;
	for (;;) {
		let t = bN(e, d, w, T);
		if (!t) break;
		let n = vN(i, t) || _N(e, d, t), { col: r, row: a } = yN(n, t), { col: o, row: s } = n;
		if (s < g || a > _ || o < v || r > y) {
			C = /* @__PURE__ */ new WeakSet(), S = [], g = Math.min(g, s), _ = Math.max(_, a), v = Math.min(v, o), y = Math.max(y, r), w = g, T = v;
			let t = _ - g;
			x = uN(e, {
				children: [],
				colCount: y - v + 1,
				rowCount: t + 1
			});
		} else {
			if (!C.has(t)) {
				C.add(t);
				let n = x.children[w - g].children;
				n[T - v] = t;
				let r = ow(e, t);
				S.push([t, r]);
			}
			if (T + 1 <= y) T += 1;
			else if (w + 1 <= _) T = v, w += 1;
			else break;
		}
	}
	let E = n || "table";
	return E === "cell" ? S : ((r = x.children) == null || r.forEach((e) => {
		let t = e;
		t.children = t.children?.filter((e) => a(e).length > 0);
	}), E === "table" ? [[x, u]] : {
		cellEntries: S,
		tableEntries: [[x, u]]
	});
}, SN = (e, { at: t, format: n = "table" }) => {
	let { enableMerging: r } = ok(e, HN);
	if (r) return xN(e, {
		at: t,
		format: n
	});
	let i = t.anchor.path, a = t.focus.path, o = i.at(-2), s = a.at(-2), c = i.at(-1), l = a.at(-1), u = Math.min(o, s), d = Math.max(o, s), f = Math.min(c, l), p = Math.max(c, l), m = i.slice(0, -2), h = d - u, g = uN(e, {
		children: [],
		colCount: p - f + 1,
		rowCount: h + 1
	}), _ = u, v = f, y = [];
	for (;;) {
		let t = m.concat([_, v]), n = J_(e, t);
		if (!n) break;
		let r = g.children[_ - u].children;
		if (r[v - f] = n, y.push([n, t]), v + 1 <= p) v += 1;
		else if (_ + 1 <= d) v = f, _ += 1;
		else break;
	}
	return n === "cell" ? y : [[g, m]];
}, CN = (e, t = {}) => {
	var n = t, { format: r = "table" } = n, i = nN(n, ["format"]);
	let a = Yv(e, eN({ match: { type: sN(e) } }, i));
	if (a) {
		let [t, n] = a;
		if (!z.equals(t[1], n[1])) return SN(e, {
			at: {
				anchor: {
					offset: 0,
					path: t[1]
				},
				focus: {
					offset: 0,
					path: n[1]
				}
			},
			format: r
		});
		if (r === "table") {
			let n = uN(e, { rowCount: 1 });
			return n.children[0].children = [t[0]], [[n, t[1].slice(0, -2)]];
		}
		return [t];
	}
	return [];
}, wN = (e, t, n, r) => {
	let { _cellIndices: i } = ok(e, HN), [a, o] = t, s = a.children[n].children.findIndex((e) => {
		let { col: t } = vN(i, e);
		return t === r;
	});
	return o.concat([n, s]);
}, TN = (e, { at: t, fromCell: n, header: r } = {}) => {
	let { _cellIndices: i } = ok(e, HN), a = n ? vv(e, {
		at: n,
		match: { type: sN(e) }
	}) : Y(e, { match: { type: sN(e) } });
	if (!a) return;
	let [, o] = a, s = a[0], c = Y(e, {
		at: o,
		match: { type: $(e, HN) }
	});
	if (!c) return;
	let { cellFactory: l, initialTableWidth: u, minColumnWidth: d } = ok(e, HN), [f, p] = c, { col: m } = vN(i, s) || _N(e, f, s), h = oN(s), g, _;
	z.isPath(t) ? (g = m, _ = m - 1) : (g = m + h, _ = m + h - 1);
	let v = f.children.length, y = g <= 0, b = 1;
	y && (_ = 0, b = 0);
	let x = /* @__PURE__ */ new Set();
	Array.from({ length: v }, (e, t) => t).forEach((t) => {
		let n = bN(e, f, t, _);
		n && x.add(n);
	}), Array.from(x).forEach((t) => {
		let n = t, { col: a, row: o } = vN(i, n) || _N(e, f, n), s = pN(n), u = oN(n), d = wN(e, c, o, a);
		if (a + u - 1 >= g && !y) pv(e, tN(eN({}, n), { colSpan: u + 1 }), { at: d });
		else {
			let t = d.slice(0, -1), n = d.at(-1), i = [...t, n + b], a = g_(e, d)[0];
			yy(e, tN(eN({}, l({
				header: r,
				row: a
			})), {
				colSpan: 1,
				rowSpan: s
			}), { at: i });
		}
	}), J(e, () => {
		let { colSizes: t } = f;
		if (t) {
			let n = [
				...t.slice(0, g),
				0,
				...t.slice(g)
			];
			if (u) {
				n[g] = t[g] ?? t[g - 1] ?? u / t.length;
				let e = t.reduce((e, t) => e + t, 0), r = n.reduce((e, t) => e + t, 0), i = Math.max(e, u);
				if (r > i) {
					let e = i / r;
					n = n.map((t) => Math.max(d ?? 0, Math.floor(t * e)));
				}
			}
			pv(e, { colSizes: n }, { at: p });
		}
	});
}, EN = (e, t = {}) => {
	let { enableMerging: n } = ok(e, HN);
	if (n) return TN(e, t);
	let { at: r, disableSelect: i, fromCell: a, header: o } = t, s = a ? vv(e, {
		at: a,
		match: { type: sN(e) }
	}) : Y(e, { match: { type: sN(e) } });
	if (!s) return;
	let [, c] = s, l = Y(e, {
		at: c,
		match: { type: $(e, HN) }
	});
	if (!l) return;
	let [u, d] = l, f, p;
	z.isPath(r) ? (f = r, p = r.at(-1)) : (f = z.next(c), p = c.at(-1) + 1);
	let m = c.at(-2), { cellFactory: h, initialTableWidth: g, minColumnWidth: _ } = ok(e, HN);
	J(e, () => {
		u.children.forEach((t, n) => {
			let a = [...f];
			z.isPath(r) ? a[r.length - 2] = n : a[c.length - 2] = n;
			let s = o === void 0 ? t.children.every((t) => t.type === $(e, "th")) : o;
			yy(e, h({ header: s }), {
				at: a,
				select: !i && n === m
			});
		});
		let { colSizes: t } = u;
		if (t) {
			let n = [
				...t.slice(0, p),
				0,
				...t.slice(p)
			];
			if (g) {
				n[p] = t[p] ?? t[p - 1] ?? g / t.length;
				let e = t.reduce((e, t) => e + t, 0), r = n.reduce((e, t) => e + t, 0), i = Math.max(e, g);
				if (r > i) {
					let e = i / r;
					n = n.map((t) => Math.max(_ ?? 0, Math.floor(t * e)));
				}
			}
			pv(e, { colSizes: n }, { at: d });
		}
	});
}, DN = (e, { at: t, fromRow: n, header: r } = {}) => {
	let { _cellIndices: i, cellFactory: a } = ok(e, HN), o = n ? vv(e, {
		at: n,
		match: { type: $(e, "tr") }
	}) : Y(e, { match: { type: $(e, "tr") } });
	if (!o) return;
	let [, s] = o, c = Y(e, {
		at: s,
		match: { type: $(e, HN) }
	});
	if (!c) return;
	let l = c[0], u = vv(e, {
		at: n,
		match: { type: sN(e) }
	});
	if (!u) return;
	let [d, f] = u, p = d, m = pN(p), { row: h } = vN(i, p) || _N(e, l, p), g = f.at(-2), _ = f.slice(0, -2), v, y, b;
	z.isPath(t) ? (v = t.at(-1), y = h - 1, b = t) : (v = h + m, y = h + m - 1, b = [..._, g + m]);
	let x = v === 0;
	x && (y = 0);
	let S = hN(l), C = /* @__PURE__ */ new Set();
	Array.from({ length: S }, (e, t) => t).forEach((t) => {
		let n = bN(e, l, y, t);
		n && C.add(n);
	});
	let w = Array.from(C), T = [];
	w.forEach((t) => {
		if (!t) return;
		let n = t, { col: o, row: s } = vN(i, n) || _N(e, l, n), u = pN(n), d = oN(n), f = wN(e, c, s, o);
		if (s + u - 1 >= v && !x) pv(e, tN(eN({}, n), { rowSpan: u + 1 }), { at: f });
		else {
			let t = g_(e, f)[0], n = a({
				header: r,
				row: t
			});
			T.push(tN(eN({}, n), {
				colSpan: d,
				rowSpan: 1
			}));
		}
	}), J(e, () => {
		yy(e, {
			children: T,
			type: $(e, "tr")
		}, { at: b });
	});
}, ON = (e, t = {}) => {
	let { cellFactory: n, enableMerging: r } = ok(e, HN);
	if (r) return DN(e, t);
	let { at: i, disableSelect: a, fromRow: o, header: s } = t, c = o ? vv(e, {
		at: o,
		match: { type: $(e, "tr") }
	}) : Y(e, { match: { type: $(e, "tr") } });
	if (!c) return;
	let [l, u] = c, d = Y(e, {
		at: u,
		match: { type: $(e, HN) }
	});
	if (!d) return;
	let f = () => ({
		children: l.children.map((t, r) => {
			let i = d[0].children.length !== 1 && d[0].children.every((t) => t.children[r].type === $(e, "th"));
			return n({ header: s ?? i });
		}),
		type: $(e, "tr")
	});
	if (J(e, () => {
		yy(e, f(), { at: z.isPath(i) ? i : z.next(u) });
	}), !a) {
		let t = Y(e, { match: { type: sN(e) } });
		if (!t) return;
		let [, n] = t;
		z.isPath(i) ? n[n.length - 2] = i.at(-2) : n[n.length - 2] += 1, w_(e, n);
	}
}, kN = (e, { at: t, edge: n, fromOneCell: r, reverse: i } = {}) => {
	if (n) {
		let i = CN(e, {
			at: t,
			format: "cell"
		}), a = +!r;
		if (i.length > a) {
			let [, t] = i[0], [, r] = i.at(-1), a = [...t], o = [...r];
			switch (n) {
				case "bottom":
					o[o.length - 2] += 1;
					break;
				case "top":
					--a[a.length - 2];
					break;
				case "right":
					o[o.length - 1] += 1;
					break;
				case "left": --a[a.length - 1];
			}
			return nv(e, a) && nv(e, o) && w_(e, {
				anchor: A_(e, a),
				focus: A_(e, o)
			}), !0;
		}
		return;
	}
	let a = Y(e, {
		at: t,
		match: { type: sN(e) }
	});
	if (a) {
		let [, t] = a, n = [...t], r = i ? -1 : 1;
		if (n[n.length - 2] += r, nv(e, n)) w_(e, A_(e, n));
		else {
			let n = t.slice(0, -2);
			i ? J(e, () => {
				w_(e, A_(e, n)), fv(e, { reverse: !0 });
			}) : J(e, () => {
				w_(e, E_(e, n)), fv(e);
			});
		}
		return !0;
	}
}, AN = (e, t) => {
	let n;
	if (!e.currentKeyboardEvent || ![
		"up",
		"down",
		"shift+up",
		"shift+right",
		"shift+down",
		"shift+left"
	].some((t) => {
		let r = (0, vT.isHotkey)(t, e.currentKeyboardEvent);
		return r && (n = t), r;
	}) || !e.selection?.focus || !t?.focus || !iy(e, {
		at: {
			anchor: e.selection.focus,
			focus: t.focus
		},
		match: { type: sN(e) }
	}) || !n) return;
	let r = rN[n];
	if (r && !gy(e, {
		at: e.selection,
		match: { type: sN(e) }
	})) return;
	let i = e.selection, a = ["shift+up", "up"].includes(n);
	setTimeout(() => {
		kN(e, {
			at: i,
			edge: r,
			fromOneCell: !0,
			reverse: a
		});
	}, 0);
}, jN = (e, { type: t }) => (n) => {
	if (n.defaultPrevented) return;
	let r = {
		"shift+down": (0, vT.isHotkey)("shift+down", n),
		"shift+left": (0, vT.isHotkey)("shift+left", n),
		"shift+right": (0, vT.isHotkey)("shift+right", n),
		"shift+up": (0, vT.isHotkey)("shift+up", n)
	};
	Object.keys(r).forEach((t) => {
		r[t] && kN(e, {
			edge: rN[t],
			reverse: t === "shift+up"
		}) && (n.preventDefault(), n.stopPropagation());
	});
	let i = yD.isTab(e, n), a = yD.isUntab(e, n);
	if (i || a) {
		let t = gN(e);
		if (!t) return;
		let { cell: r, row: o } = t, [, s] = r;
		if (a) {
			let t = fN(e, r, s, o);
			if (t) {
				let [, n] = t;
				w_(e, n);
			}
		} else if (i) {
			let t = dN(e, r, s, o);
			if (t) {
				let [, n] = t;
				w_(e, n);
			}
		}
		n.preventDefault(), n.stopPropagation();
	}
	if ((0, vT.isHotkey)("mod+a", n)) {
		let r = p_(e, { match: { type: t } });
		if (!r) return;
		let [, i] = r;
		w_(e, i), n.preventDefault(), n.stopPropagation();
	}
}, MN = (e, { reverse: t, unit: n }) => {
	let { selection: r } = e, i = t ? E_ : A_, a = t ? O_ : k_;
	if (iv(r)) {
		let o = Y(e, { match: { type: sN(e) } });
		if (o) {
			let [, t] = o, n = i(e, t);
			if (r && W.equals(r.anchor, n)) return !0;
		} else if (Y(e, {
			at: a(e, r, { unit: n }),
			match: { type: sN(e) }
		})) return fv(e, { reverse: !t }), !0;
	}
}, NN = (e) => {
	let { deleteBackward: t, deleteForward: n, deleteFragment: r } = e;
	return e.deleteBackward = (n) => {
		if (!MN(e, { unit: n })) return t(n);
	}, e.deleteForward = (t) => {
		if (!MN(e, {
			reverse: !0,
			unit: t
		})) return n(t);
	}, e.deleteFragment = (t) => {
		if (gy(e, { match: (t) => t.type === $(e, "table") })) {
			let t = CN(e, { format: "cell" });
			if (t.length > 1) {
				J(e, () => {
					t.forEach(([, t]) => {
						wy(e, {
							at: t,
							nodes: e.blockFactory()
						});
					}), w_(e, {
						anchor: A_(e, t[0][1]),
						focus: E_(e, t.at(-1)[1])
					});
				});
				return;
			}
		}
		r(t);
	}, e;
}, PN = (e, { options: t }) => {
	let { getFragment: n } = e, { getCellChildren: r } = t;
	return e.getFragment = () => {
		let t = n(), i = [];
		return t.forEach((t) => {
			if (t.type === $(e, "table")) {
				let n = t.children, a = n.length;
				if (!a) return;
				let o = n[0].children.length;
				if (a <= 1 && o <= 1) {
					let e = n[0], t = r(e);
					i.push(...t[0].children);
					return;
				}
				{
					let t = CN(e);
					if (t.length > 0) {
						i.push(t[0][0]);
						return;
					}
				}
			}
			i.push(t);
		}), i;
	}, e;
}, FN = (e, { options: t }) => {
	let { insertFragment: n } = e, { disableExpandOnInsert: r, getCellChildren: i, insertColumn: a, insertRow: o } = t, s = a_(e);
	return s.insertFragment = (t) => {
		let s = t.find((t) => t.type === $(e, HN));
		if (!s && mN(e, { at: e.selection?.anchor })) {
			let n = CN(e, { format: "cell" });
			if (n.length > 1) {
				n.forEach((n) => {
					if (n) {
						let [, r] = n;
						wy(e, {
							at: r,
							nodes: xv(t)
						});
					}
				}), w_(e, {
					anchor: A_(e, n[0][1]),
					focus: E_(e, n.at(-1)[1])
				});
				return;
			}
		}
		if (s) {
			if (mN(e, { at: e.selection?.anchor })) {
				let [t] = CN(e, {
					at: e.selection?.anchor,
					format: "cell"
				});
				if (t) {
					J(e, () => {
						let [, n] = t, c = [...n], l = c.at(-1), u = null, d = !0;
						s.children.forEach((t) => {
							if (c[c.length - 1] = l, !d) {
								let t = c.slice(0, -1);
								if (c[c.length - 2] += 1, !nv(e, c)) {
									if (r) return;
									o?.(e, { fromRow: t });
								}
							}
							d = !1;
							let n = t.children, s = !0;
							n.forEach((t) => {
								if (!s) {
									let t = [...c];
									if (c[c.length - 1] += 1, !nv(e, c)) {
										if (r) return;
										a?.(e, { fromCell: t });
									}
								}
								s = !1;
								let n = i(t);
								wy(e, {
									at: c,
									nodes: xv(n)
								}), u = [...c];
							});
						}), u && w_(e, {
							anchor: A_(e, n),
							focus: E_(e, u)
						});
					});
					return;
				}
			} else if (t.length === 1 && t[0].type === "table") {
				e.insertNode(t[0]);
				return;
			}
		}
		n(t);
	}, e;
}, IN = (e, t) => {
	let { insertText: n } = e;
	return e.insertText = (t) => {
		av(e.selection) && mN(e, { at: e.selection?.anchor }) && CN(e, { format: "cell" }).length > 1 && ov(e, { edge: "focus" }), n(t);
	}, e;
}, LN = (e) => {
	let { addMark: t, getMarks: n, removeMark: r } = e;
	return e.addMark = (n, r) => {
		let { selection: i } = e;
		if (!i || iv(i)) return t(n, r);
		let a = CN(e, { format: "cell" });
		if (a.length <= 1) return t(n, r);
		a.forEach(([t, i]) => {
			pv(e, { [n]: r }, {
				at: i,
				match: (e) => y_(e),
				split: !0,
				voids: !0
			});
		});
	}, e.removeMark = (t) => {
		let { selection: n } = e;
		if (!n || iv(n)) return r(t);
		let i = CN(e, { format: "cell" });
		if (i.length === 0) return r(t);
		i.forEach(([n, r]) => {
			hv(e, t, {
				at: r,
				match: (e) => y_(e),
				split: !0,
				voids: !0
			});
		});
	}, e.getMarks = () => {
		let { selection: t } = e;
		if (!t || iv(t)) return n();
		let r = CN(e, { format: "cell" });
		if (r.length === 0) return n();
		let i = {};
		return r.forEach(([t, n]) => {
			let r = h_(e, {
				at: n,
				match: (e) => y_(e)
			});
			Array.from(r, (e) => e[0]).forEach((e) => {
				let t = Object.keys(e);
				t.length !== 1 && (t.splice(t.indexOf("text"), 1), t.forEach((t) => {
					i[t] = e[t];
				}));
			});
		}), i;
	}, e;
}, RN = (e) => {
	let { normalizeNode: t } = e, n = a_(e), { initialTableWidth: r } = ok(e, HN);
	return n.normalizeNode = ([n, i]) => {
		if (c_(n)) {
			if (n.type === $(e, "table")) {
				if (Y(e, {
					at: i,
					match: { type: $(e, "table") }
				})) {
					gv(e, { at: i });
					return;
				}
				if (r) {
					let t = n, a = t.children[0]?.children?.length;
					if (a) {
						let n = [];
						if (t.colSizes) t.colSizes.some((e) => !e) && t.colSizes.forEach((e) => {
							n.push(e || r / a);
						});
						else for (let e = 0; e < a; e++) n.push(r / a);
						if (n.length > 0) {
							pv(e, { colSizes: n }, { at: i });
							return;
						}
					}
				}
			}
			if (n.type === $(e, "tr") && g_(e, i)?.[0].type !== $(e, "table")) {
				gv(e, { at: i });
				return;
			}
			if (sN(e).includes(n.type)) {
				let { children: t } = n;
				if (g_(e, i)?.[0].type !== $(e, "tr")) {
					gv(e, { at: i });
					return;
				}
				if (y_(t[0])) {
					Ey(e, e.blockFactory({}, i), { at: i });
					return;
				}
			}
		}
		return t([n, i]);
	}, e;
}, zN = (e) => {
	let { apply: t } = e;
	return e.apply = (n) => {
		if (n.type === "set_selection" && n.newProperties) {
			let t = eN(eN({}, e.selection), n.newProperties);
			if (B.isRange(t) && iy(e, {
				at: t,
				match: (t) => t.type === $(e, "table")
			})) {
				let r = Y(e, {
					at: t.anchor,
					match: (t) => t.type === $(e, HN)
				});
				if (r) {
					let [, i] = r;
					B.isBackward(t) ? n.newProperties.focus = A_(e, i) : k_(e, i) && (n.newProperties.focus = E_(e, i));
				} else {
					let r = Y(e, {
						at: t.focus,
						match: (t) => t.type === $(e, HN)
					});
					if (r) {
						let [, i] = r;
						if (B.isBackward(t)) {
							let t = A_(e, i), r = k_(e, t);
							n.newProperties.focus = r ?? t;
						} else n.newProperties.focus = E_(e, i);
					}
				}
			}
			AN(e, t);
		}
		t(n);
	}, e;
}, BN = (e) => {
	let { setFragmentData: t } = e;
	return e.setFragmentData = (n, r) => {
		let i = CN(e, { format: "table" })?.[0], a = CN(e, { format: "cell" }), o = e.selection;
		if (!i || !o) {
			t(n, r);
			return;
		}
		let s = z.compare(o.anchor.path, o.focus.path) < 1 ? o.anchor : o.focus, [c, l] = i, u = c.children, [d, f] = s.path.slice(l.length, l.length + 2), p = "", m = "", h = document.createElement("div"), g = document.createElement("table");
		if (i && o && a.length === 1 && (r === "copy" || r === "cut")) {
			t(n);
			return;
		}
		J(e, () => {
			u.forEach((r, i) => {
				let a = r.children, o = l.concat(d + i), s = [], c = r.type === $(e, "th") ? document.createElement("th") : document.createElement("tr");
				a.forEach((r, i) => {
					n.clearData();
					let a = o.concat(f + i);
					w_(e, {
						anchor: A_(e, a),
						focus: E_(e, a)
					}), t(n), s.push(n.getData("text/plain"));
					let l = document.createElement("td");
					l.colSpan = oN(r), l.rowSpan = pN(r), l.innerHTML = n.getData("text/html"), c.append(l);
				}), g.append(c), p += `${s.join(",")}
`, m += `${s.join("	")}
`;
			}), w_(e, o), h.append(g);
		}), n.setData("text/csv", p), n.setData("text/tsv", m), n.setData("text/plain", m), n.setData("text/html", h.innerHTML);
		let _ = JSON.stringify(c), v = window.btoa(encodeURIComponent(_));
		n.setData("application/x-slate-fragment", v);
	}, e;
}, VN = (e, t) => (e = RN(e), e = NN(e), e = PN(e, t), e = FN(e, t), e = IN(e, t), e = zN(e), e = BN(e), e = LN(e), e), HN = "table", UN = (e) => (t) => {
	let n = t.style.background || t.style.backgroundColor;
	return n ? {
		background: n,
		type: e
	} : { type: e };
}, WN = nk({
	deserializeHtml: { rules: [{ validNodeName: "TABLE" }] },
	handlers: { onKeyDown: jN },
	isElement: !0,
	key: HN,
	options: {
		_cellIndices: /* @__PURE__ */ new WeakMap(),
		enableMerging: !1,
		insertColumn: (e, { fromCell: t }) => {
			EN(e, {
				disableSelect: !0,
				fromCell: t
			});
		},
		insertRow: (e, { fromRow: t }) => {
			ON(e, {
				disableSelect: !0,
				fromRow: t
			});
		},
		minColumnWidth: 48
	},
	plugins: [
		{
			deserializeHtml: { rules: [{ validNodeName: "TR" }] },
			isElement: !0,
			key: "tr"
		},
		{
			dangerouslyAllowAttributes: ["colspan", "rowspan"],
			isElement: !0,
			key: "td",
			props: ({ element: e }) => ({ nodeProps: {
				colSpan: e?.attributes?.colspan,
				rowSpan: e?.attributes?.rowspan
			} }),
			then: (e) => ({ deserializeHtml: {
				attributeNames: ["rowspan", "colspan"],
				getNode: UN($(e, "td")),
				rules: [{ validNodeName: "TD" }]
			} })
		},
		{
			dangerouslyAllowAttributes: ["colspan", "rowspan"],
			isElement: !0,
			key: "th",
			props: ({ element: e }) => ({ nodeProps: {
				colSpan: e?.attributes?.colspan,
				rowSpan: e?.attributes?.rowspan
			} }),
			then: (e) => ({ deserializeHtml: {
				attributeNames: ["rowspan", "colspan"],
				getNode: UN($(e, "th")),
				rules: [{ validNodeName: "TH" }]
			} })
		}
	],
	then: (e) => ({ options: {
		cellFactory: (t) => cN(e, t),
		getCellChildren: (e) => e.children
	} }),
	withOverrides: VN
}), { TableProvider: GN, tableStore: KN, useTableStore: qN } = su({
	colSizeOverrides: Oe(/* @__PURE__ */ new Map()),
	hoveredColIndex: null,
	marginLeftOverride: null,
	rowSizeOverrides: Oe(/* @__PURE__ */ new Map()),
	selectedCells: null,
	selectedTable: null
}, { name: "table" }), JN = Object.getOwnPropertySymbols, YN = Object.prototype.hasOwnProperty, XN = Object.prototype.propertyIsEnumerable, ZN = (e, t) => {
	var n = {};
	for (var r in e) YN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && JN) for (var r of JN(e)) t.indexOf(r) < 0 && XN.call(e, r) && (n[r] = e[r]);
	return n;
}, QN = nk({
	key: "trailingBlock",
	options: { level: 0 },
	then: (e) => ({ type: $(e, "p") }),
	withOverrides: (e, t) => {
		var { options: n } = t, r = n, { level: i, type: a = $(e, "p") } = r, o = ZN(r, ["level", "type"]);
		let { normalizeNode: s } = e;
		return e.normalizeNode = ([t, n]) => {
			if (n.length === 0) {
				let t = ey(e, i), n = t?.[0];
				if (!n || n.type !== a && lv(t, o)) {
					let n = t ? z.next(t[1]) : [0];
					yy(e, e.blockFactory({ type: a }, n), { at: n });
					return;
				}
			}
			return s([t, n]);
		}, e;
	}
}), $N = (e) => UT(e), eP = (e, t) => LT(e, t);
function tP(e) {
	return "id" in e && "children" in e;
}
// ../document-structure/src/plateTypes.ts
var nP = "h_lg", rP = "h_md", iP = "h_sm", aP = "blockquote", oP = "callout", sP = "code_block", cP = "inline_img", lP = "video_embed", uP = "embed", dP = "anchor_link", fP = "interlink", pP = "html", mP = {
	"elevio-box-info": "info",
	"elevio-box-warning": "warning",
	"elevio-box-error": "error",
	"elevio-box-success": "success"
}, hP = Object.values(mP), gP = $N({
	key: oP,
	isElement: !0,
	deserializeHtml: {
		rules: [
			{
				validNodeName: ["CITE", "Q"],
				validClassName: "callout"
			},
			{
				validNodeName: [
					"BLOCKQUOTE",
					"DIV",
					"P"
				],
				validClassName: "callout"
			},
			{
				validNodeName: ["BLOCKQUOTE"],
				validClassName: "elevio-box-info"
			},
			{
				validNodeName: ["BLOCKQUOTE"],
				validClassName: "elevio-box-warning"
			},
			{
				validNodeName: ["BLOCKQUOTE"],
				validClassName: "elevio-box-success"
			},
			{
				validNodeName: ["BLOCKQUOTE"],
				validClassName: "elevio-box-error"
			},
			{ validNodeName: ["CALLOUT", "FIGURE"] }
		],
		getNode: (e) => {
			let t = Object.keys(mP).find((t) => e.classList.contains(t));
			return t ? {
				type: oP,
				variety: mP[t]
			} : {
				type: oP,
				variety: hP.find((t) => e.classList.contains(t)) ?? "neutral"
			};
		}
	},
	handlers: { onKeyDown: oA },
	options: { hotkey: "mod+shift+c" }
}), _P = $N({
	key: sP,
	isElement: !0,
	deserializeHtml: { rules: [{ validNodeName: "PRE" }, {
		validNodeName: "P",
		validStyle: { fontFamily: "Consolas" }
	}] },
	handlers: { onKeyDown: oA },
	options: { hotkey: ["mod+opt+8", "mod+shift+8"] }
}), vP = /\.(apng|avif|bmp|gif|ico|jpe?g|png|svg|webp)$/i;
function yP(e) {
	if (!e) return !1;
	if (/^data:image\//i.test(e.trim())) return !0;
	let t = xP(e);
	return !t || !["http:", "https:"].includes(t.protocol) ? !1 : bP(t) || vP.test(t.pathname);
}
function bP(e) {
	return e.hostname.startsWith("knowledge-cdn.") && e.hostname.endsWith(".dixa.io") && e.pathname.startsWith("/images/");
}
function xP(e) {
	try {
		return new URL(e, "https://base.invalid");
	} catch {
		return;
	}
}
// ../document-structure/src/plugins/createVideoEmbedPlugin/videoUtils.ts
var SP = [
	{
		test_regex: /^.*((youtu.be)|(youtube.com)|(youtube-nocookie.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#&?]*).*/,
		url_regex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be|youtube-nocookie\.com)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_-]+)(.+)?/g,
		url_text: "https://www.youtube.com/embed/$1?$2",
		provider: "youtube"
	},
	{
		test_regex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
		url_regex: /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?(\/[a-zA-Z0-9_-]+)?/i,
		url_text: "https://player.vimeo.com/video/$1",
		provider: "vimeo"
	},
	{
		test_regex: /^(?:.+)loom.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,
		url_regex: /^(?:.+)loom.com\/share\/([0-9a-zA-Z_-]+)(.+)?/g,
		url_text: "https://www.loom.com/embed/$1",
		provider: "loom"
	}
];
function CP(e) {
	return !e || !jv(e) ? null : SP.find((t) => t.test_regex.test(e)) || null;
}
// ../document-structure/src/plugins/createVideoEmbedPlugin/createVideoEmbedPlugin.ts
var wP = $N({
	key: lP,
	isElement: !0,
	isVoid: !0,
	deserializeHtml: {
		rules: [{ validNodeName: "IFRAME" }],
		getNode: (e) => {
			let t = e.getAttribute("src"), n = CP(t);
			if (n) return {
				type: lP,
				url: t,
				provider: n.provider,
				align: "stretch"
			};
		}
	}
}), TP = 640, EP = $N({
	key: uP,
	isElement: !0,
	isVoid: !0,
	deserializeHtml: {
		rules: [{ validNodeName: "IFRAME" }],
		getNode: (e) => {
			let t = e.getAttribute("src");
			if (CP(t) || yP(t)) return;
			let n, r = e.parentElement?.style.getPropertyValue("padding-bottom"), i = e.getAttribute("height");
			return n = r?.endsWith("%") ? parseFloat(r) / 100 * TP : i && !i.endsWith("%") ? parseInt(i, 10) : 480, {
				type: uP,
				src: e.getAttribute("src"),
				title: e.getAttribute("title") || void 0,
				height: n,
				children: [{ text: "" }]
			};
		}
	}
}), DP = $N({
	key: nP,
	isElement: !0,
	deserializeHtml: {
		getNode(e, t) {
			let n = e.getAttribute("id");
			return {
				...t,
				type: nP,
				id: n
			};
		},
		rules: [{ validNodeName: ["H1", "H2"] }]
	},
	handlers: { onKeyDown: oA },
	options: { hotkey: ["mod+opt+1", "mod+shift+1"] }
}), OP = $N({
	key: rP,
	isElement: !0,
	deserializeHtml: {
		rules: [{ validNodeName: "H3" }],
		getNode(e, t) {
			let n = e.getAttribute("id");
			return {
				...t,
				type: rP,
				id: n
			};
		}
	},
	handlers: { onKeyDown: oA },
	options: { hotkey: ["mod+opt+2", "mod+shift+2"] }
}), kP = $N({
	key: iP,
	isElement: !0,
	deserializeHtml: {
		rules: [{ validNodeName: [
			"H4",
			"H5",
			"H6"
		] }],
		getNode(e, t) {
			let n = e.getAttribute("id");
			return {
				...t,
				type: iP,
				id: n
			};
		}
	},
	handlers: { onKeyDown: oA },
	options: { hotkey: ["mod+opt+3", "mod+shift+3"] }
}), AP = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", jP = (e = 21) => {
	let t = "", n = e | 0;
	for (; n-- > 0;) t += AP[Math.random() * 64 | 0];
	return t;
}, MP = () => jP(5), NP = $N({
	key: pP,
	isElement: !0,
	isVoid: !0,
	deserializeHtml: {
		rules: [{ validNodeName: ["TABLE"] }],
		getNode(e) {
			let t = e.outerHTML;
			return {
				type: pP,
				id: MP(),
				html: t
			};
		}
	}
}), PP = UT({
	key: cP,
	isElement: !0,
	isInline: !0,
	isVoid: !0,
	deserializeHtml: {
		rules: [{ validNodeName: "IMG" }],
		getNode(e) {
			let t = e.parentElement;
			if (t && (t.textContent ?? "").trim().length !== 0) return {
				type: cP,
				url: e.getAttribute("src"),
				children: [{ text: "" }]
			};
		}
	}
}), FP = $N({
	key: "createInjectDeserializeInlineChildrenPlugin",
	options: { keys: ["p"] },
	withOverrides: (e) => {
		let { normalizeNode: t } = e;
		return e.normalizeNode = ([n, r]) => {
			if (!tP(n)) return t([n, r]);
			if (n.type === "p" && n.children.length > 0) {
				if (r.length > 1) {
					let i = g_(e, r);
					return i && aA(e, i[0], ["td", "th"]) ? t([n, r]) : void 0;
				}
				t([n, r]), dv(e, {
					at: r,
					match(t, n) {
						return l_(e, t) && n.length > 1;
					}
				});
			} else t([n, r]);
		}, e;
	},
	then(e, t) {
		let n = oD(e), r = { deserializeHtml: { getNode(t, r) {
			let i = Array.from(t.childNodes).flatMap(n).filter(Boolean).flatMap((t, n) => U_(e, t) ? t : typeof t == "string" ? { text: t } : (t?.type === "ul" || t?.type === "ol") && (r.type === "li" || r.type === "lic") ? t : l_(e, t) ? [IP({
				editor: e,
				node: t,
				index: n
			}), ...t.children].filter(Boolean) : t);
			return {
				...r,
				children: i
			};
		} } };
		return { inject: { pluginsByKey: (t.options?.keys || []).reduce((e, t) => ({
			...e,
			[t]: r
		}), {}) } };
	}
});
function IP({ editor: e, node: t, index: n }) {
	if (n !== 0 && "type" in t) return t.type === "p" && t.children.length > 0 ? t.children.length === 1 && t.children[0].text === "" ? void 0 : { text: "\n\n" } : U_(e, t) ? void 0 : { text: "\n" };
}
// ../document-structure/src/plugins/link/withMyLinks.ts
var LP = (e) => {
	let { apply: t, normalizeNode: n } = e;
	return e.apply = (n) => {
		if (n.type === "set_selection") {
			let t = n.newProperties;
			if (t && t.focus && t.anchor && iv(t)) {
				let r = p_(e, {
					at: t,
					match: (t) => aA(e, t, [fP, dP])
				});
				if (r) {
					let [, i] = r, a;
					W_(e, t.focus, i) && (a = sy(e, i)), H_(e, t.focus, i) && (a = ny(e, i)), a && (n.newProperties = {
						anchor: a,
						focus: a
					});
				}
			}
		}
		t(n);
	}, e.normalizeNode = ([t, r]) => {
		if (aA(e, t, ["interlink", "anchor_link"])) {
			let t = e.selection;
			if (t && iv(t) && H_(e, t.focus, r)) {
				let t = ny(e, r);
				if (t) w_(e, t);
				else {
					let t = z.next(r);
					uv(e, { text: "" }, { at: t }), w_(e, t);
				}
			}
		}
		n([t, r]);
	}, e = VA(e, dE({ options: { types: [fP, dP] } })), e;
}, RP = UT({
	key: fP,
	isElement: !0,
	isInline: !0,
	withOverrides: LP,
	options: { rangeBeforeOptions: {
		matchString: " ",
		skipInvalid: !0,
		afterMatch: !0
	} },
	then: () => ({ deserializeHtml: {
		rules: [{ validAttribute: "data-elevio-article" }],
		getNode(e, t) {
			let n = e.getAttribute("data-elevio-article");
			if (n) return {
				id: MP(),
				type: fP,
				linkId: `elevio-article-id:${n}`,
				linkType: "article",
				linkTitle: "",
				...t
			};
		}
	} })
}), zP = Zd("floatingLinks")({
	openEditorId: null,
	linkType: "url",
	interlinkId: "",
	interlinkTitle: "",
	interlinkLangId: "",
	linkedElementId: "",
	url: "",
	text: "",
	newTab: !1,
	mode: "",
	isEditing: !1
}).extendActions((e) => ({ reset: () => {
	e.linkType("url"), e.interlinkId(""), e.interlinkTitle(""), e.text(""), e.url(""), e.newTab(!1), e.mode(""), e.isEditing(!1), e.openEditorId(null), e.interlinkLangId("");
} })).extendActions((e) => ({
	show: (t, n) => {
		e.mode(t), e.isEditing(!1), e.openEditorId(n);
	},
	hide: () => {
		e.reset();
	}
})).extendSelectors((e) => ({ isOpen: (t) => e.openEditorId === t }));
zP.set, zP.get;
// ../document-structure/src/plugins/link/createAnchorLinkPlugin.ts
var BP = UT({
	key: dP,
	isElement: !0,
	isInline: !0,
	withOverrides: LP,
	options: { rangeBeforeOptions: {
		matchString: " ",
		skipInvalid: !0,
		afterMatch: !0
	} },
	deserializeHtml: {
		rules: [{ validNodeName: ["A"] }],
		getNode(e, t) {
			let n = e.getAttribute("href");
			return !n || !n.startsWith("#") ? void 0 : {
				type: dP,
				linkId: n.slice(1),
				...t
			};
		}
	}
}), VP = (e = [], t) => eP([
	...e,
	WM({ options: { idCreator: MP } }),
	GM(),
	jA({ deserializeHtml: {
		rules: [{ validNodeName: "BLOCKQUOTE" }],
		query: (e) => !e.matches(".callout") && !Array.from(e.classList).some((e) => /^elevio-box-/.test(e))
	} }),
	gP(),
	_P(),
	BA(),
	DP(),
	OP(),
	kP(),
	aM(),
	_M({
		options: { disableUploadInsert: !0 },
		deserializeHtml: {
			getNode: (e) => {
				if (e.nodeName === "IFRAME") {
					let t = e.getAttribute("src");
					return yP(t) ? {
						type: "img",
						url: t,
						filename: null,
						imgAlign: "center",
						children: [{ text: "" }]
					} : void 0;
				}
				let t = e, n;
				if (e.nodeName === "A") {
					let r = e.querySelector("img");
					if (!r) return;
					t = r, n = e.getAttribute("href");
				}
				let r = e.parentElement;
				if (!r || (r.textContent ?? "").trim().length > 0) return;
				let i = t.classList.contains("fr-fir") ? "end" : t.classList.contains("fr-fil") ? "start" : "center";
				return {
					type: "img",
					url: t.getAttribute("src"),
					filename: null,
					imgAlign: i,
					linkUrl: n,
					children: [{ text: "" }]
				};
			},
			rules: [
				{ validNodeName: "A" },
				{ validNodeName: "IMG" },
				{ validNodeName: "IFRAME" }
			]
		}
	}),
	wP(),
	EP(),
	NP(),
	WN(),
	wA(),
	EA(),
	AA(),
	DA(),
	TA(),
	fj({ then(e, t) {
		return { deserializeHtml: { getNode: (e, n) => {
			if (!e.querySelector("img")) return t.deserializeHtml?.getNode?.(e, n);
		} } };
	} }),
	RP(),
	BP(),
	PP(),
	KM({ options: { query: { allow: [
		"hr",
		"img",
		lP
	] } } }),
	zA({ options: { rules: [{ hotkey: "shift+enter" }] } }),
	RA({ options: { rules: [
		{
			hotkey: "mod+shift+enter",
			before: !0
		},
		{
			hotkey: "enter",
			before: !1,
			query: {
				end: !0,
				exclude: [
					"ul",
					"ol",
					"li",
					"lic"
				]
			}
		},
		{ hotkey: "mod+enter" }
	] } }),
	QN({ type: "p" }),
	FP({ options: { keys: [
		"li",
		"lic",
		aP,
		oP,
		nP,
		rP,
		iP
	] } })
], { components: t });
// ../document-structure/src/createHeadlessEditor.ts
function HP() {
	return gD({ plugins: VP([], {}) });
}
// ../document-structure/src/structure/empty.ts
var UP = () => [{
	id: MP(),
	type: "p",
	children: [{ text: "" }]
}], WP = [
	"1.0.0",
	"1.1.0",
	"1.2.0",
	"1.3.0"
], GP = WP[WP.length - 1], KP = /href\s*=\s*(["']?)\/\/([^"'>]+)/g;
function qP(e) {
	return e.replace(KP, "href=$1https://$2");
}
// ../document-structure/src/deserialize.ts
function JP(e) {
	return {
		constructor: { name: "DataTransfer" },
		getData: (t) => t === "text/html" && e
	};
}
function YP(e) {
	let t = HP();
	t.children = UP();
	let n = qP(e);
	return t.insertData(JP(n)), t.children;
}
$N({
	key: "DEBUG",
	handlers: { onChange: () => (e) => {} }
});
// src/components/Modals/components/articleSuccessMessage.tsx
var XP = ({ articleName: e, collectionName: t }) => /* @__PURE__ */ M(ie.Paragraph, {
	withMarginBottom: !0,
	children: [
		"The draft article ",
		/* @__PURE__ */ M("strong", { children: [
			"“",
			e,
			"”"
		] }),
		" has been successfully created in the collection",
		" ",
		/* @__PURE__ */ M("strong", { children: [
			"“",
			t,
			"”"
		] })
	]
});
// src/components/Modals/useDraftArticleEditor.tsx
function ZP({ conversationId: e, languageId: n, collectionId: i, collectionName: o, initialArticleName: s, initialArticleContent: c, draftSource: l, referencedConversationIds: u }) {
	let { hideModal: f } = a(), { successNotify: m, errorNotify: h } = x(), [g, _] = r(), v = d(), [y] = p(), [b, S] = ye(!1), [w, T] = ye(""), [{ articleName: E, articleContent: ee }, D] = ye({
		articleName: s,
		articleContent: c
	});
	async function O(t) {
		if (t) try {
			be.conversationArticleDraftImprovementRequested({
				conversationId: e,
				collectionId: i,
				languageCode: n,
				draftSource: l
			});
			let r = await g({
				csid: e,
				refresh: !1,
				language_id: n,
				save_draft_article_input: { collection_id: i },
				improve: {
					previous_draft_article: {
						title: E,
						article_html: ee
					},
					feedback: t
				}
			});
			be.conversationArticleDraftImprovementResponseReceived({
				conversationId: e,
				collectionId: i,
				languageCode: n,
				draftSource: l
			}), D({
				articleName: r.articleName,
				articleContent: r.articleContent
			});
		} catch (e) {
			h({ text: e?.message || "Something went wrong" });
		}
	}
	async function te() {
		S(!0);
		let r = YP(ee);
		try {
			be.conversationArticleDraftSaveRequested({
				conversationId: e,
				collectionId: i,
				languageCode: n,
				draftSource: l
			});
			let a = (await y({
				variables: {
					translations: {
						languageId: n,
						title: E,
						aiAssisted: !0,
						referencedConversationIds: [...u],
						content: {
							version: GP,
							children: r
						}
					},
					parentId: i
				},
				client: v
			})).data?.articleCreate?.id || "";
			be.conversationArticleDraftSaveResponseReceived({
				conversationId: e,
				collectionId: i,
				languageCode: n,
				articleId: a,
				draftSource: l
			});
			let s = t.articleEdit({
				articleId: a,
				collectionId: i,
				languageId: n
			});
			m({
				title: "Draft article created",
				time: 1e4,
				text: /* @__PURE__ */ j(C, { children: /* @__PURE__ */ j(XP, {
					articleName: E,
					collectionName: o
				}) }),
				icon: "check-circle",
				leftAction: {
					text: "Edit article",
					action: { navigate: s }
				}
			}), S(!1), f();
		} catch (e) {
			S(!1), h({ text: e?.message || "Something went wrong" });
		}
	}
	return {
		articleName: E,
		articleContent: ee,
		improveInput: w,
		setImproveInput: T,
		onImproveDraft: O,
		onCreateDraft: te,
		isGenerating: _.loading,
		isSaving: b
	};
}
// src/components/Modals/articleDraftModal.tsx
function QP({ onSubmit: t, queueId: r, withCollection: i = !0 }) {
	let { currentConversationId: o } = f(m), { selectedLanguageId: s } = f(n), { data: c, loading: l } = e({ selectedLanguageId: s }), u = c?.selectedLanguage, { data: d, loading: p } = h(), _ = d ? d.collections.results.filter((e) => e.linkedResources.some((e) => e.id === r)).map((e) => ({
		id: e.id,
		name: e.title
	})) : [], { hideModal: v } = a(), y = {
		conversationId: o,
		collection: [],
		language: u ? [{
			id: u.languageId,
			name: u.description
		}] : []
	}, { control: b, formState: { isValid: x }, handleSubmit: S } = Ee({
		resolver: rt(Al(i)),
		defaultValues: y,
		reValidateMode: "onChange",
		mode: "all"
	}), C = c ? c.enabledLanguages.map((e) => ({
		id: e.languageId,
		name: e.description
	})) : [];
	return /* @__PURE__ */ j(g, { children: /* @__PURE__ */ M("form", {
		onSubmit: S(t),
		children: [
			/* @__PURE__ */ j(ne, {
				title: "Create draft article",
				onClose: v
			}),
			/* @__PURE__ */ j(te, { children: /* @__PURE__ */ M(D, { children: [i && /* @__PURE__ */ j(ee, { children: /* @__PURE__ */ j(at, {
				required: !0,
				control: b,
				multiple: !1,
				label: "Collection",
				name: "collection",
				equalityFn: (e, t) => e.id === t.id,
				itemsLoading: p,
				listItems: _,
				placeholders: {
					empty: "Select a collection",
					loading: "Loading collections..."
				}
			}) }), /* @__PURE__ */ j(ee, { children: /* @__PURE__ */ j(at, {
				required: !0,
				control: b,
				multiple: !1,
				label: "Language",
				name: "language",
				equalityFn: (e, t) => e.id === t.id,
				itemsLoading: l,
				listItems: C,
				placeholders: {
					empty: "Select a collection",
					loading: "Loading collections..."
				}
			}) })] }) }),
			/* @__PURE__ */ j(k, { children: /* @__PURE__ */ M(E, {
				justifyContent: "flex-end",
				gap: "100",
				children: [/* @__PURE__ */ j(w, {
					variant: "tertiary",
					onClick: v,
					children: "Cancel"
				}), /* @__PURE__ */ j(w, {
					disabled: !x,
					type: "submit",
					children: "Next"
				})]
			}) })
		]
	}) });
}
function $P({ onRetry: e }) {
	let { hideModal: t } = a(), [n, r] = ye(!1);
	return /* @__PURE__ */ M(g, { children: [
		/* @__PURE__ */ j(ne, {
			title: "Create draft article",
			onClose: t
		}),
		/* @__PURE__ */ j(te, { children: /* @__PURE__ */ j(S, {
			variant: "fail",
			headline: "Failed to create draft article",
			description: /* @__PURE__ */ j(ie.Paragraph, { children: "Something went wrong while generating the article. Your choices are still selected, so you can try again." })
		}) }),
		/* @__PURE__ */ j(k, { children: /* @__PURE__ */ M(E, {
			justifyContent: "flex-end",
			gap: "100",
			children: [/* @__PURE__ */ j(w, {
				variant: "tertiary",
				onClick: t,
				children: "Cancel"
			}), /* @__PURE__ */ j(w, {
				variant: "primary",
				disabled: n,
				onClick: () => {
					r(!0), e();
				},
				children: "Try again"
			})]
		}) })
	] });
}
function eF({ children: e }) {
	let { hideModal: t } = a();
	return /* @__PURE__ */ M(g, { children: [
		/* @__PURE__ */ j(ne, {
			title: "Your article is being created",
			onClose: t
		}),
		/* @__PURE__ */ j(te, { children: /* @__PURE__ */ M(E, {
			flexDirection: "column",
			alignItems: "center",
			gap: "300",
			children: [/* @__PURE__ */ j(A, { size: 40 }), e]
		}) }),
		/* @__PURE__ */ j(k, { children: /* @__PURE__ */ j(E, {
			justifyContent: "flex-end",
			gap: "100",
			children: /* @__PURE__ */ j(w, {
				variant: "primary",
				onClick: t,
				children: "Close"
			})
		}) })
	] });
}
function tF({ languageId: e, articleName: t, articleContent: n, collectionId: r, collectionName: i, conversationId: o }) {
	let { hideModal: s } = a(), c = ZP({
		conversationId: o,
		languageId: e,
		collectionId: r,
		collectionName: i,
		initialArticleName: t,
		initialArticleContent: n,
		draftSource: "single-conversation",
		referencedConversationIds: [o]
	});
	return /* @__PURE__ */ M(g, {
		allowEscClose: !1,
		children: [
			/* @__PURE__ */ j(ne, {
				title: "Create draft article",
				onClose: s
			}),
			/* @__PURE__ */ M(te, {
				className: v.modalBody,
				children: [/* @__PURE__ */ j(b, {
					title: c.articleName,
					articleContent: c.articleContent,
					className: v.legacyArticleBackground
				}), /* @__PURE__ */ j(y, {
					value: c.improveInput,
					onChange: c.setImproveInput,
					onSubmit: c.onImproveDraft,
					isGenerating: c.isGenerating,
					isSaving: c.isSaving
				})]
			}),
			/* @__PURE__ */ j(Ml, {
				onDiscard: s,
				onSave: c.onCreateDraft,
				isGenerating: c.isGenerating,
				isSaving: c.isSaving
			})
		]
	});
}
export { tF as ArticleDraftCustomizeModal, $P as ArticleDraftFailedModal, QP as ArticleDraftModal, eF as ArticleDraftRequestedModal };

//# sourceMappingURL=articleDraftModal-D4YaKQRK.js.map